import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: any;
  DateOptionalTime: any;
  DateOptionalTimeRange: any;
  DateTime: any;
  Email: any;
  File: any;
  ImageFile: any;
  JSON: any;
  Mixed: any;
  UploadType: any;
  VideoFile: any;
};

export type Ad = {
  __typename?: 'Ad';
  adAccount: AdAccount;
  adAccountCurrency?: Maybe<Scalars['String']>;
  adChangelog?: Maybe<AdChangelog>;
  adClickUrl?: Maybe<Scalars['String']>;
  adCreatedAt: Scalars['DateTime'];
  adEffectiveStatus?: Maybe<AdEffectiveStatus>;
  adEventTrackers?: Maybe<Array<Maybe<EventTracker>>>;
  adGhost: Scalars['Boolean'];
  adHasErrors: Scalars['Boolean'];
  adHash?: Maybe<Scalars['String']>;
  adId: Scalars['ID'];
  adModificationTime?: Maybe<Scalars['DateTime']>;
  adName?: Maybe<Scalars['String']>;
  adPreviewExpiry?: Maybe<Scalars['DateTime']>;
  adPreviewUrl?: Maybe<Scalars['String']>;
  adStatus?: Maybe<AdStatus>;
  adStatusPending?: Maybe<AdStatus>;
  adUpdatedAt?: Maybe<Scalars['DateTime']>;
  campaign: Campaign;
  client: Client;
  creative?: Maybe<Creative>;
  externalAdId?: Maybe<Scalars['ID']>;
  group: Group;
  stats?: Maybe<Array<Maybe<Stats>>>;
};


export type AdAdChangelogArgs = {
  filters: AdChangelogSubQueryFilter;
};


export type AdStatsArgs = {
  filters?: InputMaybe<StatsFilter>;
  orderBy?: InputMaybe<Array<InputMaybe<StatsOrderBy>>>;
  query?: InputMaybe<Scalars['String']>;
};

export type AdAccount = {
  __typename?: 'AdAccount';
  adAccountAdminApproval: AdAccountAdminApproval;
  adAccountAttributionType?: Maybe<AdAccountAttributionType>;
  adAccountClickAttributionWindow?: Maybe<AdAccountAttributionWindow>;
  adAccountCreatedAt: Scalars['DateTime'];
  adAccountCurrency: Scalars['String'];
  adAccountId: Scalars['ID'];
  adAccountModificationTime?: Maybe<Scalars['DateTime']>;
  adAccountName: Scalars['String'];
  adAccountPixelPartnerPreferences?: Maybe<Array<Scalars['String']>>;
  adAccountRefreshTokenValid: Scalars['Int'];
  adAccountStatus: AdAccountStatus;
  adAccountSuspensionReason?: Maybe<Scalars['String']>;
  adAccountTimeZoneId: Scalars['String'];
  adAccountType: AdAccountType;
  adAccountViewAttributionWindow?: Maybe<AdAccountAttributionWindow>;
  business: Business;
  client: Client;
  fundingInstruments?: Maybe<Array<FundingInstrument>>;
  profiles?: Maybe<Array<Profile>>;
};


export type AdAccountFundingInstrumentsArgs = {
  filters?: InputMaybe<FundingInstrumentFilter>;
};

export enum AdAccountAdminApproval {
  NeedsIdVerification = 'NEEDS_ID_VERIFICATION',
  Suspended = 'SUSPENDED',
  Trusted = 'TRUSTED',
  Unknown = 'UNKNOWN',
  Valid = 'VALID'
}

export type AdAccountAdminApprovalFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<AdAccountAdminApproval>;
};

export enum AdAccountAttributionType {
  AllConversion = 'ALL_CONVERSION',
  ClickThroughConversion = 'CLICK_THROUGH_CONVERSION',
  Unknown = 'UNKNOWN',
  ViewThroughConversion = 'VIEW_THROUGH_CONVERSION'
}

export enum AdAccountAttributionWindow {
  Day = 'DAY',
  Month = 'MONTH',
  Unknown = 'UNKNOWN',
  Week = 'WEEK'
}

export type AdAccountCursored = {
  __typename?: 'AdAccountCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<AdAccount>>;
};

export type AdAccountFilter = {
  adAccountAdminApproval?: InputMaybe<Array<AdAccountAdminApprovalFilter>>;
  adAccountCurrency?: InputMaybe<Array<StringFilter>>;
  adAccountId?: InputMaybe<Array<IdFilter>>;
  adAccountName?: InputMaybe<Array<StringFilter>>;
  adAccountStatus?: InputMaybe<Array<AdAccountStatusFilter>>;
  adAccountSuspensionReason?: InputMaybe<Array<StringFilter>>;
  adAccountType?: InputMaybe<Array<AdAccountTypeFilter>>;
};

export type AdAccountLive = {
  __typename?: 'AdAccountLive';
  adAccountAdminApproval: AdAccountAdminApproval;
  adAccountAttributionType?: Maybe<AdAccountAttributionType>;
  adAccountClickAttributionWindow?: Maybe<AdAccountAttributionWindow>;
  adAccountCreatedAt: Scalars['DateTime'];
  adAccountCurrency: Scalars['String'];
  adAccountExists: Scalars['Boolean'];
  adAccountId: Scalars['ID'];
  adAccountModifiedAt?: Maybe<Scalars['DateTime']>;
  adAccountName: Scalars['String'];
  adAccountPixelPartnerPreferences?: Maybe<Array<Scalars['String']>>;
  adAccountSuspensionReason?: Maybe<Scalars['String']>;
  adAccountTimeZoneId?: Maybe<Scalars['String']>;
  adAccountType: AdAccountType;
  adAccountViewAttributionWindow?: Maybe<AdAccountAttributionWindow>;
  businessId: Scalars['ID'];
};

export type AdAccountLiveFilter = {
  memberId: SingleIdRealmFilter;
};

export type AdAccountOrderBy = {
  column: AdAccountOrderByColumn;
  direction?: OrderByDirection;
};

export enum AdAccountOrderByColumn {
  AdAccountAdminApproval = 'adAccountAdminApproval',
  AdAccountAttributionType = 'adAccountAttributionType',
  AdAccountClickAttributionWindow = 'adAccountClickAttributionWindow',
  AdAccountCreatedAt = 'adAccountCreatedAt',
  AdAccountCurrency = 'adAccountCurrency',
  AdAccountId = 'adAccountId',
  AdAccountModificationTime = 'adAccountModificationTime',
  AdAccountName = 'adAccountName',
  AdAccountPixelPartnerPreferences = 'adAccountPixelPartnerPreferences',
  AdAccountStatus = 'adAccountStatus',
  AdAccountTimeZoneId = 'adAccountTimeZoneId',
  AdAccountType = 'adAccountType',
  AdAccountViewAttributionWindow = 'adAccountViewAttributionWindow'
}

export enum AdAccountStatus {
  Admin = 'ADMIN',
  Banned = 'BANNED',
  FailedBilling = 'FAILED_BILLING',
  PendingBilling = 'PENDING_BILLING',
  Suspended = 'SUSPENDED',
  Suspicious = 'SUSPICIOUS',
  Trusted = 'TRUSTED',
  Unknown = 'UNKNOWN',
  Valid = 'VALID'
}

export type AdAccountStatusFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<AdAccountStatus>;
};

export enum AdAccountType {
  Managed = 'MANAGED',
  SelfServe = 'SELF_SERVE',
  Unknown = 'UNKNOWN'
}

export type AdAccountTypeFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<AdAccountType>;
};

export type AdAccountsByBusiness = {
  __typename?: 'AdAccountsByBusiness';
  adAccounts: Array<Maybe<AdAccountLive>>;
  businessId: Scalars['ID'];
  businessName: Scalars['String'];
};

export type AdChangelog = {
  __typename?: 'AdChangelog';
  adId?: Maybe<Scalars['ID']>;
  changelogs?: Maybe<Array<Maybe<Changelog>>>;
};

export type AdChangelogFilter = {
  adId: SingleIdFilter;
  differenceFields: AdDifferencesFilter;
  modificationTime?: InputMaybe<DateRangeFilter>;
};

export type AdChangelogSubQueryFilter = {
  differenceFields: AdDifferencesFilter;
  modificationTime?: InputMaybe<DateRangeFilter>;
};

export type AdCursored = {
  __typename?: 'AdCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Ad>>;
};

export enum AdDifferencesFields {
  AdClickUrl = 'adClickUrl',
  AdEventTrackers = 'adEventTrackers',
  AdName = 'adName',
  AdPreviewExpiry = 'adPreviewExpiry',
  AdPreviewUrl = 'adPreviewUrl',
  AdReEffectiveStatus = 'adReEffectiveStatus',
  AdReStatus = 'adReStatus',
  AdReStatusPending = 'adReStatusPending',
  AdStatus = 'adStatus'
}

export type AdDifferencesFilter = {
  value: Array<AdDifferencesFields>;
};

export enum AdEffectiveStatus {
  Active = 'ACTIVE',
  AdGroupPaused = 'AD_GROUP_PAUSED',
  Archived = 'ARCHIVED',
  CampaignPaused = 'CAMPAIGN_PAUSED',
  Completed = 'COMPLETED',
  Deleted = 'DELETED',
  MissingPermissions = 'MISSING_PERMISSIONS',
  Paused = 'PAUSED',
  PendingApproval = 'PENDING_APPROVAL',
  PendingBillingInfo = 'PENDING_BILLING_INFO',
  PendingIdVerification = 'PENDING_ID_VERIFICATION',
  /**  Legacy value, left it here for backward compatibility  */
  PendingReview = 'PENDING_REVIEW',
  Processing = 'PROCESSING',
  Rejected = 'REJECTED',
  Unknown = 'UNKNOWN'
}

export type AdEffectiveStatusFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<AdEffectiveStatus>;
};

export type AdFilter = {
  adAccountName?: InputMaybe<Array<StringFilter>>;
  adEffectiveStatus?: InputMaybe<Array<AdEffectiveStatusFilter>>;
  adGhost?: InputMaybe<Array<BooleanFilter>>;
  adHasErrors?: InputMaybe<Array<BooleanFilter>>;
  adId?: InputMaybe<Array<IdFilter>>;
  adName?: InputMaybe<Array<StringFilter>>;
  adStatus?: InputMaybe<Array<AdStatusFilter>>;
  campaignId?: InputMaybe<Array<IdFilter>>;
  campaignName?: InputMaybe<Array<StringFilter>>;
  campaignStatus?: InputMaybe<Array<CampaignStatusFilter>>;
  clientId?: InputMaybe<Array<IdFilter>>;
  clientName?: InputMaybe<Array<StringFilter>>;
  clientStatus?: InputMaybe<Array<ClientStatusFilter>>;
  creativeId?: InputMaybe<Array<IdFilter>>;
  externalAdId?: InputMaybe<Array<IdFilter>>;
  groupId?: InputMaybe<Array<IdFilter>>;
  groupName?: InputMaybe<Array<StringFilter>>;
  groupStatus?: InputMaybe<Array<GroupStatusFilter>>;
};

export type AdLive = {
  __typename?: 'AdLive';
  adAccountId?: Maybe<Scalars['ID']>;
  adClickUrl?: Maybe<Scalars['String']>;
  adCreatedAt?: Maybe<Scalars['DateTime']>;
  adEffectiveStatus?: Maybe<AdEffectiveStatus>;
  adEventTrackers?: Maybe<Array<Maybe<EventTracker>>>;
  adId?: Maybe<Scalars['ID']>;
  adModifiedAt?: Maybe<Scalars['DateTime']>;
  adName?: Maybe<Scalars['String']>;
  adPreviewExpiry?: Maybe<Scalars['DateTime']>;
  adPreviewUrl?: Maybe<Scalars['String']>;
  adRejectionReason?: Maybe<Scalars['String']>;
  adStatus?: Maybe<AdStatus>;
  campaignId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  postId?: Maybe<Scalars['ID']>;
  postUrl?: Maybe<Scalars['String']>;
};

export type AdLiveFilter = {
  adAccountId: SingleIdRealmFilter;
};

export type AdOrderBy = {
  column: AdOrderByColumn;
  direction?: OrderByDirection;
};

export enum AdOrderByColumn {
  AdCreatedAt = 'adCreatedAt',
  AdEffectiveStatus = 'adEffectiveStatus',
  AdId = 'adId',
  AdModificationTime = 'adModificationTime',
  AdName = 'adName',
  AdStatus = 'adStatus',
  AddToCartClickThroughConversionsAttributionWindowDay = 'addToCartClickThroughConversionsAttributionWindowDay',
  AddToCartClickThroughConversionsAttributionWindowMonth = 'addToCartClickThroughConversionsAttributionWindowMonth',
  AddToCartClickThroughConversionsAttributionWindowWeek = 'addToCartClickThroughConversionsAttributionWindowWeek',
  AddToCartViewThroughConversionsAttributionWindowDay = 'addToCartViewThroughConversionsAttributionWindowDay',
  AddToCartViewThroughConversionsAttributionWindowMonth = 'addToCartViewThroughConversionsAttributionWindowMonth',
  AddToCartViewThroughConversionsAttributionWindowWeek = 'addToCartViewThroughConversionsAttributionWindowWeek',
  AddToWishlistClickThroughConversionsAttributionWindowDay = 'addToWishlistClickThroughConversionsAttributionWindowDay',
  AddToWishlistClickThroughConversionsAttributionWindowMonth = 'addToWishlistClickThroughConversionsAttributionWindowMonth',
  AddToWishlistClickThroughConversionsAttributionWindowWeek = 'addToWishlistClickThroughConversionsAttributionWindowWeek',
  AddToWishlistViewThroughConversionsAttributionWindowDay = 'addToWishlistViewThroughConversionsAttributionWindowDay',
  AddToWishlistViewThroughConversionsAttributionWindowMonth = 'addToWishlistViewThroughConversionsAttributionWindowMonth',
  AddToWishlistViewThroughConversionsAttributionWindowWeek = 'addToWishlistViewThroughConversionsAttributionWindowWeek',
  AppInstallMetricsAddPaymentInfo = 'appInstallMetricsAddPaymentInfo',
  AppInstallMetricsAddToCart = 'appInstallMetricsAddToCart',
  AppInstallMetricsAppLaunch = 'appInstallMetricsAppLaunch',
  AppInstallMetricsCompletedTutorial = 'appInstallMetricsCompletedTutorial',
  AppInstallMetricsInstall = 'appInstallMetricsInstall',
  AppInstallMetricsLevelAchieved = 'appInstallMetricsLevelAchieved',
  AppInstallMetricsPurchase = 'appInstallMetricsPurchase',
  AppInstallMetricsSearch = 'appInstallMetricsSearch',
  AppInstallMetricsSignUp = 'appInstallMetricsSignUp',
  AppInstallMetricsSpend = 'appInstallMetricsSpend',
  AppInstallMetricsSpendCredits = 'appInstallMetricsSpendCredits',
  AppInstallMetricsViewContent = 'appInstallMetricsViewContent',
  CampaignId = 'campaignId',
  Clicks = 'clicks',
  CommentDownvotes = 'commentDownvotes',
  CommentUpvotes = 'commentUpvotes',
  CommentsPageViews = 'commentsPageViews',
  Community = 'community',
  ConversionAddToCartAvgValue = 'conversionAddToCartAvgValue',
  ConversionAddToCartTotalItems = 'conversionAddToCartTotalItems',
  ConversionAddToCartTotalValue = 'conversionAddToCartTotalValue',
  ConversionAddToWishlistAvgValue = 'conversionAddToWishlistAvgValue',
  ConversionAddToWishlistTotalItems = 'conversionAddToWishlistTotalItems',
  ConversionAddToWishlistTotalValue = 'conversionAddToWishlistTotalValue',
  ConversionLeadTotalValue = 'conversionLeadTotalValue',
  ConversionPurchaseAvgValue = 'conversionPurchaseAvgValue',
  ConversionPurchaseTotalItems = 'conversionPurchaseTotalItems',
  ConversionPurchaseTotalValue = 'conversionPurchaseTotalValue',
  ConversionRoas = 'conversionRoas',
  ConversionSignupTotalValue = 'conversionSignupTotalValue',
  Country = 'country',
  Cpc = 'cpc',
  CreativeAllowComments = 'creativeAllowComments',
  CreativeContentCallToAction = 'creativeContentCallToAction',
  CreativeContentCaption = 'creativeContentCaption',
  CreativeContentDestinationUrl = 'creativeContentDestinationUrl',
  CreativeContentDisplayUrl = 'creativeContentDisplayUrl',
  CreativeContentMediaUrl = 'creativeContentMediaUrl',
  CreativeHeadline = 'creativeHeadline',
  Ctr = 'ctr',
  CustomClickThroughConversionsAttributionWindowDay = 'customClickThroughConversionsAttributionWindowDay',
  CustomClickThroughConversionsAttributionWindowMonth = 'customClickThroughConversionsAttributionWindowMonth',
  CustomClickThroughConversionsAttributionWindowWeek = 'customClickThroughConversionsAttributionWindowWeek',
  CustomViewThroughConversionsAttributionWindowDay = 'customViewThroughConversionsAttributionWindowDay',
  CustomViewThroughConversionsAttributionWindowMonth = 'customViewThroughConversionsAttributionWindowMonth',
  CustomViewThroughConversionsAttributionWindowWeek = 'customViewThroughConversionsAttributionWindowWeek',
  /** Statistics */
  Date = 'date',
  DayOfMonth = 'dayOfMonth',
  Ecpm = 'ecpm',
  ExternalAdAccountId = 'externalAdAccountId',
  ExternalAdId = 'externalAdId',
  ExternalCampaignId = 'externalCampaignId',
  ExternalGroupId = 'externalGroupId',
  GroupId = 'groupId',
  Impressions = 'impressions',
  Interest = 'interest',
  LeadClickThroughConversionsAttributionWindowDay = 'leadClickThroughConversionsAttributionWindowDay',
  LeadClickThroughConversionsAttributionWindowMonth = 'leadClickThroughConversionsAttributionWindowMonth',
  LeadClickThroughConversionsAttributionWindowWeek = 'leadClickThroughConversionsAttributionWindowWeek',
  LeadViewThroughConversionsAttributionWindowDay = 'leadViewThroughConversionsAttributionWindowDay',
  LeadViewThroughConversionsAttributionWindowMonth = 'leadViewThroughConversionsAttributionWindowMonth',
  LeadViewThroughConversionsAttributionWindowWeek = 'leadViewThroughConversionsAttributionWindowWeek',
  LegacyClickConversionsAttributionWindowDay = 'legacyClickConversionsAttributionWindowDay',
  LegacyClickConversionsAttributionWindowMonth = 'legacyClickConversionsAttributionWindowMonth',
  LegacyClickConversionsAttributionWindowWeek = 'legacyClickConversionsAttributionWindowWeek',
  LegacyViewConversionsAttributionWindowDay = 'legacyViewConversionsAttributionWindowDay',
  LegacyViewConversionsAttributionWindowMonth = 'legacyViewConversionsAttributionWindowMonth',
  LegacyViewConversionsAttributionWindowWeek = 'legacyViewConversionsAttributionWindowWeek',
  Metro = 'metro',
  MonthName = 'monthName',
  MonthNumber = 'monthNumber',
  PageVisitClickThroughConversionsAttributionWindowDay = 'pageVisitClickThroughConversionsAttributionWindowDay',
  PageVisitClickThroughConversionsAttributionWindowMonth = 'pageVisitClickThroughConversionsAttributionWindowMonth',
  PageVisitClickThroughConversionsAttributionWindowWeek = 'pageVisitClickThroughConversionsAttributionWindowWeek',
  PageVisitViewThroughConversionsAttributionWindowDay = 'pageVisitViewThroughConversionsAttributionWindowDay',
  PageVisitViewThroughConversionsAttributionWindowMonth = 'pageVisitViewThroughConversionsAttributionWindowMonth',
  PageVisitViewThroughConversionsAttributionWindowWeek = 'pageVisitViewThroughConversionsAttributionWindowWeek',
  Placement = 'placement',
  PurchaseClickThroughConversionsAttributionWindowDay = 'purchaseClickThroughConversionsAttributionWindowDay',
  PurchaseClickThroughConversionsAttributionWindowMonth = 'purchaseClickThroughConversionsAttributionWindowMonth',
  PurchaseClickThroughConversionsAttributionWindowWeek = 'purchaseClickThroughConversionsAttributionWindowWeek',
  PurchaseViewThroughConversionsAttributionWindowDay = 'purchaseViewThroughConversionsAttributionWindowDay',
  PurchaseViewThroughConversionsAttributionWindowMonth = 'purchaseViewThroughConversionsAttributionWindowMonth',
  PurchaseViewThroughConversionsAttributionWindowWeek = 'purchaseViewThroughConversionsAttributionWindowWeek',
  Quarter = 'quarter',
  Region = 'region',
  SearchClickThroughConversionsAttributionWindowDay = 'searchClickThroughConversionsAttributionWindowDay',
  SearchClickThroughConversionsAttributionWindowMonth = 'searchClickThroughConversionsAttributionWindowMonth',
  SearchClickThroughConversionsAttributionWindowWeek = 'searchClickThroughConversionsAttributionWindowWeek',
  SearchViewThroughConversionsAttributionWindowDay = 'searchViewThroughConversionsAttributionWindowDay',
  SearchViewThroughConversionsAttributionWindowMonth = 'searchViewThroughConversionsAttributionWindowMonth',
  SearchViewThroughConversionsAttributionWindowWeek = 'searchViewThroughConversionsAttributionWindowWeek',
  SignUpClickThroughConversionsAttributionWindowDay = 'signUpClickThroughConversionsAttributionWindowDay',
  SignUpClickThroughConversionsAttributionWindowMonth = 'signUpClickThroughConversionsAttributionWindowMonth',
  SignUpClickThroughConversionsAttributionWindowWeek = 'signUpClickThroughConversionsAttributionWindowWeek',
  SignUpViewThroughConversionsAttributionWindowDay = 'signUpViewThroughConversionsAttributionWindowDay',
  SignUpViewThroughConversionsAttributionWindowMonth = 'signUpViewThroughConversionsAttributionWindowMonth',
  SignUpViewThroughConversionsAttributionWindowWeek = 'signUpViewThroughConversionsAttributionWindowWeek',
  Spend = 'spend',
  TextValue = 'textValue',
  VideoFullyViewableImpressions = 'videoFullyViewableImpressions',
  VideoPlaysExpanded = 'videoPlaysExpanded',
  VideoPlaysWithSound = 'videoPlaysWithSound',
  VideoStarted = 'videoStarted',
  VideoViewableImpressions = 'videoViewableImpressions',
  VideoWatched3Seconds = 'videoWatched3Seconds',
  VideoWatched5Seconds = 'videoWatched5Seconds',
  VideoWatched10Seconds = 'videoWatched10Seconds',
  VideoWatched25Percent = 'videoWatched25Percent',
  VideoWatched50Percent = 'videoWatched50Percent',
  VideoWatched75Percent = 'videoWatched75Percent',
  VideoWatched95Percent = 'videoWatched95Percent',
  VideoWatched100Percent = 'videoWatched100Percent',
  ViewContentClickThroughConversionsAttributionWindowDay = 'viewContentClickThroughConversionsAttributionWindowDay',
  ViewContentClickThroughConversionsAttributionWindowMonth = 'viewContentClickThroughConversionsAttributionWindowMonth',
  ViewContentClickThroughConversionsAttributionWindowWeek = 'viewContentClickThroughConversionsAttributionWindowWeek',
  ViewContentViewThroughConversionsAttributionWindowDay = 'viewContentViewThroughConversionsAttributionWindowDay',
  ViewContentViewThroughConversionsAttributionWindowMonth = 'viewContentViewThroughConversionsAttributionWindowMonth',
  ViewContentViewThroughConversionsAttributionWindowWeek = 'viewContentViewThroughConversionsAttributionWindowWeek',
  ViewableImpressions = 'viewableImpressions',
  ViewerComments = 'viewerComments',
  WeekNumber = 'weekNumber',
  WeekdayName = 'weekdayName',
  WeekdayNumber = 'weekdayNumber',
  Year = 'year',
  YearMonth = 'yearMonth'
}

export enum AdStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Deleted = 'DELETED',
  Paused = 'PAUSED',
  Unknown = 'UNKNOWN'
}

export type AdStatusFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<AdStatus>;
};

export type AdminFilter = {
  adminUserEmail?: InputMaybe<Array<StringFilter>>;
  adminUserId?: InputMaybe<Array<IdFilter>>;
  adminUserIsDeleted?: InputMaybe<Array<BooleanFilter>>;
  oauthUserId?: InputMaybe<Array<IdFilter>>;
};

export type AdminUser = {
  __typename?: 'AdminUser';
  adminUserEmail: Scalars['String'];
  adminUserId: Scalars['ID'];
  oauthUserId?: Maybe<Scalars['ID']>;
};

export type AdminUserCursored = {
  __typename?: 'AdminUserCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<AdminUser>>;
};

export type AgencyAccount = {
  __typename?: 'AgencyAccount';
  agencyAccountActivatedAt?: Maybe<Scalars['DateTime']>;
  agencyAccountCreatedAt: Scalars['DateTime'];
  agencyAccountDeletedAt?: Maybe<Scalars['DateTime']>;
  agencyAccountId: Scalars['ID'];
  agencyAccountModificationTime?: Maybe<Scalars['DateTime']>;
  agencyAccountName: Scalars['String'];
  agencyAccountProfilePictureUrl?: Maybe<Scalars['String']>;
  clients?: Maybe<Array<Client>>;
  salesforceId?: Maybe<Scalars['ID']>;
  userGroups?: Maybe<Array<UserGroup>>;
  users?: Maybe<Array<AgencyUser>>;
};


export type AgencyAccountClientsArgs = {
  filters?: InputMaybe<ClientFilter>;
  orderBy?: InputMaybe<Array<InputMaybe<ClientOrderBy>>>;
  query?: InputMaybe<Scalars['String']>;
};

export type AgencyAccountCursored = {
  __typename?: 'AgencyAccountCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<AgencyAccount>>;
};

export type AgencyAccountFilter = {
  agencyAccountId?: InputMaybe<Array<IdFilter>>;
  agencyAccountName?: InputMaybe<Array<StringFilter>>;
};

export type AgencyAccountOrderBy = {
  column: AgencyAccountOrderByColumn;
  direction?: OrderByDirection;
};

export enum AgencyAccountOrderByColumn {
  AgencyAccountId = 'agencyAccountId',
  AgencyAccountName = 'agencyAccountName'
}

export type AgencyUser = {
  __typename?: 'AgencyUser';
  agencyIsOwner: Scalars['Boolean'];
  agencyPendingInviteHash?: Maybe<Scalars['String']>;
  user: User;
};

export type Audience = {
  __typename?: 'Audience';
  adAccount: AdAccount;
  audienceCreatedAt: Scalars['DateTime'];
  audienceCustomerListConfig?: Maybe<Scalars['String']>;
  audienceDeletedAt?: Maybe<Scalars['DateTime']>;
  audienceEngagementAudienceConfig?: Maybe<Scalars['String']>;
  audienceId: Scalars['ID'];
  audienceImportedAt?: Maybe<Scalars['DateTime']>;
  audienceLookalikeConfig?: Maybe<Scalars['String']>;
  audienceName?: Maybe<Scalars['String']>;
  audiencePixelAudienceConfig?: Maybe<Scalars['String']>;
  audienceSizeRangeLower?: Maybe<Scalars['Int']>;
  audienceSizeRangeUpper?: Maybe<Scalars['Int']>;
  audienceStatus?: Maybe<AudienceStatus>;
  audienceType: AudienceType;
  externalAudienceId: Scalars['ID'];
};

export type AudienceCursored = {
  __typename?: 'AudienceCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Audience>>;
};

export type AudienceFilter = {
  adAccountId?: InputMaybe<Array<IdFilter>>;
  audienceCustomerListConfig?: InputMaybe<Array<StringFilter>>;
  audienceEngagementAudienceConfig?: InputMaybe<Array<StringFilter>>;
  audienceId?: InputMaybe<Array<IdFilter>>;
  audienceLookalikeConfig?: InputMaybe<Array<StringFilter>>;
  audienceName?: InputMaybe<Array<StringFilter>>;
  audiencePixelAudienceConfig?: InputMaybe<Array<StringFilter>>;
  audienceSizeRangeLower?: InputMaybe<Array<IntFilter>>;
  audienceSizeRangeUpper?: InputMaybe<Array<IntFilter>>;
  audienceStatus?: InputMaybe<Array<StringFilter>>;
  audienceType?: InputMaybe<Array<StringFilter>>;
  externalAudienceId?: InputMaybe<Array<IdFilter>>;
};

export type AudienceOrderBy = {
  column: AudienceOrderByColumn;
  direction?: OrderByDirection;
};

export enum AudienceOrderByColumn {
  AudienceId = 'audienceId',
  AudienceName = 'audienceName',
  AudienceSizeRangeLower = 'audienceSizeRangeLower',
  AudienceSizeRangeUpper = 'audienceSizeRangeUpper',
  AudienceStatus = 'audienceStatus',
  AudienceType = 'audienceType',
  ExternalAudienceId = 'externalAudienceId'
}

export enum AudienceStatus {
  NotEnoughMatchesError = 'NOT_ENOUGH_MATCHES_ERROR',
  Unknown = 'UNKNOWN'
}

export enum AudienceType {
  CustomerList = 'CUSTOMER_LIST',
  EngagementRetargeting = 'ENGAGEMENT_RETARGETING',
  Lookalike = 'LOOKALIKE',
  PixelRetargeting = 'PIXEL_RETARGETING',
  ThirdParty = 'THIRD_PARTY',
  Unknown = 'UNKNOWN'
}

export enum AutopilotStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Paused = 'PAUSED',
  Unknown = 'UNKNOWN'
}

export type AutopilotStatusFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<AutopilotStatus>;
};

export type BooleanFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['Boolean'];
};

export type BooleanRealmFilter = {
  value: Scalars['Boolean'];
};

export type Business = {
  __typename?: 'Business';
  adAccounts?: Maybe<Array<AdAccount>>;
  businessAgencyAffiliated: Scalars['Boolean'];
  businessCountryCode?: Maybe<Scalars['String']>;
  businessCreatedAt: Scalars['DateTime'];
  businessDeletedAt?: Maybe<Scalars['DateTime']>;
  businessId: Scalars['ID'];
  businessModificationTime?: Maybe<Scalars['DateTime']>;
  businessName: Scalars['String'];
  businessWebsiteUrl?: Maybe<Scalars['String']>;
  industryId?: Maybe<Scalars['ID']>;
};

export type BusinessCursored = {
  __typename?: 'BusinessCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Business>>;
};

export type BusinessFilter = {
  businessAgencyAffiliated?: InputMaybe<Array<BooleanFilter>>;
  businessCountryCode?: InputMaybe<Array<StringFilter>>;
  businessId?: InputMaybe<Array<IdFilter>>;
  businessName?: InputMaybe<Array<StringFilter>>;
  businessPhone?: InputMaybe<Array<StringFilter>>;
  businessWebsiteUrl?: InputMaybe<Array<StringFilter>>;
  industryId?: InputMaybe<Array<IdFilter>>;
};

export type BusinessOrderBy = {
  column: BusinessOrderByColumn;
  direction?: OrderByDirection;
};

export enum BusinessOrderByColumn {
  BusinessAgencyAffiliated = 'businessAgencyAffiliated',
  BusinessCountryCode = 'businessCountryCode',
  BusinessId = 'businessId',
  BusinessName = 'businessName',
  IndustryId = 'industryId'
}

export type Campaign = {
  __typename?: 'Campaign';
  adAccountCurrency?: Maybe<Scalars['String']>;
  campaignAutopilots?: Maybe<Array<CampaignAutopilot>>;
  campaignChangelog?: Maybe<CampaignChangelog>;
  campaignCreatedAt: Scalars['DateTime'];
  campaignDeletedAt?: Maybe<Scalars['DateTime']>;
  campaignEffectiveStatus?: Maybe<CampaignEffectiveStatus>;
  campaignGhost: Scalars['Boolean'];
  campaignHasErrors: Scalars['Boolean'];
  campaignHash?: Maybe<Scalars['String']>;
  campaignId: Scalars['ID'];
  campaignImportedAt?: Maybe<Scalars['DateTime']>;
  campaignModificationTime?: Maybe<Scalars['DateTime']>;
  campaignName: Scalars['String'];
  campaignObjective: CampaignObjective;
  campaignSpecialAdCategories?: Maybe<Array<Maybe<CampaignSpecialAdCategory>>>;
  campaignSpendCap?: Maybe<Scalars['BigInt']>;
  campaignStatus?: Maybe<CampaignStatus>;
  campaignStatusPending?: Maybe<CampaignStatus>;
  campaignUpdatedAt: Scalars['DateTime'];
  client: Client;
  externalCampaignId?: Maybe<Scalars['ID']>;
  fundingInstrument?: Maybe<FundingInstrument>;
  groups?: Maybe<Array<Group>>;
  stats?: Maybe<Array<Maybe<Stats>>>;
};


export type CampaignCampaignAutopilotsArgs = {
  filters?: InputMaybe<CampaignAutopilotFilter>;
  orderBy?: InputMaybe<Array<InputMaybe<CampaignAutopilotFilter>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type CampaignCampaignChangelogArgs = {
  filters: CampaignChangelogSubQueryFilter;
};


export type CampaignGroupsArgs = {
  filters?: InputMaybe<GroupFilter>;
  orderBy?: InputMaybe<Array<InputMaybe<GroupOrderBy>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type CampaignStatsArgs = {
  filters?: InputMaybe<StatsFilter>;
  orderBy?: InputMaybe<Array<InputMaybe<StatsOrderBy>>>;
  query?: InputMaybe<Scalars['String']>;
};

export type CampaignAutopilot = {
  __typename?: 'CampaignAutopilot';
  campaign: Campaign;
  campaignAutopilotActivatedAt?: Maybe<Scalars['DateTime']>;
  campaignAutopilotCreatedAt: Scalars['DateTime'];
  campaignAutopilotDeletedAt?: Maybe<Scalars['DateTime']>;
  campaignAutopilotId: Scalars['ID'];
  campaignAutopilotLastRun?: Maybe<Scalars['DateTime']>;
  campaignAutopilotStatus: AutopilotStatus;
  campaignAutopilotTargetEvent: CampaignAutopilotTargetEvent;
  campaignAutopilotTotalGoalAmount: Scalars['Int'];
  campaignAutopilotUpdatedAt?: Maybe<Scalars['DateTime']>;
};

export type CampaignAutopilotCursored = {
  __typename?: 'CampaignAutopilotCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<CampaignAutopilot>>;
};

export type CampaignAutopilotFilter = {
  campaignAutopilotId?: InputMaybe<Array<IdFilter>>;
  campaignAutopilotStatus?: InputMaybe<Array<AutopilotStatusFilter>>;
  campaignAutopilotTargetEvent?: InputMaybe<Array<CampaignAutopilotTargetEventFilter>>;
  campaignId?: InputMaybe<Array<IdFilter>>;
};

export type CampaignAutopilotOrderBy = {
  column: CampaignAutopilotOrderByColumn;
  direction?: OrderByDirection;
};

export enum CampaignAutopilotOrderByColumn {
  CampaignAutopilotId = 'campaignAutopilotId',
  CampaignAutopilotLastRun = 'campaignAutopilotLastRun',
  CampaignAutopilotStatus = 'campaignAutopilotStatus',
  CampaignAutopilotTargetEvent = 'campaignAutopilotTargetEvent',
  CampaignAutopilotTotalGoalAmount = 'campaignAutopilotTotalGoalAmount',
  CampaignId = 'campaignId'
}

export enum CampaignAutopilotTargetEvent {
  AddToCartCD = 'ADD_TO_CART_C_D',
  AddToCartCM = 'ADD_TO_CART_C_M',
  AddToCartCW = 'ADD_TO_CART_C_W',
  AddToCartVD = 'ADD_TO_CART_V_D',
  AddToCartVM = 'ADD_TO_CART_V_M',
  AddToCartVW = 'ADD_TO_CART_V_W',
  AddToWishlistCD = 'ADD_TO_WISHLIST_C_D',
  AddToWishlistCM = 'ADD_TO_WISHLIST_C_M',
  AddToWishlistCW = 'ADD_TO_WISHLIST_C_W',
  AddToWishlistVD = 'ADD_TO_WISHLIST_V_D',
  AddToWishlistVM = 'ADD_TO_WISHLIST_V_M',
  AddToWishlistVW = 'ADD_TO_WISHLIST_V_W',
  AppInstallMetricsAddPaymentInfo = 'APP_INSTALL_METRICS_ADD_PAYMENT_INFO',
  AppInstallMetricsAddToCart = 'APP_INSTALL_METRICS_ADD_TO_CART',
  AppInstallMetricsAppLaunch = 'APP_INSTALL_METRICS_APP_LAUNCH',
  AppInstallMetricsCompletedTutorial = 'APP_INSTALL_METRICS_COMPLETED_TUTORIAL',
  AppInstallMetricsInstall = 'APP_INSTALL_METRICS_INSTALL',
  AppInstallMetricsLevelAchieved = 'APP_INSTALL_METRICS_LEVEL_ACHIEVED',
  AppInstallMetricsPurchase = 'APP_INSTALL_METRICS_PURCHASE',
  AppInstallMetricsSearch = 'APP_INSTALL_METRICS_SEARCH',
  AppInstallMetricsSignUp = 'APP_INSTALL_METRICS_SIGN_UP',
  AppInstallMetricsSpend = 'APP_INSTALL_METRICS_SPEND',
  AppInstallMetricsSpendCredits = 'APP_INSTALL_METRICS_SPEND_CREDITS',
  AppInstallMetricsViewContent = 'APP_INSTALL_METRICS_VIEW_CONTENT',
  Clicks = 'CLICKS',
  CommentsPageViews = 'COMMENTS_PAGE_VIEWS',
  CommentDownvotes = 'COMMENT_DOWNVOTES',
  CommentUpvotes = 'COMMENT_UPVOTES',
  ConversionAddToCartTotalItems = 'CONVERSION_ADD_TO_CART_TOTAL_ITEMS',
  ConversionAddToCartTotalValue = 'CONVERSION_ADD_TO_CART_TOTAL_VALUE',
  ConversionAddToWishlistTotalItems = 'CONVERSION_ADD_TO_WISHLIST_TOTAL_ITEMS',
  ConversionAddToWishlistTotalValue = 'CONVERSION_ADD_TO_WISHLIST_TOTAL_VALUE',
  ConversionLeadTotalValue = 'CONVERSION_LEAD_TOTAL_VALUE',
  ConversionPurchaseTotalItems = 'CONVERSION_PURCHASE_TOTAL_ITEMS',
  ConversionPurchaseTotalValue = 'CONVERSION_PURCHASE_TOTAL_VALUE',
  ConversionSignupTotalValue = 'CONVERSION_SIGNUP_TOTAL_VALUE',
  CustomCD = 'CUSTOM_C_D',
  CustomCM = 'CUSTOM_C_M',
  CustomCW = 'CUSTOM_C_W',
  CustomVD = 'CUSTOM_V_D',
  CustomVM = 'CUSTOM_V_M',
  CustomVW = 'CUSTOM_V_W',
  Impressions = 'IMPRESSIONS',
  LeadCD = 'LEAD_C_D',
  LeadCM = 'LEAD_C_M',
  LeadCW = 'LEAD_C_W',
  LeadVD = 'LEAD_V_D',
  LeadVM = 'LEAD_V_M',
  LeadVW = 'LEAD_V_W',
  LegacyClickConversionsD = 'LEGACY_CLICK_CONVERSIONS_D',
  LegacyClickConversionsM = 'LEGACY_CLICK_CONVERSIONS_M',
  LegacyClickConversionsW = 'LEGACY_CLICK_CONVERSIONS_W',
  LegacyViewConversionsD = 'LEGACY_VIEW_CONVERSIONS_D',
  LegacyViewConversionsM = 'LEGACY_VIEW_CONVERSIONS_M',
  LegacyViewConversionsW = 'LEGACY_VIEW_CONVERSIONS_W',
  PageVisitCD = 'PAGE_VISIT_C_D',
  PageVisitCM = 'PAGE_VISIT_C_M',
  PageVisitCW = 'PAGE_VISIT_C_W',
  PageVisitVD = 'PAGE_VISIT_V_D',
  PageVisitVM = 'PAGE_VISIT_V_M',
  PageVisitVW = 'PAGE_VISIT_V_W',
  PurchaseCD = 'PURCHASE_C_D',
  PurchaseCM = 'PURCHASE_C_M',
  PurchaseCW = 'PURCHASE_C_W',
  PurchaseVD = 'PURCHASE_V_D',
  PurchaseVM = 'PURCHASE_V_M',
  PurchaseVW = 'PURCHASE_V_W',
  SearchCD = 'SEARCH_C_D',
  SearchCM = 'SEARCH_C_M',
  SearchCW = 'SEARCH_C_W',
  SearchVD = 'SEARCH_V_D',
  SearchVM = 'SEARCH_V_M',
  SearchVW = 'SEARCH_V_W',
  SignUpCD = 'SIGN_UP_C_D',
  SignUpCW = 'SIGN_UP_C_W',
  SignUpVD = 'SIGN_UP_V_D',
  SignUpVM = 'SIGN_UP_V_M',
  SignUpVW = 'SIGN_UP_V_W',
  Unknown = 'UNKNOWN',
  VideoFullyViewableImpressions = 'VIDEO_FULLY_VIEWABLE_IMPRESSIONS',
  VideoPlaysExpanded = 'VIDEO_PLAYS_EXPANDED',
  VideoPlaysWithSound = 'VIDEO_PLAYS_WITH_SOUND',
  VideoStarted = 'VIDEO_STARTED',
  VideoViewableImpressions = 'VIDEO_VIEWABLE_IMPRESSIONS',
  VideoWatched_3Seconds = 'VIDEO_WATCHED_3_SECONDS',
  VideoWatched_5Seconds = 'VIDEO_WATCHED_5_SECONDS',
  VideoWatched_10Seconds = 'VIDEO_WATCHED_10_SECONDS',
  VideoWatched_25Percent = 'VIDEO_WATCHED_25_PERCENT',
  VideoWatched_50Percent = 'VIDEO_WATCHED_50_PERCENT',
  VideoWatched_75Percent = 'VIDEO_WATCHED_75_PERCENT',
  VideoWatched_95Percent = 'VIDEO_WATCHED_95_PERCENT',
  VideoWatched_100Percent = 'VIDEO_WATCHED_100_PERCENT',
  ViewableImpressions = 'VIEWABLE_IMPRESSIONS',
  ViewerComments = 'VIEWER_COMMENTS',
  ViewContentCD = 'VIEW_CONTENT_C_D',
  ViewContentCM = 'VIEW_CONTENT_C_M',
  ViewContentCW = 'VIEW_CONTENT_C_W',
  ViewContentVD = 'VIEW_CONTENT_V_D',
  ViewContentVM = 'VIEW_CONTENT_V_M',
  ViewContentVW = 'VIEW_CONTENT_V_W'
}

export type CampaignAutopilotTargetEventFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<CampaignAutopilotTargetEvent>;
};

export type CampaignChangelog = {
  __typename?: 'CampaignChangelog';
  campaignId?: Maybe<Scalars['ID']>;
  changelogs?: Maybe<Array<Maybe<Changelog>>>;
};

export type CampaignChangelogFilter = {
  campaignId: SingleIdFilter;
  differenceFields: CampaignDifferencesFilter;
  modificationTime?: InputMaybe<DateRangeFilter>;
};

export type CampaignChangelogSubQueryFilter = {
  differenceFields: CampaignDifferencesFilter;
  modificationTime?: InputMaybe<DateRangeFilter>;
};

export type CampaignCursored = {
  __typename?: 'CampaignCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Campaign>>;
};

export enum CampaignDifferencesFields {
  CampaignName = 'campaignName',
  CampaignObjective = 'campaignObjective',
  CampaignReEffectiveStatus = 'campaignReEffectiveStatus',
  CampaignReStatus = 'campaignReStatus',
  CampaignReStatusPending = 'campaignReStatusPending',
  CampaignStatus = 'campaignStatus'
}

export type CampaignDifferencesFilter = {
  value: Array<CampaignDifferencesFields>;
};

export enum CampaignEffectiveStatus {
  Active = 'ACTIVE',
  AdGroupPaused = 'AD_GROUP_PAUSED',
  Archived = 'ARCHIVED',
  CampaignPaused = 'CAMPAIGN_PAUSED',
  Completed = 'COMPLETED',
  Deleted = 'DELETED',
  Paused = 'PAUSED',
  PendingApproval = 'PENDING_APPROVAL',
  PendingBillingInfo = 'PENDING_BILLING_INFO',
  PendingIdVerification = 'PENDING_ID_VERIFICATION',
  /**  Legacy value, left it here for backward compatibility  */
  PendingReview = 'PENDING_REVIEW',
  Rejected = 'REJECTED',
  Unknown = 'UNKNOWN'
}

export type CampaignEffectiveStatusFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<CampaignEffectiveStatus>;
};

export type CampaignFilter = {
  adAccountId?: InputMaybe<Array<IdFilter>>;
  adAccountName?: InputMaybe<Array<StringFilter>>;
  adId?: InputMaybe<Array<IdFilter>>;
  adName?: InputMaybe<Array<StringFilter>>;
  adStatus?: InputMaybe<Array<AdStatusFilter>>;
  campaignEffectiveStatus?: InputMaybe<Array<CampaignEffectiveStatusFilter>>;
  campaignGhost?: InputMaybe<Array<BooleanFilter>>;
  campaignHasErrors?: InputMaybe<Array<BooleanFilter>>;
  campaignId?: InputMaybe<Array<IdFilter>>;
  campaignName?: InputMaybe<Array<StringFilter>>;
  campaignObjective?: InputMaybe<Array<CampaignObjectiveFilter>>;
  campaignStatus?: InputMaybe<Array<CampaignStatusFilter>>;
  clientId?: InputMaybe<Array<IdFilter>>;
  clientName?: InputMaybe<Array<StringFilter>>;
  clientStatus?: InputMaybe<Array<ClientStatusFilter>>;
  creativeId?: InputMaybe<Array<IdFilter>>;
  externalCampaignId?: InputMaybe<Array<IdFilter>>;
  groupId?: InputMaybe<Array<IdFilter>>;
  groupName?: InputMaybe<Array<StringFilter>>;
  groupStatus?: InputMaybe<Array<GroupStatusFilter>>;
};

export type CampaignLive = {
  __typename?: 'CampaignLive';
  adAccountId?: Maybe<Scalars['ID']>;
  campaignCreatedAt?: Maybe<Scalars['DateTime']>;
  campaignEffectiveStatus?: Maybe<CampaignEffectiveStatus>;
  campaignId?: Maybe<Scalars['ID']>;
  campaignModifiedAt?: Maybe<Scalars['DateTime']>;
  campaignName?: Maybe<Scalars['String']>;
  campaignObjective?: Maybe<CampaignObjective>;
  campaignStatus?: Maybe<CampaignStatus>;
};

export type CampaignLiveFilter = {
  adAccountId: SingleIdRealmFilter;
};

export enum CampaignObjective {
  AppInstalls = 'APP_INSTALLS',
  CatalogSales = 'CATALOG_SALES',
  Clicks = 'CLICKS',
  Conversions = 'CONVERSIONS',
  Impressions = 'IMPRESSIONS',
  LeadGeneration = 'LEAD_GENERATION',
  Unknown = 'UNKNOWN',
  VideoViewableImpressions = 'VIDEO_VIEWABLE_IMPRESSIONS'
}

export type CampaignObjectiveFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<CampaignObjective>;
};

export type CampaignOrderBy = {
  column: CampaignOrderByColumn;
  direction?: OrderByDirection;
};

export enum CampaignOrderByColumn {
  AdId = 'adId',
  AddToCartClickThroughConversionsAttributionWindowDay = 'addToCartClickThroughConversionsAttributionWindowDay',
  AddToCartClickThroughConversionsAttributionWindowMonth = 'addToCartClickThroughConversionsAttributionWindowMonth',
  AddToCartClickThroughConversionsAttributionWindowWeek = 'addToCartClickThroughConversionsAttributionWindowWeek',
  AddToCartViewThroughConversionsAttributionWindowDay = 'addToCartViewThroughConversionsAttributionWindowDay',
  AddToCartViewThroughConversionsAttributionWindowMonth = 'addToCartViewThroughConversionsAttributionWindowMonth',
  AddToCartViewThroughConversionsAttributionWindowWeek = 'addToCartViewThroughConversionsAttributionWindowWeek',
  AddToWishlistClickThroughConversionsAttributionWindowDay = 'addToWishlistClickThroughConversionsAttributionWindowDay',
  AddToWishlistClickThroughConversionsAttributionWindowMonth = 'addToWishlistClickThroughConversionsAttributionWindowMonth',
  AddToWishlistClickThroughConversionsAttributionWindowWeek = 'addToWishlistClickThroughConversionsAttributionWindowWeek',
  AddToWishlistViewThroughConversionsAttributionWindowDay = 'addToWishlistViewThroughConversionsAttributionWindowDay',
  AddToWishlistViewThroughConversionsAttributionWindowMonth = 'addToWishlistViewThroughConversionsAttributionWindowMonth',
  AddToWishlistViewThroughConversionsAttributionWindowWeek = 'addToWishlistViewThroughConversionsAttributionWindowWeek',
  AppInstallMetricsAddPaymentInfo = 'appInstallMetricsAddPaymentInfo',
  AppInstallMetricsAddToCart = 'appInstallMetricsAddToCart',
  AppInstallMetricsAppLaunch = 'appInstallMetricsAppLaunch',
  AppInstallMetricsCompletedTutorial = 'appInstallMetricsCompletedTutorial',
  AppInstallMetricsInstall = 'appInstallMetricsInstall',
  AppInstallMetricsLevelAchieved = 'appInstallMetricsLevelAchieved',
  AppInstallMetricsPurchase = 'appInstallMetricsPurchase',
  AppInstallMetricsSearch = 'appInstallMetricsSearch',
  AppInstallMetricsSignUp = 'appInstallMetricsSignUp',
  AppInstallMetricsSpend = 'appInstallMetricsSpend',
  AppInstallMetricsSpendCredits = 'appInstallMetricsSpendCredits',
  AppInstallMetricsViewContent = 'appInstallMetricsViewContent',
  CampaignCreatedAt = 'campaignCreatedAt',
  CampaignEffectiveStatus = 'campaignEffectiveStatus',
  CampaignId = 'campaignId',
  CampaignObjective = 'campaignObjective',
  CampaignStatus = 'campaignStatus',
  CampaignUpdatedAt = 'campaignUpdatedAt',
  Clicks = 'clicks',
  CommentDownvotes = 'commentDownvotes',
  CommentUpvotes = 'commentUpvotes',
  CommentsPageViews = 'commentsPageViews',
  Community = 'community',
  ConversionAddToCartAvgValue = 'conversionAddToCartAvgValue',
  ConversionAddToCartTotalItems = 'conversionAddToCartTotalItems',
  ConversionAddToCartTotalValue = 'conversionAddToCartTotalValue',
  ConversionAddToWishlistAvgValue = 'conversionAddToWishlistAvgValue',
  ConversionAddToWishlistTotalItems = 'conversionAddToWishlistTotalItems',
  ConversionAddToWishlistTotalValue = 'conversionAddToWishlistTotalValue',
  ConversionLeadTotalValue = 'conversionLeadTotalValue',
  ConversionPurchaseAvgValue = 'conversionPurchaseAvgValue',
  ConversionPurchaseTotalItems = 'conversionPurchaseTotalItems',
  ConversionPurchaseTotalValue = 'conversionPurchaseTotalValue',
  ConversionRoas = 'conversionRoas',
  ConversionSignupTotalValue = 'conversionSignupTotalValue',
  Country = 'country',
  Cpc = 'cpc',
  Ctr = 'ctr',
  CustomClickThroughConversionsAttributionWindowDay = 'customClickThroughConversionsAttributionWindowDay',
  CustomClickThroughConversionsAttributionWindowMonth = 'customClickThroughConversionsAttributionWindowMonth',
  CustomClickThroughConversionsAttributionWindowWeek = 'customClickThroughConversionsAttributionWindowWeek',
  CustomViewThroughConversionsAttributionWindowDay = 'customViewThroughConversionsAttributionWindowDay',
  CustomViewThroughConversionsAttributionWindowMonth = 'customViewThroughConversionsAttributionWindowMonth',
  CustomViewThroughConversionsAttributionWindowWeek = 'customViewThroughConversionsAttributionWindowWeek',
  /** Statistics */
  Date = 'date',
  DayOfMonth = 'dayOfMonth',
  Ecpm = 'ecpm',
  ExternalAdAccountId = 'externalAdAccountId',
  ExternalAdId = 'externalAdId',
  ExternalCampaignId = 'externalCampaignId',
  ExternalGroupId = 'externalGroupId',
  GroupId = 'groupId',
  Impressions = 'impressions',
  Interest = 'interest',
  LeadClickThroughConversionsAttributionWindowDay = 'leadClickThroughConversionsAttributionWindowDay',
  LeadClickThroughConversionsAttributionWindowMonth = 'leadClickThroughConversionsAttributionWindowMonth',
  LeadClickThroughConversionsAttributionWindowWeek = 'leadClickThroughConversionsAttributionWindowWeek',
  LeadViewThroughConversionsAttributionWindowDay = 'leadViewThroughConversionsAttributionWindowDay',
  LeadViewThroughConversionsAttributionWindowMonth = 'leadViewThroughConversionsAttributionWindowMonth',
  LeadViewThroughConversionsAttributionWindowWeek = 'leadViewThroughConversionsAttributionWindowWeek',
  LegacyClickConversionsAttributionWindowDay = 'legacyClickConversionsAttributionWindowDay',
  LegacyClickConversionsAttributionWindowMonth = 'legacyClickConversionsAttributionWindowMonth',
  LegacyClickConversionsAttributionWindowWeek = 'legacyClickConversionsAttributionWindowWeek',
  LegacyViewConversionsAttributionWindowDay = 'legacyViewConversionsAttributionWindowDay',
  LegacyViewConversionsAttributionWindowMonth = 'legacyViewConversionsAttributionWindowMonth',
  LegacyViewConversionsAttributionWindowWeek = 'legacyViewConversionsAttributionWindowWeek',
  Metro = 'metro',
  MonthName = 'monthName',
  MonthNumber = 'monthNumber',
  PageVisitClickThroughConversionsAttributionWindowDay = 'pageVisitClickThroughConversionsAttributionWindowDay',
  PageVisitClickThroughConversionsAttributionWindowMonth = 'pageVisitClickThroughConversionsAttributionWindowMonth',
  PageVisitClickThroughConversionsAttributionWindowWeek = 'pageVisitClickThroughConversionsAttributionWindowWeek',
  PageVisitViewThroughConversionsAttributionWindowDay = 'pageVisitViewThroughConversionsAttributionWindowDay',
  PageVisitViewThroughConversionsAttributionWindowMonth = 'pageVisitViewThroughConversionsAttributionWindowMonth',
  PageVisitViewThroughConversionsAttributionWindowWeek = 'pageVisitViewThroughConversionsAttributionWindowWeek',
  Placement = 'placement',
  PurchaseClickThroughConversionsAttributionWindowDay = 'purchaseClickThroughConversionsAttributionWindowDay',
  PurchaseClickThroughConversionsAttributionWindowMonth = 'purchaseClickThroughConversionsAttributionWindowMonth',
  PurchaseClickThroughConversionsAttributionWindowWeek = 'purchaseClickThroughConversionsAttributionWindowWeek',
  PurchaseViewThroughConversionsAttributionWindowDay = 'purchaseViewThroughConversionsAttributionWindowDay',
  PurchaseViewThroughConversionsAttributionWindowMonth = 'purchaseViewThroughConversionsAttributionWindowMonth',
  PurchaseViewThroughConversionsAttributionWindowWeek = 'purchaseViewThroughConversionsAttributionWindowWeek',
  Quarter = 'quarter',
  Region = 'region',
  SearchClickThroughConversionsAttributionWindowDay = 'searchClickThroughConversionsAttributionWindowDay',
  SearchClickThroughConversionsAttributionWindowMonth = 'searchClickThroughConversionsAttributionWindowMonth',
  SearchClickThroughConversionsAttributionWindowWeek = 'searchClickThroughConversionsAttributionWindowWeek',
  SearchViewThroughConversionsAttributionWindowDay = 'searchViewThroughConversionsAttributionWindowDay',
  SearchViewThroughConversionsAttributionWindowMonth = 'searchViewThroughConversionsAttributionWindowMonth',
  SearchViewThroughConversionsAttributionWindowWeek = 'searchViewThroughConversionsAttributionWindowWeek',
  SignUpClickThroughConversionsAttributionWindowDay = 'signUpClickThroughConversionsAttributionWindowDay',
  SignUpClickThroughConversionsAttributionWindowMonth = 'signUpClickThroughConversionsAttributionWindowMonth',
  SignUpClickThroughConversionsAttributionWindowWeek = 'signUpClickThroughConversionsAttributionWindowWeek',
  SignUpViewThroughConversionsAttributionWindowDay = 'signUpViewThroughConversionsAttributionWindowDay',
  SignUpViewThroughConversionsAttributionWindowMonth = 'signUpViewThroughConversionsAttributionWindowMonth',
  SignUpViewThroughConversionsAttributionWindowWeek = 'signUpViewThroughConversionsAttributionWindowWeek',
  Spend = 'spend',
  VideoFullyViewableImpressions = 'videoFullyViewableImpressions',
  VideoPlaysExpanded = 'videoPlaysExpanded',
  VideoPlaysWithSound = 'videoPlaysWithSound',
  VideoStarted = 'videoStarted',
  VideoViewableImpressions = 'videoViewableImpressions',
  VideoWatched3Seconds = 'videoWatched3Seconds',
  VideoWatched5Seconds = 'videoWatched5Seconds',
  VideoWatched10Seconds = 'videoWatched10Seconds',
  VideoWatched25Percent = 'videoWatched25Percent',
  VideoWatched50Percent = 'videoWatched50Percent',
  VideoWatched75Percent = 'videoWatched75Percent',
  VideoWatched95Percent = 'videoWatched95Percent',
  VideoWatched100Percent = 'videoWatched100Percent',
  ViewContentClickThroughConversionsAttributionWindowDay = 'viewContentClickThroughConversionsAttributionWindowDay',
  ViewContentClickThroughConversionsAttributionWindowMonth = 'viewContentClickThroughConversionsAttributionWindowMonth',
  ViewContentClickThroughConversionsAttributionWindowWeek = 'viewContentClickThroughConversionsAttributionWindowWeek',
  ViewContentViewThroughConversionsAttributionWindowDay = 'viewContentViewThroughConversionsAttributionWindowDay',
  ViewContentViewThroughConversionsAttributionWindowMonth = 'viewContentViewThroughConversionsAttributionWindowMonth',
  ViewContentViewThroughConversionsAttributionWindowWeek = 'viewContentViewThroughConversionsAttributionWindowWeek',
  ViewableImpressions = 'viewableImpressions',
  ViewerComments = 'viewerComments',
  WeekNumber = 'weekNumber',
  WeekdayName = 'weekdayName',
  WeekdayNumber = 'weekdayNumber',
  Year = 'year',
  YearMonth = 'yearMonth'
}

export enum CampaignSpecialAdCategory {
  HousingEmploymentCredit = 'HOUSING_EMPLOYMENT_CREDIT',
  None = 'NONE',
  Unknown = 'UNKNOWN'
}

export enum CampaignStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Deleted = 'DELETED',
  Paused = 'PAUSED',
  Unknown = 'UNKNOWN'
}

export type CampaignStatusFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<CampaignStatus>;
};

export type Changelog = {
  __typename?: 'Changelog';
  differences?: Maybe<Array<Maybe<Difference>>>;
  modificationTime?: Maybe<Scalars['DateTime']>;
  modifierId?: Maybe<Scalars['ID']>;
  modifierLevel?: Maybe<Scalars['String']>;
  modifierName?: Maybe<Scalars['String']>;
};

export type Client = {
  __typename?: 'Client';
  adAccount: AdAccount;
  adAccountCurrency?: Maybe<Scalars['String']>;
  adAccountName?: Maybe<Scalars['String']>;
  agencyAccount?: Maybe<AgencyAccount>;
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
  clientBreakdown?: Maybe<Scalars['String']>;
  clientCreatedAt: Scalars['DateTime'];
  clientDeletedAt?: Maybe<Scalars['DateTime']>;
  clientId: Scalars['ID'];
  clientKpi?: Maybe<Scalars['String']>;
  clientModificationTime?: Maybe<Scalars['DateTime']>;
  clientName?: Maybe<Scalars['String']>;
  clientPinned: Scalars['Boolean'];
  clientProfilePictureUrl?: Maybe<Scalars['String']>;
  clientStatus: ClientStatus;
  notifications?: Maybe<Array<Notification>>;
  stats?: Maybe<Array<Maybe<Stats>>>;
  userGroups?: Maybe<Array<UserGroup>>;
  users?: Maybe<Array<ClientUser>>;
};


export type ClientCampaignsArgs = {
  filters?: InputMaybe<CampaignFilter>;
  orderBy?: InputMaybe<Array<InputMaybe<CampaignOrderBy>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type ClientNotificationsArgs = {
  filters?: InputMaybe<NotificationFilter>;
  orderBy?: InputMaybe<Array<InputMaybe<NotificationOrderBy>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type ClientStatsArgs = {
  filters?: InputMaybe<StatsFilter>;
  orderBy?: InputMaybe<Array<InputMaybe<StatsOrderBy>>>;
  query?: InputMaybe<Scalars['String']>;
};

export type ClientCursored = {
  __typename?: 'ClientCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Client>>;
};

export type ClientFilter = {
  adAccountName?: InputMaybe<Array<StringFilter>>;
  adId?: InputMaybe<Array<IdFilter>>;
  adName?: InputMaybe<Array<StringFilter>>;
  adStatus?: InputMaybe<Array<AdStatusFilter>>;
  agencyAccountId?: InputMaybe<Array<IdFilter>>;
  campaignId?: InputMaybe<Array<IdFilter>>;
  campaignName?: InputMaybe<Array<StringFilter>>;
  campaignStatus?: InputMaybe<Array<CampaignStatusFilter>>;
  clientId?: InputMaybe<Array<IdFilter>>;
  clientName?: InputMaybe<Array<StringFilter>>;
  clientStatus?: InputMaybe<Array<ClientStatusFilter>>;
  creativeId?: InputMaybe<Array<IdFilter>>;
  groupId?: InputMaybe<Array<IdFilter>>;
  groupName?: InputMaybe<Array<StringFilter>>;
  groupStatus?: InputMaybe<Array<GroupStatusFilter>>;
  userGroupId?: InputMaybe<Array<IdFilter>>;
  userId?: InputMaybe<Array<IdFilter>>;
};

export type ClientOrderBy = {
  column: ClientOrderByColumn;
  direction?: OrderByDirection;
};

export enum ClientOrderByColumn {
  AdAccountType = 'adAccountType',
  AdId = 'adId',
  AddToCartClickThroughConversionsAttributionWindowDay = 'addToCartClickThroughConversionsAttributionWindowDay',
  AddToCartClickThroughConversionsAttributionWindowMonth = 'addToCartClickThroughConversionsAttributionWindowMonth',
  AddToCartClickThroughConversionsAttributionWindowWeek = 'addToCartClickThroughConversionsAttributionWindowWeek',
  AddToCartViewThroughConversionsAttributionWindowDay = 'addToCartViewThroughConversionsAttributionWindowDay',
  AddToCartViewThroughConversionsAttributionWindowMonth = 'addToCartViewThroughConversionsAttributionWindowMonth',
  AddToCartViewThroughConversionsAttributionWindowWeek = 'addToCartViewThroughConversionsAttributionWindowWeek',
  AddToWishlistClickThroughConversionsAttributionWindowDay = 'addToWishlistClickThroughConversionsAttributionWindowDay',
  AddToWishlistClickThroughConversionsAttributionWindowMonth = 'addToWishlistClickThroughConversionsAttributionWindowMonth',
  AddToWishlistClickThroughConversionsAttributionWindowWeek = 'addToWishlistClickThroughConversionsAttributionWindowWeek',
  AddToWishlistViewThroughConversionsAttributionWindowDay = 'addToWishlistViewThroughConversionsAttributionWindowDay',
  AddToWishlistViewThroughConversionsAttributionWindowMonth = 'addToWishlistViewThroughConversionsAttributionWindowMonth',
  AddToWishlistViewThroughConversionsAttributionWindowWeek = 'addToWishlistViewThroughConversionsAttributionWindowWeek',
  AppInstallMetricsAddPaymentInfo = 'appInstallMetricsAddPaymentInfo',
  AppInstallMetricsAddToCart = 'appInstallMetricsAddToCart',
  AppInstallMetricsAppLaunch = 'appInstallMetricsAppLaunch',
  AppInstallMetricsCompletedTutorial = 'appInstallMetricsCompletedTutorial',
  AppInstallMetricsInstall = 'appInstallMetricsInstall',
  AppInstallMetricsLevelAchieved = 'appInstallMetricsLevelAchieved',
  AppInstallMetricsPurchase = 'appInstallMetricsPurchase',
  AppInstallMetricsSearch = 'appInstallMetricsSearch',
  AppInstallMetricsSignUp = 'appInstallMetricsSignUp',
  AppInstallMetricsSpend = 'appInstallMetricsSpend',
  AppInstallMetricsSpendCredits = 'appInstallMetricsSpendCredits',
  AppInstallMetricsViewContent = 'appInstallMetricsViewContent',
  CampaignId = 'campaignId',
  Clicks = 'clicks',
  ClientCreatedAt = 'clientCreatedAt',
  ClientDeletedAt = 'clientDeletedAt',
  ClientId = 'clientId',
  ClientModificationTime = 'clientModificationTime',
  ClientPinned = 'clientPinned',
  CommentDownvotes = 'commentDownvotes',
  CommentUpvotes = 'commentUpvotes',
  CommentsPageViews = 'commentsPageViews',
  Community = 'community',
  ConversionAddToCartAvgValue = 'conversionAddToCartAvgValue',
  ConversionAddToCartTotalItems = 'conversionAddToCartTotalItems',
  ConversionAddToCartTotalValue = 'conversionAddToCartTotalValue',
  ConversionAddToWishlistAvgValue = 'conversionAddToWishlistAvgValue',
  ConversionAddToWishlistTotalItems = 'conversionAddToWishlistTotalItems',
  ConversionAddToWishlistTotalValue = 'conversionAddToWishlistTotalValue',
  ConversionLeadTotalValue = 'conversionLeadTotalValue',
  ConversionPurchaseAvgValue = 'conversionPurchaseAvgValue',
  ConversionPurchaseTotalItems = 'conversionPurchaseTotalItems',
  ConversionPurchaseTotalValue = 'conversionPurchaseTotalValue',
  ConversionRoas = 'conversionRoas',
  ConversionSignupTotalValue = 'conversionSignupTotalValue',
  Country = 'country',
  Cpc = 'cpc',
  Ctr = 'ctr',
  CustomClickThroughConversionsAttributionWindowDay = 'customClickThroughConversionsAttributionWindowDay',
  CustomClickThroughConversionsAttributionWindowMonth = 'customClickThroughConversionsAttributionWindowMonth',
  CustomClickThroughConversionsAttributionWindowWeek = 'customClickThroughConversionsAttributionWindowWeek',
  CustomViewThroughConversionsAttributionWindowDay = 'customViewThroughConversionsAttributionWindowDay',
  CustomViewThroughConversionsAttributionWindowMonth = 'customViewThroughConversionsAttributionWindowMonth',
  CustomViewThroughConversionsAttributionWindowWeek = 'customViewThroughConversionsAttributionWindowWeek',
  Date = 'date',
  /** Statistics */
  DayOfMonth = 'dayOfMonth',
  Ecpm = 'ecpm',
  ExternalAdAccountId = 'externalAdAccountId',
  ExternalAdId = 'externalAdId',
  ExternalCampaignId = 'externalCampaignId',
  ExternalGroupId = 'externalGroupId',
  GroupId = 'groupId',
  Impressions = 'impressions',
  Interest = 'interest',
  LeadClickThroughConversionsAttributionWindowDay = 'leadClickThroughConversionsAttributionWindowDay',
  LeadClickThroughConversionsAttributionWindowMonth = 'leadClickThroughConversionsAttributionWindowMonth',
  LeadClickThroughConversionsAttributionWindowWeek = 'leadClickThroughConversionsAttributionWindowWeek',
  LeadViewThroughConversionsAttributionWindowDay = 'leadViewThroughConversionsAttributionWindowDay',
  LeadViewThroughConversionsAttributionWindowMonth = 'leadViewThroughConversionsAttributionWindowMonth',
  LeadViewThroughConversionsAttributionWindowWeek = 'leadViewThroughConversionsAttributionWindowWeek',
  LegacyClickConversionsAttributionWindowDay = 'legacyClickConversionsAttributionWindowDay',
  LegacyClickConversionsAttributionWindowMonth = 'legacyClickConversionsAttributionWindowMonth',
  LegacyClickConversionsAttributionWindowWeek = 'legacyClickConversionsAttributionWindowWeek',
  LegacyViewConversionsAttributionWindowDay = 'legacyViewConversionsAttributionWindowDay',
  LegacyViewConversionsAttributionWindowMonth = 'legacyViewConversionsAttributionWindowMonth',
  LegacyViewConversionsAttributionWindowWeek = 'legacyViewConversionsAttributionWindowWeek',
  Metro = 'metro',
  MonthName = 'monthName',
  MonthNumber = 'monthNumber',
  PageVisitClickThroughConversionsAttributionWindowDay = 'pageVisitClickThroughConversionsAttributionWindowDay',
  PageVisitClickThroughConversionsAttributionWindowMonth = 'pageVisitClickThroughConversionsAttributionWindowMonth',
  PageVisitClickThroughConversionsAttributionWindowWeek = 'pageVisitClickThroughConversionsAttributionWindowWeek',
  PageVisitViewThroughConversionsAttributionWindowDay = 'pageVisitViewThroughConversionsAttributionWindowDay',
  PageVisitViewThroughConversionsAttributionWindowMonth = 'pageVisitViewThroughConversionsAttributionWindowMonth',
  PageVisitViewThroughConversionsAttributionWindowWeek = 'pageVisitViewThroughConversionsAttributionWindowWeek',
  Placement = 'placement',
  PurchaseClickThroughConversionsAttributionWindowDay = 'purchaseClickThroughConversionsAttributionWindowDay',
  PurchaseClickThroughConversionsAttributionWindowMonth = 'purchaseClickThroughConversionsAttributionWindowMonth',
  PurchaseClickThroughConversionsAttributionWindowWeek = 'purchaseClickThroughConversionsAttributionWindowWeek',
  PurchaseViewThroughConversionsAttributionWindowDay = 'purchaseViewThroughConversionsAttributionWindowDay',
  PurchaseViewThroughConversionsAttributionWindowMonth = 'purchaseViewThroughConversionsAttributionWindowMonth',
  PurchaseViewThroughConversionsAttributionWindowWeek = 'purchaseViewThroughConversionsAttributionWindowWeek',
  Quarter = 'quarter',
  Region = 'region',
  SearchClickThroughConversionsAttributionWindowDay = 'searchClickThroughConversionsAttributionWindowDay',
  SearchClickThroughConversionsAttributionWindowMonth = 'searchClickThroughConversionsAttributionWindowMonth',
  SearchClickThroughConversionsAttributionWindowWeek = 'searchClickThroughConversionsAttributionWindowWeek',
  SearchViewThroughConversionsAttributionWindowDay = 'searchViewThroughConversionsAttributionWindowDay',
  SearchViewThroughConversionsAttributionWindowMonth = 'searchViewThroughConversionsAttributionWindowMonth',
  SearchViewThroughConversionsAttributionWindowWeek = 'searchViewThroughConversionsAttributionWindowWeek',
  SignUpClickThroughConversionsAttributionWindowDay = 'signUpClickThroughConversionsAttributionWindowDay',
  SignUpClickThroughConversionsAttributionWindowMonth = 'signUpClickThroughConversionsAttributionWindowMonth',
  SignUpClickThroughConversionsAttributionWindowWeek = 'signUpClickThroughConversionsAttributionWindowWeek',
  SignUpViewThroughConversionsAttributionWindowDay = 'signUpViewThroughConversionsAttributionWindowDay',
  SignUpViewThroughConversionsAttributionWindowMonth = 'signUpViewThroughConversionsAttributionWindowMonth',
  SignUpViewThroughConversionsAttributionWindowWeek = 'signUpViewThroughConversionsAttributionWindowWeek',
  Spend = 'spend',
  VideoFullyViewableImpressions = 'videoFullyViewableImpressions',
  VideoPlaysExpanded = 'videoPlaysExpanded',
  VideoPlaysWithSound = 'videoPlaysWithSound',
  VideoStarted = 'videoStarted',
  VideoViewableImpressions = 'videoViewableImpressions',
  VideoWatched3Seconds = 'videoWatched3Seconds',
  VideoWatched5Seconds = 'videoWatched5Seconds',
  VideoWatched10Seconds = 'videoWatched10Seconds',
  VideoWatched25Percent = 'videoWatched25Percent',
  VideoWatched50Percent = 'videoWatched50Percent',
  VideoWatched75Percent = 'videoWatched75Percent',
  VideoWatched95Percent = 'videoWatched95Percent',
  VideoWatched100Percent = 'videoWatched100Percent',
  ViewContentClickThroughConversionsAttributionWindowDay = 'viewContentClickThroughConversionsAttributionWindowDay',
  ViewContentClickThroughConversionsAttributionWindowMonth = 'viewContentClickThroughConversionsAttributionWindowMonth',
  ViewContentClickThroughConversionsAttributionWindowWeek = 'viewContentClickThroughConversionsAttributionWindowWeek',
  ViewContentViewThroughConversionsAttributionWindowDay = 'viewContentViewThroughConversionsAttributionWindowDay',
  ViewContentViewThroughConversionsAttributionWindowMonth = 'viewContentViewThroughConversionsAttributionWindowMonth',
  ViewContentViewThroughConversionsAttributionWindowWeek = 'viewContentViewThroughConversionsAttributionWindowWeek',
  ViewableImpressions = 'viewableImpressions',
  ViewerComments = 'viewerComments',
  WeekNumber = 'weekNumber',
  WeekdayName = 'weekdayName',
  WeekdayNumber = 'weekdayNumber',
  Year = 'year',
  YearMonth = 'yearMonth'
}

export enum ClientStatus {
  Active = 'ACTIVE',
  NotActive = 'NOT_ACTIVE',
  Unknown = 'UNKNOWN'
}

export type ClientStatusFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<ClientStatus>;
};

export type ClientUser = {
  __typename?: 'ClientUser';
  clientPendingInviteHash?: Maybe<Scalars['String']>;
  user: User;
};

export type Country = {
  __typename?: 'Country';
  countryId: Scalars['ID'];
  countryName: Scalars['String'];
};

export type CountryCursored = {
  __typename?: 'CountryCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Country>>;
};

export type CountryFilter = {
  countryId?: InputMaybe<Array<IdFilter>>;
  countryName?: InputMaybe<Array<StringFilter>>;
};

export type CountryOrderBy = {
  column: CountryOrderByColumn;
  direction?: OrderByDirection;
};

export enum CountryOrderByColumn {
  CountryId = 'countryId',
  CountryName = 'countryName'
}

export enum CreateAdAccountAdminApproval {
  NeedsIdVerification = 'NEEDS_ID_VERIFICATION',
  Suspended = 'SUSPENDED',
  Trusted = 'TRUSTED',
  Valid = 'VALID'
}

export enum CreateAdAccountAttributionType {
  AllConversion = 'ALL_CONVERSION',
  ClickThroughConversion = 'CLICK_THROUGH_CONVERSION',
  ViewThroughConversion = 'VIEW_THROUGH_CONVERSION'
}

export enum CreateAdAccountAttributionWindow {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export enum CreateAdAccountType {
  Managed = 'MANAGED',
  SelfServe = 'SELF_SERVE'
}

export type CreateAdInput = {
  adAccountId: Scalars['ID'];
  adClickUrl?: InputMaybe<Scalars['String']>;
  adEventTrackers?: InputMaybe<Array<EventTrackerInput>>;
  adHash: Scalars['String'];
  adName: Scalars['String'];
  adStatus: CreateAdStatus;
  creativeId: Scalars['ID'];
  groupId: Scalars['ID'];
};

export enum CreateAdStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Paused = 'PAUSED'
}

export type CreateCampaignInput = {
  adAccountId: Scalars['ID'];
  campaignHash: Scalars['String'];
  campaignName: Scalars['String'];
  campaignObjective: CreateCampaignObjective;
  campaignSpecialAdCategories?: InputMaybe<Array<CreateCampaignSpecialAdCategory>>;
  campaignSpendCap?: InputMaybe<Scalars['BigInt']>;
  campaignStatus?: CreateCampaignStatus;
  fundingInstrumentId: Scalars['ID'];
};

export enum CreateCampaignObjective {
  AppInstalls = 'APP_INSTALLS',
  Clicks = 'CLICKS',
  Conversions = 'CONVERSIONS',
  Impressions = 'IMPRESSIONS',
  VideoViewableImpressions = 'VIDEO_VIEWABLE_IMPRESSIONS'
}

export enum CreateCampaignSpecialAdCategory {
  HousingEmploymentCredit = 'HOUSING_EMPLOYMENT_CREDIT',
  None = 'NONE'
}

export enum CreateCampaignStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Paused = 'PAUSED'
}

export enum CreateCreativeContentCallToAction {
  ApplyNow = 'APPLY_NOW',
  ContactUs = 'CONTACT_US',
  Download = 'DOWNLOAD',
  GetQuote = 'GET_QUOTE',
  GetShowtimes = 'GET_SHOWTIMES',
  Install = 'INSTALL',
  LearnMore = 'LEARN_MORE',
  OrderNow = 'ORDER_NOW',
  PlayNow = 'PLAY_NOW',
  PreOrderNow = 'PRE_ORDER_NOW',
  SeeMenu = 'SEE_MENU',
  ShopNow = 'SHOP_NOW',
  SignUp = 'SIGN_UP',
  ViewMore = 'VIEW_MORE',
  WatchNow = 'WATCH_NOW'
}

export type CreateCreativeInput = {
  creativeAllowComments?: InputMaybe<Scalars['Boolean']>;
  creativeContent?: InputMaybe<Array<CreativeContentInput>>;
  creativeHash: Scalars['String'];
  creativeHeadline: Scalars['String'];
  creativeStatus?: InputMaybe<CreateCreativeStatus>;
  creativeText?: InputMaybe<Scalars['String']>;
  creativeThumbnailUrl?: InputMaybe<Scalars['String']>;
  creativeType: CreateCreativeType;
  profileId: Scalars['ID'];
};

export enum CreateCreativeStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Paused = 'PAUSED'
}

export enum CreateCreativeType {
  Carousel = 'CAROUSEL',
  Image = 'IMAGE',
  Text = 'TEXT',
  Video = 'VIDEO'
}

export enum CreateEventTrackerType {
  Click = 'CLICK',
  View = 'VIEW'
}

export enum CreateGroupBidStrategy {
  ManualBidding = 'MANUAL_BIDDING',
  MaximizeVolume = 'MAXIMIZE_VOLUME'
}

export enum CreateGroupBidType {
  Cpc = 'CPC',
  Cpm = 'CPM',
  Cpv = 'CPV'
}

export enum CreateGroupGoal {
  DailySpend = 'DAILY_SPEND',
  LifetimeSpend = 'LIFETIME_SPEND'
}

export type CreateGroupInput = {
  adAccountId: Scalars['ID'];
  campaignId: Scalars['ID'];
  groupAppId?: InputMaybe<Scalars['ID']>;
  groupBidAmount: Scalars['Float'];
  groupBidStrategy: CreateGroupBidStrategy;
  groupBidType: CreateGroupBidType;
  groupEndTime?: InputMaybe<Scalars['DateTime']>;
  groupGoal?: CreateGroupGoal;
  groupGoalAmount?: InputMaybe<Scalars['Float']>;
  groupHash: Scalars['String'];
  groupName: Scalars['String'];
  groupOptimizationGoal?: InputMaybe<CreateGroupOptimizationGoal>;
  groupSchedule?: InputMaybe<Array<CreateGroupScheduleInput>>;
  groupStartTime?: InputMaybe<Scalars['DateTime']>;
  groupStatus?: CreateGroupStatus;
  groupTargeting?: InputMaybe<CreateGroupTargetingInput>;
};

export enum CreateGroupOptimizationGoal {
  AddToCart = 'ADD_TO_CART',
  AddToWishlist = 'ADD_TO_WISHLIST',
  Clicks = 'CLICKS',
  Lead = 'LEAD',
  PageVisit = 'PAGE_VISIT',
  Purchase = 'PURCHASE',
  Search = 'SEARCH',
  SignUp = 'SIGN_UP',
  ViewContent = 'VIEW_CONTENT'
}

export type CreateGroupScheduleInput = {
  endDay: Scalars['Int'];
  endHour: Scalars['Int'];
  startDay: Scalars['Int'];
  startHour: Scalars['Int'];
};

export enum CreateGroupStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Deleted = 'DELETED',
  Paused = 'PAUSED'
}

export enum CreateGroupTargetingDeviceType {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE'
}

export enum CreateGroupTargetingDevicesOs {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export enum CreateGroupTargetingGender {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type CreateGroupTargetingInput = {
  groupTargetingCarriers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupTargetingCommunities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupTargetingCustomAudienceIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupTargetingDevices?: InputMaybe<Array<InputMaybe<GroupTargetingDevicesInput>>>;
  groupTargetingExcludedCommunities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupTargetingExcludedCustomAudienceIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupTargetingExcludedGeolocations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupTargetingExpandTargeting?: InputMaybe<Scalars['Boolean']>;
  groupTargetingGender?: InputMaybe<CreateGroupTargetingGender>;
  groupTargetingGeolocations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupTargetingInterests?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  groupTargetingKeywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupTargetingLocations?: Array<CreateGroupTargetingLocations>;
  groupTargetingPlatforms?: Array<CreateGroupTargetingPlatforms>;
  groupTargetingSuppressionEventTypes?: InputMaybe<Array<InputMaybe<CreateGroupTargetingSuppressionEventTypes>>>;
  groupTargetingViewModes?: InputMaybe<Array<InputMaybe<CreateGroupTargetingViewMode>>>;
};

export enum CreateGroupTargetingLocations {
  CommentsPage = 'COMMENTS_PAGE',
  Feed = 'FEED'
}

export enum CreateGroupTargetingPlatforms {
  All = 'ALL',
  Desktop = 'DESKTOP',
  MobileNative = 'MOBILE_NATIVE',
  MobileWeb = 'MOBILE_WEB',
  MobileWeb_3X = 'MOBILE_WEB_3X',
  Shredtop = 'SHREDTOP'
}

export enum CreateGroupTargetingSuppressionEventTypes {
  AllFeatures = 'ALL_FEATURES'
}

export enum CreateGroupTargetingViewMode {
  All = 'ALL',
  Card = 'CARD',
  Classic = 'CLASSIC',
  Compact = 'COMPACT',
  Immersive = 'IMMERSIVE'
}

export enum CreateInternalCategoryType {
  AdvertiserSalesforce = 'ADVERTISER_SALESFORCE',
  ClientType = 'CLIENT_TYPE',
  InternalCategory = 'INTERNAL_CATEGORY',
  ManagementRegion = 'MANAGEMENT_REGION',
  ServiceLevel = 'SERVICE_LEVEL',
  Tag = 'TAG'
}

export enum CreateNotificationCategory {
  Notice = 'NOTICE',
  Validation = 'VALIDATION'
}

export enum CreateNotificationType {
  Announcement = 'ANNOUNCEMENT',
  Change = 'CHANGE',
  Error = 'ERROR',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

export enum CreateReportActionFormat {
  Csv = 'CSV',
  Excel = 'EXCEL',
  Inline = 'INLINE',
  Json = 'JSON'
}

export enum CreateReportActionOptionType {
  ActionEmails = 'ACTION_EMAILS',
  Dataset = 'DATASET',
  From = 'FROM',
  Table = 'TABLE'
}

export enum CreateReportActionType {
  Bigquery = 'BIGQUERY',
  Email = 'EMAIL',
  Show = 'SHOW',
  Url = 'URL'
}

export enum CreateReportApiFiltersOptionsAction {
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE'
}

export enum CreateReportDateRangeType {
  DateSchedule = 'DATE_SCHEDULE',
  DaysValue = 'DAYS_VALUE'
}

export enum CreateReportDateType {
  Biweekly = 'BIWEEKLY',
  CurrentMonth = 'CURRENT_MONTH',
  CurrentWeek = 'CURRENT_WEEK',
  CurrentYear = 'CURRENT_YEAR',
  Custom = 'CUSTOM',
  From = 'FROM',
  Last = 'LAST',
  Previous = 'PREVIOUS',
  Previous_3Months = 'PREVIOUS_3_MONTHS',
  PreviousMonth = 'PREVIOUS_MONTH',
  PreviousWeek = 'PREVIOUS_WEEK',
  PreviousYear = 'PREVIOUS_YEAR',
  Today = 'TODAY',
  Yesterday = 'YESTERDAY'
}

export enum CreateUserAccountLevel {
  Admin = 'ADMIN',
  Advertiser = 'ADVERTISER',
  Agency = 'AGENCY',
  ReadonlyUser = 'READONLY_USER',
  User = 'USER'
}

export type Creative = {
  __typename?: 'Creative';
  creativeAllowComments: Scalars['Boolean'];
  creativeContent?: Maybe<Array<CreativeContent>>;
  creativeCreatedAt: Scalars['DateTime'];
  creativeGhost: Scalars['Boolean'];
  creativeHasErrors: Scalars['Boolean'];
  creativeHash?: Maybe<Scalars['String']>;
  creativeHeadline: Scalars['String'];
  creativeId: Scalars['ID'];
  creativeModificationTime?: Maybe<Scalars['DateTime']>;
  creativePostUrl?: Maybe<Scalars['String']>;
  creativeStatus?: Maybe<CreativeStatus>;
  creativeStatusPending?: Maybe<CreativeStatus>;
  creativeThumbnailUrl?: Maybe<Scalars['String']>;
  creativeType: CreativeType;
  externalCreativeId?: Maybe<Scalars['ID']>;
  profile: Profile;
  stats?: Maybe<Array<Stats>>;
  text?: Maybe<Text>;
};


export type CreativeStatsArgs = {
  filters?: InputMaybe<StatsFilter>;
  orderBy?: InputMaybe<Array<InputMaybe<StatsOrderBy>>>;
  query?: InputMaybe<Scalars['String']>;
};

export type CreativeChangelog = {
  __typename?: 'CreativeChangelog';
  changelogs?: Maybe<Array<Maybe<Changelog>>>;
  creativeId?: Maybe<Scalars['ID']>;
};

export type CreativeChangelogFilter = {
  creativeId: SingleIdFilter;
  differenceFields: CreativeDifferencesFilter;
  modificationTime?: InputMaybe<DateRangeFilter>;
};

export type CreativeChangelogSubQueryFilter = {
  differenceFields: CreativeDifferencesFilter;
  modificationTime?: InputMaybe<DateRangeFilter>;
};

export type CreativeContent = {
  __typename?: 'CreativeContent';
  creativeContentCallToAction?: Maybe<CreativeContentCallToAction>;
  creativeContentCaption?: Maybe<Scalars['String']>;
  creativeContentDestinationUrl?: Maybe<Scalars['String']>;
  creativeContentDisplayUrl?: Maybe<Scalars['String']>;
  creativeContentId: Scalars['ID'];
  creativeContentMediaUrl?: Maybe<Scalars['String']>;
};

export enum CreativeContentCallToAction {
  ApplyNow = 'APPLY_NOW',
  ContactUs = 'CONTACT_US',
  Download = 'DOWNLOAD',
  GetQuote = 'GET_QUOTE',
  GetShowtimes = 'GET_SHOWTIMES',
  Install = 'INSTALL',
  LearnMore = 'LEARN_MORE',
  OrderNow = 'ORDER_NOW',
  PlayNow = 'PLAY_NOW',
  PreOrderNow = 'PRE_ORDER_NOW',
  SeeMenu = 'SEE_MENU',
  ShopNow = 'SHOP_NOW',
  SignUp = 'SIGN_UP',
  Unknown = 'UNKNOWN',
  ViewMore = 'VIEW_MORE',
  WatchNow = 'WATCH_NOW'
}

export type CreativeContentInput = {
  creativeContentCallToAction?: InputMaybe<CreateCreativeContentCallToAction>;
  creativeContentCaption?: InputMaybe<Scalars['String']>;
  creativeContentDestinationUrl: Scalars['String'];
  creativeContentDisplayUrl?: InputMaybe<Scalars['String']>;
  creativeContentMediaUrl: Scalars['String'];
};

export type CreativeCursored = {
  __typename?: 'CreativeCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Creative>>;
};

export enum CreativeDifferencesFields {
  CreativeAllowComments = 'creativeAllowComments',
  CreativeHeadline = 'creativeHeadline',
  CreativePostUrl = 'creativePostUrl',
  CreativeReStatus = 'creativeReStatus',
  CreativeReStatusPending = 'creativeReStatusPending',
  CreativeReTextId = 'creativeReTextId',
  CreativeStatus = 'creativeStatus',
  CreativeThumbnailUrl = 'creativeThumbnailUrl',
  CreativeType = 'creativeType'
}

export type CreativeDifferencesFilter = {
  value: Array<CreativeDifferencesFields>;
};

export type CreativeFilter = {
  creativeAllowComments?: InputMaybe<Array<BooleanFilter>>;
  creativeGhost?: InputMaybe<Array<BooleanFilter>>;
  creativeHasErrors?: InputMaybe<Array<BooleanFilter>>;
  creativeHeadline?: InputMaybe<Array<StringFilter>>;
  creativeId?: InputMaybe<Array<IdFilter>>;
  creativePostUrl?: InputMaybe<Array<StringFilter>>;
  creativeText?: InputMaybe<Array<StringFilter>>;
  creativeThumbnailUrl?: InputMaybe<Array<StringFilter>>;
  creativeType?: InputMaybe<Array<CreativeTypeFilter>>;
  externalCreativeId?: InputMaybe<Array<IdFilter>>;
};

export type CreativeLive = {
  __typename?: 'CreativeLive';
  creativeAllowComments?: Maybe<Scalars['Boolean']>;
  creativeContent?: Maybe<Array<Maybe<CreativeContent>>>;
  creativeCreatedAt?: Maybe<Scalars['DateTime']>;
  creativeHeadline?: Maybe<Scalars['String']>;
  creativeId?: Maybe<Scalars['ID']>;
  creativePostUrl?: Maybe<Scalars['String']>;
  creativeText?: Maybe<Scalars['String']>;
  creativeThumbnailUrl?: Maybe<Scalars['String']>;
  creativeType?: Maybe<CreativeType>;
  profileId?: Maybe<Scalars['ID']>;
};

export type CreativeLiveFilter = {
  adAccountId: SingleIdRealmFilter;
};

export type CreativeOrderBy = {
  column: CreativeOrderByColumn;
  direction?: OrderByDirection;
};

export enum CreativeOrderByColumn {
  AdId = 'adId',
  AddToCartClickThroughConversionsAttributionWindowDay = 'addToCartClickThroughConversionsAttributionWindowDay',
  AddToCartClickThroughConversionsAttributionWindowMonth = 'addToCartClickThroughConversionsAttributionWindowMonth',
  AddToCartClickThroughConversionsAttributionWindowWeek = 'addToCartClickThroughConversionsAttributionWindowWeek',
  AddToCartViewThroughConversionsAttributionWindowDay = 'addToCartViewThroughConversionsAttributionWindowDay',
  AddToCartViewThroughConversionsAttributionWindowMonth = 'addToCartViewThroughConversionsAttributionWindowMonth',
  AddToCartViewThroughConversionsAttributionWindowWeek = 'addToCartViewThroughConversionsAttributionWindowWeek',
  AddToWishlistClickThroughConversionsAttributionWindowDay = 'addToWishlistClickThroughConversionsAttributionWindowDay',
  AddToWishlistClickThroughConversionsAttributionWindowMonth = 'addToWishlistClickThroughConversionsAttributionWindowMonth',
  AddToWishlistClickThroughConversionsAttributionWindowWeek = 'addToWishlistClickThroughConversionsAttributionWindowWeek',
  AddToWishlistViewThroughConversionsAttributionWindowDay = 'addToWishlistViewThroughConversionsAttributionWindowDay',
  AddToWishlistViewThroughConversionsAttributionWindowMonth = 'addToWishlistViewThroughConversionsAttributionWindowMonth',
  AddToWishlistViewThroughConversionsAttributionWindowWeek = 'addToWishlistViewThroughConversionsAttributionWindowWeek',
  AppInstallMetricsAddPaymentInfo = 'appInstallMetricsAddPaymentInfo',
  AppInstallMetricsAddToCart = 'appInstallMetricsAddToCart',
  AppInstallMetricsAppLaunch = 'appInstallMetricsAppLaunch',
  AppInstallMetricsCompletedTutorial = 'appInstallMetricsCompletedTutorial',
  AppInstallMetricsInstall = 'appInstallMetricsInstall',
  AppInstallMetricsLevelAchieved = 'appInstallMetricsLevelAchieved',
  AppInstallMetricsPurchase = 'appInstallMetricsPurchase',
  AppInstallMetricsSearch = 'appInstallMetricsSearch',
  AppInstallMetricsSignUp = 'appInstallMetricsSignUp',
  AppInstallMetricsSpend = 'appInstallMetricsSpend',
  AppInstallMetricsSpendCredits = 'appInstallMetricsSpendCredits',
  AppInstallMetricsViewContent = 'appInstallMetricsViewContent',
  CampaignId = 'campaignId',
  Clicks = 'clicks',
  CommentDownvotes = 'commentDownvotes',
  CommentUpvotes = 'commentUpvotes',
  CommentsPageViews = 'commentsPageViews',
  Community = 'community',
  ConversionAddToCartAvgValue = 'conversionAddToCartAvgValue',
  ConversionAddToCartTotalItems = 'conversionAddToCartTotalItems',
  ConversionAddToCartTotalValue = 'conversionAddToCartTotalValue',
  ConversionAddToWishlistAvgValue = 'conversionAddToWishlistAvgValue',
  ConversionAddToWishlistTotalItems = 'conversionAddToWishlistTotalItems',
  ConversionAddToWishlistTotalValue = 'conversionAddToWishlistTotalValue',
  ConversionLeadTotalValue = 'conversionLeadTotalValue',
  ConversionPurchaseAvgValue = 'conversionPurchaseAvgValue',
  ConversionPurchaseTotalItems = 'conversionPurchaseTotalItems',
  ConversionPurchaseTotalValue = 'conversionPurchaseTotalValue',
  ConversionRoas = 'conversionRoas',
  ConversionSignupTotalValue = 'conversionSignupTotalValue',
  Country = 'country',
  Cpc = 'cpc',
  CreativeAllowComments = 'creativeAllowComments',
  CreativeContentCallToAction = 'creativeContentCallToAction',
  CreativeContentCaption = 'creativeContentCaption',
  CreativeContentDestinationUrl = 'creativeContentDestinationUrl',
  CreativeContentDisplayUrl = 'creativeContentDisplayUrl',
  CreativeContentMediaUrl = 'creativeContentMediaUrl',
  CreativeCreatedAt = 'creativeCreatedAt',
  CreativeHeadline = 'creativeHeadline',
  CreativeId = 'creativeId',
  CreativeModificationTime = 'creativeModificationTime',
  CreativePostUrl = 'creativePostUrl',
  CreativeThumbnailUrl = 'creativeThumbnailUrl',
  CreativeType = 'creativeType',
  Ctr = 'ctr',
  CustomClickThroughConversionsAttributionWindowDay = 'customClickThroughConversionsAttributionWindowDay',
  CustomClickThroughConversionsAttributionWindowMonth = 'customClickThroughConversionsAttributionWindowMonth',
  CustomClickThroughConversionsAttributionWindowWeek = 'customClickThroughConversionsAttributionWindowWeek',
  CustomViewThroughConversionsAttributionWindowDay = 'customViewThroughConversionsAttributionWindowDay',
  CustomViewThroughConversionsAttributionWindowMonth = 'customViewThroughConversionsAttributionWindowMonth',
  CustomViewThroughConversionsAttributionWindowWeek = 'customViewThroughConversionsAttributionWindowWeek',
  /** Statistics */
  Date = 'date',
  DayOfMonth = 'dayOfMonth',
  Ecpm = 'ecpm',
  ExternalAdAccountId = 'externalAdAccountId',
  ExternalAdId = 'externalAdId',
  ExternalCampaignId = 'externalCampaignId',
  ExternalCreativeId = 'externalCreativeId',
  ExternalGroupId = 'externalGroupId',
  GroupId = 'groupId',
  Impressions = 'impressions',
  Interest = 'interest',
  LeadClickThroughConversionsAttributionWindowDay = 'leadClickThroughConversionsAttributionWindowDay',
  LeadClickThroughConversionsAttributionWindowMonth = 'leadClickThroughConversionsAttributionWindowMonth',
  LeadClickThroughConversionsAttributionWindowWeek = 'leadClickThroughConversionsAttributionWindowWeek',
  LeadViewThroughConversionsAttributionWindowDay = 'leadViewThroughConversionsAttributionWindowDay',
  LeadViewThroughConversionsAttributionWindowMonth = 'leadViewThroughConversionsAttributionWindowMonth',
  LeadViewThroughConversionsAttributionWindowWeek = 'leadViewThroughConversionsAttributionWindowWeek',
  LegacyClickConversionsAttributionWindowDay = 'legacyClickConversionsAttributionWindowDay',
  LegacyClickConversionsAttributionWindowMonth = 'legacyClickConversionsAttributionWindowMonth',
  LegacyClickConversionsAttributionWindowWeek = 'legacyClickConversionsAttributionWindowWeek',
  LegacyViewConversionsAttributionWindowDay = 'legacyViewConversionsAttributionWindowDay',
  LegacyViewConversionsAttributionWindowMonth = 'legacyViewConversionsAttributionWindowMonth',
  LegacyViewConversionsAttributionWindowWeek = 'legacyViewConversionsAttributionWindowWeek',
  Metro = 'metro',
  MonthName = 'monthName',
  MonthNumber = 'monthNumber',
  PageVisitClickThroughConversionsAttributionWindowDay = 'pageVisitClickThroughConversionsAttributionWindowDay',
  PageVisitClickThroughConversionsAttributionWindowMonth = 'pageVisitClickThroughConversionsAttributionWindowMonth',
  PageVisitClickThroughConversionsAttributionWindowWeek = 'pageVisitClickThroughConversionsAttributionWindowWeek',
  PageVisitViewThroughConversionsAttributionWindowDay = 'pageVisitViewThroughConversionsAttributionWindowDay',
  PageVisitViewThroughConversionsAttributionWindowMonth = 'pageVisitViewThroughConversionsAttributionWindowMonth',
  PageVisitViewThroughConversionsAttributionWindowWeek = 'pageVisitViewThroughConversionsAttributionWindowWeek',
  Placement = 'placement',
  PurchaseClickThroughConversionsAttributionWindowDay = 'purchaseClickThroughConversionsAttributionWindowDay',
  PurchaseClickThroughConversionsAttributionWindowMonth = 'purchaseClickThroughConversionsAttributionWindowMonth',
  PurchaseClickThroughConversionsAttributionWindowWeek = 'purchaseClickThroughConversionsAttributionWindowWeek',
  PurchaseViewThroughConversionsAttributionWindowDay = 'purchaseViewThroughConversionsAttributionWindowDay',
  PurchaseViewThroughConversionsAttributionWindowMonth = 'purchaseViewThroughConversionsAttributionWindowMonth',
  PurchaseViewThroughConversionsAttributionWindowWeek = 'purchaseViewThroughConversionsAttributionWindowWeek',
  Quarter = 'quarter',
  Region = 'region',
  SearchClickThroughConversionsAttributionWindowDay = 'searchClickThroughConversionsAttributionWindowDay',
  SearchClickThroughConversionsAttributionWindowMonth = 'searchClickThroughConversionsAttributionWindowMonth',
  SearchClickThroughConversionsAttributionWindowWeek = 'searchClickThroughConversionsAttributionWindowWeek',
  SearchViewThroughConversionsAttributionWindowDay = 'searchViewThroughConversionsAttributionWindowDay',
  SearchViewThroughConversionsAttributionWindowMonth = 'searchViewThroughConversionsAttributionWindowMonth',
  SearchViewThroughConversionsAttributionWindowWeek = 'searchViewThroughConversionsAttributionWindowWeek',
  SignUpClickThroughConversionsAttributionWindowDay = 'signUpClickThroughConversionsAttributionWindowDay',
  SignUpClickThroughConversionsAttributionWindowMonth = 'signUpClickThroughConversionsAttributionWindowMonth',
  SignUpClickThroughConversionsAttributionWindowWeek = 'signUpClickThroughConversionsAttributionWindowWeek',
  SignUpViewThroughConversionsAttributionWindowDay = 'signUpViewThroughConversionsAttributionWindowDay',
  SignUpViewThroughConversionsAttributionWindowMonth = 'signUpViewThroughConversionsAttributionWindowMonth',
  SignUpViewThroughConversionsAttributionWindowWeek = 'signUpViewThroughConversionsAttributionWindowWeek',
  Spend = 'spend',
  TextValue = 'textValue',
  VideoFullyViewableImpressions = 'videoFullyViewableImpressions',
  VideoPlaysExpanded = 'videoPlaysExpanded',
  VideoPlaysWithSound = 'videoPlaysWithSound',
  VideoStarted = 'videoStarted',
  VideoViewableImpressions = 'videoViewableImpressions',
  VideoWatched3Seconds = 'videoWatched3Seconds',
  VideoWatched5Seconds = 'videoWatched5Seconds',
  VideoWatched10Seconds = 'videoWatched10Seconds',
  VideoWatched25Percent = 'videoWatched25Percent',
  VideoWatched50Percent = 'videoWatched50Percent',
  VideoWatched75Percent = 'videoWatched75Percent',
  VideoWatched95Percent = 'videoWatched95Percent',
  VideoWatched100Percent = 'videoWatched100Percent',
  ViewContentClickThroughConversionsAttributionWindowDay = 'viewContentClickThroughConversionsAttributionWindowDay',
  ViewContentClickThroughConversionsAttributionWindowMonth = 'viewContentClickThroughConversionsAttributionWindowMonth',
  ViewContentClickThroughConversionsAttributionWindowWeek = 'viewContentClickThroughConversionsAttributionWindowWeek',
  ViewContentViewThroughConversionsAttributionWindowDay = 'viewContentViewThroughConversionsAttributionWindowDay',
  ViewContentViewThroughConversionsAttributionWindowMonth = 'viewContentViewThroughConversionsAttributionWindowMonth',
  ViewContentViewThroughConversionsAttributionWindowWeek = 'viewContentViewThroughConversionsAttributionWindowWeek',
  ViewableImpressions = 'viewableImpressions',
  ViewerComments = 'viewerComments',
  WeekNumber = 'weekNumber',
  WeekdayName = 'weekdayName',
  WeekdayNumber = 'weekdayNumber',
  Year = 'year',
  YearMonth = 'yearMonth'
}

export enum CreativeStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Paused = 'PAUSED',
  Unknown = 'UNKNOWN'
}

export enum CreativeType {
  Carousel = 'CAROUSEL',
  Image = 'IMAGE',
  Text = 'TEXT',
  Unknown = 'UNKNOWN',
  Video = 'VIDEO'
}

export type CreativeTypeFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<CreativeType>;
};

export enum CredentialName {
  ManageAdministration = 'MANAGE_ADMINISTRATION',
  ManageUser = 'MANAGE_USER',
  ManageUserAccess = 'MANAGE_USER_ACCESS',
  ModifyAgencyUser = 'MODIFY_AGENCY_USER',
  ModifyEntity = 'MODIFY_ENTITY'
}

export type DateFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<Scalars['DateOptionalTime']>;
};

export type DateRangeFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['DateOptionalTimeRange'];
};

export type DeleteAdInput = {
  adHash: Scalars['String'];
  adId: Scalars['ID'];
};

export type DeleteCampaignInput = {
  campaignHash: Scalars['String'];
  campaignId: Scalars['ID'];
};

export type DeleteGroupInput = {
  groupHash: Scalars['String'];
  groupId: Scalars['ID'];
};

export type Difference = {
  __typename?: 'Difference';
  key?: Maybe<Scalars['String']>;
  new?: Maybe<Scalars['String']>;
  old?: Maybe<Scalars['String']>;
};

export type Error = {
  fields?: InputMaybe<Array<Field>>;
  message?: InputMaybe<Scalars['String']>;
};

export type EventTracker = {
  __typename?: 'EventTracker';
  type?: Maybe<EventTrackerType>;
  url?: Maybe<Scalars['String']>;
};

export type EventTrackerInput = {
  type: CreateEventTrackerType;
  url: Scalars['String'];
};

export enum EventTrackerType {
  Click = 'CLICK',
  Unknown = 'UNKNOWN',
  View = 'VIEW'
}

export type ExactStringFilter = {
  value: Scalars['String'];
};

export type Field = {
  field?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
};

export type FloatFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<Scalars['Float']>;
};

export type FundingInstrument = {
  __typename?: 'FundingInstrument';
  externalFundingInstrumentId: Scalars['String'];
  fundingInstrumentBillableAmount: Scalars['BigInt'];
  fundingInstrumentCreditLimit: Scalars['BigInt'];
  fundingInstrumentCurrency: Scalars['String'];
  fundingInstrumentEndTime?: Maybe<Scalars['DateTime']>;
  fundingInstrumentId: Scalars['ID'];
  fundingInstrumentIsServable: Scalars['Boolean'];
  fundingInstrumentName: Scalars['String'];
  fundingInstrumentReasonsNotServable?: Maybe<Array<FundingInstrumentReasonNotServable>>;
  fundingInstrumentStartTime?: Maybe<Scalars['DateTime']>;
};

export type FundingInstrumentFilter = {
  externalFundingInstrumentId?: InputMaybe<Array<StringFilter>>;
  fundingInstrumentCurrency?: InputMaybe<Array<StringFilter>>;
  fundingInstrumentId?: InputMaybe<Array<IdFilter>>;
  fundingInstrumentIsServable: BooleanFilter;
  fundingInstrumentName?: InputMaybe<Array<StringFilter>>;
};

export enum FundingInstrumentReasonNotServable {
  CreditCardNotApproved = 'CREDIT_CARD_NOT_APPROVED',
  CreditLineExhausted = 'CREDIT_LINE_EXHAUSTED',
  DatesOutOfRange = 'DATES_OUT_OF_RANGE',
  NotActive = 'NOT_ACTIVE',
  Unknown = 'UNKNOWN'
}

export type Group = {
  __typename?: 'Group';
  adAccountCurrency?: Maybe<Scalars['String']>;
  adAccountId: Scalars['ID'];
  ads?: Maybe<Array<Ad>>;
  campaign: Campaign;
  client: Client;
  externalGroupId?: Maybe<Scalars['ID']>;
  groupAppId?: Maybe<Scalars['ID']>;
  groupAutopilots?: Maybe<Array<GroupAutopilot>>;
  groupBidAmount?: Maybe<Scalars['Float']>;
  groupBidStrategy: GroupBidStrategy;
  groupBidType: GroupBidType;
  /**  CapType will be NULL in all ads which were not created by internal Reddit Administrators.  */
  groupCapType?: Maybe<GroupCapType>;
  groupChangelog?: Maybe<GroupChangelog>;
  groupCreatedAt: Scalars['DateTime'];
  groupEffectiveStatus?: Maybe<GroupEffectiveStatus>;
  groupEndTime?: Maybe<Scalars['DateTime']>;
  groupGhost: Scalars['Boolean'];
  groupGoal?: Maybe<GroupGoal>;
  groupGoalAmount?: Maybe<Scalars['Float']>;
  groupHasErrors: Scalars['Boolean'];
  groupHash?: Maybe<Scalars['String']>;
  groupId: Scalars['ID'];
  groupModificationTime?: Maybe<Scalars['DateTime']>;
  groupName: Scalars['String'];
  groupOptimizationGoal?: Maybe<GroupOptimizationGoal>;
  groupSchedule?: Maybe<Array<GroupSchedule>>;
  groupStartTime?: Maybe<Scalars['DateTime']>;
  groupStatus?: Maybe<GroupStatus>;
  groupStatusPending?: Maybe<GroupStatus>;
  groupTargeting?: Maybe<GroupTargeting>;
  groupUpdatedAt?: Maybe<Scalars['DateTime']>;
  stats?: Maybe<Array<Stats>>;
};


export type GroupAdsArgs = {
  filters?: InputMaybe<AdFilter>;
  orderBy?: InputMaybe<Array<InputMaybe<AdOrderBy>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type GroupGroupAutopilotsArgs = {
  filters?: InputMaybe<GroupAutopilotFilter>;
  orderBy?: InputMaybe<Array<InputMaybe<GroupAutopilotOrderBy>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type GroupGroupChangelogArgs = {
  filters: GroupChangelogSubQueryFilter;
};


export type GroupStatsArgs = {
  filters?: InputMaybe<StatsFilter>;
  orderBy?: InputMaybe<Array<InputMaybe<StatsOrderBy>>>;
  query?: InputMaybe<Scalars['String']>;
};

export type GroupAutopilot = {
  __typename?: 'GroupAutopilot';
  group: Group;
  groupAutopilotActivatedAt?: Maybe<Scalars['DateTime']>;
  groupAutopilotBidCoefficient?: Maybe<Scalars['Int']>;
  groupAutopilotCreatedAt: Scalars['DateTime'];
  groupAutopilotCurrentPacing?: Maybe<Scalars['Int']>;
  groupAutopilotDeletedAt?: Maybe<Scalars['DateTime']>;
  groupAutopilotExpectedPacing?: Maybe<Scalars['Int']>;
  groupAutopilotId: Scalars['ID'];
  groupAutopilotLastRun?: Maybe<Scalars['DateTime']>;
  groupAutopilotStatus: AutopilotStatus;
  groupAutopilotUpdatedAt?: Maybe<Scalars['DateTime']>;
  groupAutopilotWeightedBidSum?: Maybe<Scalars['Int']>;
};

export type GroupAutopilotCursored = {
  __typename?: 'GroupAutopilotCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<GroupAutopilot>>;
};

export type GroupAutopilotFilter = {
  groupAutopilotId?: InputMaybe<Array<IdFilter>>;
  groupAutopilotStatus?: InputMaybe<Array<AutopilotStatusFilter>>;
  groupId?: InputMaybe<Array<IdFilter>>;
};

export type GroupAutopilotOrderBy = {
  column: GroupAutopilotOrderByColumn;
  direction?: OrderByDirection;
};

export enum GroupAutopilotOrderByColumn {
  GroupAutopilotBidCoefficient = 'groupAutopilotBidCoefficient',
  GroupAutopilotCurrentPacing = 'groupAutopilotCurrentPacing',
  GroupAutopilotExpectedPacing = 'groupAutopilotExpectedPacing',
  GroupAutopilotId = 'groupAutopilotId',
  GroupAutopilotLastRun = 'groupAutopilotLastRun',
  GroupAutopilotStatus = 'groupAutopilotStatus',
  GroupAutopilotWeightedBidSum = 'groupAutopilotWeightedBidSum',
  GroupId = 'groupId'
}

export enum GroupBidStrategy {
  Bidless = 'BIDLESS',
  ManualBidding = 'MANUAL_BIDDING',
  MaximizeVolume = 'MAXIMIZE_VOLUME',
  Unknown = 'UNKNOWN'
}

export type GroupBidStrategyFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<GroupBidStrategy>;
};

export enum GroupBidType {
  Cpc = 'CPC',
  Cpm = 'CPM',
  Cpv = 'CPV',
  Unknown = 'UNKNOWN'
}

export type GroupBidTypeFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<GroupBidType>;
};

export enum GroupCapType {
  Impressions = 'IMPRESSIONS',
  Spend = 'SPEND',
  Unknown = 'UNKNOWN'
}

export type GroupChangelog = {
  __typename?: 'GroupChangelog';
  changelogs?: Maybe<Array<Maybe<Changelog>>>;
  groupId?: Maybe<Scalars['ID']>;
};

export type GroupChangelogFilter = {
  differenceFields: GroupDifferencesFilter;
  groupId: SingleIdFilter;
  modificationTime?: InputMaybe<DateRangeFilter>;
};

export type GroupChangelogSubQueryFilter = {
  differenceFields: GroupDifferencesFilter;
  modificationTime?: InputMaybe<DateRangeFilter>;
};

export type GroupCursored = {
  __typename?: 'GroupCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Group>>;
};

export enum GroupDifferencesFields {
  GroupBidAmount = 'groupBidAmount',
  GroupBidStrategy = 'groupBidStrategy',
  GroupBidType = 'groupBidType',
  GroupCapType = 'groupCapType',
  GroupEndTime = 'groupEndTime',
  GroupGoal = 'groupGoal',
  GroupGoalAmount = 'groupGoalAmount',
  GroupName = 'groupName',
  GroupOptimizationGoal = 'groupOptimizationGoal',
  GroupReEffectiveStatus = 'groupReEffectiveStatus',
  GroupReStatus = 'groupReStatus',
  GroupReStatusPending = 'groupReStatusPending',
  GroupSchedule = 'groupSchedule',
  GroupStartTime = 'groupStartTime',
  GroupTargeting = 'groupTargeting'
}

export type GroupDifferencesFilter = {
  value: Array<GroupDifferencesFields>;
};

export enum GroupEffectiveStatus {
  Active = 'ACTIVE',
  AdGroupPaused = 'AD_GROUP_PAUSED',
  Archived = 'ARCHIVED',
  CampaignPaused = 'CAMPAIGN_PAUSED',
  Completed = 'COMPLETED',
  Deleted = 'DELETED',
  Paused = 'PAUSED',
  PendingApproval = 'PENDING_APPROVAL',
  PendingBillingInfo = 'PENDING_BILLING_INFO',
  PendingIdVerification = 'PENDING_ID_VERIFICATION',
  /**  Legacy value, left it here for backward compatibility  */
  PendingReview = 'PENDING_REVIEW',
  Rejected = 'REJECTED',
  Unknown = 'UNKNOWN'
}

export type GroupEffectiveStatusFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<GroupEffectiveStatus>;
};

export type GroupFilter = {
  adAccountId?: InputMaybe<Array<IdFilter>>;
  adAccountName?: InputMaybe<Array<StringFilter>>;
  adId?: InputMaybe<Array<IdFilter>>;
  adName?: InputMaybe<Array<StringFilter>>;
  adStatus?: InputMaybe<Array<AdStatusFilter>>;
  campaignId?: InputMaybe<Array<IdFilter>>;
  campaignName?: InputMaybe<Array<StringFilter>>;
  campaignStatus?: InputMaybe<Array<CampaignStatusFilter>>;
  clientId?: InputMaybe<Array<IdFilter>>;
  clientName?: InputMaybe<Array<StringFilter>>;
  clientStatus?: InputMaybe<Array<ClientStatusFilter>>;
  creativeId?: InputMaybe<Array<IdFilter>>;
  externalGroupId?: InputMaybe<Array<IdFilter>>;
  groupBidStrategy?: InputMaybe<Array<GroupBidStrategyFilter>>;
  groupBidType?: InputMaybe<Array<GroupBidTypeFilter>>;
  groupEffectiveStatus?: InputMaybe<Array<GroupEffectiveStatusFilter>>;
  groupGhost?: InputMaybe<Array<BooleanFilter>>;
  groupGoal?: InputMaybe<Array<GroupGoalFilter>>;
  groupHasErrors?: InputMaybe<Array<BooleanFilter>>;
  groupId?: InputMaybe<Array<IdFilter>>;
  groupName?: InputMaybe<Array<StringFilter>>;
  groupStatus?: InputMaybe<Array<GroupStatusFilter>>;
};

export enum GroupGoal {
  DailySpend = 'DAILY_SPEND',
  LifetimeSpend = 'LIFETIME_SPEND',
  Unknown = 'UNKNOWN'
}

export type GroupGoalFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<GroupGoal>;
};

export type GroupLive = {
  __typename?: 'GroupLive';
  adAccountId?: Maybe<Scalars['ID']>;
  campaignId?: Maybe<Scalars['ID']>;
  groupAppId?: Maybe<Scalars['ID']>;
  groupBidAmount?: Maybe<Scalars['Float']>;
  groupBidStrategy?: Maybe<GroupBidStrategy>;
  groupBidType?: Maybe<GroupBidType>;
  groupCapType?: Maybe<Scalars['String']>;
  groupConfiguredStatus?: Maybe<GroupStatus>;
  groupCreatedAt?: Maybe<Scalars['DateTime']>;
  groupEffectiveStatus?: Maybe<GroupEffectiveStatus>;
  groupEndTime?: Maybe<Scalars['DateTime']>;
  groupGoal?: Maybe<GroupGoal>;
  groupGoalAmount?: Maybe<Scalars['Float']>;
  groupId?: Maybe<Scalars['ID']>;
  groupModificationTime?: Maybe<Scalars['DateTime']>;
  groupModifiedAt?: Maybe<Scalars['DateTime']>;
  groupName?: Maybe<Scalars['String']>;
  groupSchedule?: Maybe<Array<Maybe<GroupSchedule>>>;
  groupStartTime?: Maybe<Scalars['DateTime']>;
  groupTargeting?: Maybe<GroupTargeting>;
};

export type GroupLiveFilter = {
  adAccountId: SingleIdRealmFilter;
};

export enum GroupOptimizationGoal {
  AddToCart = 'ADD_TO_CART',
  AddToWishlist = 'ADD_TO_WISHLIST',
  Clicks = 'CLICKS',
  Lead = 'LEAD',
  PageVisit = 'PAGE_VISIT',
  Purchase = 'PURCHASE',
  Search = 'SEARCH',
  SignUp = 'SIGN_UP',
  Unknown = 'UNKNOWN',
  ViewContent = 'VIEW_CONTENT'
}

export type GroupOrderBy = {
  column: GroupOrderByColumn;
  direction?: OrderByDirection;
};

export enum GroupOrderByColumn {
  AdAccountId = 'adAccountId',
  AdId = 'adId',
  AddToCartClickThroughConversionsAttributionWindowDay = 'addToCartClickThroughConversionsAttributionWindowDay',
  AddToCartClickThroughConversionsAttributionWindowMonth = 'addToCartClickThroughConversionsAttributionWindowMonth',
  AddToCartClickThroughConversionsAttributionWindowWeek = 'addToCartClickThroughConversionsAttributionWindowWeek',
  AddToCartViewThroughConversionsAttributionWindowDay = 'addToCartViewThroughConversionsAttributionWindowDay',
  AddToCartViewThroughConversionsAttributionWindowMonth = 'addToCartViewThroughConversionsAttributionWindowMonth',
  AddToCartViewThroughConversionsAttributionWindowWeek = 'addToCartViewThroughConversionsAttributionWindowWeek',
  AddToWishlistClickThroughConversionsAttributionWindowDay = 'addToWishlistClickThroughConversionsAttributionWindowDay',
  AddToWishlistClickThroughConversionsAttributionWindowMonth = 'addToWishlistClickThroughConversionsAttributionWindowMonth',
  AddToWishlistClickThroughConversionsAttributionWindowWeek = 'addToWishlistClickThroughConversionsAttributionWindowWeek',
  AddToWishlistViewThroughConversionsAttributionWindowDay = 'addToWishlistViewThroughConversionsAttributionWindowDay',
  AddToWishlistViewThroughConversionsAttributionWindowMonth = 'addToWishlistViewThroughConversionsAttributionWindowMonth',
  AddToWishlistViewThroughConversionsAttributionWindowWeek = 'addToWishlistViewThroughConversionsAttributionWindowWeek',
  AppInstallMetricsAddPaymentInfo = 'appInstallMetricsAddPaymentInfo',
  AppInstallMetricsAddToCart = 'appInstallMetricsAddToCart',
  AppInstallMetricsAppLaunch = 'appInstallMetricsAppLaunch',
  AppInstallMetricsCompletedTutorial = 'appInstallMetricsCompletedTutorial',
  AppInstallMetricsInstall = 'appInstallMetricsInstall',
  AppInstallMetricsLevelAchieved = 'appInstallMetricsLevelAchieved',
  AppInstallMetricsPurchase = 'appInstallMetricsPurchase',
  AppInstallMetricsSearch = 'appInstallMetricsSearch',
  AppInstallMetricsSignUp = 'appInstallMetricsSignUp',
  AppInstallMetricsSpend = 'appInstallMetricsSpend',
  AppInstallMetricsSpendCredits = 'appInstallMetricsSpendCredits',
  AppInstallMetricsViewContent = 'appInstallMetricsViewContent',
  CampaignId = 'campaignId',
  Clicks = 'clicks',
  CommentDownvotes = 'commentDownvotes',
  CommentUpvotes = 'commentUpvotes',
  CommentsPageViews = 'commentsPageViews',
  Community = 'community',
  ConversionAddToCartAvgValue = 'conversionAddToCartAvgValue',
  ConversionAddToCartTotalItems = 'conversionAddToCartTotalItems',
  ConversionAddToCartTotalValue = 'conversionAddToCartTotalValue',
  ConversionAddToWishlistAvgValue = 'conversionAddToWishlistAvgValue',
  ConversionAddToWishlistTotalItems = 'conversionAddToWishlistTotalItems',
  ConversionAddToWishlistTotalValue = 'conversionAddToWishlistTotalValue',
  ConversionLeadTotalValue = 'conversionLeadTotalValue',
  ConversionPurchaseAvgValue = 'conversionPurchaseAvgValue',
  ConversionPurchaseTotalItems = 'conversionPurchaseTotalItems',
  ConversionPurchaseTotalValue = 'conversionPurchaseTotalValue',
  ConversionRoas = 'conversionRoas',
  ConversionSignupTotalValue = 'conversionSignupTotalValue',
  Country = 'country',
  Cpc = 'cpc',
  Ctr = 'ctr',
  CustomClickThroughConversionsAttributionWindowDay = 'customClickThroughConversionsAttributionWindowDay',
  CustomClickThroughConversionsAttributionWindowMonth = 'customClickThroughConversionsAttributionWindowMonth',
  CustomClickThroughConversionsAttributionWindowWeek = 'customClickThroughConversionsAttributionWindowWeek',
  CustomViewThroughConversionsAttributionWindowDay = 'customViewThroughConversionsAttributionWindowDay',
  CustomViewThroughConversionsAttributionWindowMonth = 'customViewThroughConversionsAttributionWindowMonth',
  CustomViewThroughConversionsAttributionWindowWeek = 'customViewThroughConversionsAttributionWindowWeek',
  /** Statistics */
  Date = 'date',
  DayOfMonth = 'dayOfMonth',
  Ecpm = 'ecpm',
  ExternalAdAccountId = 'externalAdAccountId',
  ExternalAdId = 'externalAdId',
  ExternalCampaignId = 'externalCampaignId',
  ExternalGroupId = 'externalGroupId',
  GroupBidAmount = 'groupBidAmount',
  GroupBidStrategy = 'groupBidStrategy',
  GroupCreatedAt = 'groupCreatedAt',
  GroupEffectiveStatus = 'groupEffectiveStatus',
  GroupEndTime = 'groupEndTime',
  GroupGoal = 'groupGoal',
  GroupGoalAmount = 'groupGoalAmount',
  GroupId = 'groupId',
  GroupModificationTime = 'groupModificationTime',
  GroupName = 'groupName',
  GroupStartTime = 'groupStartTime',
  GroupStatus = 'groupStatus',
  GroupUpdatedAt = 'groupUpdatedAt',
  Impressions = 'impressions',
  Interest = 'interest',
  LeadClickThroughConversionsAttributionWindowDay = 'leadClickThroughConversionsAttributionWindowDay',
  LeadClickThroughConversionsAttributionWindowMonth = 'leadClickThroughConversionsAttributionWindowMonth',
  LeadClickThroughConversionsAttributionWindowWeek = 'leadClickThroughConversionsAttributionWindowWeek',
  LeadViewThroughConversionsAttributionWindowDay = 'leadViewThroughConversionsAttributionWindowDay',
  LeadViewThroughConversionsAttributionWindowMonth = 'leadViewThroughConversionsAttributionWindowMonth',
  LeadViewThroughConversionsAttributionWindowWeek = 'leadViewThroughConversionsAttributionWindowWeek',
  LegacyClickConversionsAttributionWindowDay = 'legacyClickConversionsAttributionWindowDay',
  LegacyClickConversionsAttributionWindowMonth = 'legacyClickConversionsAttributionWindowMonth',
  LegacyClickConversionsAttributionWindowWeek = 'legacyClickConversionsAttributionWindowWeek',
  LegacyViewConversionsAttributionWindowDay = 'legacyViewConversionsAttributionWindowDay',
  LegacyViewConversionsAttributionWindowMonth = 'legacyViewConversionsAttributionWindowMonth',
  LegacyViewConversionsAttributionWindowWeek = 'legacyViewConversionsAttributionWindowWeek',
  Metro = 'metro',
  MonthName = 'monthName',
  MonthNumber = 'monthNumber',
  PageVisitClickThroughConversionsAttributionWindowDay = 'pageVisitClickThroughConversionsAttributionWindowDay',
  PageVisitClickThroughConversionsAttributionWindowMonth = 'pageVisitClickThroughConversionsAttributionWindowMonth',
  PageVisitClickThroughConversionsAttributionWindowWeek = 'pageVisitClickThroughConversionsAttributionWindowWeek',
  PageVisitViewThroughConversionsAttributionWindowDay = 'pageVisitViewThroughConversionsAttributionWindowDay',
  PageVisitViewThroughConversionsAttributionWindowMonth = 'pageVisitViewThroughConversionsAttributionWindowMonth',
  PageVisitViewThroughConversionsAttributionWindowWeek = 'pageVisitViewThroughConversionsAttributionWindowWeek',
  Placement = 'placement',
  PurchaseClickThroughConversionsAttributionWindowDay = 'purchaseClickThroughConversionsAttributionWindowDay',
  PurchaseClickThroughConversionsAttributionWindowMonth = 'purchaseClickThroughConversionsAttributionWindowMonth',
  PurchaseClickThroughConversionsAttributionWindowWeek = 'purchaseClickThroughConversionsAttributionWindowWeek',
  PurchaseViewThroughConversionsAttributionWindowDay = 'purchaseViewThroughConversionsAttributionWindowDay',
  PurchaseViewThroughConversionsAttributionWindowMonth = 'purchaseViewThroughConversionsAttributionWindowMonth',
  PurchaseViewThroughConversionsAttributionWindowWeek = 'purchaseViewThroughConversionsAttributionWindowWeek',
  Quarter = 'quarter',
  Region = 'region',
  SearchClickThroughConversionsAttributionWindowDay = 'searchClickThroughConversionsAttributionWindowDay',
  SearchClickThroughConversionsAttributionWindowMonth = 'searchClickThroughConversionsAttributionWindowMonth',
  SearchClickThroughConversionsAttributionWindowWeek = 'searchClickThroughConversionsAttributionWindowWeek',
  SearchViewThroughConversionsAttributionWindowDay = 'searchViewThroughConversionsAttributionWindowDay',
  SearchViewThroughConversionsAttributionWindowMonth = 'searchViewThroughConversionsAttributionWindowMonth',
  SearchViewThroughConversionsAttributionWindowWeek = 'searchViewThroughConversionsAttributionWindowWeek',
  SignUpClickThroughConversionsAttributionWindowDay = 'signUpClickThroughConversionsAttributionWindowDay',
  SignUpClickThroughConversionsAttributionWindowMonth = 'signUpClickThroughConversionsAttributionWindowMonth',
  SignUpClickThroughConversionsAttributionWindowWeek = 'signUpClickThroughConversionsAttributionWindowWeek',
  SignUpViewThroughConversionsAttributionWindowDay = 'signUpViewThroughConversionsAttributionWindowDay',
  SignUpViewThroughConversionsAttributionWindowMonth = 'signUpViewThroughConversionsAttributionWindowMonth',
  SignUpViewThroughConversionsAttributionWindowWeek = 'signUpViewThroughConversionsAttributionWindowWeek',
  Spend = 'spend',
  VideoFullyViewableImpressions = 'videoFullyViewableImpressions',
  VideoPlaysExpanded = 'videoPlaysExpanded',
  VideoPlaysWithSound = 'videoPlaysWithSound',
  VideoStarted = 'videoStarted',
  VideoViewableImpressions = 'videoViewableImpressions',
  VideoWatched3Seconds = 'videoWatched3Seconds',
  VideoWatched5Seconds = 'videoWatched5Seconds',
  VideoWatched10Seconds = 'videoWatched10Seconds',
  VideoWatched25Percent = 'videoWatched25Percent',
  VideoWatched50Percent = 'videoWatched50Percent',
  VideoWatched75Percent = 'videoWatched75Percent',
  VideoWatched95Percent = 'videoWatched95Percent',
  VideoWatched100Percent = 'videoWatched100Percent',
  ViewContentClickThroughConversionsAttributionWindowDay = 'viewContentClickThroughConversionsAttributionWindowDay',
  ViewContentClickThroughConversionsAttributionWindowMonth = 'viewContentClickThroughConversionsAttributionWindowMonth',
  ViewContentClickThroughConversionsAttributionWindowWeek = 'viewContentClickThroughConversionsAttributionWindowWeek',
  ViewContentViewThroughConversionsAttributionWindowDay = 'viewContentViewThroughConversionsAttributionWindowDay',
  ViewContentViewThroughConversionsAttributionWindowMonth = 'viewContentViewThroughConversionsAttributionWindowMonth',
  ViewContentViewThroughConversionsAttributionWindowWeek = 'viewContentViewThroughConversionsAttributionWindowWeek',
  ViewableImpressions = 'viewableImpressions',
  ViewerComments = 'viewerComments',
  WeekNumber = 'weekNumber',
  WeekdayName = 'weekdayName',
  WeekdayNumber = 'weekdayNumber',
  Year = 'year',
  YearMonth = 'yearMonth'
}

export type GroupSchedule = {
  __typename?: 'GroupSchedule';
  endDay?: Maybe<Scalars['Int']>;
  endHour?: Maybe<Scalars['Int']>;
  startDay?: Maybe<Scalars['Int']>;
  startHour?: Maybe<Scalars['Int']>;
};

export enum GroupStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Deleted = 'DELETED',
  Paused = 'PAUSED',
  Unknown = 'UNKNOWN'
}

export type GroupStatusFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<GroupStatus>;
};

export type GroupTargeting = {
  __typename?: 'GroupTargeting';
  groupTargetingCarriers?: Maybe<Array<Maybe<Scalars['String']>>>;
  groupTargetingCommunities?: Maybe<Array<Maybe<Scalars['String']>>>;
  groupTargetingCustomAudienceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  groupTargetingDevices?: Maybe<Array<Maybe<GroupTargetingDevices>>>;
  groupTargetingExcludedCommunities?: Maybe<Array<Maybe<Scalars['String']>>>;
  groupTargetingExcludedCustomAudienceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  groupTargetingExcludedGeolocations?: Maybe<Array<Maybe<Scalars['String']>>>;
  groupTargetingExcludedInterests?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**  This should never be present.  */
  groupTargetingExcludedKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  groupTargetingExpandTargeting?: Maybe<Scalars['Boolean']>;
  groupTargetingGender?: Maybe<GroupTargetingGender>;
  groupTargetingGeolocations?: Maybe<Array<Maybe<Scalars['String']>>>;
  groupTargetingInterests?: Maybe<Array<Maybe<Scalars['String']>>>;
  groupTargetingKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  groupTargetingLocations?: Maybe<Array<Maybe<GroupTargetingLocations>>>;
  /**  This is only present in old ads.  */
  groupTargetingPlacements?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  groupTargetingPlatforms?: Maybe<Array<Maybe<GroupTargetingPlatforms>>>;
  groupTargetingSlots?: Maybe<Array<Maybe<Scalars['String']>>>;
  groupTargetingSuppressionEventTypes?: Maybe<Array<Maybe<GroupTargetingSuppressionEventTypes>>>;
  groupTargetingViewModes?: Maybe<Array<Maybe<GroupTargetingViewMode>>>;
};

export enum GroupTargetingDeviceType {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE',
  Unknown = 'UNKNOWN'
}

export type GroupTargetingDevices = {
  __typename?: 'GroupTargetingDevices';
  groupTargetingDevicesLabelMap?: Maybe<Scalars['Mixed']>;
  groupTargetingDevicesOS?: Maybe<GroupTargetingDevicesOs>;
  groupTargetingDevicesOSMaxVersion?: Maybe<Scalars['String']>;
  groupTargetingDevicesOSMinVersion?: Maybe<Scalars['String']>;
  groupTargetingDevicesType?: Maybe<GroupTargetingDeviceType>;
};

export type GroupTargetingDevicesInput = {
  groupTargetingDevicesLabelMap?: InputMaybe<Array<InputMaybe<KeyValueInput>>>;
  groupTargetingDevicesOS?: InputMaybe<CreateGroupTargetingDevicesOs>;
  groupTargetingDevicesOSMaxVersion?: InputMaybe<Scalars['String']>;
  groupTargetingDevicesOSMinVersion?: InputMaybe<Scalars['String']>;
  groupTargetingDevicesType: CreateGroupTargetingDeviceType;
};

export enum GroupTargetingDevicesOs {
  Android = 'ANDROID',
  Ios = 'IOS',
  Unknown = 'UNKNOWN'
}

export enum GroupTargetingGender {
  Female = 'FEMALE',
  Male = 'MALE',
  Unknown = 'UNKNOWN'
}

export enum GroupTargetingLocations {
  CommentsPage = 'COMMENTS_PAGE',
  Feed = 'FEED',
  FullBleedVideoFeed = 'FULL_BLEED_VIDEO_FEED',
  LightboxSidebar = 'LIGHTBOX_SIDEBAR',
  MainSidebar = 'MAIN_SIDEBAR',
  Sidebars = 'SIDEBARS',
  TrendingDiscovery = 'TRENDING_DISCOVERY',
  TrendingSearchResult = 'TRENDING_SEARCH_RESULT',
  Unknown = 'UNKNOWN'
}

export enum GroupTargetingPlatforms {
  All = 'ALL',
  Desktop = 'DESKTOP',
  MobileNative = 'MOBILE_NATIVE',
  MobileWeb = 'MOBILE_WEB',
  MobileWeb_3X = 'MOBILE_WEB_3X',
  Shredtop = 'SHREDTOP',
  Unknown = 'UNKNOWN'
}

export enum GroupTargetingSuppressionEventTypes {
  AllFeatures = 'ALL_FEATURES',
  Unknown = 'UNKNOWN'
}

export enum GroupTargetingViewMode {
  All = 'ALL',
  Card = 'CARD',
  Classic = 'CLASSIC',
  Compact = 'COMPACT',
  Immersive = 'IMMERSIVE',
  Unknown = 'UNKNOWN'
}

export type IdFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<Scalars['ID']>;
};

export type IdRealmFilter = {
  value: Array<Scalars['ID']>;
};

export type Industry = {
  __typename?: 'Industry';
  industryId: Scalars['String'];
  industryName: Scalars['String'];
};

export type IndustryCursored = {
  __typename?: 'IndustryCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Industry>>;
};

export type IndustryFilter = {
  industryId?: InputMaybe<Array<IdFilter>>;
  industryName?: InputMaybe<Array<StringFilter>>;
};

export type IndustryOrderBy = {
  column: IndustryOrderByColumn;
  direction?: OrderByDirection;
};

export enum IndustryOrderByColumn {
  IndustryId = 'industryId',
  IndustryName = 'industryName'
}

export type IntFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<Scalars['Int']>;
};

export type InternalCategory = {
  __typename?: 'InternalCategory';
  internalCategoryCreatedAt?: Maybe<Scalars['DateTime']>;
  internalCategoryId: Scalars['ID'];
  internalCategoryModificationTime?: Maybe<Scalars['DateTime']>;
  internalCategoryName: Scalars['String'];
  internalCategoryType: InternalCategoryType;
  modifierId?: Maybe<Scalars['ID']>;
  modifierLevel: Scalars['String'];
};

export type InternalCategoryCursored = {
  __typename?: 'InternalCategoryCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<InternalCategory>>;
};

export type InternalCategoryFilter = {
  internalCategoryId?: InputMaybe<Array<IdFilter>>;
  internalCategoryName?: InputMaybe<Array<StringFilter>>;
  internalCategoryType?: InputMaybe<Array<StringFilter>>;
};

export type InternalCategoryOrderBy = {
  column: InternalCategoryOrderByColumn;
  direction?: OrderByDirection;
};

export enum InternalCategoryOrderByColumn {
  InternalCategoryId = 'internalCategoryId',
  InternalCategoryName = 'internalCategoryName',
  InternalCategoryType = 'internalCategoryType'
}

export enum InternalCategoryType {
  AdvertiserSalesforce = 'ADVERTISER_SALESFORCE',
  ClientType = 'CLIENT_TYPE',
  InternalCategory = 'INTERNAL_CATEGORY',
  ManagementRegion = 'MANAGEMENT_REGION',
  ServiceLevel = 'SERVICE_LEVEL',
  Tag = 'TAG',
  Unknown = 'UNKNOWN'
}

export type KeyValue = {
  __typename?: 'KeyValue';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Mixed']>;
};

export type KeyValueInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Mixed']>;
};

export type Media = {
  __typename?: 'Media';
  mediaId: Scalars['ID'];
  mediaOriginalExtension: Scalars['String'];
  mediaOriginalFileName?: Maybe<Scalars['String']>;
  mediaOriginalFormat: Scalars['String'];
  mediaThumbnail?: Maybe<Scalars['String']>;
  mediaType: Scalars['String'];
  mediaUrl?: Maybe<Scalars['String']>;
};

export type MediaCursored = {
  __typename?: 'MediaCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Media>>;
};

export type MediaFilter = {
  mediaId?: InputMaybe<Array<IdFilter>>;
};

export type MediaInput = {
  image?: InputMaybe<Scalars['ImageFile']>;
  video?: InputMaybe<Scalars['VideoFile']>;
};

export type MediaOrderBy = {
  column: MediaOrderByColumn;
  direction?: OrderByDirection;
};

export enum MediaOrderByColumn {
  MediaId = 'mediaId',
  MediaOriginalExtension = 'mediaOriginalExtension',
  MediaOriginalFormat = 'mediaOriginalFormat',
  MediaThumbnail = 'mediaThumbnail',
  MediaType = 'mediaType'
}

export type Member = {
  __typename?: 'Member';
  memberAccessTokenExpiry: Scalars['DateTime'];
  memberEmail?: Maybe<Scalars['String']>;
  memberFirstName?: Maybe<Scalars['String']>;
  memberId: Scalars['ID'];
  memberLastName?: Maybe<Scalars['String']>;
  memberPhone?: Maybe<Scalars['String']>;
  memberRefreshTokenValid: Scalars['Boolean'];
  memberUsername: Scalars['String'];
};

export type MemberCursored = {
  __typename?: 'MemberCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Member>>;
};

export type MemberFilter = {
  memberAccessTokenExpiry?: InputMaybe<Array<DateFilter>>;
  memberEmail?: InputMaybe<Array<StringFilter>>;
  memberFirstName?: InputMaybe<Array<StringFilter>>;
  memberId?: InputMaybe<Array<IdFilter>>;
  memberLastName?: InputMaybe<Array<StringFilter>>;
  memberPhone?: InputMaybe<Array<StringFilter>>;
  memberRefreshTokenValid?: InputMaybe<Array<BooleanFilter>>;
  memberUsername?: InputMaybe<Array<StringFilter>>;
};

export type MemberOrderBy = {
  column: MemberOrderByColumn;
  direction?: OrderByDirection;
};

export enum MemberOrderByColumn {
  MemberAccessTokenExpiry = 'memberAccessTokenExpiry',
  MemberEmail = 'memberEmail',
  MemberFirstName = 'memberFirstName',
  MemberId = 'memberId',
  MemberLastName = 'memberLastName',
  MemberPhone = 'memberPhone',
  MemberRefreshTokenValid = 'memberRefreshTokenValid',
  MemberUsername = 'memberUsername'
}

export type Mutation = {
  __typename?: 'Mutation';
  activateAgencyAccount: AgencyAccount;
  createAdAccounts: Array<AdAccount>;
  createAds: Array<Ad>;
  createAgencyAccount: AgencyAccount;
  createCampaignAutopilot?: Maybe<CampaignAutopilot>;
  createCampaigns: Array<Campaign>;
  createCreatives?: Maybe<Array<Maybe<Creative>>>;
  createGlobalNotification: Array<Notification>;
  createGroupAutopilot?: Maybe<GroupAutopilot>;
  createGroups?: Maybe<Array<Group>>;
  createInternalCategory: InternalCategory;
  createMember: Scalars['Boolean'];
  createReport: Report;
  createReportGoogleAccess: ReportOAuth;
  createUser: User;
  createUserGroup: UserGroup;
  deleteAds?: Maybe<Scalars['Boolean']>;
  deleteAgencyAccount: Scalars['Boolean'];
  deleteCampaignAutopilot?: Maybe<Scalars['Boolean']>;
  deleteCampaigns: Scalars['Boolean'];
  deleteClient: Scalars['Boolean'];
  deleteGlobalNotification: Scalars['Boolean'];
  deleteGroupAutopilot?: Maybe<Scalars['Boolean']>;
  deleteGroups: Scalars['Boolean'];
  deleteInternalCategory: Scalars['Boolean'];
  deleteReport: Scalars['Boolean'];
  deleteUser: Scalars['Boolean'];
  deleteUserGroup: Scalars['Boolean'];
  linkUserGroupsToAgencyAccount: AgencyAccount;
  linkUserGroupsToClient: Client;
  linkUserGroupsToUser: User;
  linkUsersToAgencyAccount: AgencyAccount;
  linkUsersToClient: Client;
  linkUsersToUserGroup: UserGroup;
  markAsRead?: Maybe<Array<Maybe<Notification>>>;
  notifyEntitySynced: Scalars['Boolean'];
  requestResetPassword?: Maybe<Scalars['Boolean']>;
  resetPassword?: Maybe<Scalars['Boolean']>;
  resolvePendingInvite: Scalars['Boolean'];
  restoreUser: User;
  transferAgencyAccountOwnership: AgencyAccount;
  transferUserGroupOwnership: UserGroup;
  unlinkUserGroupsFromAgencyAccount: AgencyAccount;
  unlinkUserGroupsFromClient: Client;
  unlinkUserGroupsFromUser: User;
  unlinkUsersFromAgencyAccount: AgencyAccount;
  unlinkUsersFromClient: Client;
  unlinkUsersFromUserGroup: UserGroup;
  updateAds: Array<Ad>;
  updateAgencyAccount: AgencyAccount;
  updateCampaignAutopilot?: Maybe<CampaignAutopilot>;
  updateCampaigns: Array<Campaign>;
  updateClient: Client;
  updateCreatives?: Maybe<Array<Maybe<Creative>>>;
  updateGroupAutopilot?: Maybe<GroupAutopilot>;
  updateGroups?: Maybe<Array<Group>>;
  updateInternalCategory: InternalCategory;
  updateMe: User;
  updateReport: Report;
  updateUser: User;
  updateUserGroup: UserGroup;
  updateUserGroupUserRole: UserGroup;
  uploadMedia: Media;
  version?: Maybe<Scalars['String']>;
};


export type MutationActivateAgencyAccountArgs = {
  agencyAccountId: Scalars['ID'];
};


export type MutationCreateAdAccountsArgs = {
  adAccountIds: Array<Scalars['ID']>;
  agencyAccountId: Scalars['ID'];
  businessId: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type MutationCreateAdsArgs = {
  ads: Array<CreateAdInput>;
};


export type MutationCreateAgencyAccountArgs = {
  agencyAccountName: Scalars['String'];
  agencyAccountOwnerId: Scalars['ID'];
  agencyAccountProfilePicture?: InputMaybe<Scalars['ImageFile']>;
  internalCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  salesforceId?: InputMaybe<Scalars['ID']>;
  userGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationCreateCampaignAutopilotArgs = {
  campaignAutopilotStatus: AutopilotStatus;
  campaignAutopilotTargetEvent: CampaignAutopilotTargetEvent;
  campaignAutopilotTotalGoalAmount: Scalars['Int'];
  campaignId: Scalars['ID'];
};


export type MutationCreateCampaignsArgs = {
  campaigns: Array<CreateCampaignInput>;
};


export type MutationCreateCreativesArgs = {
  creatives: Array<CreateCreativeInput>;
};


export type MutationCreateGlobalNotificationArgs = {
  notificationCategory: CreateNotificationCategory;
  notificationMessage: Scalars['String'];
  notificationPriority: Scalars['Int'];
  notificationTitle: Scalars['String'];
  notificationType: CreateNotificationType;
};


export type MutationCreateGroupAutopilotArgs = {
  groupAutopilotBidCoefficient?: InputMaybe<Scalars['Int']>;
  groupAutopilotCurrentPacing?: InputMaybe<Scalars['Int']>;
  groupAutopilotExpectedPacing?: InputMaybe<Scalars['Int']>;
  groupAutopilotStatus: AutopilotStatus;
  groupAutopilotWeightedBidSum?: InputMaybe<Scalars['Int']>;
  groupId: Scalars['ID'];
};


export type MutationCreateGroupsArgs = {
  groups: Array<CreateGroupInput>;
};


export type MutationCreateInternalCategoryArgs = {
  internalCategoryName: Scalars['String'];
  internalCategoryType: CreateInternalCategoryType;
};


export type MutationCreateMemberArgs = {
  memberAccessToken: Scalars['String'];
  memberAccessTokenExpiry: Scalars['DateTime'];
  memberEmail?: InputMaybe<Scalars['String']>;
  memberFirstName?: InputMaybe<Scalars['String']>;
  memberId: Scalars['ID'];
  memberLastName?: InputMaybe<Scalars['String']>;
  memberPhone?: InputMaybe<Scalars['String']>;
  memberRefreshToken: Scalars['String'];
  memberUsername: Scalars['String'];
};


export type MutationCreateReportArgs = {
  reportActionFormat: CreateReportActionFormat;
  reportActionOptions?: InputMaybe<ReportActionOptions>;
  reportActionType: CreateReportActionType;
  reportApiConditions?: InputMaybe<Array<ReportApiConditions>>;
  reportApiDataset: Scalars['String'];
  reportApiDimensions: Array<Scalars['String']>;
  reportApiFiltersOptions?: InputMaybe<Array<ReportApiFiltersOptions>>;
  reportApiHideZeroRows?: InputMaybe<Scalars['Boolean']>;
  reportApiMetrics: Array<Scalars['String']>;
  reportDateRangeOptions?: InputMaybe<ReportDateRangeOptions>;
  reportDateType: CreateReportDateType;
  reportName: Scalars['String'];
  reportReady?: InputMaybe<Scalars['Boolean']>;
  reportSchedule: Scalars['String'];
  userGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationCreateReportGoogleAccessArgs = {
  reportApiToken: Scalars['String'];
  userId: Scalars['ID'];
  userPassword?: InputMaybe<Scalars['String']>;
};


export type MutationCreateUserArgs = {
  credentials?: InputMaybe<Array<InputMaybe<UserCredentialInput>>>;
  userAccountLevel: CreateUserAccountLevel;
  userCompanyName?: InputMaybe<Scalars['String']>;
  userEmail: Scalars['Email'];
  userHasAgreedToTerms?: Scalars['Boolean'];
  userIsActivated?: Scalars['Boolean'];
  userName: Scalars['String'];
  userProfilePicture?: InputMaybe<Scalars['ImageFile']>;
  userSurname: Scalars['String'];
};


export type MutationCreateUserGroupArgs = {
  salesforceId?: InputMaybe<Scalars['String']>;
  userGroupName: Scalars['String'];
  userGroupProfilePicture?: InputMaybe<Scalars['ImageFile']>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationDeleteAdsArgs = {
  ads: Array<DeleteAdInput>;
};


export type MutationDeleteAgencyAccountArgs = {
  agencyAccountId: Scalars['ID'];
};


export type MutationDeleteCampaignAutopilotArgs = {
  campaignAutopilotId: Scalars['ID'];
};


export type MutationDeleteCampaignsArgs = {
  campaigns: Array<DeleteCampaignInput>;
};


export type MutationDeleteClientArgs = {
  clientId: Scalars['ID'];
};


export type MutationDeleteGlobalNotificationArgs = {
  notificationId: Scalars['ID'];
};


export type MutationDeleteGroupAutopilotArgs = {
  groupAutopilotId: Scalars['ID'];
};


export type MutationDeleteGroupsArgs = {
  groups: Array<DeleteGroupInput>;
};


export type MutationDeleteInternalCategoryArgs = {
  internalCategoryId: Scalars['ID'];
};


export type MutationDeleteReportArgs = {
  reportId: Scalars['ID'];
};


export type MutationDeleteUserArgs = {
  userId: Scalars['ID'];
};


export type MutationDeleteUserGroupArgs = {
  userGroupId: Scalars['ID'];
};


export type MutationLinkUserGroupsToAgencyAccountArgs = {
  agencyAccountId: Scalars['ID'];
  userGroupIds: Array<Scalars['ID']>;
};


export type MutationLinkUserGroupsToClientArgs = {
  clientId: Scalars['ID'];
  userGroupIds: Array<Scalars['ID']>;
};


export type MutationLinkUserGroupsToUserArgs = {
  userGroupIds: Array<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type MutationLinkUsersToAgencyAccountArgs = {
  agencyAccountId: Scalars['ID'];
  userIds: Array<Scalars['ID']>;
};


export type MutationLinkUsersToClientArgs = {
  clientId: Scalars['ID'];
  userIds: Array<Scalars['ID']>;
};


export type MutationLinkUsersToUserGroupArgs = {
  userGroupId: Scalars['ID'];
  userIds: Array<Scalars['ID']>;
};


export type MutationMarkAsReadArgs = {
  notificationIds: Array<Scalars['ID']>;
};


export type MutationNotifyEntitySyncedArgs = {
  entityId: Scalars['ID'];
  entityType: Sync_Entity_Type;
  error?: InputMaybe<Error>;
  status?: InputMaybe<Sync_Status>;
  userId: Scalars['ID'];
};


export type MutationRequestResetPasswordArgs = {
  userEmail: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  token: Scalars['String'];
  userPassword: Scalars['String'];
  userPasswordConfirmation: Scalars['String'];
};


export type MutationResolvePendingInviteArgs = {
  pendingInviteAction: PendingInviteAction;
  pendingInviteHash: Scalars['String'];
};


export type MutationRestoreUserArgs = {
  userId: Scalars['ID'];
};


export type MutationTransferAgencyAccountOwnershipArgs = {
  agencyAccountId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationTransferUserGroupOwnershipArgs = {
  userGroupId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationUnlinkUserGroupsFromAgencyAccountArgs = {
  agencyAccountId: Scalars['ID'];
  userGroupIds: Array<Scalars['ID']>;
};


export type MutationUnlinkUserGroupsFromClientArgs = {
  clientId: Scalars['ID'];
  userGroupIds: Array<Scalars['ID']>;
};


export type MutationUnlinkUserGroupsFromUserArgs = {
  userGroupIds: Array<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type MutationUnlinkUsersFromAgencyAccountArgs = {
  agencyAccountId: Scalars['ID'];
  userIds: Array<Scalars['ID']>;
};


export type MutationUnlinkUsersFromClientArgs = {
  clientId: Scalars['ID'];
  userIds: Array<Scalars['ID']>;
};


export type MutationUnlinkUsersFromUserGroupArgs = {
  userGroupId: Scalars['ID'];
  userIds: Array<Scalars['ID']>;
};


export type MutationUpdateAdsArgs = {
  ads: Array<UpdateAdInput>;
};


export type MutationUpdateAgencyAccountArgs = {
  agencyAccountId: Scalars['ID'];
  agencyAccountName?: InputMaybe<Scalars['String']>;
  agencyAccountProfilePicture?: InputMaybe<Scalars['ImageFile']>;
  internalCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salesforceId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateCampaignAutopilotArgs = {
  campaignAutopilotId: Scalars['ID'];
  campaignAutopilotLastRun?: InputMaybe<Scalars['DateTime']>;
  campaignAutopilotStatus?: InputMaybe<AutopilotStatus>;
  campaignAutopilotTargetEvent?: InputMaybe<CampaignAutopilotTargetEvent>;
  campaignAutopilotTotalGoalAmount?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateCampaignsArgs = {
  campaigns: Array<UpdateCampaignInput>;
};


export type MutationUpdateClientArgs = {
  clientBreakdown?: InputMaybe<Scalars['String']>;
  clientId: Scalars['ID'];
  clientKpi?: InputMaybe<Scalars['String']>;
  clientName?: InputMaybe<Scalars['String']>;
  clientPinned?: InputMaybe<Scalars['Boolean']>;
  clientProfilePicture?: InputMaybe<Scalars['ImageFile']>;
  internalCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationUpdateCreativesArgs = {
  creatives: Array<UpdateCreativeInput>;
};


export type MutationUpdateGroupAutopilotArgs = {
  groupAutopilotBidCoefficient?: InputMaybe<Scalars['Int']>;
  groupAutopilotCurrentPacing?: InputMaybe<Scalars['Int']>;
  groupAutopilotExpectedPacing?: InputMaybe<Scalars['Int']>;
  groupAutopilotId: Scalars['ID'];
  groupAutopilotLastRun?: InputMaybe<Scalars['DateTime']>;
  groupAutopilotStatus?: InputMaybe<AutopilotStatus>;
  groupAutopilotWeightedBidSum?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateGroupsArgs = {
  groups: Array<UpdateGroupInput>;
};


export type MutationUpdateInternalCategoryArgs = {
  internalCategoryId: Scalars['ID'];
  internalCategoryName?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateMeArgs = {
  userName?: InputMaybe<Scalars['String']>;
  userPassword?: InputMaybe<Scalars['String']>;
  userPasswordConfirmation?: InputMaybe<Scalars['String']>;
  userProfilePicture?: InputMaybe<Scalars['ImageFile']>;
  userSurname?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateReportArgs = {
  reportActionFormat?: InputMaybe<CreateReportActionFormat>;
  reportActionOptions?: InputMaybe<ReportActionOptions>;
  reportActionType?: InputMaybe<CreateReportActionType>;
  reportApiConditions?: InputMaybe<Array<ReportApiConditions>>;
  reportApiDataset?: InputMaybe<Scalars['String']>;
  reportApiDimensions?: InputMaybe<Array<Scalars['String']>>;
  reportApiFiltersOptions?: InputMaybe<Array<ReportApiFiltersOptions>>;
  reportApiHideZeroRows?: InputMaybe<Scalars['Boolean']>;
  reportApiMetrics?: InputMaybe<Array<Scalars['String']>>;
  reportDateRangeOptions?: InputMaybe<ReportDateRangeOptions>;
  reportDateType?: InputMaybe<CreateReportDateType>;
  reportId: Scalars['ID'];
  reportName?: InputMaybe<Scalars['String']>;
  reportReady?: InputMaybe<Scalars['Boolean']>;
  reportSchedule?: InputMaybe<Scalars['String']>;
  userGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationUpdateUserArgs = {
  credentials?: InputMaybe<Array<InputMaybe<UserCredentialInput>>>;
  userAccountLevel?: InputMaybe<CreateUserAccountLevel>;
  userCompanyName?: InputMaybe<Scalars['String']>;
  userHasAgreedToTerms?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
  userIsActivated?: InputMaybe<Scalars['Boolean']>;
  userName?: InputMaybe<Scalars['String']>;
  userPassword?: InputMaybe<Scalars['String']>;
  userPasswordConfirmation?: InputMaybe<Scalars['String']>;
  userProfilePicture?: InputMaybe<Scalars['ImageFile']>;
  userSurname?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateUserGroupArgs = {
  salesforceId?: InputMaybe<Scalars['String']>;
  userGroupId: Scalars['ID'];
  userGroupName?: InputMaybe<Scalars['String']>;
  userGroupProfilePicture?: InputMaybe<Scalars['ImageFile']>;
};


export type MutationUpdateUserGroupUserRoleArgs = {
  userGroupId: Scalars['ID'];
  userId: Scalars['ID'];
  userRole: UserGroupRoleInput;
};


export type MutationUploadMediaArgs = {
  clientId: Scalars['ID'];
  media: MediaInput;
};

export type Notification = {
  __typename?: 'Notification';
  client?: Maybe<Client>;
  notificationCategory: NotificationCategory;
  notificationCreatedAt: Scalars['DateTime'];
  notificationEntityId?: Maybe<Scalars['ID']>;
  notificationEntityType?: Maybe<NotificationEntityType>;
  notificationId: Scalars['ID'];
  notificationIsGlobal: Scalars['Boolean'];
  notificationIsRead: Scalars['Boolean'];
  notificationMessage: Scalars['String'];
  notificationPriority: Scalars['Int'];
  notificationTitle: Scalars['String'];
  notificationType: NotificationType;
};

export enum NotificationCategory {
  Notice = 'NOTICE',
  Unknown = 'UNKNOWN',
  Validation = 'VALIDATION'
}

export type NotificationCursored = {
  __typename?: 'NotificationCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Notification>>;
};

export enum NotificationEntityType {
  Ad = 'AD',
  AdAccount = 'AD_ACCOUNT',
  Campaign = 'CAMPAIGN',
  Creative = 'CREATIVE',
  Group = 'GROUP',
  Unknown = 'UNKNOWN'
}

export type NotificationFilter = {
  clientId?: InputMaybe<Array<IdFilter>>;
  notificationCategory?: InputMaybe<Array<StringFilter>>;
  notificationEntityId?: InputMaybe<Array<IdFilter>>;
  notificationEntityType?: InputMaybe<Array<StringFilter>>;
  notificationId?: InputMaybe<Array<IdFilter>>;
  notificationIsGlobal?: InputMaybe<Array<BooleanFilter>>;
  notificationIsRead?: InputMaybe<Array<BooleanFilter>>;
  notificationMessage?: InputMaybe<Array<StringFilter>>;
  notificationPriority?: InputMaybe<Array<IntFilter>>;
  notificationTitle?: InputMaybe<Array<InputMaybe<StringFilter>>>;
  notificationType?: InputMaybe<Array<StringFilter>>;
};

export type NotificationOrderBy = {
  column: NotificationOrderByColumn;
  direction?: OrderByDirection;
};

export enum NotificationOrderByColumn {
  NotificationCategory = 'notificationCategory',
  NotificationCreatedAt = 'notificationCreatedAt',
  NotificationEntityId = 'notificationEntityId',
  NotificationEntityType = 'notificationEntityType',
  NotificationId = 'notificationId',
  NotificationIsGlobal = 'notificationIsGlobal',
  NotificationIsRead = 'notificationIsRead',
  NotificationMessage = 'notificationMessage',
  NotificationPriority = 'notificationPriority',
  NotificationTitle = 'notificationTitle',
  NotificationType = 'notificationType'
}

export enum NotificationType {
  Announcement = 'ANNOUNCEMENT',
  Change = 'CHANGE',
  Error = 'ERROR',
  Success = 'SUCCESS',
  Unknown = 'UNKNOWN',
  Warning = 'WARNING'
}

export type OpenAiCompletionChoices = {
  __typename?: 'OpenAiCompletionChoices';
  finishReason?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  logprobs?: Maybe<Scalars['String']>;
  message?: Maybe<OpenAiCompletionChoicesMessage>;
};

export type OpenAiCompletionChoicesMessage = {
  __typename?: 'OpenAiCompletionChoicesMessage';
  content?: Maybe<Array<Maybe<Scalars['String']>>>;
  role?: Maybe<Scalars['String']>;
  toolCalls?: Maybe<Array<Maybe<OpenAiToolCalls>>>;
};

export type OpenAiToolCalls = {
  __typename?: 'OpenAiToolCalls';
  function?: Maybe<OpenAiToolCallsFunction>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type OpenAiToolCallsFunction = {
  __typename?: 'OpenAiToolCallsFunction';
  arguments?: Maybe<Scalars['Mixed']>;
  name?: Maybe<Scalars['String']>;
};

export enum OrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type PendingInvite = {
  __typename?: 'PendingInvite';
  pendingInviteCreatedAt: Scalars['String'];
  pendingInviteEntityId: Scalars['ID'];
  pendingInviteEntityType: PendingInviteEntityType;
  pendingInviteHash: Scalars['String'];
};

export enum PendingInviteAction {
  Accept = 'ACCEPT',
  Decline = 'DECLINE'
}

export enum PendingInviteEntityType {
  AgencyAccount = 'AGENCY_ACCOUNT',
  Client = 'CLIENT',
  Unknown = 'UNKNOWN',
  UserGroup = 'USER_GROUP'
}

export type PendingInviteEntityTypeFilter = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<PendingInviteEntityType>;
};

export type PendingInviteFilter = {
  pendingInviteEntityId?: InputMaybe<Array<IdFilter>>;
  pendingInviteEntityType?: InputMaybe<Array<PendingInviteEntityTypeFilter>>;
};

export enum Permission {
  ManageAdministrationDelete = 'manage_administration_delete',
  ManageAdministrationRead = 'manage_administration_read',
  ManageAdministrationWrite = 'manage_administration_write',
  ManageUserAccessDelete = 'manage_user_access_delete',
  ManageUserAccessRead = 'manage_user_access_read',
  ManageUserAccessWrite = 'manage_user_access_write',
  ManageUserDelete = 'manage_user_delete',
  ManageUserRead = 'manage_user_read',
  ManageUserWrite = 'manage_user_write',
  ModifyAgencyUserDelete = 'modify_agency_user_delete',
  ModifyAgencyUserRead = 'modify_agency_user_read',
  ModifyAgencyUserWrite = 'modify_agency_user_write',
  ModifyEntityDelete = 'modify_entity_delete',
  ModifyEntityRead = 'modify_entity_read',
  ModifyEntityWrite = 'modify_entity_write'
}

export type PixelLiveFilter = {
  pixelId: SingleIdRealmFilter;
};

export type Profile = {
  __typename?: 'Profile';
  business: Business;
  profileId: Scalars['ID'];
  profileModificationTime?: Maybe<Scalars['DateTime']>;
  profileName: Scalars['String'];
};

export type ProfileCursored = {
  __typename?: 'ProfileCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Profile>>;
};

export type ProfileFilter = {
  businessId?: InputMaybe<Array<IdFilter>>;
  profileId?: InputMaybe<Array<IdFilter>>;
  profileName?: InputMaybe<Array<StringFilter>>;
};

export type ProfileOrderBy = {
  column: ProfileOrderByColumn;
  direction?: OrderByDirection;
};

export enum ProfileOrderByColumn {
  ProfileId = 'profileId',
  ProfileName = 'profileName'
}

export type Query = {
  __typename?: 'Query';
  adAccounts: AdAccountCursored;
  adAccountsByBusinessLive?: Maybe<Array<Maybe<AdAccountsByBusiness>>>;
  adChangelog?: Maybe<AdChangelog>;
  /**  Get all admin users. Query used for fetching oauth admin user data  */
  adminUsers: AdminUserCursored;
  ads: AdCursored;
  adsLive?: Maybe<Array<Maybe<AdLive>>>;
  agencyAccounts: AgencyAccountCursored;
  audiences: AudienceCursored;
  businesses: BusinessCursored;
  campaignAutopilots: CampaignAutopilotCursored;
  campaignChangelog?: Maybe<CampaignChangelog>;
  campaigns: CampaignCursored;
  campaignsLive?: Maybe<Array<Maybe<CampaignLive>>>;
  clients: ClientCursored;
  countries: CountryCursored;
  creativeChangelog?: Maybe<CreativeChangelog>;
  creatives: CreativeCursored;
  creativesLive?: Maybe<Array<Maybe<CreativeLive>>>;
  groupAutopilots: GroupAutopilotCursored;
  groupChangelog?: Maybe<GroupChangelog>;
  groups: GroupCursored;
  groupsLive?: Maybe<Array<Maybe<GroupLive>>>;
  industries: IndustryCursored;
  internalCategories: InternalCategoryCursored;
  me: User;
  media: MediaCursored;
  members: MemberCursored;
  notifications: NotificationCursored;
  openAiCompletion?: Maybe<Array<Maybe<OpenAiCompletionChoices>>>;
  openAiHeadlines?: Maybe<Array<Maybe<Scalars['String']>>>;
  pixelLastFiredAt?: Maybe<Array<Maybe<GroupOptimizationGoal>>>;
  profiles: ProfileCursored;
  reportOAuth?: Maybe<ReportOAuth>;
  reports: ReportCursored;
  searchUsers: Array<SearchUser>;
  stats?: Maybe<StatsCursored>;
  targetingCarriers: TargetingCarrierCursored;
  targetingCarriersLive?: Maybe<Array<Maybe<TargetingCarrierLive>>>;
  targetingCommunities: TargetingCommunityCursored;
  targetingDevices: TargetingDeviceCursored;
  targetingDevicesLive?: Maybe<Array<Maybe<TargetingDeviceLive>>>;
  targetingGeolocations: TargetingGeolocationCursored;
  targetingGeolocationsLive?: Maybe<Array<Maybe<TargetingGeolocationLive>>>;
  targetingInterests: TargetingInterestCursored;
  targetingInterestsLive?: Maybe<Array<Maybe<TargetingInterestLive>>>;
  userGroups: UserGroupCursored;
  users: UserCursored;
  version?: Maybe<Scalars['String']>;
};


export type QueryAdAccountsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<AdAccountFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AdAccountOrderBy>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryAdAccountsByBusinessLiveArgs = {
  filters: AdAccountLiveFilter;
};


export type QueryAdChangelogArgs = {
  filters: AdChangelogFilter;
};


export type QueryAdminUsersArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<AdminFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryAdsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<AdFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<AdOrderBy>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryAdsLiveArgs = {
  filters: AdLiveFilter;
};


export type QueryAgencyAccountsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<AgencyAccountFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<AgencyAccountOrderBy>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryAudiencesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<AudienceFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<AudienceOrderBy>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryBusinessesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<BusinessFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BusinessOrderBy>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryCampaignAutopilotsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<CampaignAutopilotFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CampaignAutopilotOrderBy>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryCampaignChangelogArgs = {
  filters: CampaignChangelogFilter;
};


export type QueryCampaignsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<CampaignFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CampaignOrderBy>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryCampaignsLiveArgs = {
  filters: CampaignLiveFilter;
};


export type QueryClientsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ClientFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ClientOrderBy>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryCountriesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<CountryFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountryOrderBy>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryCreativeChangelogArgs = {
  filters: CreativeChangelogFilter;
};


export type QueryCreativesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<CreativeFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CreativeOrderBy>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryCreativesLiveArgs = {
  filters: CreativeLiveFilter;
};


export type QueryGroupAutopilotsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<GroupAutopilotFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupAutopilotOrderBy>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryGroupChangelogArgs = {
  filters: GroupChangelogFilter;
};


export type QueryGroupsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<GroupFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupOrderBy>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryGroupsLiveArgs = {
  filters: GroupLiveFilter;
};


export type QueryIndustriesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<IndustryFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IndustryOrderBy>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryInternalCategoriesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<InternalCategoryFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InternalCategoryOrderBy>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryMediaArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<MediaFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MediaOrderBy>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryMembersArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<MemberFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MemberOrderBy>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryNotificationsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<NotificationFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationOrderBy>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryOpenAiCompletionArgs = {
  columnNames: Array<Scalars['String']>;
  columnNamesArray: Array<Array<Scalars['String']>>;
  model: Scalars['String'];
  stringFormats: Array<Scalars['String']>;
  temperature: Scalars['Int'];
};


export type QueryOpenAiHeadlinesArgs = {
  count: Scalars['Int'];
  prompt: Scalars['String'];
};


export type QueryPixelLastFiredAtArgs = {
  filters: PixelLiveFilter;
};


export type QueryProfilesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ProfileFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProfileOrderBy>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryReportOAuthArgs = {
  email: Scalars['String'];
  hash: Scalars['String'];
};


export type QueryReportsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ReportFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportOrderBy>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QuerySearchUsersArgs = {
  filters: SearchUserFilter;
};


export type QueryStatsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<StatsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<StatsOrderBy>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryTargetingCarriersArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<TargetingCarrierFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<TargetingCarrierOrderBy>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryTargetingCarriersLiveArgs = {
  filters: TargetingCarrierLiveFilter;
};


export type QueryTargetingCommunitiesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<TargetingCommunityFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<TargetingCommunityOrderBy>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryTargetingDevicesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<TargetingDeviceFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<TargetingDeviceOrderBy>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryTargetingDevicesLiveArgs = {
  filters: TargetingDeviceLiveFilter;
};


export type QueryTargetingGeolocationsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<TargetingGeolocationFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TargetingGeolocationOrderBy>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryTargetingGeolocationsLiveArgs = {
  filters: TargetingGeolocationLiveFilter;
};


export type QueryTargetingInterestsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<TargetingInterestFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<TargetingInterestOrderBy>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryTargetingInterestsLiveArgs = {
  filters: TargetingInterestLiveFilter;
};


export type QueryUserGroupsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<UserGroupFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserGroupOrderBy>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryUsersArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<UserFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserOrderBy>>;
  query?: InputMaybe<Scalars['String']>;
};

export type Report = {
  __typename?: 'Report';
  entityId: Scalars['ID'];
  entityType: Scalars['String'];
  owner: User;
  reportActionFormat?: Maybe<ReportActionFormat>;
  reportActionOptions?: Maybe<ReportActionOptionsType>;
  reportActionType: ReportActionType;
  reportActivatedAt?: Maybe<Scalars['DateTime']>;
  reportApi: ReportApi;
  reportCreatedAt?: Maybe<Scalars['DateTime']>;
  reportDateRangeOptions?: Maybe<ReportDateRangeOptionsType>;
  reportDateType: ReportDateType;
  reportId: Scalars['ID'];
  reportName: Scalars['String'];
  reportOverviewType: Scalars['String'];
  reportReady: Scalars['Boolean'];
  reportSchedule: Scalars['String'];
  userGroups?: Maybe<Array<UserGroup>>;
  users?: Maybe<Array<User>>;
};

export enum ReportActionFormat {
  Csv = 'CSV',
  Excel = 'EXCEL',
  Inline = 'INLINE',
  Json = 'JSON',
  Unknown = 'UNKNOWN'
}

export enum ReportActionOptionType {
  ActionEmails = 'ACTION_EMAILS',
  Dataset = 'DATASET',
  From = 'FROM',
  Table = 'TABLE',
  Unknown = 'UNKNOWN'
}

export type ReportActionOptions = {
  actionOptionType: CreateReportActionOptionType;
  actionOptionValue: Array<Scalars['String']>;
};

export type ReportActionOptionsType = {
  __typename?: 'ReportActionOptionsType';
  actionOptionType?: Maybe<ReportActionOptionType>;
  actionOptionValue?: Maybe<Array<Scalars['String']>>;
};

export enum ReportActionType {
  Bigquery = 'BIGQUERY',
  Email = 'EMAIL',
  Show = 'SHOW',
  Unknown = 'UNKNOWN',
  Url = 'URL'
}

export type ReportActionTypeFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<CreateReportActionType>;
};

export type ReportApi = {
  __typename?: 'ReportApi';
  reportApiConditions?: Maybe<Array<Maybe<ReportApiConditionsType>>>;
  reportApiDataset: Scalars['String'];
  reportApiDimensions: Array<Maybe<Scalars['String']>>;
  reportApiFilters: Scalars['String'];
  reportApiFiltersOptions: Array<Maybe<ReportApiFiltersOptionsType>>;
  reportApiHideZeroRows: Scalars['Boolean'];
  reportApiId: Scalars['ID'];
  reportApiMetrics: Array<Maybe<Scalars['String']>>;
  reportApiToken: Scalars['String'];
};

export type ReportApiConditions = {
  metric: Scalars['String'];
  operator: Scalars['String'];
  value: Scalars['String'];
};

export type ReportApiConditionsType = {
  __typename?: 'ReportApiConditionsType';
  metric: Scalars['String'];
  operator: Scalars['String'];
  value: Scalars['String'];
};

export type ReportApiFiltersOptions = {
  action: CreateReportApiFiltersOptionsAction;
  filter: Scalars['String'];
  label: Scalars['String'];
  name: Scalars['String'];
  value: Array<Scalars['String']>;
};

export enum ReportApiFiltersOptionsAction {
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE',
  Unknown = 'UNKNOWN'
}

export type ReportApiFiltersOptionsType = {
  __typename?: 'ReportApiFiltersOptionsType';
  action: ReportApiFiltersOptionsAction;
  filter: Scalars['String'];
  label: Scalars['String'];
  name: Scalars['String'];
  value: Array<Scalars['String']>;
};

export type ReportCursored = {
  __typename?: 'ReportCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Report>>;
};

export type ReportDateRangeOptions = {
  dateRangeType: CreateReportDateRangeType;
  dateRangeValue: Array<Scalars['String']>;
};

export type ReportDateRangeOptionsType = {
  __typename?: 'ReportDateRangeOptionsType';
  dateRangeType?: Maybe<ReportDateRangeType>;
  dateRangeValue?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum ReportDateRangeType {
  DateSchedule = 'DATE_SCHEDULE',
  DaysValue = 'DAYS_VALUE',
  Unknown = 'UNKNOWN'
}

export enum ReportDateType {
  Biweekly = 'BIWEEKLY',
  CurrentMonth = 'CURRENT_MONTH',
  CurrentWeek = 'CURRENT_WEEK',
  CurrentYear = 'CURRENT_YEAR',
  Custom = 'CUSTOM',
  From = 'FROM',
  Last = 'LAST',
  Previous = 'PREVIOUS',
  Previous_3Months = 'PREVIOUS_3_MONTHS',
  PreviousMonth = 'PREVIOUS_MONTH',
  PreviousWeek = 'PREVIOUS_WEEK',
  PreviousYear = 'PREVIOUS_YEAR',
  Today = 'TODAY',
  Unknown = 'UNKNOWN',
  Yesterday = 'YESTERDAY'
}

export type ReportFilter = {
  reportActionType?: InputMaybe<Array<ReportActionTypeFilter>>;
  reportApiDataset?: InputMaybe<Array<StringFilter>>;
  reportApiDimensions?: InputMaybe<Array<StringFilter>>;
  reportApiFilters?: InputMaybe<Array<StringFilter>>;
  reportApiMetrics?: InputMaybe<Array<StringFilter>>;
  reportId?: InputMaybe<Array<IdFilter>>;
  reportName?: InputMaybe<Array<StringFilter>>;
};

export type ReportOAuth = {
  __typename?: 'ReportOAuth';
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
  email: Scalars['String'];
};

export type ReportOrderBy = {
  column: ReportOrderByColumn;
  direction?: OrderByDirection;
};

export enum ReportOrderByColumn {
  EntityId = 'entityId',
  EntityType = 'entityType',
  ReportActionFormat = 'reportActionFormat',
  ReportActionType = 'reportActionType',
  ReportActivatedAt = 'reportActivatedAt',
  ReportCreatedAt = 'reportCreatedAt',
  ReportDateType = 'reportDateType',
  ReportId = 'reportId',
  ReportName = 'reportName',
  ReportOverviewType = 'reportOverviewType',
  ReportReady = 'reportReady',
  ReportSchedule = 'reportSchedule'
}

export enum Role {
  Admin = 'ADMIN',
  Advertiser = 'ADVERTISER',
  Agency = 'AGENCY',
  ReadonlyUser = 'READONLY_USER',
  User = 'USER'
}

export enum Sync_Entity_Type {
  Ad = 'AD',
  Campaign = 'CAMPAIGN',
  Creative = 'CREATIVE',
  Group = 'GROUP'
}

export enum Sync_Status {
  Error = 'ERROR',
  Success = 'SUCCESS'
}

export type SearchUser = {
  __typename?: 'SearchUser';
  userAccountLevel: UserAccountLevel;
  userEmail: Scalars['Email'];
  userFullName?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
  userProfilePictureUrl?: Maybe<Scalars['String']>;
};

export type SearchUserFilter = {
  userAccountLevel?: InputMaybe<Array<UserAccountLevelFilter>>;
  userEmail: Array<ExactStringFilter>;
};

export type SingleDateFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['DateOptionalTime'];
};

export type SingleDateRealmFilter = {
  value: Scalars['DateTime'];
};

export type SingleFloatFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['Float'];
};

export type SingleFloatRealmFilter = {
  value: Scalars['Float'];
};

export type SingleIdFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['ID'];
};

export type SingleIdRealmFilter = {
  value: Scalars['ID'];
};

export type SingleIntFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['Int'];
};

export type SingleIntRealmFilter = {
  value: Scalars['Int'];
};

export type SingleStringFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['String'];
  wildcard?: InputMaybe<Scalars['Boolean']>;
};

export type SingleStringRealmFilter = {
  value: Scalars['String'];
};

export type Stats = {
  __typename?: 'Stats';
  adAccountCurrency?: Maybe<Scalars['String']>;
  adAccountId?: Maybe<Scalars['ID']>;
  adAccountName?: Maybe<Scalars['String']>;
  adId?: Maybe<Scalars['ID']>;
  adName?: Maybe<Scalars['String']>;
  addToCartClickThroughConversionsAttributionWindowDay?: Maybe<Scalars['Float']>;
  addToCartClickThroughConversionsAttributionWindowMonth?: Maybe<Scalars['Float']>;
  addToCartClickThroughConversionsAttributionWindowWeek?: Maybe<Scalars['Float']>;
  addToCartViewThroughConversionsAttributionWindowDay?: Maybe<Scalars['Float']>;
  addToCartViewThroughConversionsAttributionWindowMonth?: Maybe<Scalars['Float']>;
  addToCartViewThroughConversionsAttributionWindowWeek?: Maybe<Scalars['Float']>;
  addToWishlistClickThroughConversionsAttributionWindowDay?: Maybe<Scalars['Float']>;
  addToWishlistClickThroughConversionsAttributionWindowMonth?: Maybe<Scalars['Float']>;
  addToWishlistClickThroughConversionsAttributionWindowWeek?: Maybe<Scalars['Float']>;
  addToWishlistViewThroughConversionsAttributionWindowDay?: Maybe<Scalars['Float']>;
  addToWishlistViewThroughConversionsAttributionWindowMonth?: Maybe<Scalars['Float']>;
  addToWishlistViewThroughConversionsAttributionWindowWeek?: Maybe<Scalars['Float']>;
  agencyAccountId?: Maybe<Scalars['ID']>;
  agencyAccountName?: Maybe<Scalars['String']>;
  appInstallMetricsAddPaymentInfo?: Maybe<Scalars['Float']>;
  appInstallMetricsAddToCart?: Maybe<Scalars['Float']>;
  appInstallMetricsAppLaunch?: Maybe<Scalars['Float']>;
  appInstallMetricsCompletedTutorial?: Maybe<Scalars['Float']>;
  appInstallMetricsInstall?: Maybe<Scalars['Float']>;
  appInstallMetricsLevelAchieved?: Maybe<Scalars['Float']>;
  appInstallMetricsPurchase?: Maybe<Scalars['Float']>;
  appInstallMetricsSearch?: Maybe<Scalars['Float']>;
  appInstallMetricsSignUp?: Maybe<Scalars['Float']>;
  appInstallMetricsSpend?: Maybe<Scalars['Float']>;
  appInstallMetricsSpendCredits?: Maybe<Scalars['Float']>;
  appInstallMetricsViewContent?: Maybe<Scalars['Float']>;
  campaignId?: Maybe<Scalars['ID']>;
  campaignName?: Maybe<Scalars['String']>;
  campaignObjective?: Maybe<CampaignObjective>;
  clicks?: Maybe<Scalars['Float']>;
  clientId?: Maybe<Scalars['ID']>;
  clientName?: Maybe<Scalars['String']>;
  commentDownvotes?: Maybe<Scalars['Float']>;
  commentUpvotes?: Maybe<Scalars['Float']>;
  commentsPageViews?: Maybe<Scalars['Float']>;
  community?: Maybe<Scalars['String']>;
  conversionAddToCartAvgValue?: Maybe<Scalars['Float']>;
  conversionAddToCartTotalItems?: Maybe<Scalars['Float']>;
  conversionAddToCartTotalValue?: Maybe<Scalars['Float']>;
  conversionAddToWishlistAvgValue?: Maybe<Scalars['Float']>;
  conversionAddToWishlistTotalItems?: Maybe<Scalars['Float']>;
  conversionAddToWishlistTotalValue?: Maybe<Scalars['Float']>;
  conversionLeadTotalValue?: Maybe<Scalars['Float']>;
  conversionPurchaseAvgValue?: Maybe<Scalars['Float']>;
  conversionPurchaseTotalItems?: Maybe<Scalars['Float']>;
  conversionPurchaseTotalValue?: Maybe<Scalars['Float']>;
  conversionRoas?: Maybe<Scalars['Float']>;
  conversionSignupTotalValue?: Maybe<Scalars['Float']>;
  country?: Maybe<Scalars['String']>;
  cpc?: Maybe<Scalars['Float']>;
  ctr?: Maybe<Scalars['Float']>;
  customClickThroughConversionsAttributionWindowDay?: Maybe<Scalars['Float']>;
  customClickThroughConversionsAttributionWindowMonth?: Maybe<Scalars['Float']>;
  customClickThroughConversionsAttributionWindowWeek?: Maybe<Scalars['Float']>;
  customViewThroughConversionsAttributionWindowDay?: Maybe<Scalars['Float']>;
  customViewThroughConversionsAttributionWindowMonth?: Maybe<Scalars['Float']>;
  customViewThroughConversionsAttributionWindowWeek?: Maybe<Scalars['Float']>;
  date?: Maybe<Scalars['DateOptionalTime']>;
  dayOfMonth?: Maybe<Scalars['Int']>;
  ecpm?: Maybe<Scalars['Float']>;
  externalAdAccountId?: Maybe<Scalars['ID']>;
  externalAdId?: Maybe<Scalars['ID']>;
  externalCampaignId?: Maybe<Scalars['ID']>;
  externalGroupId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  groupName?: Maybe<Scalars['String']>;
  impressions?: Maybe<Scalars['Float']>;
  interest?: Maybe<Scalars['String']>;
  leadClickThroughConversionsAttributionWindowDay?: Maybe<Scalars['Float']>;
  leadClickThroughConversionsAttributionWindowMonth?: Maybe<Scalars['Float']>;
  leadClickThroughConversionsAttributionWindowWeek?: Maybe<Scalars['Float']>;
  leadViewThroughConversionsAttributionWindowDay?: Maybe<Scalars['Float']>;
  leadViewThroughConversionsAttributionWindowMonth?: Maybe<Scalars['Float']>;
  leadViewThroughConversionsAttributionWindowWeek?: Maybe<Scalars['Float']>;
  legacyClickConversionsAttributionWindowDay?: Maybe<Scalars['Float']>;
  legacyClickConversionsAttributionWindowMonth?: Maybe<Scalars['Float']>;
  legacyClickConversionsAttributionWindowWeek?: Maybe<Scalars['Float']>;
  legacyViewConversionsAttributionWindowDay?: Maybe<Scalars['Float']>;
  legacyViewConversionsAttributionWindowMonth?: Maybe<Scalars['Float']>;
  legacyViewConversionsAttributionWindowWeek?: Maybe<Scalars['Float']>;
  metro?: Maybe<Scalars['String']>;
  monthName?: Maybe<Scalars['String']>;
  monthNumber?: Maybe<Scalars['Int']>;
  pageVisitClickThroughConversionsAttributionWindowDay?: Maybe<Scalars['Float']>;
  pageVisitClickThroughConversionsAttributionWindowMonth?: Maybe<Scalars['Float']>;
  pageVisitClickThroughConversionsAttributionWindowWeek?: Maybe<Scalars['Float']>;
  pageVisitViewThroughConversionsAttributionWindowDay?: Maybe<Scalars['Float']>;
  pageVisitViewThroughConversionsAttributionWindowMonth?: Maybe<Scalars['Float']>;
  pageVisitViewThroughConversionsAttributionWindowWeek?: Maybe<Scalars['Float']>;
  placement?: Maybe<Scalars['String']>;
  purchaseClickThroughConversionsAttributionWindowDay?: Maybe<Scalars['Float']>;
  purchaseClickThroughConversionsAttributionWindowMonth?: Maybe<Scalars['Float']>;
  purchaseClickThroughConversionsAttributionWindowWeek?: Maybe<Scalars['Float']>;
  purchaseViewThroughConversionsAttributionWindowDay?: Maybe<Scalars['Float']>;
  purchaseViewThroughConversionsAttributionWindowMonth?: Maybe<Scalars['Float']>;
  purchaseViewThroughConversionsAttributionWindowWeek?: Maybe<Scalars['Float']>;
  quarter?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  searchClickThroughConversionsAttributionWindowDay?: Maybe<Scalars['Float']>;
  searchClickThroughConversionsAttributionWindowMonth?: Maybe<Scalars['Float']>;
  searchClickThroughConversionsAttributionWindowWeek?: Maybe<Scalars['Float']>;
  searchViewThroughConversionsAttributionWindowDay?: Maybe<Scalars['Float']>;
  searchViewThroughConversionsAttributionWindowMonth?: Maybe<Scalars['Float']>;
  searchViewThroughConversionsAttributionWindowWeek?: Maybe<Scalars['Float']>;
  signUpClickThroughConversionsAttributionWindowDay?: Maybe<Scalars['Float']>;
  signUpClickThroughConversionsAttributionWindowMonth?: Maybe<Scalars['Float']>;
  signUpClickThroughConversionsAttributionWindowWeek?: Maybe<Scalars['Float']>;
  signUpViewThroughConversionsAttributionWindowDay?: Maybe<Scalars['Float']>;
  signUpViewThroughConversionsAttributionWindowMonth?: Maybe<Scalars['Float']>;
  signUpViewThroughConversionsAttributionWindowWeek?: Maybe<Scalars['Float']>;
  spend?: Maybe<Scalars['Float']>;
  videoFullyViewableImpressions?: Maybe<Scalars['Float']>;
  videoPlaysExpanded?: Maybe<Scalars['Float']>;
  videoPlaysWithSound?: Maybe<Scalars['Float']>;
  videoStarted?: Maybe<Scalars['Float']>;
  videoViewableImpressions?: Maybe<Scalars['Float']>;
  videoWatched3Seconds?: Maybe<Scalars['Float']>;
  videoWatched5Seconds?: Maybe<Scalars['Float']>;
  videoWatched10Seconds?: Maybe<Scalars['Float']>;
  videoWatched25Percent?: Maybe<Scalars['Float']>;
  videoWatched50Percent?: Maybe<Scalars['Float']>;
  videoWatched75Percent?: Maybe<Scalars['Float']>;
  videoWatched95Percent?: Maybe<Scalars['Float']>;
  videoWatched100Percent?: Maybe<Scalars['Float']>;
  viewContentClickThroughConversionsAttributionWindowDay?: Maybe<Scalars['Float']>;
  viewContentClickThroughConversionsAttributionWindowMonth?: Maybe<Scalars['Float']>;
  viewContentClickThroughConversionsAttributionWindowWeek?: Maybe<Scalars['Float']>;
  viewContentViewThroughConversionsAttributionWindowDay?: Maybe<Scalars['Float']>;
  viewContentViewThroughConversionsAttributionWindowMonth?: Maybe<Scalars['Float']>;
  viewContentViewThroughConversionsAttributionWindowWeek?: Maybe<Scalars['Float']>;
  viewableImpressions?: Maybe<Scalars['Float']>;
  viewerComments?: Maybe<Scalars['Float']>;
  weekNumber?: Maybe<Scalars['Int']>;
  weekdayName?: Maybe<Scalars['String']>;
  weekdayNumber?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
  yearMonth?: Maybe<Scalars['String']>;
};

export type StatsCursored = {
  __typename?: 'StatsCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Stats>>;
};

export type StatsFilter = {
  adId?: InputMaybe<Array<InputMaybe<IdFilter>>>;
  adName?: InputMaybe<Array<InputMaybe<StringFilter>>>;
  adStatus?: InputMaybe<Array<InputMaybe<AdStatusFilter>>>;
  agencyAccountId?: InputMaybe<Array<InputMaybe<IdFilter>>>;
  campaignId?: InputMaybe<Array<InputMaybe<IdFilter>>>;
  campaignName?: InputMaybe<Array<InputMaybe<StringFilter>>>;
  campaignStatus?: InputMaybe<Array<InputMaybe<CampaignStatusFilter>>>;
  clientId?: InputMaybe<Array<InputMaybe<IdFilter>>>;
  clientStatus?: InputMaybe<Array<InputMaybe<ClientStatusFilter>>>;
  currency?: InputMaybe<Array<InputMaybe<StringFilter>>>;
  date?: InputMaybe<DateRangeFilter>;
  groupId?: InputMaybe<Array<InputMaybe<IdFilter>>>;
  groupName?: InputMaybe<Array<InputMaybe<StringFilter>>>;
  groupStatus?: InputMaybe<Array<InputMaybe<GroupStatusFilter>>>;
  internalCategoryId?: InputMaybe<Array<InputMaybe<IdFilter>>>;
  /** Define which metrics will be returned under metrics field in response. */
  metrics?: InputMaybe<Array<InputMaybe<StringFilter>>>;
  postId?: InputMaybe<Array<InputMaybe<IdFilter>>>;
  userGroupId?: InputMaybe<Array<InputMaybe<IdFilter>>>;
  userId?: InputMaybe<Array<InputMaybe<IdFilter>>>;
};

export type StatsOrderBy = {
  column: StatsOrderByColumn;
  direction?: OrderByDirection;
};

export enum StatsOrderByColumn {
  AdId = 'adId',
  AddToCartClickThroughConversionsAttributionWindowDay = 'addToCartClickThroughConversionsAttributionWindowDay',
  AddToCartClickThroughConversionsAttributionWindowMonth = 'addToCartClickThroughConversionsAttributionWindowMonth',
  AddToCartClickThroughConversionsAttributionWindowWeek = 'addToCartClickThroughConversionsAttributionWindowWeek',
  AddToCartViewThroughConversionsAttributionWindowDay = 'addToCartViewThroughConversionsAttributionWindowDay',
  AddToCartViewThroughConversionsAttributionWindowMonth = 'addToCartViewThroughConversionsAttributionWindowMonth',
  AddToCartViewThroughConversionsAttributionWindowWeek = 'addToCartViewThroughConversionsAttributionWindowWeek',
  AddToWishlistClickThroughConversionsAttributionWindowDay = 'addToWishlistClickThroughConversionsAttributionWindowDay',
  AddToWishlistClickThroughConversionsAttributionWindowMonth = 'addToWishlistClickThroughConversionsAttributionWindowMonth',
  AddToWishlistClickThroughConversionsAttributionWindowWeek = 'addToWishlistClickThroughConversionsAttributionWindowWeek',
  AddToWishlistViewThroughConversionsAttributionWindowDay = 'addToWishlistViewThroughConversionsAttributionWindowDay',
  AddToWishlistViewThroughConversionsAttributionWindowMonth = 'addToWishlistViewThroughConversionsAttributionWindowMonth',
  AddToWishlistViewThroughConversionsAttributionWindowWeek = 'addToWishlistViewThroughConversionsAttributionWindowWeek',
  AppInstallMetricsAddPaymentInfo = 'appInstallMetricsAddPaymentInfo',
  AppInstallMetricsAddToCart = 'appInstallMetricsAddToCart',
  AppInstallMetricsAppLaunch = 'appInstallMetricsAppLaunch',
  AppInstallMetricsCompletedTutorial = 'appInstallMetricsCompletedTutorial',
  AppInstallMetricsInstall = 'appInstallMetricsInstall',
  AppInstallMetricsLevelAchieved = 'appInstallMetricsLevelAchieved',
  AppInstallMetricsPurchase = 'appInstallMetricsPurchase',
  AppInstallMetricsSearch = 'appInstallMetricsSearch',
  AppInstallMetricsSignUp = 'appInstallMetricsSignUp',
  AppInstallMetricsSpend = 'appInstallMetricsSpend',
  AppInstallMetricsSpendCredits = 'appInstallMetricsSpendCredits',
  AppInstallMetricsViewContent = 'appInstallMetricsViewContent',
  CampaignId = 'campaignId',
  CampaignObjective = 'campaignObjective',
  Clicks = 'clicks',
  CommentDownvotes = 'commentDownvotes',
  CommentUpvotes = 'commentUpvotes',
  CommentsPageViews = 'commentsPageViews',
  Community = 'community',
  ConversionAddToCartAvgValue = 'conversionAddToCartAvgValue',
  ConversionAddToCartTotalItems = 'conversionAddToCartTotalItems',
  ConversionAddToCartTotalValue = 'conversionAddToCartTotalValue',
  ConversionAddToWishlistAvgValue = 'conversionAddToWishlistAvgValue',
  ConversionAddToWishlistTotalItems = 'conversionAddToWishlistTotalItems',
  ConversionAddToWishlistTotalValue = 'conversionAddToWishlistTotalValue',
  ConversionLeadTotalValue = 'conversionLeadTotalValue',
  ConversionPurchaseAvgValue = 'conversionPurchaseAvgValue',
  ConversionPurchaseTotalItems = 'conversionPurchaseTotalItems',
  ConversionPurchaseTotalValue = 'conversionPurchaseTotalValue',
  ConversionRoas = 'conversionRoas',
  ConversionSignupTotalValue = 'conversionSignupTotalValue',
  Country = 'country',
  Cpc = 'cpc',
  Ctr = 'ctr',
  CustomClickThroughConversionsAttributionWindowDay = 'customClickThroughConversionsAttributionWindowDay',
  CustomClickThroughConversionsAttributionWindowMonth = 'customClickThroughConversionsAttributionWindowMonth',
  CustomClickThroughConversionsAttributionWindowWeek = 'customClickThroughConversionsAttributionWindowWeek',
  CustomViewThroughConversionsAttributionWindowDay = 'customViewThroughConversionsAttributionWindowDay',
  CustomViewThroughConversionsAttributionWindowMonth = 'customViewThroughConversionsAttributionWindowMonth',
  CustomViewThroughConversionsAttributionWindowWeek = 'customViewThroughConversionsAttributionWindowWeek',
  Date = 'date',
  DayOfMonth = 'dayOfMonth',
  Ecpm = 'ecpm',
  ExternalAdAccountId = 'externalAdAccountId',
  ExternalAdId = 'externalAdId',
  ExternalCampaignId = 'externalCampaignId',
  ExternalGroupId = 'externalGroupId',
  GroupId = 'groupId',
  Impressions = 'impressions',
  Interest = 'interest',
  LeadClickThroughConversionsAttributionWindowDay = 'leadClickThroughConversionsAttributionWindowDay',
  LeadClickThroughConversionsAttributionWindowMonth = 'leadClickThroughConversionsAttributionWindowMonth',
  LeadClickThroughConversionsAttributionWindowWeek = 'leadClickThroughConversionsAttributionWindowWeek',
  LeadViewThroughConversionsAttributionWindowDay = 'leadViewThroughConversionsAttributionWindowDay',
  LeadViewThroughConversionsAttributionWindowMonth = 'leadViewThroughConversionsAttributionWindowMonth',
  LeadViewThroughConversionsAttributionWindowWeek = 'leadViewThroughConversionsAttributionWindowWeek',
  LegacyClickConversionsAttributionWindowDay = 'legacyClickConversionsAttributionWindowDay',
  LegacyClickConversionsAttributionWindowMonth = 'legacyClickConversionsAttributionWindowMonth',
  LegacyClickConversionsAttributionWindowWeek = 'legacyClickConversionsAttributionWindowWeek',
  LegacyViewConversionsAttributionWindowDay = 'legacyViewConversionsAttributionWindowDay',
  LegacyViewConversionsAttributionWindowMonth = 'legacyViewConversionsAttributionWindowMonth',
  LegacyViewConversionsAttributionWindowWeek = 'legacyViewConversionsAttributionWindowWeek',
  Metro = 'metro',
  MonthName = 'monthName',
  MonthNumber = 'monthNumber',
  PageVisitClickThroughConversionsAttributionWindowDay = 'pageVisitClickThroughConversionsAttributionWindowDay',
  PageVisitClickThroughConversionsAttributionWindowMonth = 'pageVisitClickThroughConversionsAttributionWindowMonth',
  PageVisitClickThroughConversionsAttributionWindowWeek = 'pageVisitClickThroughConversionsAttributionWindowWeek',
  PageVisitViewThroughConversionsAttributionWindowDay = 'pageVisitViewThroughConversionsAttributionWindowDay',
  PageVisitViewThroughConversionsAttributionWindowMonth = 'pageVisitViewThroughConversionsAttributionWindowMonth',
  PageVisitViewThroughConversionsAttributionWindowWeek = 'pageVisitViewThroughConversionsAttributionWindowWeek',
  Placement = 'placement',
  PurchaseClickThroughConversionsAttributionWindowDay = 'purchaseClickThroughConversionsAttributionWindowDay',
  PurchaseClickThroughConversionsAttributionWindowMonth = 'purchaseClickThroughConversionsAttributionWindowMonth',
  PurchaseClickThroughConversionsAttributionWindowWeek = 'purchaseClickThroughConversionsAttributionWindowWeek',
  PurchaseViewThroughConversionsAttributionWindowDay = 'purchaseViewThroughConversionsAttributionWindowDay',
  PurchaseViewThroughConversionsAttributionWindowMonth = 'purchaseViewThroughConversionsAttributionWindowMonth',
  PurchaseViewThroughConversionsAttributionWindowWeek = 'purchaseViewThroughConversionsAttributionWindowWeek',
  Quarter = 'quarter',
  Region = 'region',
  SearchClickThroughConversionsAttributionWindowDay = 'searchClickThroughConversionsAttributionWindowDay',
  SearchClickThroughConversionsAttributionWindowMonth = 'searchClickThroughConversionsAttributionWindowMonth',
  SearchClickThroughConversionsAttributionWindowWeek = 'searchClickThroughConversionsAttributionWindowWeek',
  SearchViewThroughConversionsAttributionWindowDay = 'searchViewThroughConversionsAttributionWindowDay',
  SearchViewThroughConversionsAttributionWindowMonth = 'searchViewThroughConversionsAttributionWindowMonth',
  SearchViewThroughConversionsAttributionWindowWeek = 'searchViewThroughConversionsAttributionWindowWeek',
  SignUpClickThroughConversionsAttributionWindowDay = 'signUpClickThroughConversionsAttributionWindowDay',
  SignUpClickThroughConversionsAttributionWindowMonth = 'signUpClickThroughConversionsAttributionWindowMonth',
  SignUpClickThroughConversionsAttributionWindowWeek = 'signUpClickThroughConversionsAttributionWindowWeek',
  SignUpViewThroughConversionsAttributionWindowDay = 'signUpViewThroughConversionsAttributionWindowDay',
  SignUpViewThroughConversionsAttributionWindowMonth = 'signUpViewThroughConversionsAttributionWindowMonth',
  SignUpViewThroughConversionsAttributionWindowWeek = 'signUpViewThroughConversionsAttributionWindowWeek',
  Spend = 'spend',
  VideoFullyViewableImpressions = 'videoFullyViewableImpressions',
  VideoPlaysExpanded = 'videoPlaysExpanded',
  VideoPlaysWithSound = 'videoPlaysWithSound',
  VideoStarted = 'videoStarted',
  VideoViewableImpressions = 'videoViewableImpressions',
  VideoWatched3Seconds = 'videoWatched3Seconds',
  VideoWatched5Seconds = 'videoWatched5Seconds',
  VideoWatched10Seconds = 'videoWatched10Seconds',
  VideoWatched25Percent = 'videoWatched25Percent',
  VideoWatched50Percent = 'videoWatched50Percent',
  VideoWatched75Percent = 'videoWatched75Percent',
  VideoWatched95Percent = 'videoWatched95Percent',
  VideoWatched100Percent = 'videoWatched100Percent',
  ViewContentClickThroughConversionsAttributionWindowDay = 'viewContentClickThroughConversionsAttributionWindowDay',
  ViewContentClickThroughConversionsAttributionWindowMonth = 'viewContentClickThroughConversionsAttributionWindowMonth',
  ViewContentClickThroughConversionsAttributionWindowWeek = 'viewContentClickThroughConversionsAttributionWindowWeek',
  ViewContentViewThroughConversionsAttributionWindowDay = 'viewContentViewThroughConversionsAttributionWindowDay',
  ViewContentViewThroughConversionsAttributionWindowMonth = 'viewContentViewThroughConversionsAttributionWindowMonth',
  ViewContentViewThroughConversionsAttributionWindowWeek = 'viewContentViewThroughConversionsAttributionWindowWeek',
  ViewableImpressions = 'viewableImpressions',
  ViewerComments = 'viewerComments',
  WeekNumber = 'weekNumber',
  WeekdayName = 'weekdayName',
  WeekdayNumber = 'weekdayNumber',
  Year = 'year',
  YearMonth = 'yearMonth'
}

export type StringFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<Scalars['String']>;
  wildcard?: InputMaybe<Scalars['Boolean']>;
};

export type StringRealmFilter = {
  value: Array<Scalars['String']>;
};

export type TargetingCarrier = {
  __typename?: 'TargetingCarrier';
  targetingCarrierCountryCode: Scalars['String'];
  targetingCarrierId: Scalars['ID'];
  targetingCarrierName: Scalars['String'];
};

export type TargetingCarrierCursored = {
  __typename?: 'TargetingCarrierCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<TargetingCarrier>>;
};

export type TargetingCarrierFilter = {
  targetingCarrierCountryCode?: InputMaybe<Array<StringFilter>>;
  targetingCarrierId?: InputMaybe<Array<IdFilter>>;
  targetingCarrierName?: InputMaybe<Array<StringFilter>>;
};

export type TargetingCarrierLive = {
  __typename?: 'TargetingCarrierLive';
  targetingCarrierLiveCountryCode?: Maybe<Scalars['String']>;
  targetingCarrierLiveId?: Maybe<Scalars['ID']>;
  targetingCarrierLiveName?: Maybe<Scalars['String']>;
};

export type TargetingCarrierLiveFilter = {
  adAccountId: SingleIdRealmFilter;
};

export type TargetingCarrierOrderBy = {
  column: TargetingCarrierOrderByColumns;
  direction?: OrderByDirection;
};

export enum TargetingCarrierOrderByColumns {
  TargetingCarrierCountryCode = 'targetingCarrierCountryCode',
  TargetingCarrierId = 'targetingCarrierId',
  TargetingCarrierName = 'targetingCarrierName'
}

export type TargetingCommunity = {
  __typename?: 'TargetingCommunity';
  targetingCommunityCategories?: Maybe<Array<Scalars['String']>>;
  targetingCommunityDescription?: Maybe<Scalars['String']>;
  targetingCommunityIconUrl?: Maybe<Scalars['String']>;
  targetingCommunityId: Scalars['ID'];
  targetingCommunityName: Scalars['String'];
  targetingCommunitySubscriberCount: Scalars['Int'];
};

export type TargetingCommunityCursored = {
  __typename?: 'TargetingCommunityCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<TargetingCommunity>>;
};

export type TargetingCommunityFilter = {
  targetingCommunityId?: InputMaybe<Array<IdFilter>>;
  targetingCommunityName?: InputMaybe<Array<StringFilter>>;
  targetingCommunitySubscriberCount?: InputMaybe<Array<IntFilter>>;
};

export type TargetingCommunityOrderBy = {
  column: TargetingCommunityOrderByColumns;
  direction?: OrderByDirection;
};

export enum TargetingCommunityOrderByColumns {
  TargetingCommunityId = 'targetingCommunityId',
  TargetingCommunityName = 'targetingCommunityName',
  TargetingCommunitySubscriberCount = 'targetingCommunitySubscriberCount'
}

export type TargetingDevice = {
  __typename?: 'TargetingDevice';
  targetingDeviceMake: Scalars['String'];
  targetingDeviceModel: Scalars['String'];
};

export type TargetingDeviceCursored = {
  __typename?: 'TargetingDeviceCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<TargetingDevice>>;
};

export type TargetingDeviceFilter = {
  targetingDeviceMake?: InputMaybe<Array<StringFilter>>;
  targetingDeviceModel?: InputMaybe<Array<StringFilter>>;
};

export type TargetingDeviceLive = {
  __typename?: 'TargetingDeviceLive';
  targetingDeviceLiveMake?: Maybe<Scalars['String']>;
  targetingDeviceLiveModel?: Maybe<Scalars['ID']>;
};

export type TargetingDeviceLiveFilter = {
  adAccountId: SingleIdRealmFilter;
};

export type TargetingDeviceOrderBy = {
  column: TargetingDeviceOrderByColumns;
  direction?: OrderByDirection;
};

export enum TargetingDeviceOrderByColumns {
  TargetingDeviceMake = 'targetingDeviceMake',
  TargetingDeviceModel = 'targetingDeviceModel'
}

export type TargetingGeolocation = {
  __typename?: 'TargetingGeolocation';
  targetingGeolocationCountry: Scalars['String'];
  targetingGeolocationDma?: Maybe<Scalars['Int']>;
  targetingGeolocationId: Scalars['ID'];
  targetingGeolocationName: Scalars['String'];
  targetingGeolocationPostalCode?: Maybe<Scalars['String']>;
  targetingGeolocationRegion?: Maybe<Scalars['String']>;
};

export type TargetingGeolocationCursored = {
  __typename?: 'TargetingGeolocationCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<TargetingGeolocation>>;
};

export type TargetingGeolocationFilter = {
  targetingGeolocationCountry?: InputMaybe<Array<StringFilter>>;
  targetingGeolocationDma?: InputMaybe<Array<IntFilter>>;
  targetingGeolocationId?: InputMaybe<Array<IdFilter>>;
  targetingGeolocationName?: InputMaybe<Array<StringFilter>>;
  targetingGeolocationPostalCode?: InputMaybe<Array<StringFilter>>;
  targetingGeolocationRegion?: InputMaybe<Array<StringFilter>>;
};

export type TargetingGeolocationLive = {
  __typename?: 'TargetingGeolocationLive';
  targetingGeolocationLiveCountry?: Maybe<Scalars['String']>;
  targetingGeolocationLiveDma?: Maybe<Scalars['Int']>;
  targetingGeolocationLiveId?: Maybe<Scalars['ID']>;
  targetingGeolocationLiveName?: Maybe<Scalars['String']>;
  targetingGeolocationLivePostalCode?: Maybe<Scalars['String']>;
  targetingGeolocationLiveRegion?: Maybe<Scalars['String']>;
};

export type TargetingGeolocationLiveFilter = {
  adAccountId: SingleIdRealmFilter;
  targetingGeolocationLiveCountry?: InputMaybe<SingleStringRealmFilter>;
  targetingGeolocationLivePostalCode?: InputMaybe<SingleStringRealmFilter>;
};

export type TargetingGeolocationOrderBy = {
  column: TargetingGeolocationOrderByColumns;
  direction?: OrderByDirection;
};

export enum TargetingGeolocationOrderByColumns {
  TargetingGeolocationCountry = 'targetingGeolocationCountry',
  TargetingGeolocationDma = 'targetingGeolocationDma',
  TargetingGeolocationId = 'targetingGeolocationId',
  TargetingGeolocationName = 'targetingGeolocationName',
  TargetingGeolocationPostalCode = 'targetingGeolocationPostalCode',
  TargetingGeolocationRegion = 'targetingGeolocationRegion'
}

export type TargetingInterest = {
  __typename?: 'TargetingInterest';
  targetingInterestCategory: Scalars['ID'];
  targetingInterestId: Scalars['ID'];
  targetingInterestName: Scalars['ID'];
};

export type TargetingInterestCursored = {
  __typename?: 'TargetingInterestCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<TargetingInterest>>;
};

export type TargetingInterestFilter = {
  targetingInterestCategory?: InputMaybe<Array<StringFilter>>;
  targetingInterestId?: InputMaybe<Array<IdFilter>>;
  targetingInterestName?: InputMaybe<Array<StringFilter>>;
};

export type TargetingInterestLive = {
  __typename?: 'TargetingInterestLive';
  targetingInterestLiveCategory?: Maybe<Scalars['String']>;
  targetingInterestLiveId?: Maybe<Scalars['ID']>;
  targetingInterestLiveName?: Maybe<Scalars['String']>;
};

export type TargetingInterestLiveFilter = {
  adAccountId: SingleIdRealmFilter;
};

export type TargetingInterestOrderBy = {
  column: TargetingInterestOrderByColumns;
  direction?: OrderByDirection;
};

export enum TargetingInterestOrderByColumns {
  TargetingInterestCategory = 'targetingInterestCategory',
  TargetingInterestId = 'targetingInterestId',
  TargetingInterestName = 'targetingInterestName'
}

export type Text = {
  __typename?: 'Text';
  textHash?: Maybe<Scalars['String']>;
  textId: Scalars['ID'];
  textValue?: Maybe<Scalars['String']>;
};

export type UpdateAdInput = {
  adEventTrackers?: InputMaybe<Array<InputMaybe<EventTrackerInput>>>;
  adHash: Scalars['String'];
  adId: Scalars['ID'];
  adName?: InputMaybe<Scalars['String']>;
  adStatus?: InputMaybe<CreateAdStatus>;
  creativeId?: InputMaybe<Scalars['ID']>;
};

export type UpdateCampaignInput = {
  campaignHash: Scalars['String'];
  campaignId: Scalars['ID'];
  campaignName?: InputMaybe<Scalars['String']>;
  campaignSpendCap?: InputMaybe<Scalars['BigInt']>;
  campaignStatus?: InputMaybe<CreateCampaignStatus>;
  fundingInstrumentId?: InputMaybe<Scalars['ID']>;
};

export type UpdateCreativeInput = {
  creativeAllowComments?: InputMaybe<Scalars['Boolean']>;
  creativeContent?: InputMaybe<Array<CreativeContentInput>>;
  creativeHash: Scalars['String'];
  creativeHeadline?: InputMaybe<Scalars['String']>;
  creativeId: Scalars['ID'];
  creativeStatus?: InputMaybe<CreateCreativeStatus>;
  creativeText?: InputMaybe<Scalars['String']>;
  creativeThumbnailUrl?: InputMaybe<Scalars['String']>;
};

export type UpdateGroupInput = {
  groupBidAmount?: InputMaybe<Scalars['Float']>;
  groupBidStrategy?: InputMaybe<CreateGroupBidStrategy>;
  groupEndTime?: InputMaybe<Scalars['DateTime']>;
  groupGoalAmount?: InputMaybe<Scalars['Float']>;
  groupHash: Scalars['String'];
  groupId: Scalars['ID'];
  groupName?: InputMaybe<Scalars['String']>;
  groupSchedule?: InputMaybe<Array<InputMaybe<CreateGroupScheduleInput>>>;
  groupStartTime?: InputMaybe<Scalars['DateTime']>;
  groupStatus?: InputMaybe<CreateGroupStatus>;
  groupTargeting?: InputMaybe<UpdateGroupTargetingInput>;
};

export type UpdateGroupTargetingInput = {
  groupTargetingCarriers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupTargetingCommunities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupTargetingCustomAudienceIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupTargetingExcludedCommunities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupTargetingExcludedCustomAudienceIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupTargetingExcludedGeolocations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupTargetingExpandTargeting?: InputMaybe<Scalars['Boolean']>;
  groupTargetingGender?: InputMaybe<CreateGroupTargetingGender>;
  groupTargetingGeolocations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupTargetingInterests?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  groupTargetingKeywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupTargetingLocations?: InputMaybe<Array<InputMaybe<CreateGroupTargetingLocations>>>;
  groupTargetingSuppressionEventTypes?: InputMaybe<Array<InputMaybe<CreateGroupTargetingSuppressionEventTypes>>>;
  groupTargetingViewModes?: InputMaybe<Array<InputMaybe<CreateGroupTargetingViewMode>>>;
};

export type User = {
  __typename?: 'User';
  notifications?: Maybe<Array<Notification>>;
  pendingInvites?: Maybe<Array<PendingInvite>>;
  userAccess?: Maybe<Array<UserAccess>>;
  userAccountLevel: UserAccountLevel;
  userActivatedAt?: Maybe<Scalars['DateTime']>;
  userCompanyName?: Maybe<Scalars['String']>;
  userCreatedAt: Scalars['DateTime'];
  userCreatedBy?: Maybe<Scalars['Int']>;
  userCredential?: Maybe<Array<UserCredential>>;
  userDeletedAt?: Maybe<Scalars['DateTime']>;
  userEmail: Scalars['Email'];
  userFullName?: Maybe<Scalars['String']>;
  userGroups?: Maybe<Array<UserGroup>>;
  userHasAgreedToTerms?: Maybe<Scalars['DateTime']>;
  userId: Scalars['ID'];
  userModificationTime?: Maybe<Scalars['DateTime']>;
  userName?: Maybe<Scalars['String']>;
  userProfilePictureUrl?: Maybe<Scalars['String']>;
  userSurname?: Maybe<Scalars['String']>;
  userTwoFactorAuthenticationEnabled: Scalars['Boolean'];
};


export type UserNotificationsArgs = {
  filters?: InputMaybe<NotificationFilter>;
  orderBy?: InputMaybe<Array<InputMaybe<NotificationOrderBy>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type UserPendingInvitesArgs = {
  filters?: InputMaybe<PendingInviteFilter>;
};

export type UserAccess = {
  __typename?: 'UserAccess';
  userAccessAccessType: UserAccessEntityType;
  userAccessEntityId: Scalars['ID'];
  userAccessEntityName: Scalars['String'];
  userGroupName?: Maybe<Scalars['String']>;
};

export enum UserAccessEntityType {
  Agency = 'AGENCY',
  Client = 'CLIENT'
}

export type UserAccessInput = {
  agencyIds?: InputMaybe<Array<Scalars['ID']>>;
  clientIds?: InputMaybe<Array<Scalars['ID']>>;
  userGroupIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum UserAccountLevel {
  Admin = 'ADMIN',
  Advertiser = 'ADVERTISER',
  Agency = 'AGENCY',
  ReadonlyUser = 'READONLY_USER',
  Unknown = 'UNKNOWN',
  User = 'USER'
}

export type UserAccountLevelFilter = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<UserAccountLevel>;
};

export type UserCredential = {
  __typename?: 'UserCredential';
  credentialId: Scalars['ID'];
  credentialName: Scalars['String'];
  userCredentialDelete: Scalars['Boolean'];
  userCredentialModificationTime?: Maybe<Scalars['DateTime']>;
  userCredentialRead: Scalars['Boolean'];
  userCredentialWrite: Scalars['Boolean'];
};

export type UserCredentialInput = {
  userCredentialDelete?: InputMaybe<Scalars['Boolean']>;
  userCredentialName: CredentialName;
  userCredentialRead?: InputMaybe<Scalars['Boolean']>;
  userCredentialWrite?: InputMaybe<Scalars['Boolean']>;
};

export type UserCursored = {
  __typename?: 'UserCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<User>>;
};

export type UserFilter = {
  userAccountLevel?: InputMaybe<Array<UserAccountLevelFilter>>;
  userCompanyName?: InputMaybe<Array<StringFilter>>;
  userCreatedBy?: InputMaybe<Array<IdFilter>>;
  userEmail?: InputMaybe<Array<StringFilter>>;
  userFullName?: InputMaybe<Array<StringFilter>>;
  userHasAgreedToTerms?: InputMaybe<Array<DateFilter>>;
  userId?: InputMaybe<Array<IdFilter>>;
  userName?: InputMaybe<Array<StringFilter>>;
  userSurname?: InputMaybe<Array<StringFilter>>;
};

export type UserGroup = {
  __typename?: 'UserGroup';
  agencyAccounts?: Maybe<Array<AgencyAccount>>;
  clients?: Maybe<Array<Client>>;
  salesforceId?: Maybe<Scalars['String']>;
  userGroupId: Scalars['ID'];
  userGroupName: Scalars['String'];
  userGroupProfilePictureUrl?: Maybe<Scalars['String']>;
  userGroupType: UserGroupType;
  users?: Maybe<Array<UserGroupUser>>;
};


export type UserGroupUsersArgs = {
  filters?: InputMaybe<UserFilter>;
};

export type UserGroupCursored = {
  __typename?: 'UserGroupCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<UserGroup>>;
};

export type UserGroupFilter = {
  userGroupId?: InputMaybe<Array<IdFilter>>;
  userGroupName?: InputMaybe<Array<StringFilter>>;
  userGroupOwnerEmail?: InputMaybe<Array<StringFilter>>;
  userGroupType?: InputMaybe<Array<StringFilter>>;
  userGroupUserRole?: InputMaybe<Array<UserGroupRoleFilter>>;
  userId?: InputMaybe<Array<IdFilter>>;
};

export type UserGroupOrderBy = {
  column: UserGroupOrderByColumn;
  direction?: OrderByDirection;
};

export enum UserGroupOrderByColumn {
  UserGroupId = 'userGroupId',
  UserGroupName = 'userGroupName'
}

export enum UserGroupRole {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Owner = 'OWNER'
}

export type UserGroupRoleFilter = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<UserGroupRole>;
};

export enum UserGroupRoleInput {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

export enum UserGroupType {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  Unknown = 'UNKNOWN'
}

export type UserGroupUser = {
  __typename?: 'UserGroupUser';
  user: User;
  userGroupPendingInviteHash?: Maybe<Scalars['String']>;
  userGroupUserRole: UserGroupRole;
};

export type UserOrderBy = {
  column: UserOrderByColumn;
  direction?: OrderByDirection;
};

export enum UserOrderByColumn {
  UserAccountLevel = 'userAccountLevel',
  UserCompanyName = 'userCompanyName',
  UserEmail = 'userEmail',
  UserHasAgreedToTerms = 'userHasAgreedToTerms',
  UserId = 'userId',
  UserName = 'userName',
  UserSurname = 'userSurname'
}



export type AcceptInviteMutationVariables = Exact<{

  hash: Scalars['String'];

}>;

export type AcceptInviteMutation = {
	__typename?: 'Mutation',
	resolvePendingInvite: boolean 
};

export type RequestResetPasswordMutationVariables = Exact<{

  userEmail: Scalars['String'];

}>;

export type RequestResetPasswordMutation = {
	__typename?: 'Mutation',
	requestResetPassword?: boolean | null 
};

export type ResetPasswordMutationVariables = Exact<{

  token: Scalars['String'];

  userPassword: Scalars['String'];

}>;

export type ResetPasswordMutation = {
	__typename?: 'Mutation',
	resetPassword?: boolean | null 
};

export type UpdateMeMutationVariables = Exact<{

  userProfilePicture?: InputMaybe<Scalars['ImageFile']>;

  userName?: InputMaybe<Scalars['String']>;

  userSurname?: InputMaybe<Scalars['String']>;

  userPassword?: InputMaybe<Scalars['String']>;

  userPasswordConfirmation?: InputMaybe<Scalars['String']>;

}>;

export type UpdateMeMutationUpdateMe = {
	__typename?: 'User',
	userName?: string | null,
	userSurname?: string | null,
	userProfilePictureUrl?: string | null,
	id: string 
}

export type UpdateMeMutation = {
	__typename?: 'Mutation',
	updateMe: UpdateMeMutationUpdateMe 
};

export type UserMetaDataQueryVariables = Exact<{ [key: string]: never; }>;

export type UserMetaDataQueryUserCredential = {
	__typename?: 'UserCredential',
	credentialId: string,
	credentialName: string,
	userCredentialRead: boolean,
	userCredentialWrite: boolean,
	userCredentialDelete: boolean 
}

export type UserMetaDataQueryUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string 
}

export type UserMetaDataQueryMe = {
	__typename?: 'User',
	userId: string,
	userFullName?: string | null,
	userName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null,
	userAccountLevel: UserAccountLevel,
	userTwoFactorAuthenticationEnabled: boolean,
	userCompanyName?: string | null,
	id: string,
	userCredential?: Array<UserMetaDataQueryUserCredential> | null,
	userGroups?: Array<UserMetaDataQueryUserGroups> | null 
}

export type UserMetaDataQuery = {
	__typename?: 'Query',
	me: UserMetaDataQueryMe 
};

export type UserFieldsFragment = { __typename?: 'User', userId: string, userEmail: any, userFullName?: string | null, userProfilePictureUrl?: string | null, id: string, value: string, label?: string | null, profilePictureUrl?: string | null };

export type RedditUsersAndGroupsQueryVariables = Exact<{

  usersFilterName?: InputMaybe<UserFilter>;

  usersFilterEmail?: InputMaybe<UserFilter>;

  userGroupFilter?: InputMaybe<UserGroupFilter>;

  userGroupSearchFilter?: InputMaybe<UserGroupFilter>;

  searchUserFilter: SearchUserFilter;

}>;

export type RedditUsersAndGroupsQueryItems = {
	__typename?: 'User',
	userId: string,
	userEmail: any,
	userFullName?: string | null,
	userProfilePictureUrl?: string | null,
	id: string,
	value: string,
	label?: string | null,
	profilePictureUrl?: string | null 
}

export type RedditUsersAndGroupsQuerySameOrganizationUsersEmail = {
	__typename?: 'UserCursored',
	items?: Array<RedditUsersAndGroupsQueryItems> | null 
}

export type RedditUsersAndGroupsQuerySameOrganizationUsersName = {
	__typename?: 'UserCursored',
	items?: Array<RedditUsersAndGroupsQueryItems> | null 
}

export type RedditUsersAndGroupsQueryUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any,
	userFullName?: string | null,
	userProfilePictureUrl?: string | null,
	id: string,
	value: string,
	label?: string | null,
	profilePictureUrl?: string | null 
}

export type RedditUsersAndGroupsQueryUsers = {
	__typename?: 'UserGroupUser',
	user: RedditUsersAndGroupsQueryUser 
}

export type RedditUsersAndGroupsQueryItemsItems = {
	__typename?: 'UserGroup',
	users?: Array<RedditUsersAndGroupsQueryUsers> | null 
}

export type RedditUsersAndGroupsQuerySharedTeamsName = {
	__typename?: 'UserGroupCursored',
	items?: Array<RedditUsersAndGroupsQueryItemsItems> | null 
}

export type RedditUsersAndGroupsQuerySharedTeamsEmail = {
	__typename?: 'UserGroupCursored',
	items?: Array<RedditUsersAndGroupsQueryItemsItems> | null 
}

export type RedditUsersAndGroupsQueryUserUser = {
	__typename?: 'User',
	userName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	id: string,
	profilePictureUrl?: string | null 
}

export type RedditUsersAndGroupsQueryUsersUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	userGroupPendingInviteHash?: string | null,
	user: RedditUsersAndGroupsQueryUserUser 
}

export type RedditUsersAndGroupsQueryItemsItemsItems = {
	__typename?: 'UserGroup',
	userGroupName: string,
	id: string,
	label: string,
	value: string,
	profilePictureUrl?: string | null,
	users?: Array<RedditUsersAndGroupsQueryUsersUsers> | null 
}

export type RedditUsersAndGroupsQuerySharedTeams = {
	__typename?: 'UserGroupCursored',
	items?: Array<RedditUsersAndGroupsQueryItemsItemsItems> | null 
}

export type RedditUsersAndGroupsQueryFullEmailUsers = {
	__typename?: 'SearchUser',
	userId: string,
	userFullName?: string | null,
	userProfilePictureUrl?: string | null,
	userEmail: any,
	id: string,
	value: string,
	label: any,
	profilePictureUrl?: string | null 
}

export type RedditUsersAndGroupsQuery = {
	__typename?: 'Query',
	sameOrganizationUsersEmail: RedditUsersAndGroupsQuerySameOrganizationUsersEmail, sameOrganizationUsersName: RedditUsersAndGroupsQuerySameOrganizationUsersName, sharedTeamsName: RedditUsersAndGroupsQuerySharedTeamsName, sharedTeamsEmail: RedditUsersAndGroupsQuerySharedTeamsEmail, sharedTeams: RedditUsersAndGroupsQuerySharedTeams, fullEmailUsers: Array<RedditUsersAndGroupsQueryFullEmailUsers> 
};

export type MatchColumnNamesQueryVariables = Exact<{

  model: Scalars['String'];

  columnNames: Array<Scalars['String']> | Scalars['String'];

  stringFormats: Array<Scalars['String']> | Scalars['String'];

  columnNamesArray: Array<Array<Scalars['String']> | Scalars['String']> | Array<Scalars['String']> | Scalars['String'];

  temperature: Scalars['Int'];

}>;

export type MatchColumnNamesQueryFunction = {
	__typename?: 'OpenAiToolCallsFunction',
	name?: string | null,
	arguments?: any | null 
}

export type MatchColumnNamesQueryToolCalls = {
	__typename?: 'OpenAiToolCalls',
	id?: string | null,
	type?: string | null,
	function?: MatchColumnNamesQueryFunction | null 
}

export type MatchColumnNamesQueryMessage = {
	__typename?: 'OpenAiCompletionChoicesMessage',
	role?: string | null,
	content?: Array<string | null> | null,
	toolCalls?: Array<MatchColumnNamesQueryToolCalls | null> | null 
}

export type MatchColumnNamesQueryOpenAiCompletion = {
	__typename?: 'OpenAiCompletionChoices',
	index?: number | null,
	logprobs?: string | null,
	finishReason?: string | null,
	message?: MatchColumnNamesQueryMessage | null 
}

export type MatchColumnNamesQuery = {
	__typename?: 'Query',
	openAiCompletion?: Array<MatchColumnNamesQueryOpenAiCompletion | null> | null 
};

export type AgencyAccessOptionsQueryVariables = Exact<{

  emailSearch: Scalars['String'];

  groupSearch: Scalars['String'];

  userSearch: Scalars['String'];

  userLevel: Array<UserAccountLevel> | UserAccountLevel;

  selectedGroupIds: Array<Scalars['ID']> | Scalars['ID'];

}>;

export type AgencyAccessOptionsQueryUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any,
	id: string,
	value: string,
	label: any 
}

export type AgencyAccessOptionsQueryUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: AgencyAccessOptionsQueryUser 
}

export type AgencyAccessOptionsQueryItems = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	id: string,
	value: string,
	label: string,
	profilePicture?: string | null,
	users?: Array<AgencyAccessOptionsQueryUsers> | null 
}

export type AgencyAccessOptionsQueryUserGroups = {
	__typename?: 'UserGroupCursored',
	items?: Array<AgencyAccessOptionsQueryItems> | null 
}

export type AgencyAccessOptionsQueryUsersUsers = {
	__typename?: 'SearchUser',
	userId: string,
	userFullName?: string | null,
	userEmail: any,
	id: string,
	profilePicture?: string | null,
	label?: string | null,
	value: string 
}

export type AgencyAccessOptionsQuery = {
	__typename?: 'Query',
	userGroups: AgencyAccessOptionsQueryUserGroups, users: Array<AgencyAccessOptionsQueryUsersUsers> 
};

export type ActivateAgencyAccountMutationVariables = Exact<{

  agencyAccountId: Scalars['ID'];

}>;

export type ActivateAgencyAccountMutationUser = {
	__typename?: 'User',
	userEmail: any,
	id: string 
}

export type ActivateAgencyAccountMutationUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: ActivateAgencyAccountMutationUser 
}

export type ActivateAgencyAccountMutationUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	id: string,
	profilePicture?: string | null,
	profilePictureUrl?: string | null,
	users?: Array<ActivateAgencyAccountMutationUsers> | null 
}

export type ActivateAgencyAccountMutationUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null,
	userAccountLevel: UserAccountLevel,
	id: string,
	profilePicture?: string | null,
	profilePictureUrl?: string | null 
}

export type ActivateAgencyAccountMutationUsersUsers = {
	__typename?: 'AgencyUser',
	agencyIsOwner: boolean,
	agencyPendingInviteHash?: string | null,
	user: ActivateAgencyAccountMutationUserUser 
}

export type ActivateAgencyAccountMutationClients = {
	__typename?: 'Client',
	clientName?: string | null,
	adAccountName?: string | null,
	id: string 
}

export type ActivateAgencyAccountMutationActivateAgencyAccount = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	agencyAccountDeletedAt?: any | null,
	id: string,
	agencyAccountProfilePicture?: string | null,
	userGroups?: Array<ActivateAgencyAccountMutationUserGroups> | null,
	users?: Array<ActivateAgencyAccountMutationUsersUsers> | null,
	clients?: Array<ActivateAgencyAccountMutationClients> | null 
}

export type ActivateAgencyAccountMutation = {
	__typename?: 'Mutation',
	activateAgencyAccount: ActivateAgencyAccountMutationActivateAgencyAccount 
};

export type AddTeamToAgencyMutationVariables = Exact<{

  userGroupIds: Array<Scalars['ID']> | Scalars['ID'];

  agencyAccountId: Scalars['ID'];

}>;

export type AddTeamToAgencyMutationUser = {
	__typename?: 'User',
	userEmail: any,
	id: string 
}

export type AddTeamToAgencyMutationUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: AddTeamToAgencyMutationUser 
}

export type AddTeamToAgencyMutationUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	id: string,
	profilePicture?: string | null,
	profilePictureUrl?: string | null,
	users?: Array<AddTeamToAgencyMutationUsers> | null 
}

export type AddTeamToAgencyMutationUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null,
	userAccountLevel: UserAccountLevel,
	id: string,
	profilePicture?: string | null,
	profilePictureUrl?: string | null 
}

export type AddTeamToAgencyMutationUsersUsers = {
	__typename?: 'AgencyUser',
	agencyIsOwner: boolean,
	agencyPendingInviteHash?: string | null,
	user: AddTeamToAgencyMutationUserUser 
}

export type AddTeamToAgencyMutationClients = {
	__typename?: 'Client',
	clientName?: string | null,
	adAccountName?: string | null,
	id: string 
}

export type AddTeamToAgencyMutationLinkUserGroupsToAgencyAccount = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	agencyAccountDeletedAt?: any | null,
	id: string,
	agencyAccountProfilePicture?: string | null,
	userGroups?: Array<AddTeamToAgencyMutationUserGroups> | null,
	users?: Array<AddTeamToAgencyMutationUsersUsers> | null,
	clients?: Array<AddTeamToAgencyMutationClients> | null 
}

export type AddTeamToAgencyMutation = {
	__typename?: 'Mutation',
	linkUserGroupsToAgencyAccount: AddTeamToAgencyMutationLinkUserGroupsToAgencyAccount 
};

export type RedditAdvertiserListQueryVariables = Exact<{

  search: Scalars['String'];

  cursor?: InputMaybe<Scalars['String']>;

}>;

export type RedditAdvertiserListQueryUser = {
	__typename?: 'User',
	userEmail: any,
	id: string 
}

export type RedditAdvertiserListQueryUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: RedditAdvertiserListQueryUser 
}

export type RedditAdvertiserListQueryUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	id: string,
	profilePicture?: string | null,
	profilePictureUrl?: string | null,
	users?: Array<RedditAdvertiserListQueryUsers> | null 
}

export type RedditAdvertiserListQueryUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null,
	userAccountLevel: UserAccountLevel,
	id: string,
	profilePicture?: string | null,
	profilePictureUrl?: string | null 
}

export type RedditAdvertiserListQueryUsersUsers = {
	__typename?: 'AgencyUser',
	agencyIsOwner: boolean,
	agencyPendingInviteHash?: string | null,
	user: RedditAdvertiserListQueryUserUser 
}

export type RedditAdvertiserListQueryClients = {
	__typename?: 'Client',
	clientName?: string | null,
	adAccountName?: string | null,
	id: string 
}

export type RedditAdvertiserListQueryItems = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	agencyAccountDeletedAt?: any | null,
	id: string,
	agencyAccountProfilePicture?: string | null,
	userGroups?: Array<RedditAdvertiserListQueryUserGroups> | null,
	users?: Array<RedditAdvertiserListQueryUsersUsers> | null,
	clients?: Array<RedditAdvertiserListQueryClients> | null 
}

export type RedditAdvertiserListQueryAgencyAccounts = {
	__typename?: 'AgencyAccountCursored',
	cursor?: string | null,
	items?: Array<RedditAdvertiserListQueryItems> | null 
}

export type RedditAdvertiserListQuery = {
	__typename?: 'Query',
	agencyAccounts: RedditAdvertiserListQueryAgencyAccounts 
};

export type CancelAgencyInvitationMutationVariables = Exact<{

  hash: Scalars['String'];

}>;

export type CancelAgencyInvitationMutation = {
	__typename?: 'Mutation',
	resolvePendingInvite: boolean 
};

export type CreateRedditAdvertiserMutationVariables = Exact<{

  agencyAccountName: Scalars['String'];

  agencyAccountOwnerId: Scalars['ID'];

  agencyAccountProfilePicture?: InputMaybe<Scalars['ImageFile']>;

  salesforceId?: InputMaybe<Scalars['ID']>;

  userGroupIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;

  userIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;

}>;

export type CreateRedditAdvertiserMutationUser = {
	__typename?: 'User',
	userEmail: any,
	id: string 
}

export type CreateRedditAdvertiserMutationUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: CreateRedditAdvertiserMutationUser 
}

export type CreateRedditAdvertiserMutationUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	id: string,
	profilePicture?: string | null,
	profilePictureUrl?: string | null,
	users?: Array<CreateRedditAdvertiserMutationUsers> | null 
}

export type CreateRedditAdvertiserMutationUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null,
	userAccountLevel: UserAccountLevel,
	id: string,
	profilePicture?: string | null,
	profilePictureUrl?: string | null 
}

export type CreateRedditAdvertiserMutationUsersUsers = {
	__typename?: 'AgencyUser',
	agencyIsOwner: boolean,
	agencyPendingInviteHash?: string | null,
	user: CreateRedditAdvertiserMutationUserUser 
}

export type CreateRedditAdvertiserMutationClients = {
	__typename?: 'Client',
	clientName?: string | null,
	adAccountName?: string | null,
	id: string 
}

export type CreateRedditAdvertiserMutationCreateAgencyAccount = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	agencyAccountDeletedAt?: any | null,
	id: string,
	agencyAccountProfilePicture?: string | null,
	userGroups?: Array<CreateRedditAdvertiserMutationUserGroups> | null,
	users?: Array<CreateRedditAdvertiserMutationUsersUsers> | null,
	clients?: Array<CreateRedditAdvertiserMutationClients> | null 
}

export type CreateRedditAdvertiserMutation = {
	__typename?: 'Mutation',
	createAgencyAccount: CreateRedditAdvertiserMutationCreateAgencyAccount 
};

export type DeleteAgencyAccountMutationVariables = Exact<{

  agencyAccountId: Scalars['ID'];

}>;

export type DeleteAgencyAccountMutation = {
	__typename?: 'Mutation',
	deleteAgencyAccount: boolean 
};

export type RedditAgencyFragmentFragment = { __typename?: 'AgencyAccount', agencyAccountId: string, agencyAccountName: string, salesforceId?: string | null, agencyAccountActivatedAt?: any | null, agencyAccountDeletedAt?: any | null, id: string, agencyAccountProfilePicture?: string | null, userGroups?: Array<{ __typename?: 'UserGroup', userGroupId: string, userGroupName: string, id: string, profilePicture?: string | null, profilePictureUrl?: string | null, users?: Array<{ __typename?: 'UserGroupUser', userGroupUserRole: UserGroupRole, user: { __typename?: 'User', userEmail: any, id: string } }> | null }> | null, users?: Array<{ __typename?: 'AgencyUser', agencyIsOwner: boolean, agencyPendingInviteHash?: string | null, user: { __typename?: 'User', userId: string, userName?: string | null, userFullName?: string | null, userSurname?: string | null, userEmail: any, userProfilePictureUrl?: string | null, userAccountLevel: UserAccountLevel, id: string, profilePicture?: string | null, profilePictureUrl?: string | null } }> | null, clients?: Array<{ __typename?: 'Client', clientName?: string | null, adAccountName?: string | null, id: string }> | null };

export type InviteUserToAgencyMutationVariables = Exact<{

  userIds: Array<Scalars['ID']> | Scalars['ID'];

  agencyAccountId: Scalars['ID'];

}>;

export type InviteUserToAgencyMutationUser = {
	__typename?: 'User',
	userEmail: any,
	id: string 
}

export type InviteUserToAgencyMutationUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: InviteUserToAgencyMutationUser 
}

export type InviteUserToAgencyMutationUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	id: string,
	profilePicture?: string | null,
	profilePictureUrl?: string | null,
	users?: Array<InviteUserToAgencyMutationUsers> | null 
}

export type InviteUserToAgencyMutationUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null,
	userAccountLevel: UserAccountLevel,
	id: string,
	profilePicture?: string | null,
	profilePictureUrl?: string | null 
}

export type InviteUserToAgencyMutationUsersUsers = {
	__typename?: 'AgencyUser',
	agencyIsOwner: boolean,
	agencyPendingInviteHash?: string | null,
	user: InviteUserToAgencyMutationUserUser 
}

export type InviteUserToAgencyMutationClients = {
	__typename?: 'Client',
	clientName?: string | null,
	adAccountName?: string | null,
	id: string 
}

export type InviteUserToAgencyMutationLinkUsersToAgencyAccount = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	agencyAccountDeletedAt?: any | null,
	id: string,
	agencyAccountProfilePicture?: string | null,
	userGroups?: Array<InviteUserToAgencyMutationUserGroups> | null,
	users?: Array<InviteUserToAgencyMutationUsersUsers> | null,
	clients?: Array<InviteUserToAgencyMutationClients> | null 
}

export type InviteUserToAgencyMutation = {
	__typename?: 'Mutation',
	linkUsersToAgencyAccount: InviteUserToAgencyMutationLinkUsersToAgencyAccount 
};

export type LinkGroupToAgencyMutationVariables = Exact<{

  groupIds: Array<Scalars['ID']> | Scalars['ID'];

  agencyAccountId: Scalars['ID'];

}>;

export type LinkGroupToAgencyMutationUser = {
	__typename?: 'User',
	userEmail: any,
	id: string 
}

export type LinkGroupToAgencyMutationUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: LinkGroupToAgencyMutationUser 
}

export type LinkGroupToAgencyMutationUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	id: string,
	profilePicture?: string | null,
	profilePictureUrl?: string | null,
	users?: Array<LinkGroupToAgencyMutationUsers> | null 
}

export type LinkGroupToAgencyMutationUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null,
	userAccountLevel: UserAccountLevel,
	id: string,
	profilePicture?: string | null,
	profilePictureUrl?: string | null 
}

export type LinkGroupToAgencyMutationUsersUsers = {
	__typename?: 'AgencyUser',
	agencyIsOwner: boolean,
	agencyPendingInviteHash?: string | null,
	user: LinkGroupToAgencyMutationUserUser 
}

export type LinkGroupToAgencyMutationClients = {
	__typename?: 'Client',
	clientName?: string | null,
	adAccountName?: string | null,
	id: string 
}

export type LinkGroupToAgencyMutationLinkUserGroupsToAgencyAccount = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	agencyAccountDeletedAt?: any | null,
	id: string,
	agencyAccountProfilePicture?: string | null,
	userGroups?: Array<LinkGroupToAgencyMutationUserGroups> | null,
	users?: Array<LinkGroupToAgencyMutationUsersUsers> | null,
	clients?: Array<LinkGroupToAgencyMutationClients> | null 
}

export type LinkGroupToAgencyMutation = {
	__typename?: 'Mutation',
	linkUserGroupsToAgencyAccount: LinkGroupToAgencyMutationLinkUserGroupsToAgencyAccount 
};

export type AdvertiserOwnerOptionsQueryVariables = Exact<{

  search: Scalars['String'];

}>;

export type AdvertiserOwnerOptionsQueryUsers = {
	__typename?: 'SearchUser',
	userId: string,
	userFullName?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null,
	userAccountLevel: UserAccountLevel,
	id: string,
	profilePicture?: string | null 
}

export type AdvertiserOwnerOptionsQuery = {
	__typename?: 'Query',
	users: Array<AdvertiserOwnerOptionsQueryUsers> 
};

export type AdvertiserOwnerOptionsAutocompleteQueryVariables = Exact<{

  search: Scalars['String'];

}>;

export type AdvertiserOwnerOptionsAutocompleteQueryUsers = {
	__typename?: 'SearchUser',
	userId: string,
	userFullName?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null,
	userAccountLevel: UserAccountLevel,
	id: string,
	profilePicture?: string | null,
	value: string,
	label?: string | null 
}

export type AdvertiserOwnerOptionsAutocompleteQuery = {
	__typename?: 'Query',
	users: Array<AdvertiserOwnerOptionsAutocompleteQueryUsers> 
};

export type RevokeGroupAccessToAgencyMutationVariables = Exact<{

  userGroupIds: Array<Scalars['ID']> | Scalars['ID'];

  agencyAccountId: Scalars['ID'];

}>;

export type RevokeGroupAccessToAgencyMutationUser = {
	__typename?: 'User',
	userEmail: any,
	id: string 
}

export type RevokeGroupAccessToAgencyMutationUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: RevokeGroupAccessToAgencyMutationUser 
}

export type RevokeGroupAccessToAgencyMutationUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	id: string,
	profilePicture?: string | null,
	profilePictureUrl?: string | null,
	users?: Array<RevokeGroupAccessToAgencyMutationUsers> | null 
}

export type RevokeGroupAccessToAgencyMutationUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null,
	userAccountLevel: UserAccountLevel,
	id: string,
	profilePicture?: string | null,
	profilePictureUrl?: string | null 
}

export type RevokeGroupAccessToAgencyMutationUsersUsers = {
	__typename?: 'AgencyUser',
	agencyIsOwner: boolean,
	agencyPendingInviteHash?: string | null,
	user: RevokeGroupAccessToAgencyMutationUserUser 
}

export type RevokeGroupAccessToAgencyMutationClients = {
	__typename?: 'Client',
	clientName?: string | null,
	adAccountName?: string | null,
	id: string 
}

export type RevokeGroupAccessToAgencyMutationUnlinkUserGroupsFromAgencyAccount = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	agencyAccountDeletedAt?: any | null,
	id: string,
	agencyAccountProfilePicture?: string | null,
	userGroups?: Array<RevokeGroupAccessToAgencyMutationUserGroups> | null,
	users?: Array<RevokeGroupAccessToAgencyMutationUsersUsers> | null,
	clients?: Array<RevokeGroupAccessToAgencyMutationClients> | null 
}

export type RevokeGroupAccessToAgencyMutation = {
	__typename?: 'Mutation',
	unlinkUserGroupsFromAgencyAccount: RevokeGroupAccessToAgencyMutationUnlinkUserGroupsFromAgencyAccount 
};

export type RevokeUserAccessToAgencyMutationVariables = Exact<{

  userIds: Array<Scalars['ID']> | Scalars['ID'];

  agencyAccountId: Scalars['ID'];

}>;

export type RevokeUserAccessToAgencyMutationUser = {
	__typename?: 'User',
	userEmail: any,
	id: string 
}

export type RevokeUserAccessToAgencyMutationUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: RevokeUserAccessToAgencyMutationUser 
}

export type RevokeUserAccessToAgencyMutationUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	id: string,
	profilePicture?: string | null,
	profilePictureUrl?: string | null,
	users?: Array<RevokeUserAccessToAgencyMutationUsers> | null 
}

export type RevokeUserAccessToAgencyMutationUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null,
	userAccountLevel: UserAccountLevel,
	id: string,
	profilePicture?: string | null,
	profilePictureUrl?: string | null 
}

export type RevokeUserAccessToAgencyMutationUsersUsers = {
	__typename?: 'AgencyUser',
	agencyIsOwner: boolean,
	agencyPendingInviteHash?: string | null,
	user: RevokeUserAccessToAgencyMutationUserUser 
}

export type RevokeUserAccessToAgencyMutationClients = {
	__typename?: 'Client',
	clientName?: string | null,
	adAccountName?: string | null,
	id: string 
}

export type RevokeUserAccessToAgencyMutationUnlinkUsersFromAgencyAccount = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	agencyAccountDeletedAt?: any | null,
	id: string,
	agencyAccountProfilePicture?: string | null,
	userGroups?: Array<RevokeUserAccessToAgencyMutationUserGroups> | null,
	users?: Array<RevokeUserAccessToAgencyMutationUsersUsers> | null,
	clients?: Array<RevokeUserAccessToAgencyMutationClients> | null 
}

export type RevokeUserAccessToAgencyMutation = {
	__typename?: 'Mutation',
	unlinkUsersFromAgencyAccount: RevokeUserAccessToAgencyMutationUnlinkUsersFromAgencyAccount 
};

export type RedditAdvertiserQueryVariables = Exact<{

  advertiserId: Scalars['ID'];

}>;

export type RedditAdvertiserQueryUser = {
	__typename?: 'User',
	userEmail: any,
	id: string 
}

export type RedditAdvertiserQueryUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: RedditAdvertiserQueryUser 
}

export type RedditAdvertiserQueryUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	id: string,
	profilePicture?: string | null,
	profilePictureUrl?: string | null,
	users?: Array<RedditAdvertiserQueryUsers> | null 
}

export type RedditAdvertiserQueryUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null,
	userAccountLevel: UserAccountLevel,
	id: string,
	profilePicture?: string | null,
	profilePictureUrl?: string | null 
}

export type RedditAdvertiserQueryUsersUsers = {
	__typename?: 'AgencyUser',
	agencyIsOwner: boolean,
	agencyPendingInviteHash?: string | null,
	user: RedditAdvertiserQueryUserUser 
}

export type RedditAdvertiserQueryClients = {
	__typename?: 'Client',
	clientName?: string | null,
	adAccountName?: string | null,
	id: string 
}

export type RedditAdvertiserQueryItems = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	agencyAccountDeletedAt?: any | null,
	id: string,
	agencyAccountProfilePicture?: string | null,
	userGroups?: Array<RedditAdvertiserQueryUserGroups> | null,
	users?: Array<RedditAdvertiserQueryUsersUsers> | null,
	clients?: Array<RedditAdvertiserQueryClients> | null 
}

export type RedditAdvertiserQueryAgencyAccounts = {
	__typename?: 'AgencyAccountCursored',
	items?: Array<RedditAdvertiserQueryItems> | null 
}

export type RedditAdvertiserQuery = {
	__typename?: 'Query',
	agencyAccounts: RedditAdvertiserQueryAgencyAccounts 
};

export type TransferAdvertiserOwnershipMutationVariables = Exact<{

  agencyAccountId: Scalars['ID'];

  userId: Scalars['ID'];

}>;

export type TransferAdvertiserOwnershipMutationUser = {
	__typename?: 'User',
	userEmail: any,
	id: string 
}

export type TransferAdvertiserOwnershipMutationUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: TransferAdvertiserOwnershipMutationUser 
}

export type TransferAdvertiserOwnershipMutationUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	id: string,
	profilePicture?: string | null,
	profilePictureUrl?: string | null,
	users?: Array<TransferAdvertiserOwnershipMutationUsers> | null 
}

export type TransferAdvertiserOwnershipMutationUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null,
	userAccountLevel: UserAccountLevel,
	id: string,
	profilePicture?: string | null,
	profilePictureUrl?: string | null 
}

export type TransferAdvertiserOwnershipMutationUsersUsers = {
	__typename?: 'AgencyUser',
	agencyIsOwner: boolean,
	agencyPendingInviteHash?: string | null,
	user: TransferAdvertiserOwnershipMutationUserUser 
}

export type TransferAdvertiserOwnershipMutationClients = {
	__typename?: 'Client',
	clientName?: string | null,
	adAccountName?: string | null,
	id: string 
}

export type TransferAdvertiserOwnershipMutationTransferAgencyAccountOwnership = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	agencyAccountDeletedAt?: any | null,
	id: string,
	agencyAccountProfilePicture?: string | null,
	userGroups?: Array<TransferAdvertiserOwnershipMutationUserGroups> | null,
	users?: Array<TransferAdvertiserOwnershipMutationUsersUsers> | null,
	clients?: Array<TransferAdvertiserOwnershipMutationClients> | null 
}

export type TransferAdvertiserOwnershipMutation = {
	__typename?: 'Mutation',
	transferAgencyAccountOwnership: TransferAdvertiserOwnershipMutationTransferAgencyAccountOwnership 
};

export type UpdateRedditAdvertiserMutationVariables = Exact<{

  agencyAccountId: Scalars['ID'];

  agencyAccountName?: InputMaybe<Scalars['String']>;

  salesforceId?: InputMaybe<Scalars['ID']>;

  profilePicture?: InputMaybe<Scalars['ImageFile']>;

}>;

export type UpdateRedditAdvertiserMutationUser = {
	__typename?: 'User',
	userEmail: any,
	id: string 
}

export type UpdateRedditAdvertiserMutationUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: UpdateRedditAdvertiserMutationUser 
}

export type UpdateRedditAdvertiserMutationUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	id: string,
	profilePicture?: string | null,
	profilePictureUrl?: string | null,
	users?: Array<UpdateRedditAdvertiserMutationUsers> | null 
}

export type UpdateRedditAdvertiserMutationUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null,
	userAccountLevel: UserAccountLevel,
	id: string,
	profilePicture?: string | null,
	profilePictureUrl?: string | null 
}

export type UpdateRedditAdvertiserMutationUsersUsers = {
	__typename?: 'AgencyUser',
	agencyIsOwner: boolean,
	agencyPendingInviteHash?: string | null,
	user: UpdateRedditAdvertiserMutationUserUser 
}

export type UpdateRedditAdvertiserMutationClients = {
	__typename?: 'Client',
	clientName?: string | null,
	adAccountName?: string | null,
	id: string 
}

export type UpdateRedditAdvertiserMutationUpdateAgencyAccount = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	agencyAccountDeletedAt?: any | null,
	id: string,
	agencyAccountProfilePicture?: string | null,
	userGroups?: Array<UpdateRedditAdvertiserMutationUserGroups> | null,
	users?: Array<UpdateRedditAdvertiserMutationUsersUsers> | null,
	clients?: Array<UpdateRedditAdvertiserMutationClients> | null 
}

export type UpdateRedditAdvertiserMutation = {
	__typename?: 'Mutation',
	updateAgencyAccount: UpdateRedditAdvertiserMutationUpdateAgencyAccount 
};

export type CreateReportGoogleAccessMutationVariables = Exact<{

  reportApiToken: Scalars['String'];

  userId: Scalars['ID'];

}>;

export type CreateReportGoogleAccessMutationCreateReportGoogleAccess = {
	__typename?: 'ReportOAuth',
	clientId: string,
	clientSecret: string 
}

export type CreateReportGoogleAccessMutation = {
	__typename?: 'Mutation',
	createReportGoogleAccess: CreateReportGoogleAccessMutationCreateReportGoogleAccess 
};

export type CreateRedditReportMutationVariables = Exact<{

  reportName: Scalars['String'];

  reportActionFormat: CreateReportActionFormat;

  reportActionType: CreateReportActionType;

  reportApiDimensions: Array<Scalars['String']> | Scalars['String'];

  reportApiMetrics: Array<Scalars['String']> | Scalars['String'];

  reportDateType: CreateReportDateType;

  reportSchedule: Scalars['String'];

  reportDateRangeOptions?: InputMaybe<ReportDateRangeOptions>;

  reportApiFiltersOptions: Array<ReportApiFiltersOptions> | ReportApiFiltersOptions;

  reportActionOptions?: InputMaybe<ReportActionOptions>;

  userIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;

  userGroupIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;

}>;

export type CreateRedditReportMutationReportApiFiltersOptions = {
	__typename?: 'ReportApiFiltersOptionsType',
	action: ReportApiFiltersOptionsAction,
	name: string,
	filter: string,
	value: Array<string>,
	label: string 
}

export type CreateRedditReportMutationReportApi = {
	__typename?: 'ReportApi',
	reportApiToken: string,
	reportApiMetrics: Array<string | null>,
	reportApiDimensions: Array<string | null>,
	reportApiFilters: string,
	reportApiFiltersOptions: Array<CreateRedditReportMutationReportApiFiltersOptions | null> 
}

export type CreateRedditReportMutationReportActionOptions = {
	__typename?: 'ReportActionOptionsType',
	actionOptionType?: ReportActionOptionType | null,
	actionOptionValue?: Array<string> | null 
}

export type CreateRedditReportMutationReportDateRangeOptions = {
	__typename?: 'ReportDateRangeOptionsType',
	dateRangeType?: ReportDateRangeType | null,
	dateRangeValue?: Array<string | null> | null 
}

export type CreateRedditReportMutationUsers = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userSurname?: string | null,
	userFullName?: string | null,
	userEmail: any,
	id: string,
	value: string,
	label?: string | null,
	profilePictureUrl?: string | null 
}

export type CreateRedditReportMutationUser = {
	__typename?: 'User',
	userName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	id: string,
	profilePictureUrl?: string | null 
}

export type CreateRedditReportMutationUsersUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	userGroupPendingInviteHash?: string | null,
	user: CreateRedditReportMutationUser 
}

export type CreateRedditReportMutationUserGroups = {
	__typename?: 'UserGroup',
	userGroupName: string,
	id: string,
	profilePictureUrl?: string | null,
	label: string,
	value: string,
	users?: Array<CreateRedditReportMutationUsersUsers> | null 
}

export type CreateRedditReportMutationOwner = {
	__typename?: 'User',
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	id: string,
	profilePictureUrl?: string | null 
}

export type CreateRedditReportMutationCreateReport = {
	__typename?: 'Report',
	reportId: string,
	reportName: string,
	reportReady: boolean,
	reportSchedule: string,
	reportDateType: ReportDateType,
	reportActivatedAt?: any | null,
	id: string,
	reportApi: CreateRedditReportMutationReportApi, reportActionOptions?: CreateRedditReportMutationReportActionOptions | null,
	reportDateRangeOptions?: CreateRedditReportMutationReportDateRangeOptions | null,
	users?: Array<CreateRedditReportMutationUsers> | null,
	userGroups?: Array<CreateRedditReportMutationUserGroups> | null,
	owner: CreateRedditReportMutationOwner 
}

export type CreateRedditReportMutation = {
	__typename?: 'Mutation',
	createReport: CreateRedditReportMutationCreateReport 
};

export type RedditReportDataSourcesQueryVariables = Exact<{

  datasourceClientSearch?: InputMaybe<Scalars['String']>;

  userGroupName: Scalars['String'];

}>;

export type RedditReportDataSourcesQueryClients = {
	__typename?: 'Client',
	adAccountName?: string | null,
	clientProfilePictureUrl?: string | null,
	id: string,
	name?: string | null 
}

export type RedditReportDataSourcesQueryItems = {
	__typename?: 'AgencyAccount',
	id: string,
	name: string,
	profilePictureUrl?: string | null,
	clients?: Array<RedditReportDataSourcesQueryClients> | null 
}

export type RedditReportDataSourcesQueryAgencyAccounts = {
	__typename?: 'AgencyAccountCursored',
	items?: Array<RedditReportDataSourcesQueryItems> | null 
}

export type RedditReportDataSourcesQueryAgencyAccount = {
	__typename?: 'AgencyAccount',
	id: string 
}

export type RedditReportDataSourcesQueryItemsItems = {
	__typename?: 'Client',
	adAccountName?: string | null,
	id: string,
	name?: string | null,
	profilePictureUrl?: string | null,
	agencyAccount?: RedditReportDataSourcesQueryAgencyAccount | null 
}

export type RedditReportDataSourcesQueryClientsClients = {
	__typename?: 'ClientCursored',
	items?: Array<RedditReportDataSourcesQueryItemsItems> | null 
}

export type RedditReportDataSourcesQueryClientsClientsClients = {
	__typename?: 'Client',
	clientProfilePictureUrl?: string | null,
	adAccountName?: string | null,
	id: string,
	name?: string | null 
}

export type RedditReportDataSourcesQueryAgencyAccountsAgencyAccounts = {
	__typename?: 'AgencyAccount',
	clients?: Array<RedditReportDataSourcesQueryClientsClientsClients> | null 
}

export type RedditReportDataSourcesQueryItemsItemsItems = {
	__typename?: 'UserGroup',
	id: string,
	name: string,
	profilePictureUrl?: string | null,
	clients?: Array<RedditReportDataSourcesQueryClientsClientsClients> | null,
	agencyAccounts?: Array<RedditReportDataSourcesQueryAgencyAccountsAgencyAccounts> | null 
}

export type RedditReportDataSourcesQueryUserGroups = {
	__typename?: 'UserGroupCursored',
	items?: Array<RedditReportDataSourcesQueryItemsItemsItems> | null 
}

export type RedditReportDataSourcesQuery = {
	__typename?: 'Query',
	agencyAccounts: RedditReportDataSourcesQueryAgencyAccounts, clients: RedditReportDataSourcesQueryClientsClients, userGroups: RedditReportDataSourcesQueryUserGroups 
};

export type DeleteRedditReportMutationVariables = Exact<{

  reportId: Scalars['ID'];

}>;

export type DeleteRedditReportMutation = {
	__typename?: 'Mutation',
	deleteReport: boolean 
};

export type ReportFragmentFragment = { __typename?: 'Report', reportId: string, reportName: string, reportReady: boolean, reportSchedule: string, reportDateType: ReportDateType, reportActivatedAt?: any | null, id: string, reportApi: { __typename?: 'ReportApi', reportApiToken: string, reportApiMetrics: Array<string | null>, reportApiDimensions: Array<string | null>, reportApiFilters: string, reportApiFiltersOptions: Array<{ __typename?: 'ReportApiFiltersOptionsType', action: ReportApiFiltersOptionsAction, name: string, filter: string, value: Array<string>, label: string } | null> }, reportActionOptions?: { __typename?: 'ReportActionOptionsType', actionOptionType?: ReportActionOptionType | null, actionOptionValue?: Array<string> | null } | null, reportDateRangeOptions?: { __typename?: 'ReportDateRangeOptionsType', dateRangeType?: ReportDateRangeType | null, dateRangeValue?: Array<string | null> | null } | null, users?: Array<{ __typename?: 'User', userId: string, userName?: string | null, userSurname?: string | null, userFullName?: string | null, userEmail: any, id: string, value: string, label?: string | null, profilePictureUrl?: string | null }> | null, userGroups?: Array<{ __typename?: 'UserGroup', userGroupName: string, id: string, profilePictureUrl?: string | null, label: string, value: string, users?: Array<{ __typename?: 'UserGroupUser', userGroupUserRole: UserGroupRole, userGroupPendingInviteHash?: string | null, user: { __typename?: 'User', userName?: string | null, userSurname?: string | null, userEmail: any, id: string, profilePictureUrl?: string | null } }> | null }> | null, owner: { __typename?: 'User', userName?: string | null, userFullName?: string | null, userSurname?: string | null, userEmail: any, id: string, profilePictureUrl?: string | null } };

export type ReportImageQueryVariables = Exact<{

  clientIds: Array<Scalars['ID']> | Scalars['ID'];

}>;

export type ReportImageQueryAdAccount = {
	__typename?: 'AdAccount',
	id: string 
}

export type ReportImageQueryAgencyAccount = {
	__typename?: 'AgencyAccount',
	id: string 
}

export type ReportImageQueryItems = {
	__typename?: 'Client',
	clientProfilePictureUrl?: string | null,
	id: string,
	adAccount: ReportImageQueryAdAccount, agencyAccount?: ReportImageQueryAgencyAccount | null 
}

export type ReportImageQueryClients = {
	__typename?: 'ClientCursored',
	items?: Array<ReportImageQueryItems> | null 
}

export type ReportImageQuery = {
	__typename?: 'Query',
	clients: ReportImageQueryClients 
};

export type RedditReportsQueryVariables = Exact<{

  search: Scalars['String'];

  cursor?: InputMaybe<Scalars['String']>;

}>;

export type RedditReportsQueryReportApiFiltersOptions = {
	__typename?: 'ReportApiFiltersOptionsType',
	action: ReportApiFiltersOptionsAction,
	name: string,
	filter: string,
	value: Array<string>,
	label: string 
}

export type RedditReportsQueryReportApi = {
	__typename?: 'ReportApi',
	reportApiToken: string,
	reportApiMetrics: Array<string | null>,
	reportApiDimensions: Array<string | null>,
	reportApiFilters: string,
	reportApiFiltersOptions: Array<RedditReportsQueryReportApiFiltersOptions | null> 
}

export type RedditReportsQueryReportActionOptions = {
	__typename?: 'ReportActionOptionsType',
	actionOptionType?: ReportActionOptionType | null,
	actionOptionValue?: Array<string> | null 
}

export type RedditReportsQueryReportDateRangeOptions = {
	__typename?: 'ReportDateRangeOptionsType',
	dateRangeType?: ReportDateRangeType | null,
	dateRangeValue?: Array<string | null> | null 
}

export type RedditReportsQueryUsers = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userSurname?: string | null,
	userFullName?: string | null,
	userEmail: any,
	id: string,
	value: string,
	label?: string | null,
	profilePictureUrl?: string | null 
}

export type RedditReportsQueryUser = {
	__typename?: 'User',
	userName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	id: string,
	profilePictureUrl?: string | null 
}

export type RedditReportsQueryUsersUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	userGroupPendingInviteHash?: string | null,
	user: RedditReportsQueryUser 
}

export type RedditReportsQueryUserGroups = {
	__typename?: 'UserGroup',
	userGroupName: string,
	id: string,
	profilePictureUrl?: string | null,
	label: string,
	value: string,
	users?: Array<RedditReportsQueryUsersUsers> | null 
}

export type RedditReportsQueryOwner = {
	__typename?: 'User',
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	id: string,
	profilePictureUrl?: string | null 
}

export type RedditReportsQueryItems = {
	__typename?: 'Report',
	reportId: string,
	reportName: string,
	reportReady: boolean,
	reportSchedule: string,
	reportDateType: ReportDateType,
	reportActivatedAt?: any | null,
	id: string,
	reportApi: RedditReportsQueryReportApi, reportActionOptions?: RedditReportsQueryReportActionOptions | null,
	reportDateRangeOptions?: RedditReportsQueryReportDateRangeOptions | null,
	users?: Array<RedditReportsQueryUsers> | null,
	userGroups?: Array<RedditReportsQueryUserGroups> | null,
	owner: RedditReportsQueryOwner 
}

export type RedditReportsQueryReports = {
	__typename?: 'ReportCursored',
	cursor?: string | null,
	items?: Array<RedditReportsQueryItems> | null 
}

export type RedditReportsQuery = {
	__typename?: 'Query',
	reports: RedditReportsQueryReports 
};

export type ToggleRedditReportStatusMutationVariables = Exact<{

  reportId: Scalars['ID'];

  reportActive: Scalars['Boolean'];

}>;

export type ToggleRedditReportStatusMutationReportApiFiltersOptions = {
	__typename?: 'ReportApiFiltersOptionsType',
	action: ReportApiFiltersOptionsAction,
	name: string,
	filter: string,
	value: Array<string>,
	label: string 
}

export type ToggleRedditReportStatusMutationReportApi = {
	__typename?: 'ReportApi',
	reportApiToken: string,
	reportApiMetrics: Array<string | null>,
	reportApiDimensions: Array<string | null>,
	reportApiFilters: string,
	reportApiFiltersOptions: Array<ToggleRedditReportStatusMutationReportApiFiltersOptions | null> 
}

export type ToggleRedditReportStatusMutationReportActionOptions = {
	__typename?: 'ReportActionOptionsType',
	actionOptionType?: ReportActionOptionType | null,
	actionOptionValue?: Array<string> | null 
}

export type ToggleRedditReportStatusMutationReportDateRangeOptions = {
	__typename?: 'ReportDateRangeOptionsType',
	dateRangeType?: ReportDateRangeType | null,
	dateRangeValue?: Array<string | null> | null 
}

export type ToggleRedditReportStatusMutationUsers = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userSurname?: string | null,
	userFullName?: string | null,
	userEmail: any,
	id: string,
	value: string,
	label?: string | null,
	profilePictureUrl?: string | null 
}

export type ToggleRedditReportStatusMutationUser = {
	__typename?: 'User',
	userName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	id: string,
	profilePictureUrl?: string | null 
}

export type ToggleRedditReportStatusMutationUsersUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	userGroupPendingInviteHash?: string | null,
	user: ToggleRedditReportStatusMutationUser 
}

export type ToggleRedditReportStatusMutationUserGroups = {
	__typename?: 'UserGroup',
	userGroupName: string,
	id: string,
	profilePictureUrl?: string | null,
	label: string,
	value: string,
	users?: Array<ToggleRedditReportStatusMutationUsersUsers> | null 
}

export type ToggleRedditReportStatusMutationOwner = {
	__typename?: 'User',
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	id: string,
	profilePictureUrl?: string | null 
}

export type ToggleRedditReportStatusMutationUpdateReport = {
	__typename?: 'Report',
	reportId: string,
	reportName: string,
	reportReady: boolean,
	reportSchedule: string,
	reportDateType: ReportDateType,
	reportActivatedAt?: any | null,
	id: string,
	reportApi: ToggleRedditReportStatusMutationReportApi, reportActionOptions?: ToggleRedditReportStatusMutationReportActionOptions | null,
	reportDateRangeOptions?: ToggleRedditReportStatusMutationReportDateRangeOptions | null,
	users?: Array<ToggleRedditReportStatusMutationUsers> | null,
	userGroups?: Array<ToggleRedditReportStatusMutationUserGroups> | null,
	owner: ToggleRedditReportStatusMutationOwner 
}

export type ToggleRedditReportStatusMutation = {
	__typename?: 'Mutation',
	updateReport: ToggleRedditReportStatusMutationUpdateReport 
};

export type UpdateRedditReportMutationVariables = Exact<{

  reportId: Scalars['ID'];

  reportName: Scalars['String'];

  reportActionFormat: CreateReportActionFormat;

  reportActionType: CreateReportActionType;

  reportApiDimensions: Array<Scalars['String']> | Scalars['String'];

  reportApiMetrics: Array<Scalars['String']> | Scalars['String'];

  reportDateType: CreateReportDateType;

  reportSchedule: Scalars['String'];

  reportDateRangeOptions?: InputMaybe<ReportDateRangeOptions>;

  reportApiFiltersOptions: Array<ReportApiFiltersOptions> | ReportApiFiltersOptions;

  reportActionOptions?: InputMaybe<ReportActionOptions>;

}>;

export type UpdateRedditReportMutationReportApiFiltersOptions = {
	__typename?: 'ReportApiFiltersOptionsType',
	action: ReportApiFiltersOptionsAction,
	name: string,
	filter: string,
	value: Array<string>,
	label: string 
}

export type UpdateRedditReportMutationReportApi = {
	__typename?: 'ReportApi',
	reportApiToken: string,
	reportApiMetrics: Array<string | null>,
	reportApiDimensions: Array<string | null>,
	reportApiFilters: string,
	reportApiFiltersOptions: Array<UpdateRedditReportMutationReportApiFiltersOptions | null> 
}

export type UpdateRedditReportMutationReportActionOptions = {
	__typename?: 'ReportActionOptionsType',
	actionOptionType?: ReportActionOptionType | null,
	actionOptionValue?: Array<string> | null 
}

export type UpdateRedditReportMutationReportDateRangeOptions = {
	__typename?: 'ReportDateRangeOptionsType',
	dateRangeType?: ReportDateRangeType | null,
	dateRangeValue?: Array<string | null> | null 
}

export type UpdateRedditReportMutationUsers = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userSurname?: string | null,
	userFullName?: string | null,
	userEmail: any,
	id: string,
	value: string,
	label?: string | null,
	profilePictureUrl?: string | null 
}

export type UpdateRedditReportMutationUser = {
	__typename?: 'User',
	userName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	id: string,
	profilePictureUrl?: string | null 
}

export type UpdateRedditReportMutationUsersUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	userGroupPendingInviteHash?: string | null,
	user: UpdateRedditReportMutationUser 
}

export type UpdateRedditReportMutationUserGroups = {
	__typename?: 'UserGroup',
	userGroupName: string,
	id: string,
	profilePictureUrl?: string | null,
	label: string,
	value: string,
	users?: Array<UpdateRedditReportMutationUsersUsers> | null 
}

export type UpdateRedditReportMutationOwner = {
	__typename?: 'User',
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	id: string,
	profilePictureUrl?: string | null 
}

export type UpdateRedditReportMutationUpdateReport = {
	__typename?: 'Report',
	reportId: string,
	reportName: string,
	reportReady: boolean,
	reportSchedule: string,
	reportDateType: ReportDateType,
	reportActivatedAt?: any | null,
	id: string,
	reportApi: UpdateRedditReportMutationReportApi, reportActionOptions?: UpdateRedditReportMutationReportActionOptions | null,
	reportDateRangeOptions?: UpdateRedditReportMutationReportDateRangeOptions | null,
	users?: Array<UpdateRedditReportMutationUsers> | null,
	userGroups?: Array<UpdateRedditReportMutationUserGroups> | null,
	owner: UpdateRedditReportMutationOwner 
}

export type UpdateRedditReportMutation = {
	__typename?: 'Mutation',
	updateReport: UpdateRedditReportMutationUpdateReport 
};

export type UpdateRedditReportAccessMutationVariables = Exact<{

  reportId: Scalars['ID'];

  userIds: Array<Scalars['ID']> | Scalars['ID'];

  userGroupIds: Array<Scalars['ID']> | Scalars['ID'];

  userEmails: Array<Scalars['String']> | Scalars['String'];

}>;

export type UpdateRedditReportAccessMutationReportApiFiltersOptions = {
	__typename?: 'ReportApiFiltersOptionsType',
	action: ReportApiFiltersOptionsAction,
	name: string,
	filter: string,
	value: Array<string>,
	label: string 
}

export type UpdateRedditReportAccessMutationReportApi = {
	__typename?: 'ReportApi',
	reportApiToken: string,
	reportApiMetrics: Array<string | null>,
	reportApiDimensions: Array<string | null>,
	reportApiFilters: string,
	reportApiFiltersOptions: Array<UpdateRedditReportAccessMutationReportApiFiltersOptions | null> 
}

export type UpdateRedditReportAccessMutationReportActionOptions = {
	__typename?: 'ReportActionOptionsType',
	actionOptionType?: ReportActionOptionType | null,
	actionOptionValue?: Array<string> | null 
}

export type UpdateRedditReportAccessMutationReportDateRangeOptions = {
	__typename?: 'ReportDateRangeOptionsType',
	dateRangeType?: ReportDateRangeType | null,
	dateRangeValue?: Array<string | null> | null 
}

export type UpdateRedditReportAccessMutationUsers = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userSurname?: string | null,
	userFullName?: string | null,
	userEmail: any,
	id: string,
	value: string,
	label?: string | null,
	profilePictureUrl?: string | null 
}

export type UpdateRedditReportAccessMutationUser = {
	__typename?: 'User',
	userName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	id: string,
	profilePictureUrl?: string | null 
}

export type UpdateRedditReportAccessMutationUsersUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	userGroupPendingInviteHash?: string | null,
	user: UpdateRedditReportAccessMutationUser 
}

export type UpdateRedditReportAccessMutationUserGroups = {
	__typename?: 'UserGroup',
	userGroupName: string,
	id: string,
	profilePictureUrl?: string | null,
	label: string,
	value: string,
	users?: Array<UpdateRedditReportAccessMutationUsersUsers> | null 
}

export type UpdateRedditReportAccessMutationOwner = {
	__typename?: 'User',
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	id: string,
	profilePictureUrl?: string | null 
}

export type UpdateRedditReportAccessMutationUpdateReport = {
	__typename?: 'Report',
	reportId: string,
	reportName: string,
	reportReady: boolean,
	reportSchedule: string,
	reportDateType: ReportDateType,
	reportActivatedAt?: any | null,
	id: string,
	reportApi: UpdateRedditReportAccessMutationReportApi, reportActionOptions?: UpdateRedditReportAccessMutationReportActionOptions | null,
	reportDateRangeOptions?: UpdateRedditReportAccessMutationReportDateRangeOptions | null,
	users?: Array<UpdateRedditReportAccessMutationUsers> | null,
	userGroups?: Array<UpdateRedditReportAccessMutationUserGroups> | null,
	owner: UpdateRedditReportAccessMutationOwner 
}

export type UpdateRedditReportAccessMutation = {
	__typename?: 'Mutation',
	updateReport: UpdateRedditReportAccessMutationUpdateReport 
};

export type DuplicateEntityTreeQueryVariables = Exact<{

  campaignFilters: CampaignFilter;

  groupFilters: GroupFilter;

  adFilters: AdFilter;

}>;

export type DuplicateEntityTreeQueryProfiles = {
	__typename?: 'Profile',
	profileId: string,
	profileName: string,
	id: string,
	value: string,
	label: string 
}

export type DuplicateEntityTreeQueryBusiness = {
	__typename?: 'Business',
	businessId: string,
	businessName: string,
	businessWebsiteUrl?: string | null,
	industryId?: string | null 
}

export type DuplicateEntityTreeQueryFundingInstruments = {
	__typename?: 'FundingInstrument',
	fundingInstrumentId: string,
	fundingInstrumentName: string 
}

export type DuplicateEntityTreeQueryAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string,
	adAccountName: string,
	profiles?: Array<DuplicateEntityTreeQueryProfiles> | null,
	business: DuplicateEntityTreeQueryBusiness, fundingInstruments?: Array<DuplicateEntityTreeQueryFundingInstruments> | null 
}

export type DuplicateEntityTreeQueryUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any 
}

export type DuplicateEntityTreeQueryUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: DuplicateEntityTreeQueryUser 
}

export type DuplicateEntityTreeQueryUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<DuplicateEntityTreeQueryUsers> | null 
}

export type DuplicateEntityTreeQueryUserUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any,
	userName?: string | null,
	userSurname?: string | null,
	userProfilePictureUrl?: string | null 
}

export type DuplicateEntityTreeQueryUsersUsers = {
	__typename?: 'AgencyUser',
	agencyPendingInviteHash?: string | null,
	agencyIsOwner: boolean,
	user: DuplicateEntityTreeQueryUserUser 
}

export type DuplicateEntityTreeQueryAgencyAccount = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	agencyAccountProfilePictureUrl?: string | null,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	userGroups?: Array<DuplicateEntityTreeQueryUserGroups> | null,
	users?: Array<DuplicateEntityTreeQueryUsersUsers> | null 
}

export type DuplicateEntityTreeQueryFlatAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string 
}

export type DuplicateEntityTreeQueryUsersUsersUsers = {
	__typename?: 'UserGroupUser',
	userGroupPendingInviteHash?: string | null,
	userGroupUserRole: UserGroupRole,
	user: DuplicateEntityTreeQueryUser 
}

export type DuplicateEntityTreeQueryUserGroupsUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<DuplicateEntityTreeQueryUsersUsersUsers> | null 
}

export type DuplicateEntityTreeQueryUserUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null 
}

export type DuplicateEntityTreeQueryUsersUsersUsersUsers = {
	__typename?: 'ClientUser',
	clientPendingInviteHash?: string | null,
	user: DuplicateEntityTreeQueryUserUserUser 
}

export type DuplicateEntityTreeQueryParent = {
	__typename?: 'Client',
	clientPinned: boolean,
	clientKpi?: string | null,
	clientBreakdown?: string | null,
	clientStatus: ClientStatus,
	clientId: string,
	clientCreatedAt: any,
	id: string,
	name?: string | null,
	clientProfilePicture?: string | null,
	currency?: string | null,
	adAccount: DuplicateEntityTreeQueryAdAccount, agencyAccount?: DuplicateEntityTreeQueryAgencyAccount | null,
	flatAdAccount: DuplicateEntityTreeQueryFlatAdAccount, userGroups?: Array<DuplicateEntityTreeQueryUserGroupsUserGroups> | null,
	users?: Array<DuplicateEntityTreeQueryUsersUsersUsersUsers> | null 
}

export type DuplicateEntityTreeQueryAdEventTrackers = {
	__typename?: 'EventTracker',
	url?: string | null,
	type?: EventTrackerType | null 
}

export type DuplicateEntityTreeQueryFundingInstrument = {
	__typename?: 'FundingInstrument',
	fundingInstrumentId: string,
	fundingInstrumentName: string 
}

export type DuplicateEntityTreeQueryParentParent = {
	__typename?: 'Campaign',
	campaignId: string,
	campaignName: string,
	campaignCreatedAt: any,
	campaignUpdatedAt: any,
	campaignSpecialAdCategories?: Array<CampaignSpecialAdCategory | null> | null,
	campaignObjective: CampaignObjective,
	campaignStatus?: CampaignStatus | null,
	campaignSpendCap?: any | null,
	id: string,
	name: string,
	externalId?: string | null,
	hasErrors: boolean,
	currency?: string | null,
	updatedAt: any,
	modificationTime: any,
	status?: CampaignStatus | null,
	statusPending?: CampaignStatus | null,
	parent: DuplicateEntityTreeQueryParent, fundingInstrument?: DuplicateEntityTreeQueryFundingInstrument | null 
}

export type DuplicateEntityTreeQueryGroupTargetingDevices = {
	__typename?: 'GroupTargetingDevices',
	groupTargetingDevicesLabelMap?: any | null,
	groupTargetingDevicesOS?: GroupTargetingDevicesOs | null,
	groupTargetingDevicesOSMaxVersion?: string | null,
	groupTargetingDevicesOSMinVersion?: string | null,
	groupTargetingDevicesType?: GroupTargetingDeviceType | null 
}

export type DuplicateEntityTreeQueryGroupTargeting = {
	__typename?: 'GroupTargeting',
	groupTargetingKeywords?: Array<string | null> | null,
	groupTargetingExcludedKeywords?: Array<string | null> | null,
	placements?: Array<GroupTargetingLocations | null> | null,
	gender?: GroupTargetingGender | null,
	deviceType?: Array<GroupTargetingPlatforms | null> | null,
	communities?: Array<string | null> | null,
	communitiesExcluded?: Array<string | null> | null,
	locations?: Array<string | null> | null,
	locationsExcluded?: Array<string | null> | null,
	interests?: Array<string | null> | null,
	keywords?: Array<string | null> | null,
	customAudiences?: Array<string | null> | null,
	customAudiencesExcluded?: Array<string | null> | null,
	carriers?: Array<string | null> | null,
	groupTargetingDevices?: Array<DuplicateEntityTreeQueryGroupTargetingDevices | null> | null 
}

export type DuplicateEntityTreeQueryParentParentParent = {
	__typename?: 'Group',
	groupId: string,
	groupName: string,
	externalGroupId?: string | null,
	groupStatus?: GroupStatus | null,
	groupBidType: GroupBidType,
	groupBidStrategy: GroupBidStrategy,
	groupBidAmount?: number | null,
	groupGoal?: GroupGoal | null,
	groupGoalAmount?: number | null,
	groupOptimizationGoal?: GroupOptimizationGoal | null,
	groupStartTime?: any | null,
	groupEndTime?: any | null,
	groupCreatedAt: any,
	groupModificationTime?: any | null,
	groupAppId?: string | null,
	id: string,
	name: string,
	externalId?: string | null,
	hasErrors: boolean,
	status?: GroupStatus | null,
	statusPending?: GroupStatus | null,
	updatedAt?: any | null,
	modificationTime?: any | null,
	currency?: string | null,
	parent: DuplicateEntityTreeQueryParentParent, groupTargeting?: DuplicateEntityTreeQueryGroupTargeting | null 
}

export type DuplicateEntityTreeQueryProfile = {
	__typename?: 'Profile',
	profileName: string,
	id: string,
	value: string,
	label: string 
}

export type DuplicateEntityTreeQueryFlatText = {
	__typename?: 'Text',
	creativeText?: string | null 
}

export type DuplicateEntityTreeQueryFlatCreativeContent = {
	__typename?: 'CreativeContent',
	creativeContentId: string,
	creativeContentCallToAction?: CreativeContentCallToAction | null,
	creativeContentDestinationUrl?: string | null,
	creativeContentDisplayUrl?: string | null,
	creativeContentMediaUrl?: string | null,
	creativeContentCaption?: string | null 
}

export type DuplicateEntityTreeQueryFlatCreative = {
	__typename?: 'Creative',
	creativeId: string,
	creativePostUrl?: string | null,
	creativeHeadline: string,
	creativeThumbnailUrl?: string | null,
	creativeAllowComments: boolean,
	creativeType: CreativeType,
	externalCreativeId?: string | null,
	creativeHasErrors: boolean,
	profile: DuplicateEntityTreeQueryProfile, flatText?: DuplicateEntityTreeQueryFlatText | null,
	flatCreativeContent?: Array<DuplicateEntityTreeQueryFlatCreativeContent> | null 
}

export type DuplicateEntityTreeQueryFlatAdAccountFlatAdAccount = {
	__typename?: 'AdAccount',
	currency: string 
}

export type DuplicateEntityTreeQueryFlatClient = {
	__typename?: 'Client',
	flatAdAccount: DuplicateEntityTreeQueryFlatAdAccountFlatAdAccount 
}

export type DuplicateEntityTreeQueryAds = {
	__typename?: 'Ad',
	adId: string,
	adName?: string | null,
	adCreatedAt: any,
	adModificationTime?: any | null,
	id: string,
	name?: string | null,
	externalId?: string | null,
	hasErrors: boolean,
	modificationTime?: any | null,
	updatedAt?: any | null,
	status?: AdStatus | null,
	statusPending?: AdStatus | null,
	currency?: string | null,
	adEventTrackers?: Array<DuplicateEntityTreeQueryAdEventTrackers | null> | null,
	parent: DuplicateEntityTreeQueryParentParentParent, flatCreative?: DuplicateEntityTreeQueryFlatCreative | null,
	flatClient: DuplicateEntityTreeQueryFlatClient 
}

export type DuplicateEntityTreeQueryGroups = {
	__typename?: 'Group',
	groupId: string,
	groupName: string,
	externalGroupId?: string | null,
	groupStatus?: GroupStatus | null,
	groupBidType: GroupBidType,
	groupBidStrategy: GroupBidStrategy,
	groupBidAmount?: number | null,
	groupGoal?: GroupGoal | null,
	groupGoalAmount?: number | null,
	groupOptimizationGoal?: GroupOptimizationGoal | null,
	groupStartTime?: any | null,
	groupEndTime?: any | null,
	groupCreatedAt: any,
	groupModificationTime?: any | null,
	groupAppId?: string | null,
	id: string,
	name: string,
	externalId?: string | null,
	hasErrors: boolean,
	status?: GroupStatus | null,
	statusPending?: GroupStatus | null,
	updatedAt?: any | null,
	modificationTime?: any | null,
	currency?: string | null,
	ads?: Array<DuplicateEntityTreeQueryAds> | null,
	groupTargeting?: DuplicateEntityTreeQueryGroupTargeting | null 
}

export type DuplicateEntityTreeQueryCampaigns = {
	__typename?: 'Campaign',
	campaignId: string,
	campaignName: string,
	campaignCreatedAt: any,
	campaignUpdatedAt: any,
	campaignSpecialAdCategories?: Array<CampaignSpecialAdCategory | null> | null,
	campaignObjective: CampaignObjective,
	campaignStatus?: CampaignStatus | null,
	campaignSpendCap?: any | null,
	id: string,
	name: string,
	externalId?: string | null,
	hasErrors: boolean,
	currency?: string | null,
	updatedAt: any,
	modificationTime: any,
	status?: CampaignStatus | null,
	statusPending?: CampaignStatus | null,
	parent: DuplicateEntityTreeQueryParent, groups?: Array<DuplicateEntityTreeQueryGroups> | null,
	fundingInstrument?: DuplicateEntityTreeQueryFundingInstrument | null 
}

export type DuplicateEntityTreeQueryEntities = {
	__typename?: 'CampaignCursored',
	campaigns?: Array<DuplicateEntityTreeQueryCampaigns> | null 
}

export type DuplicateEntityTreeQuery = {
	__typename?: 'Query',
	entities: DuplicateEntityTreeQueryEntities 
};

export type CampaignBreadcrumbsQueryVariables = Exact<{

  filters?: InputMaybe<CampaignFilter>;

}>;

export type CampaignBreadcrumbsQueryAdAccount = {
	__typename?: 'AdAccount',
	name: string 
}

export type CampaignBreadcrumbsQueryClient = {
	__typename?: 'Client',
	id: string,
	adAccount: CampaignBreadcrumbsQueryAdAccount 
}

export type CampaignBreadcrumbsQueryItems = {
	__typename?: 'Campaign',
	id: string,
	name: string,
	client: CampaignBreadcrumbsQueryClient 
}

export type CampaignBreadcrumbsQueryBreadcrumbs = {
	__typename?: 'CampaignCursored',
	items?: Array<CampaignBreadcrumbsQueryItems> | null 
}

export type CampaignBreadcrumbsQuery = {
	__typename?: 'Query',
	breadcrumbs: CampaignBreadcrumbsQueryBreadcrumbs 
};

export type ClientBreadcrumbsQueryVariables = Exact<{

  filters?: InputMaybe<ClientFilter>;

}>;

export type ClientBreadcrumbsQueryAdAccount = {
	__typename?: 'AdAccount',
	name: string 
}

export type ClientBreadcrumbsQueryItems = {
	__typename?: 'Client',
	id: string,
	adAccount: ClientBreadcrumbsQueryAdAccount 
}

export type ClientBreadcrumbsQueryBreadcrumbs = {
	__typename?: 'ClientCursored',
	items?: Array<ClientBreadcrumbsQueryItems> | null 
}

export type ClientBreadcrumbsQuery = {
	__typename?: 'Query',
	breadcrumbs: ClientBreadcrumbsQueryBreadcrumbs 
};

export type GroupBreadcrumbsQueryVariables = Exact<{

  filters?: InputMaybe<GroupFilter>;

}>;

export type GroupBreadcrumbsQueryCampaign = {
	__typename?: 'Campaign',
	id: string,
	name: string 
}

export type GroupBreadcrumbsQueryAdAccount = {
	__typename?: 'AdAccount',
	name: string 
}

export type GroupBreadcrumbsQueryClient = {
	__typename?: 'Client',
	id: string,
	adAccount: GroupBreadcrumbsQueryAdAccount 
}

export type GroupBreadcrumbsQueryItems = {
	__typename?: 'Group',
	id: string,
	name: string,
	campaign: GroupBreadcrumbsQueryCampaign, client: GroupBreadcrumbsQueryClient 
}

export type GroupBreadcrumbsQueryBreadcrumbs = {
	__typename?: 'GroupCursored',
	items?: Array<GroupBreadcrumbsQueryItems> | null 
}

export type GroupBreadcrumbsQuery = {
	__typename?: 'Query',
	breadcrumbs: GroupBreadcrumbsQueryBreadcrumbs 
};

export type ArchiveEntitiesMutationVariables = Exact<{

  ads: Array<UpdateAdInput> | UpdateAdInput;

  groups: Array<UpdateGroupInput> | UpdateGroupInput;

  campaigns: Array<UpdateCampaignInput> | UpdateCampaignInput;

}>;

export type ArchiveEntitiesMutationAdEventTrackers = {
	__typename?: 'EventTracker',
	url?: string | null,
	type?: EventTrackerType | null 
}

export type ArchiveEntitiesMutationProfiles = {
	__typename?: 'Profile',
	profileId: string,
	profileName: string,
	id: string,
	value: string,
	label: string 
}

export type ArchiveEntitiesMutationBusiness = {
	__typename?: 'Business',
	businessId: string,
	businessName: string,
	businessWebsiteUrl?: string | null,
	industryId?: string | null 
}

export type ArchiveEntitiesMutationFundingInstruments = {
	__typename?: 'FundingInstrument',
	fundingInstrumentId: string,
	fundingInstrumentName: string 
}

export type ArchiveEntitiesMutationAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string,
	adAccountName: string,
	profiles?: Array<ArchiveEntitiesMutationProfiles> | null,
	business: ArchiveEntitiesMutationBusiness, fundingInstruments?: Array<ArchiveEntitiesMutationFundingInstruments> | null 
}

export type ArchiveEntitiesMutationUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any 
}

export type ArchiveEntitiesMutationUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: ArchiveEntitiesMutationUser 
}

export type ArchiveEntitiesMutationUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<ArchiveEntitiesMutationUsers> | null 
}

export type ArchiveEntitiesMutationUserUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any,
	userName?: string | null,
	userSurname?: string | null,
	userProfilePictureUrl?: string | null 
}

export type ArchiveEntitiesMutationUsersUsers = {
	__typename?: 'AgencyUser',
	agencyPendingInviteHash?: string | null,
	agencyIsOwner: boolean,
	user: ArchiveEntitiesMutationUserUser 
}

export type ArchiveEntitiesMutationAgencyAccount = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	agencyAccountProfilePictureUrl?: string | null,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	userGroups?: Array<ArchiveEntitiesMutationUserGroups> | null,
	users?: Array<ArchiveEntitiesMutationUsersUsers> | null 
}

export type ArchiveEntitiesMutationFlatAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string 
}

export type ArchiveEntitiesMutationUsersUsersUsers = {
	__typename?: 'UserGroupUser',
	userGroupPendingInviteHash?: string | null,
	userGroupUserRole: UserGroupRole,
	user: ArchiveEntitiesMutationUser 
}

export type ArchiveEntitiesMutationUserGroupsUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<ArchiveEntitiesMutationUsersUsersUsers> | null 
}

export type ArchiveEntitiesMutationUserUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null 
}

export type ArchiveEntitiesMutationUsersUsersUsersUsers = {
	__typename?: 'ClientUser',
	clientPendingInviteHash?: string | null,
	user: ArchiveEntitiesMutationUserUserUser 
}

export type ArchiveEntitiesMutationParent = {
	__typename?: 'Client',
	clientPinned: boolean,
	clientKpi?: string | null,
	clientBreakdown?: string | null,
	clientStatus: ClientStatus,
	clientId: string,
	clientCreatedAt: any,
	id: string,
	name?: string | null,
	clientProfilePicture?: string | null,
	currency?: string | null,
	adAccount: ArchiveEntitiesMutationAdAccount, agencyAccount?: ArchiveEntitiesMutationAgencyAccount | null,
	flatAdAccount: ArchiveEntitiesMutationFlatAdAccount, userGroups?: Array<ArchiveEntitiesMutationUserGroupsUserGroups> | null,
	users?: Array<ArchiveEntitiesMutationUsersUsersUsersUsers> | null 
}

export type ArchiveEntitiesMutationFundingInstrument = {
	__typename?: 'FundingInstrument',
	fundingInstrumentId: string,
	fundingInstrumentName: string 
}

export type ArchiveEntitiesMutationParentParent = {
	__typename?: 'Campaign',
	campaignId: string,
	campaignName: string,
	campaignCreatedAt: any,
	campaignUpdatedAt: any,
	campaignSpecialAdCategories?: Array<CampaignSpecialAdCategory | null> | null,
	campaignObjective: CampaignObjective,
	campaignStatus?: CampaignStatus | null,
	campaignSpendCap?: any | null,
	id: string,
	name: string,
	externalId?: string | null,
	hasErrors: boolean,
	currency?: string | null,
	updatedAt: any,
	modificationTime: any,
	status?: CampaignStatus | null,
	statusPending?: CampaignStatus | null,
	parent: ArchiveEntitiesMutationParent, fundingInstrument?: ArchiveEntitiesMutationFundingInstrument | null 
}

export type ArchiveEntitiesMutationGroupTargetingDevices = {
	__typename?: 'GroupTargetingDevices',
	groupTargetingDevicesLabelMap?: any | null,
	groupTargetingDevicesOS?: GroupTargetingDevicesOs | null,
	groupTargetingDevicesOSMaxVersion?: string | null,
	groupTargetingDevicesOSMinVersion?: string | null,
	groupTargetingDevicesType?: GroupTargetingDeviceType | null 
}

export type ArchiveEntitiesMutationGroupTargeting = {
	__typename?: 'GroupTargeting',
	groupTargetingKeywords?: Array<string | null> | null,
	groupTargetingExcludedKeywords?: Array<string | null> | null,
	placements?: Array<GroupTargetingLocations | null> | null,
	gender?: GroupTargetingGender | null,
	deviceType?: Array<GroupTargetingPlatforms | null> | null,
	communities?: Array<string | null> | null,
	communitiesExcluded?: Array<string | null> | null,
	locations?: Array<string | null> | null,
	locationsExcluded?: Array<string | null> | null,
	interests?: Array<string | null> | null,
	keywords?: Array<string | null> | null,
	customAudiences?: Array<string | null> | null,
	customAudiencesExcluded?: Array<string | null> | null,
	carriers?: Array<string | null> | null,
	groupTargetingDevices?: Array<ArchiveEntitiesMutationGroupTargetingDevices | null> | null 
}

export type ArchiveEntitiesMutationParentParentParent = {
	__typename?: 'Group',
	groupId: string,
	groupName: string,
	externalGroupId?: string | null,
	groupStatus?: GroupStatus | null,
	groupBidType: GroupBidType,
	groupBidStrategy: GroupBidStrategy,
	groupBidAmount?: number | null,
	groupGoal?: GroupGoal | null,
	groupGoalAmount?: number | null,
	groupOptimizationGoal?: GroupOptimizationGoal | null,
	groupStartTime?: any | null,
	groupEndTime?: any | null,
	groupCreatedAt: any,
	groupModificationTime?: any | null,
	groupAppId?: string | null,
	id: string,
	name: string,
	externalId?: string | null,
	hasErrors: boolean,
	status?: GroupStatus | null,
	statusPending?: GroupStatus | null,
	updatedAt?: any | null,
	modificationTime?: any | null,
	currency?: string | null,
	parent: ArchiveEntitiesMutationParentParent, groupTargeting?: ArchiveEntitiesMutationGroupTargeting | null 
}

export type ArchiveEntitiesMutationProfile = {
	__typename?: 'Profile',
	profileName: string,
	id: string,
	value: string,
	label: string 
}

export type ArchiveEntitiesMutationFlatText = {
	__typename?: 'Text',
	creativeText?: string | null 
}

export type ArchiveEntitiesMutationFlatCreativeContent = {
	__typename?: 'CreativeContent',
	creativeContentId: string,
	creativeContentCallToAction?: CreativeContentCallToAction | null,
	creativeContentDestinationUrl?: string | null,
	creativeContentDisplayUrl?: string | null,
	creativeContentMediaUrl?: string | null,
	creativeContentCaption?: string | null 
}

export type ArchiveEntitiesMutationFlatCreative = {
	__typename?: 'Creative',
	creativeId: string,
	creativePostUrl?: string | null,
	creativeHeadline: string,
	creativeThumbnailUrl?: string | null,
	creativeAllowComments: boolean,
	creativeType: CreativeType,
	externalCreativeId?: string | null,
	creativeHasErrors: boolean,
	profile: ArchiveEntitiesMutationProfile, flatText?: ArchiveEntitiesMutationFlatText | null,
	flatCreativeContent?: Array<ArchiveEntitiesMutationFlatCreativeContent> | null 
}

export type ArchiveEntitiesMutationFlatAdAccountFlatAdAccount = {
	__typename?: 'AdAccount',
	currency: string 
}

export type ArchiveEntitiesMutationFlatClient = {
	__typename?: 'Client',
	flatAdAccount: ArchiveEntitiesMutationFlatAdAccountFlatAdAccount 
}

export type ArchiveEntitiesMutationUpdateAds = {
	__typename?: 'Ad',
	adId: string,
	adName?: string | null,
	adCreatedAt: any,
	adModificationTime?: any | null,
	id: string,
	name?: string | null,
	externalId?: string | null,
	hasErrors: boolean,
	modificationTime?: any | null,
	updatedAt?: any | null,
	status?: AdStatus | null,
	statusPending?: AdStatus | null,
	currency?: string | null,
	adEventTrackers?: Array<ArchiveEntitiesMutationAdEventTrackers | null> | null,
	parent: ArchiveEntitiesMutationParentParentParent, flatCreative?: ArchiveEntitiesMutationFlatCreative | null,
	flatClient: ArchiveEntitiesMutationFlatClient 
}

export type ArchiveEntitiesMutationUpdateGroups = {
	__typename?: 'Group',
	groupId: string,
	groupName: string,
	externalGroupId?: string | null,
	groupStatus?: GroupStatus | null,
	groupBidType: GroupBidType,
	groupBidStrategy: GroupBidStrategy,
	groupBidAmount?: number | null,
	groupGoal?: GroupGoal | null,
	groupGoalAmount?: number | null,
	groupOptimizationGoal?: GroupOptimizationGoal | null,
	groupStartTime?: any | null,
	groupEndTime?: any | null,
	groupCreatedAt: any,
	groupModificationTime?: any | null,
	groupAppId?: string | null,
	id: string,
	name: string,
	externalId?: string | null,
	hasErrors: boolean,
	status?: GroupStatus | null,
	statusPending?: GroupStatus | null,
	updatedAt?: any | null,
	modificationTime?: any | null,
	currency?: string | null,
	groupTargeting?: ArchiveEntitiesMutationGroupTargeting | null 
}

export type ArchiveEntitiesMutationUpdateCampaigns = {
	__typename?: 'Campaign',
	campaignId: string,
	campaignName: string,
	campaignCreatedAt: any,
	campaignUpdatedAt: any,
	campaignSpecialAdCategories?: Array<CampaignSpecialAdCategory | null> | null,
	campaignObjective: CampaignObjective,
	campaignStatus?: CampaignStatus | null,
	campaignSpendCap?: any | null,
	id: string,
	name: string,
	externalId?: string | null,
	hasErrors: boolean,
	currency?: string | null,
	updatedAt: any,
	modificationTime: any,
	status?: CampaignStatus | null,
	statusPending?: CampaignStatus | null,
	fundingInstrument?: ArchiveEntitiesMutationFundingInstrument | null 
}

export type ArchiveEntitiesMutation = {
	__typename?: 'Mutation',
	updateAds: Array<ArchiveEntitiesMutationUpdateAds>,
	updateGroups?: Array<ArchiveEntitiesMutationUpdateGroups> | null,
	updateCampaigns: Array<ArchiveEntitiesMutationUpdateCampaigns> 
};

export type ChangeStatusOfEntitiesMutationVariables = Exact<{

  ads: Array<UpdateAdInput> | UpdateAdInput;

  groups: Array<UpdateGroupInput> | UpdateGroupInput;

  campaigns: Array<UpdateCampaignInput> | UpdateCampaignInput;

}>;

export type ChangeStatusOfEntitiesMutationAdEventTrackers = {
	__typename?: 'EventTracker',
	url?: string | null,
	type?: EventTrackerType | null 
}

export type ChangeStatusOfEntitiesMutationProfiles = {
	__typename?: 'Profile',
	profileId: string,
	profileName: string,
	id: string,
	value: string,
	label: string 
}

export type ChangeStatusOfEntitiesMutationBusiness = {
	__typename?: 'Business',
	businessId: string,
	businessName: string,
	businessWebsiteUrl?: string | null,
	industryId?: string | null 
}

export type ChangeStatusOfEntitiesMutationFundingInstruments = {
	__typename?: 'FundingInstrument',
	fundingInstrumentId: string,
	fundingInstrumentName: string 
}

export type ChangeStatusOfEntitiesMutationAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string,
	adAccountName: string,
	profiles?: Array<ChangeStatusOfEntitiesMutationProfiles> | null,
	business: ChangeStatusOfEntitiesMutationBusiness, fundingInstruments?: Array<ChangeStatusOfEntitiesMutationFundingInstruments> | null 
}

export type ChangeStatusOfEntitiesMutationUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any 
}

export type ChangeStatusOfEntitiesMutationUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: ChangeStatusOfEntitiesMutationUser 
}

export type ChangeStatusOfEntitiesMutationUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<ChangeStatusOfEntitiesMutationUsers> | null 
}

export type ChangeStatusOfEntitiesMutationUserUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any,
	userName?: string | null,
	userSurname?: string | null,
	userProfilePictureUrl?: string | null 
}

export type ChangeStatusOfEntitiesMutationUsersUsers = {
	__typename?: 'AgencyUser',
	agencyPendingInviteHash?: string | null,
	agencyIsOwner: boolean,
	user: ChangeStatusOfEntitiesMutationUserUser 
}

export type ChangeStatusOfEntitiesMutationAgencyAccount = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	agencyAccountProfilePictureUrl?: string | null,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	userGroups?: Array<ChangeStatusOfEntitiesMutationUserGroups> | null,
	users?: Array<ChangeStatusOfEntitiesMutationUsersUsers> | null 
}

export type ChangeStatusOfEntitiesMutationFlatAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string 
}

export type ChangeStatusOfEntitiesMutationUsersUsersUsers = {
	__typename?: 'UserGroupUser',
	userGroupPendingInviteHash?: string | null,
	userGroupUserRole: UserGroupRole,
	user: ChangeStatusOfEntitiesMutationUser 
}

export type ChangeStatusOfEntitiesMutationUserGroupsUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<ChangeStatusOfEntitiesMutationUsersUsersUsers> | null 
}

export type ChangeStatusOfEntitiesMutationUserUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null 
}

export type ChangeStatusOfEntitiesMutationUsersUsersUsersUsers = {
	__typename?: 'ClientUser',
	clientPendingInviteHash?: string | null,
	user: ChangeStatusOfEntitiesMutationUserUserUser 
}

export type ChangeStatusOfEntitiesMutationParent = {
	__typename?: 'Client',
	clientPinned: boolean,
	clientKpi?: string | null,
	clientBreakdown?: string | null,
	clientStatus: ClientStatus,
	clientId: string,
	clientCreatedAt: any,
	id: string,
	name?: string | null,
	clientProfilePicture?: string | null,
	currency?: string | null,
	adAccount: ChangeStatusOfEntitiesMutationAdAccount, agencyAccount?: ChangeStatusOfEntitiesMutationAgencyAccount | null,
	flatAdAccount: ChangeStatusOfEntitiesMutationFlatAdAccount, userGroups?: Array<ChangeStatusOfEntitiesMutationUserGroupsUserGroups> | null,
	users?: Array<ChangeStatusOfEntitiesMutationUsersUsersUsersUsers> | null 
}

export type ChangeStatusOfEntitiesMutationFundingInstrument = {
	__typename?: 'FundingInstrument',
	fundingInstrumentId: string,
	fundingInstrumentName: string 
}

export type ChangeStatusOfEntitiesMutationParentParent = {
	__typename?: 'Campaign',
	campaignId: string,
	campaignName: string,
	campaignCreatedAt: any,
	campaignUpdatedAt: any,
	campaignSpecialAdCategories?: Array<CampaignSpecialAdCategory | null> | null,
	campaignObjective: CampaignObjective,
	campaignStatus?: CampaignStatus | null,
	campaignSpendCap?: any | null,
	id: string,
	name: string,
	externalId?: string | null,
	hasErrors: boolean,
	currency?: string | null,
	updatedAt: any,
	modificationTime: any,
	status?: CampaignStatus | null,
	statusPending?: CampaignStatus | null,
	parent: ChangeStatusOfEntitiesMutationParent, fundingInstrument?: ChangeStatusOfEntitiesMutationFundingInstrument | null 
}

export type ChangeStatusOfEntitiesMutationGroupTargetingDevices = {
	__typename?: 'GroupTargetingDevices',
	groupTargetingDevicesLabelMap?: any | null,
	groupTargetingDevicesOS?: GroupTargetingDevicesOs | null,
	groupTargetingDevicesOSMaxVersion?: string | null,
	groupTargetingDevicesOSMinVersion?: string | null,
	groupTargetingDevicesType?: GroupTargetingDeviceType | null 
}

export type ChangeStatusOfEntitiesMutationGroupTargeting = {
	__typename?: 'GroupTargeting',
	groupTargetingKeywords?: Array<string | null> | null,
	groupTargetingExcludedKeywords?: Array<string | null> | null,
	placements?: Array<GroupTargetingLocations | null> | null,
	gender?: GroupTargetingGender | null,
	deviceType?: Array<GroupTargetingPlatforms | null> | null,
	communities?: Array<string | null> | null,
	communitiesExcluded?: Array<string | null> | null,
	locations?: Array<string | null> | null,
	locationsExcluded?: Array<string | null> | null,
	interests?: Array<string | null> | null,
	keywords?: Array<string | null> | null,
	customAudiences?: Array<string | null> | null,
	customAudiencesExcluded?: Array<string | null> | null,
	carriers?: Array<string | null> | null,
	groupTargetingDevices?: Array<ChangeStatusOfEntitiesMutationGroupTargetingDevices | null> | null 
}

export type ChangeStatusOfEntitiesMutationParentParentParent = {
	__typename?: 'Group',
	groupId: string,
	groupName: string,
	externalGroupId?: string | null,
	groupStatus?: GroupStatus | null,
	groupBidType: GroupBidType,
	groupBidStrategy: GroupBidStrategy,
	groupBidAmount?: number | null,
	groupGoal?: GroupGoal | null,
	groupGoalAmount?: number | null,
	groupOptimizationGoal?: GroupOptimizationGoal | null,
	groupStartTime?: any | null,
	groupEndTime?: any | null,
	groupCreatedAt: any,
	groupModificationTime?: any | null,
	groupAppId?: string | null,
	id: string,
	name: string,
	externalId?: string | null,
	hasErrors: boolean,
	status?: GroupStatus | null,
	statusPending?: GroupStatus | null,
	updatedAt?: any | null,
	modificationTime?: any | null,
	currency?: string | null,
	parent: ChangeStatusOfEntitiesMutationParentParent, groupTargeting?: ChangeStatusOfEntitiesMutationGroupTargeting | null 
}

export type ChangeStatusOfEntitiesMutationProfile = {
	__typename?: 'Profile',
	profileName: string,
	id: string,
	value: string,
	label: string 
}

export type ChangeStatusOfEntitiesMutationFlatText = {
	__typename?: 'Text',
	creativeText?: string | null 
}

export type ChangeStatusOfEntitiesMutationFlatCreativeContent = {
	__typename?: 'CreativeContent',
	creativeContentId: string,
	creativeContentCallToAction?: CreativeContentCallToAction | null,
	creativeContentDestinationUrl?: string | null,
	creativeContentDisplayUrl?: string | null,
	creativeContentMediaUrl?: string | null,
	creativeContentCaption?: string | null 
}

export type ChangeStatusOfEntitiesMutationFlatCreative = {
	__typename?: 'Creative',
	creativeId: string,
	creativePostUrl?: string | null,
	creativeHeadline: string,
	creativeThumbnailUrl?: string | null,
	creativeAllowComments: boolean,
	creativeType: CreativeType,
	externalCreativeId?: string | null,
	creativeHasErrors: boolean,
	profile: ChangeStatusOfEntitiesMutationProfile, flatText?: ChangeStatusOfEntitiesMutationFlatText | null,
	flatCreativeContent?: Array<ChangeStatusOfEntitiesMutationFlatCreativeContent> | null 
}

export type ChangeStatusOfEntitiesMutationFlatAdAccountFlatAdAccount = {
	__typename?: 'AdAccount',
	currency: string 
}

export type ChangeStatusOfEntitiesMutationFlatClient = {
	__typename?: 'Client',
	flatAdAccount: ChangeStatusOfEntitiesMutationFlatAdAccountFlatAdAccount 
}

export type ChangeStatusOfEntitiesMutationUpdateAds = {
	__typename?: 'Ad',
	adId: string,
	adName?: string | null,
	adCreatedAt: any,
	adModificationTime?: any | null,
	id: string,
	name?: string | null,
	externalId?: string | null,
	hasErrors: boolean,
	modificationTime?: any | null,
	updatedAt?: any | null,
	status?: AdStatus | null,
	statusPending?: AdStatus | null,
	currency?: string | null,
	adEventTrackers?: Array<ChangeStatusOfEntitiesMutationAdEventTrackers | null> | null,
	parent: ChangeStatusOfEntitiesMutationParentParentParent, flatCreative?: ChangeStatusOfEntitiesMutationFlatCreative | null,
	flatClient: ChangeStatusOfEntitiesMutationFlatClient 
}

export type ChangeStatusOfEntitiesMutationUpdateGroups = {
	__typename?: 'Group',
	groupId: string,
	groupName: string,
	externalGroupId?: string | null,
	groupStatus?: GroupStatus | null,
	groupBidType: GroupBidType,
	groupBidStrategy: GroupBidStrategy,
	groupBidAmount?: number | null,
	groupGoal?: GroupGoal | null,
	groupGoalAmount?: number | null,
	groupOptimizationGoal?: GroupOptimizationGoal | null,
	groupStartTime?: any | null,
	groupEndTime?: any | null,
	groupCreatedAt: any,
	groupModificationTime?: any | null,
	groupAppId?: string | null,
	id: string,
	name: string,
	externalId?: string | null,
	hasErrors: boolean,
	status?: GroupStatus | null,
	statusPending?: GroupStatus | null,
	updatedAt?: any | null,
	modificationTime?: any | null,
	currency?: string | null,
	groupTargeting?: ChangeStatusOfEntitiesMutationGroupTargeting | null 
}

export type ChangeStatusOfEntitiesMutationUpdateCampaigns = {
	__typename?: 'Campaign',
	campaignId: string,
	campaignName: string,
	campaignCreatedAt: any,
	campaignUpdatedAt: any,
	campaignSpecialAdCategories?: Array<CampaignSpecialAdCategory | null> | null,
	campaignObjective: CampaignObjective,
	campaignStatus?: CampaignStatus | null,
	campaignSpendCap?: any | null,
	id: string,
	name: string,
	externalId?: string | null,
	hasErrors: boolean,
	currency?: string | null,
	updatedAt: any,
	modificationTime: any,
	status?: CampaignStatus | null,
	statusPending?: CampaignStatus | null,
	fundingInstrument?: ChangeStatusOfEntitiesMutationFundingInstrument | null 
}

export type ChangeStatusOfEntitiesMutation = {
	__typename?: 'Mutation',
	updateAds: Array<ChangeStatusOfEntitiesMutationUpdateAds>,
	updateGroups?: Array<ChangeStatusOfEntitiesMutationUpdateGroups> | null,
	updateCampaigns: Array<ChangeStatusOfEntitiesMutationUpdateCampaigns> 
};

export type DeleteEntitiesMutationVariables = Exact<{

  ads: Array<DeleteAdInput> | DeleteAdInput;

  groups: Array<DeleteGroupInput> | DeleteGroupInput;

  campaigns: Array<DeleteCampaignInput> | DeleteCampaignInput;

}>;

export type DeleteEntitiesMutation = {
	__typename?: 'Mutation',
	deleteAds?: boolean | null,
	deleteGroups: boolean,
	deleteCampaigns: boolean 
};

export type AdOptionsQueryVariables = Exact<{

  filters?: InputMaybe<AdFilter>;

}>;

export type AdOptionsQueryItems = {
	__typename?: 'Ad',
	value: string,
	label?: string | null 
}

export type AdOptionsQueryOptions = {
	__typename?: 'AdCursored',
	items?: Array<AdOptionsQueryItems> | null 
}

export type AdOptionsQuery = {
	__typename?: 'Query',
	options: AdOptionsQueryOptions 
};

export type AdvertisersOptionsQueryVariables = Exact<{

  search: Scalars['String'];

}>;

export type AdvertisersOptionsQueryItems = {
	__typename?: 'AgencyAccount',
	id: string,
	value: string,
	label: string 
}

export type AdvertisersOptionsQueryOptions = {
	__typename?: 'AgencyAccountCursored',
	items?: Array<AdvertisersOptionsQueryItems> | null 
}

export type AdvertisersOptionsQuery = {
	__typename?: 'Query',
	options: AdvertisersOptionsQueryOptions 
};

export type CampaignOptionsQueryVariables = Exact<{

  filters?: InputMaybe<CampaignFilter>;

}>;

export type CampaignOptionsQueryItems = {
	__typename?: 'Campaign',
	value: string,
	label: string 
}

export type CampaignOptionsQueryOptions = {
	__typename?: 'CampaignCursored',
	items?: Array<CampaignOptionsQueryItems> | null 
}

export type CampaignOptionsQuery = {
	__typename?: 'Query',
	options: CampaignOptionsQueryOptions 
};

export type ClientOptionsQueryVariables = Exact<{

  filters?: InputMaybe<ClientFilter>;

}>;

export type ClientOptionsQueryItems = {
	__typename?: 'Client',
	value: string,
	label?: string | null 
}

export type ClientOptionsQueryOptions = {
	__typename?: 'ClientCursored',
	items?: Array<ClientOptionsQueryItems> | null 
}

export type ClientOptionsQuery = {
	__typename?: 'Query',
	options: ClientOptionsQueryOptions 
};

export type GroupOptionsQueryVariables = Exact<{

  filters?: InputMaybe<GroupFilter>;

}>;

export type GroupOptionsQueryItems = {
	__typename?: 'Group',
	value: string,
	label: string 
}

export type GroupOptionsQueryOptions = {
	__typename?: 'GroupCursored',
	items?: Array<GroupOptionsQueryItems> | null 
}

export type GroupOptionsQuery = {
	__typename?: 'Query',
	options: GroupOptionsQueryOptions 
};

export type UserGroupOptionsQueryVariables = Exact<{

  search: Scalars['String'];

  userId: Array<Scalars['ID']> | Scalars['ID'];

}>;

export type UserGroupOptionsQueryItems = {
	__typename?: 'UserGroup',
	id: string,
	value: string,
	label: string 
}

export type UserGroupOptionsQueryOptions = {
	__typename?: 'UserGroupCursored',
	items?: Array<UserGroupOptionsQueryItems> | null 
}

export type UserGroupOptionsQuery = {
	__typename?: 'Query',
	options: UserGroupOptionsQueryOptions 
};

export type UserOptionsQueryVariables = Exact<{

  search: Scalars['String'];

}>;

export type UserOptionsQueryItems = {
	__typename?: 'User',
	id: string,
	value: string,
	label?: string | null 
}

export type UserOptionsQueryOptions = {
	__typename?: 'UserCursored',
	items?: Array<UserOptionsQueryItems> | null 
}

export type UserOptionsQuery = {
	__typename?: 'Query',
	options: UserOptionsQueryOptions 
};

export type MarkNotificationsAsReadMutationVariables = Exact<{

  notificationIds: Array<Scalars['ID']> | Scalars['ID'];

}>;

export type MarkNotificationsAsReadMutationMarkAsRead = {
	__typename?: 'Notification',
	notificationIsRead: boolean,
	id: string 
}

export type MarkNotificationsAsReadMutation = {
	__typename?: 'Mutation',
	markAsRead?: Array<MarkNotificationsAsReadMutationMarkAsRead | null> | null 
};

export type RedditNotificationsQueryVariables = Exact<{

  filters?: InputMaybe<NotificationFilter>;

}>;

export type RedditNotificationsQueryClient = {
	__typename?: 'Client',
	clientId: string,
	clientName?: string | null,
	clientProfilePictureUrl?: string | null,
	adAccountName?: string | null 
}

export type RedditNotificationsQueryItems = {
	__typename?: 'Notification',
	notificationId: string,
	notificationEntityType?: NotificationEntityType | null,
	notificationEntityId?: string | null,
	notificationType: NotificationType,
	notificationCategory: NotificationCategory,
	notificationPriority: number,
	notificationTitle: string,
	notificationMessage: string,
	notificationCreatedAt: any,
	notificationIsRead: boolean,
	notificationIsGlobal: boolean,
	id: string,
	client?: RedditNotificationsQueryClient | null 
}

export type RedditNotificationsQueryNotifications = {
	__typename?: 'NotificationCursored',
	items?: Array<RedditNotificationsQueryItems> | null 
}

export type RedditNotificationsQuery = {
	__typename?: 'Query',
	notifications: RedditNotificationsQueryNotifications 
};

export type AdSuperGridListQueryVariables = Exact<{

  statsFilter?: InputMaybe<StatsFilter>;

  filters?: InputMaybe<AdFilter>;

  limit?: InputMaybe<Scalars['Int']>;

  cursor?: InputMaybe<Scalars['String']>;

  orderBy?: InputMaybe<Array<AdOrderBy> | AdOrderBy>;

}>;

export type AdSuperGridListQueryFlatStats = {
	__typename?: 'Stats',
	appInstallMetricsAddPaymentInfo?: number | null,
	appInstallMetricsAddToCart?: number | null,
	appInstallMetricsAppLaunch?: number | null,
	appInstallMetricsCompletedTutorial?: number | null,
	appInstallMetricsInstall?: number | null,
	appInstallMetricsLevelAchieved?: number | null,
	appInstallMetricsPurchase?: number | null,
	appInstallMetricsSearch?: number | null,
	appInstallMetricsSignUp?: number | null,
	appInstallMetricsSpend?: number | null,
	appInstallMetricsSpendCredits?: number | null,
	appInstallMetricsViewContent?: number | null,
	clicks?: number | null,
	commentDownvotes?: number | null,
	commentUpvotes?: number | null,
	commentsPageViews?: number | null,
	conversionAddToCartAvgValue?: number | null,
	conversionAddToCartTotalItems?: number | null,
	conversionAddToCartTotalValue?: number | null,
	conversionAddToWishlistAvgValue?: number | null,
	conversionAddToWishlistTotalItems?: number | null,
	conversionAddToWishlistTotalValue?: number | null,
	conversionLeadTotalValue?: number | null,
	conversionPurchaseAvgValue?: number | null,
	conversionPurchaseTotalItems?: number | null,
	conversionPurchaseTotalValue?: number | null,
	conversionRoas?: number | null,
	conversionSignupTotalValue?: number | null,
	customClickThroughConversionsAttributionWindowDay?: number | null,
	customClickThroughConversionsAttributionWindowMonth?: number | null,
	customClickThroughConversionsAttributionWindowWeek?: number | null,
	customViewThroughConversionsAttributionWindowDay?: number | null,
	customViewThroughConversionsAttributionWindowMonth?: number | null,
	customViewThroughConversionsAttributionWindowWeek?: number | null,
	impressions?: number | null,
	spend?: number | null,
	videoFullyViewableImpressions?: number | null,
	videoPlaysExpanded?: number | null,
	videoPlaysWithSound?: number | null,
	videoStarted?: number | null,
	videoViewableImpressions?: number | null,
	videoWatched100Percent?: number | null,
	videoWatched10Seconds?: number | null,
	videoWatched25Percent?: number | null,
	videoWatched3Seconds?: number | null,
	videoWatched50Percent?: number | null,
	videoWatched5Seconds?: number | null,
	videoWatched75Percent?: number | null,
	videoWatched95Percent?: number | null,
	viewableImpressions?: number | null,
	viewerComments?: number | null,
	cpc?: number | null,
	ctr?: number | null,
	ecpm?: number | null 
}

export type AdSuperGridListQueryAdEventTrackers = {
	__typename?: 'EventTracker',
	url?: string | null,
	type?: EventTrackerType | null 
}

export type AdSuperGridListQueryProfiles = {
	__typename?: 'Profile',
	profileId: string,
	profileName: string,
	id: string,
	value: string,
	label: string 
}

export type AdSuperGridListQueryBusiness = {
	__typename?: 'Business',
	businessId: string,
	businessName: string,
	businessWebsiteUrl?: string | null,
	industryId?: string | null 
}

export type AdSuperGridListQueryFundingInstruments = {
	__typename?: 'FundingInstrument',
	fundingInstrumentId: string,
	fundingInstrumentName: string 
}

export type AdSuperGridListQueryAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string,
	adAccountName: string,
	profiles?: Array<AdSuperGridListQueryProfiles> | null,
	business: AdSuperGridListQueryBusiness, fundingInstruments?: Array<AdSuperGridListQueryFundingInstruments> | null 
}

export type AdSuperGridListQueryUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any 
}

export type AdSuperGridListQueryUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: AdSuperGridListQueryUser 
}

export type AdSuperGridListQueryUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<AdSuperGridListQueryUsers> | null 
}

export type AdSuperGridListQueryUserUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any,
	userName?: string | null,
	userSurname?: string | null,
	userProfilePictureUrl?: string | null 
}

export type AdSuperGridListQueryUsersUsers = {
	__typename?: 'AgencyUser',
	agencyPendingInviteHash?: string | null,
	agencyIsOwner: boolean,
	user: AdSuperGridListQueryUserUser 
}

export type AdSuperGridListQueryAgencyAccount = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	agencyAccountProfilePictureUrl?: string | null,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	userGroups?: Array<AdSuperGridListQueryUserGroups> | null,
	users?: Array<AdSuperGridListQueryUsersUsers> | null 
}

export type AdSuperGridListQueryFlatAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string 
}

export type AdSuperGridListQueryUsersUsersUsers = {
	__typename?: 'UserGroupUser',
	userGroupPendingInviteHash?: string | null,
	userGroupUserRole: UserGroupRole,
	user: AdSuperGridListQueryUser 
}

export type AdSuperGridListQueryUserGroupsUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<AdSuperGridListQueryUsersUsersUsers> | null 
}

export type AdSuperGridListQueryUserUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null 
}

export type AdSuperGridListQueryUsersUsersUsersUsers = {
	__typename?: 'ClientUser',
	clientPendingInviteHash?: string | null,
	user: AdSuperGridListQueryUserUserUser 
}

export type AdSuperGridListQueryParent = {
	__typename?: 'Client',
	clientPinned: boolean,
	clientKpi?: string | null,
	clientBreakdown?: string | null,
	clientStatus: ClientStatus,
	clientId: string,
	clientCreatedAt: any,
	id: string,
	name?: string | null,
	clientProfilePicture?: string | null,
	currency?: string | null,
	adAccount: AdSuperGridListQueryAdAccount, agencyAccount?: AdSuperGridListQueryAgencyAccount | null,
	flatAdAccount: AdSuperGridListQueryFlatAdAccount, userGroups?: Array<AdSuperGridListQueryUserGroupsUserGroups> | null,
	users?: Array<AdSuperGridListQueryUsersUsersUsersUsers> | null 
}

export type AdSuperGridListQueryFundingInstrument = {
	__typename?: 'FundingInstrument',
	fundingInstrumentId: string,
	fundingInstrumentName: string 
}

export type AdSuperGridListQueryParentParent = {
	__typename?: 'Campaign',
	campaignId: string,
	campaignName: string,
	campaignCreatedAt: any,
	campaignUpdatedAt: any,
	campaignSpecialAdCategories?: Array<CampaignSpecialAdCategory | null> | null,
	campaignObjective: CampaignObjective,
	campaignStatus?: CampaignStatus | null,
	campaignSpendCap?: any | null,
	id: string,
	name: string,
	externalId?: string | null,
	hasErrors: boolean,
	currency?: string | null,
	updatedAt: any,
	modificationTime: any,
	status?: CampaignStatus | null,
	statusPending?: CampaignStatus | null,
	parent: AdSuperGridListQueryParent, fundingInstrument?: AdSuperGridListQueryFundingInstrument | null 
}

export type AdSuperGridListQueryGroupTargetingDevices = {
	__typename?: 'GroupTargetingDevices',
	groupTargetingDevicesLabelMap?: any | null,
	groupTargetingDevicesOS?: GroupTargetingDevicesOs | null,
	groupTargetingDevicesOSMaxVersion?: string | null,
	groupTargetingDevicesOSMinVersion?: string | null,
	groupTargetingDevicesType?: GroupTargetingDeviceType | null 
}

export type AdSuperGridListQueryGroupTargeting = {
	__typename?: 'GroupTargeting',
	groupTargetingKeywords?: Array<string | null> | null,
	groupTargetingExcludedKeywords?: Array<string | null> | null,
	placements?: Array<GroupTargetingLocations | null> | null,
	gender?: GroupTargetingGender | null,
	deviceType?: Array<GroupTargetingPlatforms | null> | null,
	communities?: Array<string | null> | null,
	communitiesExcluded?: Array<string | null> | null,
	locations?: Array<string | null> | null,
	locationsExcluded?: Array<string | null> | null,
	interests?: Array<string | null> | null,
	keywords?: Array<string | null> | null,
	customAudiences?: Array<string | null> | null,
	customAudiencesExcluded?: Array<string | null> | null,
	carriers?: Array<string | null> | null,
	groupTargetingDevices?: Array<AdSuperGridListQueryGroupTargetingDevices | null> | null 
}

export type AdSuperGridListQueryParentParentParent = {
	__typename?: 'Group',
	groupId: string,
	groupName: string,
	externalGroupId?: string | null,
	groupStatus?: GroupStatus | null,
	groupBidType: GroupBidType,
	groupBidStrategy: GroupBidStrategy,
	groupBidAmount?: number | null,
	groupGoal?: GroupGoal | null,
	groupGoalAmount?: number | null,
	groupOptimizationGoal?: GroupOptimizationGoal | null,
	groupStartTime?: any | null,
	groupEndTime?: any | null,
	groupCreatedAt: any,
	groupModificationTime?: any | null,
	groupAppId?: string | null,
	id: string,
	name: string,
	externalId?: string | null,
	hasErrors: boolean,
	status?: GroupStatus | null,
	statusPending?: GroupStatus | null,
	updatedAt?: any | null,
	modificationTime?: any | null,
	currency?: string | null,
	parent: AdSuperGridListQueryParentParent, groupTargeting?: AdSuperGridListQueryGroupTargeting | null 
}

export type AdSuperGridListQueryProfile = {
	__typename?: 'Profile',
	profileName: string,
	id: string,
	value: string,
	label: string 
}

export type AdSuperGridListQueryFlatText = {
	__typename?: 'Text',
	creativeText?: string | null 
}

export type AdSuperGridListQueryFlatCreativeContent = {
	__typename?: 'CreativeContent',
	creativeContentId: string,
	creativeContentCallToAction?: CreativeContentCallToAction | null,
	creativeContentDestinationUrl?: string | null,
	creativeContentDisplayUrl?: string | null,
	creativeContentMediaUrl?: string | null,
	creativeContentCaption?: string | null 
}

export type AdSuperGridListQueryFlatCreative = {
	__typename?: 'Creative',
	creativeId: string,
	creativePostUrl?: string | null,
	creativeHeadline: string,
	creativeThumbnailUrl?: string | null,
	creativeAllowComments: boolean,
	creativeType: CreativeType,
	externalCreativeId?: string | null,
	creativeHasErrors: boolean,
	profile: AdSuperGridListQueryProfile, flatText?: AdSuperGridListQueryFlatText | null,
	flatCreativeContent?: Array<AdSuperGridListQueryFlatCreativeContent> | null 
}

export type AdSuperGridListQueryFlatAdAccountFlatAdAccount = {
	__typename?: 'AdAccount',
	currency: string 
}

export type AdSuperGridListQueryFlatClient = {
	__typename?: 'Client',
	flatAdAccount: AdSuperGridListQueryFlatAdAccountFlatAdAccount 
}

export type AdSuperGridListQueryItems = {
	__typename?: 'Ad',
	adId: string,
	adName?: string | null,
	adCreatedAt: any,
	adModificationTime?: any | null,
	id: string,
	name?: string | null,
	externalId?: string | null,
	hasErrors: boolean,
	modificationTime?: any | null,
	updatedAt?: any | null,
	status?: AdStatus | null,
	statusPending?: AdStatus | null,
	currency?: string | null,
	flatStats?: Array<AdSuperGridListQueryFlatStats | null> | null,
	adEventTrackers?: Array<AdSuperGridListQueryAdEventTrackers | null> | null,
	parent: AdSuperGridListQueryParentParentParent, flatCreative?: AdSuperGridListQueryFlatCreative | null,
	flatClient: AdSuperGridListQueryFlatClient 
}

export type AdSuperGridListQueryEntities = {
	__typename?: 'AdCursored',
	cursor?: string | null,
	items?: Array<AdSuperGridListQueryItems> | null 
}

export type AdSuperGridListQuery = {
	__typename?: 'Query',
	entities: AdSuperGridListQueryEntities 
};

export type CommunityBreakdownSuperGridListQueryVariables = Exact<{

  filters?: InputMaybe<StatsFilter>;

  limit?: InputMaybe<Scalars['Int']>;

  cursor?: InputMaybe<Scalars['String']>;

  orderBy?: InputMaybe<Array<StatsOrderBy> | StatsOrderBy>;

}>;

export type CommunityBreakdownSuperGridListQueryItems = {
	__typename?: 'Stats',
	appInstallMetricsAddPaymentInfo?: number | null,
	appInstallMetricsAddToCart?: number | null,
	appInstallMetricsAppLaunch?: number | null,
	appInstallMetricsCompletedTutorial?: number | null,
	appInstallMetricsInstall?: number | null,
	appInstallMetricsLevelAchieved?: number | null,
	appInstallMetricsPurchase?: number | null,
	appInstallMetricsSearch?: number | null,
	appInstallMetricsSignUp?: number | null,
	appInstallMetricsSpend?: number | null,
	appInstallMetricsSpendCredits?: number | null,
	appInstallMetricsViewContent?: number | null,
	clicks?: number | null,
	commentDownvotes?: number | null,
	commentUpvotes?: number | null,
	commentsPageViews?: number | null,
	conversionAddToCartAvgValue?: number | null,
	conversionAddToCartTotalItems?: number | null,
	conversionAddToCartTotalValue?: number | null,
	conversionAddToWishlistAvgValue?: number | null,
	conversionAddToWishlistTotalItems?: number | null,
	conversionAddToWishlistTotalValue?: number | null,
	conversionLeadTotalValue?: number | null,
	conversionPurchaseAvgValue?: number | null,
	conversionPurchaseTotalItems?: number | null,
	conversionPurchaseTotalValue?: number | null,
	conversionRoas?: number | null,
	conversionSignupTotalValue?: number | null,
	customClickThroughConversionsAttributionWindowDay?: number | null,
	customClickThroughConversionsAttributionWindowMonth?: number | null,
	customClickThroughConversionsAttributionWindowWeek?: number | null,
	customViewThroughConversionsAttributionWindowDay?: number | null,
	customViewThroughConversionsAttributionWindowMonth?: number | null,
	customViewThroughConversionsAttributionWindowWeek?: number | null,
	impressions?: number | null,
	spend?: number | null,
	videoFullyViewableImpressions?: number | null,
	videoPlaysExpanded?: number | null,
	videoPlaysWithSound?: number | null,
	videoStarted?: number | null,
	videoViewableImpressions?: number | null,
	videoWatched100Percent?: number | null,
	videoWatched10Seconds?: number | null,
	videoWatched25Percent?: number | null,
	videoWatched3Seconds?: number | null,
	videoWatched50Percent?: number | null,
	videoWatched5Seconds?: number | null,
	videoWatched75Percent?: number | null,
	videoWatched95Percent?: number | null,
	viewableImpressions?: number | null,
	viewerComments?: number | null,
	cpc?: number | null,
	ctr?: number | null,
	ecpm?: number | null,
	id?: string | null,
	name?: string | null 
}

export type CommunityBreakdownSuperGridListQueryEntities = {
	__typename?: 'StatsCursored',
	cursor?: string | null,
	items?: Array<CommunityBreakdownSuperGridListQueryItems> | null 
}

export type CommunityBreakdownSuperGridListQuery = {
	__typename?: 'Query',
	entities?: CommunityBreakdownSuperGridListQueryEntities | null 
};

export type CountryBreakdownSuperGridListQueryVariables = Exact<{

  filters?: InputMaybe<StatsFilter>;

  limit?: InputMaybe<Scalars['Int']>;

  cursor?: InputMaybe<Scalars['String']>;

  orderBy?: InputMaybe<Array<StatsOrderBy> | StatsOrderBy>;

}>;

export type CountryBreakdownSuperGridListQueryItems = {
	__typename?: 'Stats',
	appInstallMetricsAddPaymentInfo?: number | null,
	appInstallMetricsAddToCart?: number | null,
	appInstallMetricsAppLaunch?: number | null,
	appInstallMetricsCompletedTutorial?: number | null,
	appInstallMetricsInstall?: number | null,
	appInstallMetricsLevelAchieved?: number | null,
	appInstallMetricsPurchase?: number | null,
	appInstallMetricsSearch?: number | null,
	appInstallMetricsSignUp?: number | null,
	appInstallMetricsSpend?: number | null,
	appInstallMetricsSpendCredits?: number | null,
	appInstallMetricsViewContent?: number | null,
	clicks?: number | null,
	commentDownvotes?: number | null,
	commentUpvotes?: number | null,
	commentsPageViews?: number | null,
	conversionAddToCartAvgValue?: number | null,
	conversionAddToCartTotalItems?: number | null,
	conversionAddToCartTotalValue?: number | null,
	conversionAddToWishlistAvgValue?: number | null,
	conversionAddToWishlistTotalItems?: number | null,
	conversionAddToWishlistTotalValue?: number | null,
	conversionLeadTotalValue?: number | null,
	conversionPurchaseAvgValue?: number | null,
	conversionPurchaseTotalItems?: number | null,
	conversionPurchaseTotalValue?: number | null,
	conversionRoas?: number | null,
	conversionSignupTotalValue?: number | null,
	customClickThroughConversionsAttributionWindowDay?: number | null,
	customClickThroughConversionsAttributionWindowMonth?: number | null,
	customClickThroughConversionsAttributionWindowWeek?: number | null,
	customViewThroughConversionsAttributionWindowDay?: number | null,
	customViewThroughConversionsAttributionWindowMonth?: number | null,
	customViewThroughConversionsAttributionWindowWeek?: number | null,
	impressions?: number | null,
	spend?: number | null,
	videoFullyViewableImpressions?: number | null,
	videoPlaysExpanded?: number | null,
	videoPlaysWithSound?: number | null,
	videoStarted?: number | null,
	videoViewableImpressions?: number | null,
	videoWatched100Percent?: number | null,
	videoWatched10Seconds?: number | null,
	videoWatched25Percent?: number | null,
	videoWatched3Seconds?: number | null,
	videoWatched50Percent?: number | null,
	videoWatched5Seconds?: number | null,
	videoWatched75Percent?: number | null,
	videoWatched95Percent?: number | null,
	viewableImpressions?: number | null,
	viewerComments?: number | null,
	cpc?: number | null,
	ctr?: number | null,
	ecpm?: number | null,
	id?: string | null,
	name?: string | null 
}

export type CountryBreakdownSuperGridListQueryEntities = {
	__typename?: 'StatsCursored',
	cursor?: string | null,
	items?: Array<CountryBreakdownSuperGridListQueryItems> | null 
}

export type CountryBreakdownSuperGridListQuery = {
	__typename?: 'Query',
	entities?: CountryBreakdownSuperGridListQueryEntities | null 
};

export type DateBreakdownSuperGridListQueryVariables = Exact<{

  filters?: InputMaybe<StatsFilter>;

  limit?: InputMaybe<Scalars['Int']>;

  cursor?: InputMaybe<Scalars['String']>;

}>;

export type DateBreakdownSuperGridListQueryItems = {
	__typename?: 'Stats',
	appInstallMetricsAddPaymentInfo?: number | null,
	appInstallMetricsAddToCart?: number | null,
	appInstallMetricsAppLaunch?: number | null,
	appInstallMetricsCompletedTutorial?: number | null,
	appInstallMetricsInstall?: number | null,
	appInstallMetricsLevelAchieved?: number | null,
	appInstallMetricsPurchase?: number | null,
	appInstallMetricsSearch?: number | null,
	appInstallMetricsSignUp?: number | null,
	appInstallMetricsSpend?: number | null,
	appInstallMetricsSpendCredits?: number | null,
	appInstallMetricsViewContent?: number | null,
	clicks?: number | null,
	commentDownvotes?: number | null,
	commentUpvotes?: number | null,
	commentsPageViews?: number | null,
	conversionAddToCartAvgValue?: number | null,
	conversionAddToCartTotalItems?: number | null,
	conversionAddToCartTotalValue?: number | null,
	conversionAddToWishlistAvgValue?: number | null,
	conversionAddToWishlistTotalItems?: number | null,
	conversionAddToWishlistTotalValue?: number | null,
	conversionLeadTotalValue?: number | null,
	conversionPurchaseAvgValue?: number | null,
	conversionPurchaseTotalItems?: number | null,
	conversionPurchaseTotalValue?: number | null,
	conversionRoas?: number | null,
	conversionSignupTotalValue?: number | null,
	customClickThroughConversionsAttributionWindowDay?: number | null,
	customClickThroughConversionsAttributionWindowMonth?: number | null,
	customClickThroughConversionsAttributionWindowWeek?: number | null,
	customViewThroughConversionsAttributionWindowDay?: number | null,
	customViewThroughConversionsAttributionWindowMonth?: number | null,
	customViewThroughConversionsAttributionWindowWeek?: number | null,
	impressions?: number | null,
	spend?: number | null,
	videoFullyViewableImpressions?: number | null,
	videoPlaysExpanded?: number | null,
	videoPlaysWithSound?: number | null,
	videoStarted?: number | null,
	videoViewableImpressions?: number | null,
	videoWatched100Percent?: number | null,
	videoWatched10Seconds?: number | null,
	videoWatched25Percent?: number | null,
	videoWatched3Seconds?: number | null,
	videoWatched50Percent?: number | null,
	videoWatched5Seconds?: number | null,
	videoWatched75Percent?: number | null,
	videoWatched95Percent?: number | null,
	viewableImpressions?: number | null,
	viewerComments?: number | null,
	cpc?: number | null,
	ctr?: number | null,
	ecpm?: number | null,
	id?: any | null,
	name?: any | null 
}

export type DateBreakdownSuperGridListQueryEntities = {
	__typename?: 'StatsCursored',
	cursor?: string | null,
	items?: Array<DateBreakdownSuperGridListQueryItems> | null 
}

export type DateBreakdownSuperGridListQuery = {
	__typename?: 'Query',
	entities?: DateBreakdownSuperGridListQueryEntities | null 
};

export type InterestBreakdownSuperGridListQueryVariables = Exact<{

  filters?: InputMaybe<StatsFilter>;

  limit?: InputMaybe<Scalars['Int']>;

  cursor?: InputMaybe<Scalars['String']>;

  orderBy?: InputMaybe<Array<StatsOrderBy> | StatsOrderBy>;

}>;

export type InterestBreakdownSuperGridListQueryItems = {
	__typename?: 'Stats',
	appInstallMetricsAddPaymentInfo?: number | null,
	appInstallMetricsAddToCart?: number | null,
	appInstallMetricsAppLaunch?: number | null,
	appInstallMetricsCompletedTutorial?: number | null,
	appInstallMetricsInstall?: number | null,
	appInstallMetricsLevelAchieved?: number | null,
	appInstallMetricsPurchase?: number | null,
	appInstallMetricsSearch?: number | null,
	appInstallMetricsSignUp?: number | null,
	appInstallMetricsSpend?: number | null,
	appInstallMetricsSpendCredits?: number | null,
	appInstallMetricsViewContent?: number | null,
	clicks?: number | null,
	commentDownvotes?: number | null,
	commentUpvotes?: number | null,
	commentsPageViews?: number | null,
	conversionAddToCartAvgValue?: number | null,
	conversionAddToCartTotalItems?: number | null,
	conversionAddToCartTotalValue?: number | null,
	conversionAddToWishlistAvgValue?: number | null,
	conversionAddToWishlistTotalItems?: number | null,
	conversionAddToWishlistTotalValue?: number | null,
	conversionLeadTotalValue?: number | null,
	conversionPurchaseAvgValue?: number | null,
	conversionPurchaseTotalItems?: number | null,
	conversionPurchaseTotalValue?: number | null,
	conversionRoas?: number | null,
	conversionSignupTotalValue?: number | null,
	customClickThroughConversionsAttributionWindowDay?: number | null,
	customClickThroughConversionsAttributionWindowMonth?: number | null,
	customClickThroughConversionsAttributionWindowWeek?: number | null,
	customViewThroughConversionsAttributionWindowDay?: number | null,
	customViewThroughConversionsAttributionWindowMonth?: number | null,
	customViewThroughConversionsAttributionWindowWeek?: number | null,
	impressions?: number | null,
	spend?: number | null,
	videoFullyViewableImpressions?: number | null,
	videoPlaysExpanded?: number | null,
	videoPlaysWithSound?: number | null,
	videoStarted?: number | null,
	videoViewableImpressions?: number | null,
	videoWatched100Percent?: number | null,
	videoWatched10Seconds?: number | null,
	videoWatched25Percent?: number | null,
	videoWatched3Seconds?: number | null,
	videoWatched50Percent?: number | null,
	videoWatched5Seconds?: number | null,
	videoWatched75Percent?: number | null,
	videoWatched95Percent?: number | null,
	viewableImpressions?: number | null,
	viewerComments?: number | null,
	cpc?: number | null,
	ctr?: number | null,
	ecpm?: number | null,
	id?: string | null,
	name?: string | null 
}

export type InterestBreakdownSuperGridListQueryEntities = {
	__typename?: 'StatsCursored',
	cursor?: string | null,
	items?: Array<InterestBreakdownSuperGridListQueryItems> | null 
}

export type InterestBreakdownSuperGridListQuery = {
	__typename?: 'Query',
	entities?: InterestBreakdownSuperGridListQueryEntities | null 
};

export type RegionBreakdownSuperGridListQueryVariables = Exact<{

  filters?: InputMaybe<StatsFilter>;

  limit?: InputMaybe<Scalars['Int']>;

  cursor?: InputMaybe<Scalars['String']>;

  orderBy?: InputMaybe<Array<StatsOrderBy> | StatsOrderBy>;

}>;

export type RegionBreakdownSuperGridListQueryItems = {
	__typename?: 'Stats',
	appInstallMetricsAddPaymentInfo?: number | null,
	appInstallMetricsAddToCart?: number | null,
	appInstallMetricsAppLaunch?: number | null,
	appInstallMetricsCompletedTutorial?: number | null,
	appInstallMetricsInstall?: number | null,
	appInstallMetricsLevelAchieved?: number | null,
	appInstallMetricsPurchase?: number | null,
	appInstallMetricsSearch?: number | null,
	appInstallMetricsSignUp?: number | null,
	appInstallMetricsSpend?: number | null,
	appInstallMetricsSpendCredits?: number | null,
	appInstallMetricsViewContent?: number | null,
	clicks?: number | null,
	commentDownvotes?: number | null,
	commentUpvotes?: number | null,
	commentsPageViews?: number | null,
	conversionAddToCartAvgValue?: number | null,
	conversionAddToCartTotalItems?: number | null,
	conversionAddToCartTotalValue?: number | null,
	conversionAddToWishlistAvgValue?: number | null,
	conversionAddToWishlistTotalItems?: number | null,
	conversionAddToWishlistTotalValue?: number | null,
	conversionLeadTotalValue?: number | null,
	conversionPurchaseAvgValue?: number | null,
	conversionPurchaseTotalItems?: number | null,
	conversionPurchaseTotalValue?: number | null,
	conversionRoas?: number | null,
	conversionSignupTotalValue?: number | null,
	customClickThroughConversionsAttributionWindowDay?: number | null,
	customClickThroughConversionsAttributionWindowMonth?: number | null,
	customClickThroughConversionsAttributionWindowWeek?: number | null,
	customViewThroughConversionsAttributionWindowDay?: number | null,
	customViewThroughConversionsAttributionWindowMonth?: number | null,
	customViewThroughConversionsAttributionWindowWeek?: number | null,
	impressions?: number | null,
	spend?: number | null,
	videoFullyViewableImpressions?: number | null,
	videoPlaysExpanded?: number | null,
	videoPlaysWithSound?: number | null,
	videoStarted?: number | null,
	videoViewableImpressions?: number | null,
	videoWatched100Percent?: number | null,
	videoWatched10Seconds?: number | null,
	videoWatched25Percent?: number | null,
	videoWatched3Seconds?: number | null,
	videoWatched50Percent?: number | null,
	videoWatched5Seconds?: number | null,
	videoWatched75Percent?: number | null,
	videoWatched95Percent?: number | null,
	viewableImpressions?: number | null,
	viewerComments?: number | null,
	cpc?: number | null,
	ctr?: number | null,
	ecpm?: number | null,
	id?: string | null,
	name?: string | null 
}

export type RegionBreakdownSuperGridListQueryEntities = {
	__typename?: 'StatsCursored',
	cursor?: string | null,
	items?: Array<RegionBreakdownSuperGridListQueryItems> | null 
}

export type RegionBreakdownSuperGridListQuery = {
	__typename?: 'Query',
	entities?: RegionBreakdownSuperGridListQueryEntities | null 
};

export type CampaignSuperGridListQueryVariables = Exact<{

  statsFilter?: InputMaybe<StatsFilter>;

  filters?: InputMaybe<CampaignFilter>;

  limit?: InputMaybe<Scalars['Int']>;

  cursor?: InputMaybe<Scalars['String']>;

  orderBy?: InputMaybe<Array<CampaignOrderBy> | CampaignOrderBy>;

}>;

export type CampaignSuperGridListQueryProfiles = {
	__typename?: 'Profile',
	profileId: string,
	profileName: string,
	id: string,
	value: string,
	label: string 
}

export type CampaignSuperGridListQueryBusiness = {
	__typename?: 'Business',
	businessId: string,
	businessName: string,
	businessWebsiteUrl?: string | null,
	industryId?: string | null 
}

export type CampaignSuperGridListQueryFundingInstruments = {
	__typename?: 'FundingInstrument',
	fundingInstrumentId: string,
	fundingInstrumentName: string 
}

export type CampaignSuperGridListQueryAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string,
	adAccountName: string,
	profiles?: Array<CampaignSuperGridListQueryProfiles> | null,
	business: CampaignSuperGridListQueryBusiness, fundingInstruments?: Array<CampaignSuperGridListQueryFundingInstruments> | null 
}

export type CampaignSuperGridListQueryUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any 
}

export type CampaignSuperGridListQueryUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: CampaignSuperGridListQueryUser 
}

export type CampaignSuperGridListQueryUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<CampaignSuperGridListQueryUsers> | null 
}

export type CampaignSuperGridListQueryUserUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any,
	userName?: string | null,
	userSurname?: string | null,
	userProfilePictureUrl?: string | null 
}

export type CampaignSuperGridListQueryUsersUsers = {
	__typename?: 'AgencyUser',
	agencyPendingInviteHash?: string | null,
	agencyIsOwner: boolean,
	user: CampaignSuperGridListQueryUserUser 
}

export type CampaignSuperGridListQueryAgencyAccount = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	agencyAccountProfilePictureUrl?: string | null,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	userGroups?: Array<CampaignSuperGridListQueryUserGroups> | null,
	users?: Array<CampaignSuperGridListQueryUsersUsers> | null 
}

export type CampaignSuperGridListQueryFlatAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string 
}

export type CampaignSuperGridListQueryUsersUsersUsers = {
	__typename?: 'UserGroupUser',
	userGroupPendingInviteHash?: string | null,
	userGroupUserRole: UserGroupRole,
	user: CampaignSuperGridListQueryUser 
}

export type CampaignSuperGridListQueryUserGroupsUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<CampaignSuperGridListQueryUsersUsersUsers> | null 
}

export type CampaignSuperGridListQueryUserUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null 
}

export type CampaignSuperGridListQueryUsersUsersUsersUsers = {
	__typename?: 'ClientUser',
	clientPendingInviteHash?: string | null,
	user: CampaignSuperGridListQueryUserUserUser 
}

export type CampaignSuperGridListQueryParent = {
	__typename?: 'Client',
	clientPinned: boolean,
	clientKpi?: string | null,
	clientBreakdown?: string | null,
	clientStatus: ClientStatus,
	clientId: string,
	clientCreatedAt: any,
	id: string,
	name?: string | null,
	clientProfilePicture?: string | null,
	currency?: string | null,
	adAccount: CampaignSuperGridListQueryAdAccount, agencyAccount?: CampaignSuperGridListQueryAgencyAccount | null,
	flatAdAccount: CampaignSuperGridListQueryFlatAdAccount, userGroups?: Array<CampaignSuperGridListQueryUserGroupsUserGroups> | null,
	users?: Array<CampaignSuperGridListQueryUsersUsersUsersUsers> | null 
}

export type CampaignSuperGridListQueryFlatStats = {
	__typename?: 'Stats',
	appInstallMetricsAddPaymentInfo?: number | null,
	appInstallMetricsAddToCart?: number | null,
	appInstallMetricsAppLaunch?: number | null,
	appInstallMetricsCompletedTutorial?: number | null,
	appInstallMetricsInstall?: number | null,
	appInstallMetricsLevelAchieved?: number | null,
	appInstallMetricsPurchase?: number | null,
	appInstallMetricsSearch?: number | null,
	appInstallMetricsSignUp?: number | null,
	appInstallMetricsSpend?: number | null,
	appInstallMetricsSpendCredits?: number | null,
	appInstallMetricsViewContent?: number | null,
	clicks?: number | null,
	commentDownvotes?: number | null,
	commentUpvotes?: number | null,
	commentsPageViews?: number | null,
	conversionAddToCartAvgValue?: number | null,
	conversionAddToCartTotalItems?: number | null,
	conversionAddToCartTotalValue?: number | null,
	conversionAddToWishlistAvgValue?: number | null,
	conversionAddToWishlistTotalItems?: number | null,
	conversionAddToWishlistTotalValue?: number | null,
	conversionLeadTotalValue?: number | null,
	conversionPurchaseAvgValue?: number | null,
	conversionPurchaseTotalItems?: number | null,
	conversionPurchaseTotalValue?: number | null,
	conversionRoas?: number | null,
	conversionSignupTotalValue?: number | null,
	customClickThroughConversionsAttributionWindowDay?: number | null,
	customClickThroughConversionsAttributionWindowMonth?: number | null,
	customClickThroughConversionsAttributionWindowWeek?: number | null,
	customViewThroughConversionsAttributionWindowDay?: number | null,
	customViewThroughConversionsAttributionWindowMonth?: number | null,
	customViewThroughConversionsAttributionWindowWeek?: number | null,
	impressions?: number | null,
	spend?: number | null,
	videoFullyViewableImpressions?: number | null,
	videoPlaysExpanded?: number | null,
	videoPlaysWithSound?: number | null,
	videoStarted?: number | null,
	videoViewableImpressions?: number | null,
	videoWatched100Percent?: number | null,
	videoWatched10Seconds?: number | null,
	videoWatched25Percent?: number | null,
	videoWatched3Seconds?: number | null,
	videoWatched50Percent?: number | null,
	videoWatched5Seconds?: number | null,
	videoWatched75Percent?: number | null,
	videoWatched95Percent?: number | null,
	viewableImpressions?: number | null,
	viewerComments?: number | null,
	cpc?: number | null,
	ctr?: number | null,
	ecpm?: number | null 
}

export type CampaignSuperGridListQueryFundingInstrument = {
	__typename?: 'FundingInstrument',
	fundingInstrumentId: string,
	fundingInstrumentName: string 
}

export type CampaignSuperGridListQueryItems = {
	__typename?: 'Campaign',
	campaignId: string,
	campaignName: string,
	campaignCreatedAt: any,
	campaignUpdatedAt: any,
	campaignSpecialAdCategories?: Array<CampaignSpecialAdCategory | null> | null,
	campaignObjective: CampaignObjective,
	campaignStatus?: CampaignStatus | null,
	campaignSpendCap?: any | null,
	id: string,
	name: string,
	externalId?: string | null,
	hasErrors: boolean,
	currency?: string | null,
	updatedAt: any,
	modificationTime: any,
	status?: CampaignStatus | null,
	statusPending?: CampaignStatus | null,
	parent: CampaignSuperGridListQueryParent, flatStats?: Array<CampaignSuperGridListQueryFlatStats | null> | null,
	fundingInstrument?: CampaignSuperGridListQueryFundingInstrument | null 
}

export type CampaignSuperGridListQueryEntities = {
	__typename?: 'CampaignCursored',
	cursor?: string | null,
	items?: Array<CampaignSuperGridListQueryItems> | null 
}

export type CampaignSuperGridListQuery = {
	__typename?: 'Query',
	entities: CampaignSuperGridListQueryEntities 
};

export type ClientSuperGridListQueryVariables = Exact<{

  statsFilter?: InputMaybe<StatsFilter>;

  filters?: InputMaybe<ClientFilter>;

  limit?: InputMaybe<Scalars['Int']>;

  cursor?: InputMaybe<Scalars['String']>;

  orderBy?: InputMaybe<Array<ClientOrderBy> | ClientOrderBy>;

}>;

export type ClientSuperGridListQueryFlatStats = {
	__typename?: 'Stats',
	appInstallMetricsAddPaymentInfo?: number | null,
	appInstallMetricsAddToCart?: number | null,
	appInstallMetricsAppLaunch?: number | null,
	appInstallMetricsCompletedTutorial?: number | null,
	appInstallMetricsInstall?: number | null,
	appInstallMetricsLevelAchieved?: number | null,
	appInstallMetricsPurchase?: number | null,
	appInstallMetricsSearch?: number | null,
	appInstallMetricsSignUp?: number | null,
	appInstallMetricsSpend?: number | null,
	appInstallMetricsSpendCredits?: number | null,
	appInstallMetricsViewContent?: number | null,
	clicks?: number | null,
	commentDownvotes?: number | null,
	commentUpvotes?: number | null,
	commentsPageViews?: number | null,
	conversionAddToCartAvgValue?: number | null,
	conversionAddToCartTotalItems?: number | null,
	conversionAddToCartTotalValue?: number | null,
	conversionAddToWishlistAvgValue?: number | null,
	conversionAddToWishlistTotalItems?: number | null,
	conversionAddToWishlistTotalValue?: number | null,
	conversionLeadTotalValue?: number | null,
	conversionPurchaseAvgValue?: number | null,
	conversionPurchaseTotalItems?: number | null,
	conversionPurchaseTotalValue?: number | null,
	conversionRoas?: number | null,
	conversionSignupTotalValue?: number | null,
	customClickThroughConversionsAttributionWindowDay?: number | null,
	customClickThroughConversionsAttributionWindowMonth?: number | null,
	customClickThroughConversionsAttributionWindowWeek?: number | null,
	customViewThroughConversionsAttributionWindowDay?: number | null,
	customViewThroughConversionsAttributionWindowMonth?: number | null,
	customViewThroughConversionsAttributionWindowWeek?: number | null,
	impressions?: number | null,
	spend?: number | null,
	videoFullyViewableImpressions?: number | null,
	videoPlaysExpanded?: number | null,
	videoPlaysWithSound?: number | null,
	videoStarted?: number | null,
	videoViewableImpressions?: number | null,
	videoWatched100Percent?: number | null,
	videoWatched10Seconds?: number | null,
	videoWatched25Percent?: number | null,
	videoWatched3Seconds?: number | null,
	videoWatched50Percent?: number | null,
	videoWatched5Seconds?: number | null,
	videoWatched75Percent?: number | null,
	videoWatched95Percent?: number | null,
	viewableImpressions?: number | null,
	viewerComments?: number | null,
	cpc?: number | null,
	ctr?: number | null,
	ecpm?: number | null 
}

export type ClientSuperGridListQueryProfiles = {
	__typename?: 'Profile',
	profileId: string,
	profileName: string,
	id: string,
	value: string,
	label: string 
}

export type ClientSuperGridListQueryBusiness = {
	__typename?: 'Business',
	businessId: string,
	businessName: string,
	businessWebsiteUrl?: string | null,
	industryId?: string | null 
}

export type ClientSuperGridListQueryFundingInstruments = {
	__typename?: 'FundingInstrument',
	fundingInstrumentId: string,
	fundingInstrumentName: string 
}

export type ClientSuperGridListQueryAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string,
	adAccountName: string,
	profiles?: Array<ClientSuperGridListQueryProfiles> | null,
	business: ClientSuperGridListQueryBusiness, fundingInstruments?: Array<ClientSuperGridListQueryFundingInstruments> | null 
}

export type ClientSuperGridListQueryUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any 
}

export type ClientSuperGridListQueryUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: ClientSuperGridListQueryUser 
}

export type ClientSuperGridListQueryUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<ClientSuperGridListQueryUsers> | null 
}

export type ClientSuperGridListQueryUserUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any,
	userName?: string | null,
	userSurname?: string | null,
	userProfilePictureUrl?: string | null 
}

export type ClientSuperGridListQueryUsersUsers = {
	__typename?: 'AgencyUser',
	agencyPendingInviteHash?: string | null,
	agencyIsOwner: boolean,
	user: ClientSuperGridListQueryUserUser 
}

export type ClientSuperGridListQueryAgencyAccount = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	agencyAccountProfilePictureUrl?: string | null,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	userGroups?: Array<ClientSuperGridListQueryUserGroups> | null,
	users?: Array<ClientSuperGridListQueryUsersUsers> | null 
}

export type ClientSuperGridListQueryFlatAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string 
}

export type ClientSuperGridListQueryUsersUsersUsers = {
	__typename?: 'UserGroupUser',
	userGroupPendingInviteHash?: string | null,
	userGroupUserRole: UserGroupRole,
	user: ClientSuperGridListQueryUser 
}

export type ClientSuperGridListQueryUserGroupsUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<ClientSuperGridListQueryUsersUsersUsers> | null 
}

export type ClientSuperGridListQueryUserUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null 
}

export type ClientSuperGridListQueryUsersUsersUsersUsers = {
	__typename?: 'ClientUser',
	clientPendingInviteHash?: string | null,
	user: ClientSuperGridListQueryUserUserUser 
}

export type ClientSuperGridListQueryItems = {
	__typename?: 'Client',
	clientPinned: boolean,
	clientKpi?: string | null,
	clientBreakdown?: string | null,
	clientStatus: ClientStatus,
	clientId: string,
	clientCreatedAt: any,
	id: string,
	name?: string | null,
	clientProfilePicture?: string | null,
	currency?: string | null,
	flatStats?: Array<ClientSuperGridListQueryFlatStats | null> | null,
	adAccount: ClientSuperGridListQueryAdAccount, agencyAccount?: ClientSuperGridListQueryAgencyAccount | null,
	flatAdAccount: ClientSuperGridListQueryFlatAdAccount, userGroups?: Array<ClientSuperGridListQueryUserGroupsUserGroups> | null,
	users?: Array<ClientSuperGridListQueryUsersUsersUsersUsers> | null 
}

export type ClientSuperGridListQueryEntities = {
	__typename?: 'ClientCursored',
	cursor?: string | null,
	items?: Array<ClientSuperGridListQueryItems> | null 
}

export type ClientSuperGridListQuery = {
	__typename?: 'Query',
	entities: ClientSuperGridListQueryEntities 
};

export type RedditSupergridAdFragmentFragment = { __typename?: 'Ad', adId: string, adName?: string | null, adCreatedAt: any, adModificationTime?: any | null, id: string, name?: string | null, externalId?: string | null, hasErrors: boolean, modificationTime?: any | null, updatedAt?: any | null, status?: AdStatus | null, statusPending?: AdStatus | null, currency?: string | null, adEventTrackers?: Array<{ __typename?: 'EventTracker', url?: string | null, type?: EventTrackerType | null } | null> | null, parent: { __typename?: 'Group', groupId: string, groupName: string, externalGroupId?: string | null, groupStatus?: GroupStatus | null, groupBidType: GroupBidType, groupBidStrategy: GroupBidStrategy, groupBidAmount?: number | null, groupGoal?: GroupGoal | null, groupGoalAmount?: number | null, groupOptimizationGoal?: GroupOptimizationGoal | null, groupStartTime?: any | null, groupEndTime?: any | null, groupCreatedAt: any, groupModificationTime?: any | null, groupAppId?: string | null, id: string, name: string, externalId?: string | null, hasErrors: boolean, status?: GroupStatus | null, statusPending?: GroupStatus | null, updatedAt?: any | null, modificationTime?: any | null, currency?: string | null, parent: { __typename?: 'Campaign', campaignId: string, campaignName: string, campaignCreatedAt: any, campaignUpdatedAt: any, campaignSpecialAdCategories?: Array<CampaignSpecialAdCategory | null> | null, campaignObjective: CampaignObjective, campaignStatus?: CampaignStatus | null, campaignSpendCap?: any | null, id: string, name: string, externalId?: string | null, hasErrors: boolean, currency?: string | null, updatedAt: any, modificationTime: any, status?: CampaignStatus | null, statusPending?: CampaignStatus | null, parent: { __typename?: 'Client', clientPinned: boolean, clientKpi?: string | null, clientBreakdown?: string | null, clientStatus: ClientStatus, clientId: string, clientCreatedAt: any, id: string, name?: string | null, clientProfilePicture?: string | null, currency?: string | null, adAccount: { __typename?: 'AdAccount', adAccountId: string, adAccountName: string, profiles?: Array<{ __typename?: 'Profile', profileId: string, profileName: string, id: string, value: string, label: string }> | null, business: { __typename?: 'Business', businessId: string, businessName: string, businessWebsiteUrl?: string | null, industryId?: string | null }, fundingInstruments?: Array<{ __typename?: 'FundingInstrument', fundingInstrumentId: string, fundingInstrumentName: string }> | null }, agencyAccount?: { __typename?: 'AgencyAccount', agencyAccountId: string, agencyAccountName: string, agencyAccountProfilePictureUrl?: string | null, salesforceId?: string | null, agencyAccountActivatedAt?: any | null, userGroups?: Array<{ __typename?: 'UserGroup', userGroupId: string, userGroupName: string, userGroupProfilePictureUrl?: string | null, users?: Array<{ __typename?: 'UserGroupUser', userGroupUserRole: UserGroupRole, user: { __typename?: 'User', userId: string, userEmail: any } }> | null }> | null, users?: Array<{ __typename?: 'AgencyUser', agencyPendingInviteHash?: string | null, agencyIsOwner: boolean, user: { __typename?: 'User', userId: string, userEmail: any, userName?: string | null, userSurname?: string | null, userProfilePictureUrl?: string | null } }> | null } | null, flatAdAccount: { __typename?: 'AdAccount', adAccountId: string }, userGroups?: Array<{ __typename?: 'UserGroup', userGroupId: string, userGroupName: string, userGroupProfilePictureUrl?: string | null, users?: Array<{ __typename?: 'UserGroupUser', userGroupPendingInviteHash?: string | null, userGroupUserRole: UserGroupRole, user: { __typename?: 'User', userId: string, userEmail: any } }> | null }> | null, users?: Array<{ __typename?: 'ClientUser', clientPendingInviteHash?: string | null, user: { __typename?: 'User', userId: string, userName?: string | null, userFullName?: string | null, userSurname?: string | null, userEmail: any, userProfilePictureUrl?: string | null } }> | null }, fundingInstrument?: { __typename?: 'FundingInstrument', fundingInstrumentId: string, fundingInstrumentName: string } | null }, groupTargeting?: { __typename?: 'GroupTargeting', groupTargetingKeywords?: Array<string | null> | null, groupTargetingExcludedKeywords?: Array<string | null> | null, placements?: Array<GroupTargetingLocations | null> | null, gender?: GroupTargetingGender | null, deviceType?: Array<GroupTargetingPlatforms | null> | null, communities?: Array<string | null> | null, communitiesExcluded?: Array<string | null> | null, locations?: Array<string | null> | null, locationsExcluded?: Array<string | null> | null, interests?: Array<string | null> | null, keywords?: Array<string | null> | null, customAudiences?: Array<string | null> | null, customAudiencesExcluded?: Array<string | null> | null, carriers?: Array<string | null> | null, groupTargetingDevices?: Array<{ __typename?: 'GroupTargetingDevices', groupTargetingDevicesLabelMap?: any | null, groupTargetingDevicesOS?: GroupTargetingDevicesOs | null, groupTargetingDevicesOSMaxVersion?: string | null, groupTargetingDevicesOSMinVersion?: string | null, groupTargetingDevicesType?: GroupTargetingDeviceType | null } | null> | null } | null }, flatCreative?: { __typename?: 'Creative', creativeId: string, creativePostUrl?: string | null, creativeHeadline: string, creativeThumbnailUrl?: string | null, creativeAllowComments: boolean, creativeType: CreativeType, externalCreativeId?: string | null, creativeHasErrors: boolean, profile: { __typename?: 'Profile', profileName: string, id: string, value: string, label: string }, flatText?: { __typename?: 'Text', creativeText?: string | null } | null, flatCreativeContent?: Array<{ __typename?: 'CreativeContent', creativeContentId: string, creativeContentCallToAction?: CreativeContentCallToAction | null, creativeContentDestinationUrl?: string | null, creativeContentDisplayUrl?: string | null, creativeContentMediaUrl?: string | null, creativeContentCaption?: string | null }> | null } | null, flatClient: { __typename?: 'Client', flatAdAccount: { __typename?: 'AdAccount', currency: string } } };

export type RedditSupergridCampaignFragmentFragment = { __typename?: 'Campaign', campaignId: string, campaignName: string, campaignCreatedAt: any, campaignUpdatedAt: any, campaignSpecialAdCategories?: Array<CampaignSpecialAdCategory | null> | null, campaignObjective: CampaignObjective, campaignStatus?: CampaignStatus | null, campaignSpendCap?: any | null, id: string, name: string, externalId?: string | null, hasErrors: boolean, currency?: string | null, updatedAt: any, modificationTime: any, status?: CampaignStatus | null, statusPending?: CampaignStatus | null, fundingInstrument?: { __typename?: 'FundingInstrument', fundingInstrumentId: string, fundingInstrumentName: string } | null };

export type RedditSupergridClientFragmentFragment = { __typename?: 'Client', clientPinned: boolean, clientKpi?: string | null, clientBreakdown?: string | null, clientStatus: ClientStatus, clientId: string, clientCreatedAt: any, id: string, name?: string | null, clientProfilePicture?: string | null, currency?: string | null, adAccount: { __typename?: 'AdAccount', adAccountId: string, adAccountName: string, profiles?: Array<{ __typename?: 'Profile', profileId: string, profileName: string, id: string, value: string, label: string }> | null, business: { __typename?: 'Business', businessId: string, businessName: string, businessWebsiteUrl?: string | null, industryId?: string | null }, fundingInstruments?: Array<{ __typename?: 'FundingInstrument', fundingInstrumentId: string, fundingInstrumentName: string }> | null }, agencyAccount?: { __typename?: 'AgencyAccount', agencyAccountId: string, agencyAccountName: string, agencyAccountProfilePictureUrl?: string | null, salesforceId?: string | null, agencyAccountActivatedAt?: any | null, userGroups?: Array<{ __typename?: 'UserGroup', userGroupId: string, userGroupName: string, userGroupProfilePictureUrl?: string | null, users?: Array<{ __typename?: 'UserGroupUser', userGroupUserRole: UserGroupRole, user: { __typename?: 'User', userId: string, userEmail: any } }> | null }> | null, users?: Array<{ __typename?: 'AgencyUser', agencyPendingInviteHash?: string | null, agencyIsOwner: boolean, user: { __typename?: 'User', userId: string, userEmail: any, userName?: string | null, userSurname?: string | null, userProfilePictureUrl?: string | null } }> | null } | null, flatAdAccount: { __typename?: 'AdAccount', adAccountId: string }, userGroups?: Array<{ __typename?: 'UserGroup', userGroupId: string, userGroupName: string, userGroupProfilePictureUrl?: string | null, users?: Array<{ __typename?: 'UserGroupUser', userGroupPendingInviteHash?: string | null, userGroupUserRole: UserGroupRole, user: { __typename?: 'User', userId: string, userEmail: any } }> | null }> | null, users?: Array<{ __typename?: 'ClientUser', clientPendingInviteHash?: string | null, user: { __typename?: 'User', userId: string, userName?: string | null, userFullName?: string | null, userSurname?: string | null, userEmail: any, userProfilePictureUrl?: string | null } }> | null };

export type RedditSupergridGroupFragmentFragment = { __typename?: 'Group', groupId: string, groupName: string, externalGroupId?: string | null, groupStatus?: GroupStatus | null, groupBidType: GroupBidType, groupBidStrategy: GroupBidStrategy, groupBidAmount?: number | null, groupGoal?: GroupGoal | null, groupGoalAmount?: number | null, groupOptimizationGoal?: GroupOptimizationGoal | null, groupStartTime?: any | null, groupEndTime?: any | null, groupCreatedAt: any, groupModificationTime?: any | null, groupAppId?: string | null, id: string, name: string, externalId?: string | null, hasErrors: boolean, status?: GroupStatus | null, statusPending?: GroupStatus | null, updatedAt?: any | null, modificationTime?: any | null, currency?: string | null, groupTargeting?: { __typename?: 'GroupTargeting', groupTargetingKeywords?: Array<string | null> | null, groupTargetingExcludedKeywords?: Array<string | null> | null, placements?: Array<GroupTargetingLocations | null> | null, gender?: GroupTargetingGender | null, deviceType?: Array<GroupTargetingPlatforms | null> | null, communities?: Array<string | null> | null, communitiesExcluded?: Array<string | null> | null, locations?: Array<string | null> | null, locationsExcluded?: Array<string | null> | null, interests?: Array<string | null> | null, keywords?: Array<string | null> | null, customAudiences?: Array<string | null> | null, customAudiencesExcluded?: Array<string | null> | null, carriers?: Array<string | null> | null, groupTargetingDevices?: Array<{ __typename?: 'GroupTargetingDevices', groupTargetingDevicesLabelMap?: any | null, groupTargetingDevicesOS?: GroupTargetingDevicesOs | null, groupTargetingDevicesOSMaxVersion?: string | null, groupTargetingDevicesOSMinVersion?: string | null, groupTargetingDevicesType?: GroupTargetingDeviceType | null } | null> | null } | null };

export type GroupSuperGridListQueryVariables = Exact<{

  statsFilter?: InputMaybe<StatsFilter>;

  filters?: InputMaybe<GroupFilter>;

  limit?: InputMaybe<Scalars['Int']>;

  cursor?: InputMaybe<Scalars['String']>;

  orderBy?: InputMaybe<Array<GroupOrderBy> | GroupOrderBy>;

}>;

export type GroupSuperGridListQueryProfiles = {
	__typename?: 'Profile',
	profileId: string,
	profileName: string,
	id: string,
	value: string,
	label: string 
}

export type GroupSuperGridListQueryBusiness = {
	__typename?: 'Business',
	businessId: string,
	businessName: string,
	businessWebsiteUrl?: string | null,
	industryId?: string | null 
}

export type GroupSuperGridListQueryFundingInstruments = {
	__typename?: 'FundingInstrument',
	fundingInstrumentId: string,
	fundingInstrumentName: string 
}

export type GroupSuperGridListQueryAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string,
	adAccountName: string,
	profiles?: Array<GroupSuperGridListQueryProfiles> | null,
	business: GroupSuperGridListQueryBusiness, fundingInstruments?: Array<GroupSuperGridListQueryFundingInstruments> | null 
}

export type GroupSuperGridListQueryUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any 
}

export type GroupSuperGridListQueryUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: GroupSuperGridListQueryUser 
}

export type GroupSuperGridListQueryUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<GroupSuperGridListQueryUsers> | null 
}

export type GroupSuperGridListQueryUserUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any,
	userName?: string | null,
	userSurname?: string | null,
	userProfilePictureUrl?: string | null 
}

export type GroupSuperGridListQueryUsersUsers = {
	__typename?: 'AgencyUser',
	agencyPendingInviteHash?: string | null,
	agencyIsOwner: boolean,
	user: GroupSuperGridListQueryUserUser 
}

export type GroupSuperGridListQueryAgencyAccount = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	agencyAccountProfilePictureUrl?: string | null,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	userGroups?: Array<GroupSuperGridListQueryUserGroups> | null,
	users?: Array<GroupSuperGridListQueryUsersUsers> | null 
}

export type GroupSuperGridListQueryFlatAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string 
}

export type GroupSuperGridListQueryUsersUsersUsers = {
	__typename?: 'UserGroupUser',
	userGroupPendingInviteHash?: string | null,
	userGroupUserRole: UserGroupRole,
	user: GroupSuperGridListQueryUser 
}

export type GroupSuperGridListQueryUserGroupsUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<GroupSuperGridListQueryUsersUsersUsers> | null 
}

export type GroupSuperGridListQueryUserUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null 
}

export type GroupSuperGridListQueryUsersUsersUsersUsers = {
	__typename?: 'ClientUser',
	clientPendingInviteHash?: string | null,
	user: GroupSuperGridListQueryUserUserUser 
}

export type GroupSuperGridListQueryParent = {
	__typename?: 'Client',
	clientPinned: boolean,
	clientKpi?: string | null,
	clientBreakdown?: string | null,
	clientStatus: ClientStatus,
	clientId: string,
	clientCreatedAt: any,
	id: string,
	name?: string | null,
	clientProfilePicture?: string | null,
	currency?: string | null,
	adAccount: GroupSuperGridListQueryAdAccount, agencyAccount?: GroupSuperGridListQueryAgencyAccount | null,
	flatAdAccount: GroupSuperGridListQueryFlatAdAccount, userGroups?: Array<GroupSuperGridListQueryUserGroupsUserGroups> | null,
	users?: Array<GroupSuperGridListQueryUsersUsersUsersUsers> | null 
}

export type GroupSuperGridListQueryFundingInstrument = {
	__typename?: 'FundingInstrument',
	fundingInstrumentId: string,
	fundingInstrumentName: string 
}

export type GroupSuperGridListQueryParentParent = {
	__typename?: 'Campaign',
	campaignId: string,
	campaignName: string,
	campaignCreatedAt: any,
	campaignUpdatedAt: any,
	campaignSpecialAdCategories?: Array<CampaignSpecialAdCategory | null> | null,
	campaignObjective: CampaignObjective,
	campaignStatus?: CampaignStatus | null,
	campaignSpendCap?: any | null,
	id: string,
	name: string,
	externalId?: string | null,
	hasErrors: boolean,
	currency?: string | null,
	updatedAt: any,
	modificationTime: any,
	status?: CampaignStatus | null,
	statusPending?: CampaignStatus | null,
	parent: GroupSuperGridListQueryParent, fundingInstrument?: GroupSuperGridListQueryFundingInstrument | null 
}

export type GroupSuperGridListQueryFlatStats = {
	__typename?: 'Stats',
	appInstallMetricsAddPaymentInfo?: number | null,
	appInstallMetricsAddToCart?: number | null,
	appInstallMetricsAppLaunch?: number | null,
	appInstallMetricsCompletedTutorial?: number | null,
	appInstallMetricsInstall?: number | null,
	appInstallMetricsLevelAchieved?: number | null,
	appInstallMetricsPurchase?: number | null,
	appInstallMetricsSearch?: number | null,
	appInstallMetricsSignUp?: number | null,
	appInstallMetricsSpend?: number | null,
	appInstallMetricsSpendCredits?: number | null,
	appInstallMetricsViewContent?: number | null,
	clicks?: number | null,
	commentDownvotes?: number | null,
	commentUpvotes?: number | null,
	commentsPageViews?: number | null,
	conversionAddToCartAvgValue?: number | null,
	conversionAddToCartTotalItems?: number | null,
	conversionAddToCartTotalValue?: number | null,
	conversionAddToWishlistAvgValue?: number | null,
	conversionAddToWishlistTotalItems?: number | null,
	conversionAddToWishlistTotalValue?: number | null,
	conversionLeadTotalValue?: number | null,
	conversionPurchaseAvgValue?: number | null,
	conversionPurchaseTotalItems?: number | null,
	conversionPurchaseTotalValue?: number | null,
	conversionRoas?: number | null,
	conversionSignupTotalValue?: number | null,
	customClickThroughConversionsAttributionWindowDay?: number | null,
	customClickThroughConversionsAttributionWindowMonth?: number | null,
	customClickThroughConversionsAttributionWindowWeek?: number | null,
	customViewThroughConversionsAttributionWindowDay?: number | null,
	customViewThroughConversionsAttributionWindowMonth?: number | null,
	customViewThroughConversionsAttributionWindowWeek?: number | null,
	impressions?: number | null,
	spend?: number | null,
	videoFullyViewableImpressions?: number | null,
	videoPlaysExpanded?: number | null,
	videoPlaysWithSound?: number | null,
	videoStarted?: number | null,
	videoViewableImpressions?: number | null,
	videoWatched100Percent?: number | null,
	videoWatched10Seconds?: number | null,
	videoWatched25Percent?: number | null,
	videoWatched3Seconds?: number | null,
	videoWatched50Percent?: number | null,
	videoWatched5Seconds?: number | null,
	videoWatched75Percent?: number | null,
	videoWatched95Percent?: number | null,
	viewableImpressions?: number | null,
	viewerComments?: number | null,
	cpc?: number | null,
	ctr?: number | null,
	ecpm?: number | null 
}

export type GroupSuperGridListQueryGroupTargetingDevices = {
	__typename?: 'GroupTargetingDevices',
	groupTargetingDevicesLabelMap?: any | null,
	groupTargetingDevicesOS?: GroupTargetingDevicesOs | null,
	groupTargetingDevicesOSMaxVersion?: string | null,
	groupTargetingDevicesOSMinVersion?: string | null,
	groupTargetingDevicesType?: GroupTargetingDeviceType | null 
}

export type GroupSuperGridListQueryGroupTargeting = {
	__typename?: 'GroupTargeting',
	groupTargetingKeywords?: Array<string | null> | null,
	groupTargetingExcludedKeywords?: Array<string | null> | null,
	placements?: Array<GroupTargetingLocations | null> | null,
	gender?: GroupTargetingGender | null,
	deviceType?: Array<GroupTargetingPlatforms | null> | null,
	communities?: Array<string | null> | null,
	communitiesExcluded?: Array<string | null> | null,
	locations?: Array<string | null> | null,
	locationsExcluded?: Array<string | null> | null,
	interests?: Array<string | null> | null,
	keywords?: Array<string | null> | null,
	customAudiences?: Array<string | null> | null,
	customAudiencesExcluded?: Array<string | null> | null,
	carriers?: Array<string | null> | null,
	groupTargetingDevices?: Array<GroupSuperGridListQueryGroupTargetingDevices | null> | null 
}

export type GroupSuperGridListQueryItems = {
	__typename?: 'Group',
	groupId: string,
	groupName: string,
	externalGroupId?: string | null,
	groupStatus?: GroupStatus | null,
	groupBidType: GroupBidType,
	groupBidStrategy: GroupBidStrategy,
	groupBidAmount?: number | null,
	groupGoal?: GroupGoal | null,
	groupGoalAmount?: number | null,
	groupOptimizationGoal?: GroupOptimizationGoal | null,
	groupStartTime?: any | null,
	groupEndTime?: any | null,
	groupCreatedAt: any,
	groupModificationTime?: any | null,
	groupAppId?: string | null,
	id: string,
	name: string,
	externalId?: string | null,
	hasErrors: boolean,
	status?: GroupStatus | null,
	statusPending?: GroupStatus | null,
	updatedAt?: any | null,
	modificationTime?: any | null,
	currency?: string | null,
	parent: GroupSuperGridListQueryParentParent, flatStats?: Array<GroupSuperGridListQueryFlatStats> | null,
	groupTargeting?: GroupSuperGridListQueryGroupTargeting | null 
}

export type GroupSuperGridListQueryEntities = {
	__typename?: 'GroupCursored',
	cursor?: string | null,
	items?: Array<GroupSuperGridListQueryItems> | null 
}

export type GroupSuperGridListQuery = {
	__typename?: 'Query',
	entities: GroupSuperGridListQueryEntities 
};

export type PixelEventsQueryVariables = Exact<{

  adAccountId: Scalars['ID'];

}>;

export type PixelEventsQuery = {
	__typename?: 'Query',
	pixelLastFiredAt?: Array<GroupOptimizationGoal | null> | null 
};

export type RedditSuperGridStatsFragmentFragment = { __typename?: 'Stats', appInstallMetricsAddPaymentInfo?: number | null, appInstallMetricsAddToCart?: number | null, appInstallMetricsAppLaunch?: number | null, appInstallMetricsCompletedTutorial?: number | null, appInstallMetricsInstall?: number | null, appInstallMetricsLevelAchieved?: number | null, appInstallMetricsPurchase?: number | null, appInstallMetricsSearch?: number | null, appInstallMetricsSignUp?: number | null, appInstallMetricsSpend?: number | null, appInstallMetricsSpendCredits?: number | null, appInstallMetricsViewContent?: number | null, clicks?: number | null, commentDownvotes?: number | null, commentUpvotes?: number | null, commentsPageViews?: number | null, conversionAddToCartAvgValue?: number | null, conversionAddToCartTotalItems?: number | null, conversionAddToCartTotalValue?: number | null, conversionAddToWishlistAvgValue?: number | null, conversionAddToWishlistTotalItems?: number | null, conversionAddToWishlistTotalValue?: number | null, conversionLeadTotalValue?: number | null, conversionPurchaseAvgValue?: number | null, conversionPurchaseTotalItems?: number | null, conversionPurchaseTotalValue?: number | null, conversionRoas?: number | null, conversionSignupTotalValue?: number | null, customClickThroughConversionsAttributionWindowDay?: number | null, customClickThroughConversionsAttributionWindowMonth?: number | null, customClickThroughConversionsAttributionWindowWeek?: number | null, customViewThroughConversionsAttributionWindowDay?: number | null, customViewThroughConversionsAttributionWindowMonth?: number | null, customViewThroughConversionsAttributionWindowWeek?: number | null, impressions?: number | null, spend?: number | null, videoFullyViewableImpressions?: number | null, videoPlaysExpanded?: number | null, videoPlaysWithSound?: number | null, videoStarted?: number | null, videoViewableImpressions?: number | null, videoWatched100Percent?: number | null, videoWatched10Seconds?: number | null, videoWatched25Percent?: number | null, videoWatched3Seconds?: number | null, videoWatched50Percent?: number | null, videoWatched5Seconds?: number | null, videoWatched75Percent?: number | null, videoWatched95Percent?: number | null, viewableImpressions?: number | null, viewerComments?: number | null, cpc?: number | null, ctr?: number | null, ecpm?: number | null };

export type UpdateClientPinnedMutationVariables = Exact<{

  clientId: Scalars['ID'];

  clientPinned: Scalars['Boolean'];

}>;

export type UpdateClientPinnedMutationUpdateClient = {
	__typename?: 'Client',
	clientPinned: boolean,
	id: string 
}

export type UpdateClientPinnedMutation = {
	__typename?: 'Mutation',
	updateClient: UpdateClientPinnedMutationUpdateClient 
};

export type UploadRedditMediaMutationVariables = Exact<{

  clientId: Scalars['ID'];

  media: MediaInput;

}>;

export type UploadRedditMediaMutationUploadMedia = {
	__typename?: 'Media',
	mediaId: string,
	mediaUrl?: string | null,
	mediaThumbnail?: string | null,
	mediaType: string 
}

export type UploadRedditMediaMutation = {
	__typename?: 'Mutation',
	uploadMedia: UploadRedditMediaMutationUploadMedia 
};

export type UpdateClientDashboardSettingsMutationVariables = Exact<{

  clientId: Scalars['ID'];

  clientKpi?: InputMaybe<Scalars['String']>;

  clientBreakdown?: InputMaybe<Scalars['String']>;

}>;

export type UpdateClientDashboardSettingsMutationUpdateClient = {
	__typename?: 'Client',
	clientKpi?: string | null,
	clientBreakdown?: string | null,
	id: string 
}

export type UpdateClientDashboardSettingsMutation = {
	__typename?: 'Mutation',
	updateClient: UpdateClientDashboardSettingsMutationUpdateClient 
};

export type RedditMediaQueryVariables = Exact<{ [key: string]: never; }>;

export type RedditMediaQueryItems = {
	__typename?: 'Media',
	mediaId: string,
	mediaThumbnail?: string | null,
	mediaUrl?: string | null,
	mediaType: string 
}

export type RedditMediaQueryMedia = {
	__typename?: 'MediaCursored',
	items?: Array<RedditMediaQueryItems> | null 
}

export type RedditMediaQuery = {
	__typename?: 'Query',
	media: RedditMediaQueryMedia 
};

export type DashboardStatsQueryVariables = Exact<{

  filters: StatsFilter;

  performerFilters?: InputMaybe<CampaignFilter>;

  currDateFilter?: InputMaybe<DateRangeFilter>;

  lastDateFilter?: InputMaybe<DateRangeFilter>;

  performersSortColumn: CampaignOrderByColumn;

}>;

export type DashboardStatsQueryItems = {
	__typename?: 'Stats',
	date?: any | null,
	appInstallMetricsAddPaymentInfo?: number | null,
	appInstallMetricsAddToCart?: number | null,
	appInstallMetricsAppLaunch?: number | null,
	appInstallMetricsCompletedTutorial?: number | null,
	appInstallMetricsInstall?: number | null,
	appInstallMetricsLevelAchieved?: number | null,
	appInstallMetricsPurchase?: number | null,
	appInstallMetricsSearch?: number | null,
	appInstallMetricsSignUp?: number | null,
	appInstallMetricsSpend?: number | null,
	appInstallMetricsSpendCredits?: number | null,
	appInstallMetricsViewContent?: number | null,
	clicks?: number | null,
	commentDownvotes?: number | null,
	commentUpvotes?: number | null,
	commentsPageViews?: number | null,
	conversionAddToCartAvgValue?: number | null,
	conversionAddToCartTotalItems?: number | null,
	conversionAddToCartTotalValue?: number | null,
	conversionAddToWishlistAvgValue?: number | null,
	conversionAddToWishlistTotalItems?: number | null,
	conversionAddToWishlistTotalValue?: number | null,
	conversionLeadTotalValue?: number | null,
	conversionPurchaseAvgValue?: number | null,
	conversionPurchaseTotalItems?: number | null,
	conversionPurchaseTotalValue?: number | null,
	conversionRoas?: number | null,
	conversionSignupTotalValue?: number | null,
	customClickThroughConversionsAttributionWindowDay?: number | null,
	customClickThroughConversionsAttributionWindowMonth?: number | null,
	customClickThroughConversionsAttributionWindowWeek?: number | null,
	customViewThroughConversionsAttributionWindowDay?: number | null,
	customViewThroughConversionsAttributionWindowMonth?: number | null,
	customViewThroughConversionsAttributionWindowWeek?: number | null,
	impressions?: number | null,
	spend?: number | null,
	videoFullyViewableImpressions?: number | null,
	videoPlaysExpanded?: number | null,
	videoPlaysWithSound?: number | null,
	videoStarted?: number | null,
	videoViewableImpressions?: number | null,
	videoWatched100Percent?: number | null,
	videoWatched10Seconds?: number | null,
	videoWatched25Percent?: number | null,
	videoWatched3Seconds?: number | null,
	videoWatched50Percent?: number | null,
	videoWatched5Seconds?: number | null,
	videoWatched75Percent?: number | null,
	videoWatched95Percent?: number | null,
	viewableImpressions?: number | null,
	viewerComments?: number | null,
	cpc?: number | null,
	ctr?: number | null,
	ecpm?: number | null 
}

export type DashboardStatsQuerySparklineStats = {
	__typename?: 'StatsCursored',
	items?: Array<DashboardStatsQueryItems> | null 
}

export type DashboardStatsQueryLastStats = {
	__typename?: 'Stats',
	appInstallMetricsAddPaymentInfo?: number | null,
	appInstallMetricsAddToCart?: number | null,
	appInstallMetricsAppLaunch?: number | null,
	appInstallMetricsCompletedTutorial?: number | null,
	appInstallMetricsInstall?: number | null,
	appInstallMetricsLevelAchieved?: number | null,
	appInstallMetricsPurchase?: number | null,
	appInstallMetricsSearch?: number | null,
	appInstallMetricsSignUp?: number | null,
	appInstallMetricsSpend?: number | null,
	appInstallMetricsSpendCredits?: number | null,
	appInstallMetricsViewContent?: number | null,
	clicks?: number | null,
	commentDownvotes?: number | null,
	commentUpvotes?: number | null,
	commentsPageViews?: number | null,
	conversionAddToCartAvgValue?: number | null,
	conversionAddToCartTotalItems?: number | null,
	conversionAddToCartTotalValue?: number | null,
	conversionAddToWishlistAvgValue?: number | null,
	conversionAddToWishlistTotalItems?: number | null,
	conversionAddToWishlistTotalValue?: number | null,
	conversionLeadTotalValue?: number | null,
	conversionPurchaseAvgValue?: number | null,
	conversionPurchaseTotalItems?: number | null,
	conversionPurchaseTotalValue?: number | null,
	conversionRoas?: number | null,
	conversionSignupTotalValue?: number | null,
	customClickThroughConversionsAttributionWindowDay?: number | null,
	customClickThroughConversionsAttributionWindowMonth?: number | null,
	customClickThroughConversionsAttributionWindowWeek?: number | null,
	customViewThroughConversionsAttributionWindowDay?: number | null,
	customViewThroughConversionsAttributionWindowMonth?: number | null,
	customViewThroughConversionsAttributionWindowWeek?: number | null,
	impressions?: number | null,
	spend?: number | null,
	videoFullyViewableImpressions?: number | null,
	videoPlaysExpanded?: number | null,
	videoPlaysWithSound?: number | null,
	videoStarted?: number | null,
	videoViewableImpressions?: number | null,
	videoWatched100Percent?: number | null,
	videoWatched10Seconds?: number | null,
	videoWatched25Percent?: number | null,
	videoWatched3Seconds?: number | null,
	videoWatched50Percent?: number | null,
	videoWatched5Seconds?: number | null,
	videoWatched75Percent?: number | null,
	videoWatched95Percent?: number | null,
	viewableImpressions?: number | null,
	viewerComments?: number | null,
	cpc?: number | null,
	ctr?: number | null,
	ecpm?: number | null 
}

export type DashboardStatsQueryCurrStats = {
	__typename?: 'Stats',
	appInstallMetricsAddPaymentInfo?: number | null,
	appInstallMetricsAddToCart?: number | null,
	appInstallMetricsAppLaunch?: number | null,
	appInstallMetricsCompletedTutorial?: number | null,
	appInstallMetricsInstall?: number | null,
	appInstallMetricsLevelAchieved?: number | null,
	appInstallMetricsPurchase?: number | null,
	appInstallMetricsSearch?: number | null,
	appInstallMetricsSignUp?: number | null,
	appInstallMetricsSpend?: number | null,
	appInstallMetricsSpendCredits?: number | null,
	appInstallMetricsViewContent?: number | null,
	clicks?: number | null,
	commentDownvotes?: number | null,
	commentUpvotes?: number | null,
	commentsPageViews?: number | null,
	conversionAddToCartAvgValue?: number | null,
	conversionAddToCartTotalItems?: number | null,
	conversionAddToCartTotalValue?: number | null,
	conversionAddToWishlistAvgValue?: number | null,
	conversionAddToWishlistTotalItems?: number | null,
	conversionAddToWishlistTotalValue?: number | null,
	conversionLeadTotalValue?: number | null,
	conversionPurchaseAvgValue?: number | null,
	conversionPurchaseTotalItems?: number | null,
	conversionPurchaseTotalValue?: number | null,
	conversionRoas?: number | null,
	conversionSignupTotalValue?: number | null,
	customClickThroughConversionsAttributionWindowDay?: number | null,
	customClickThroughConversionsAttributionWindowMonth?: number | null,
	customClickThroughConversionsAttributionWindowWeek?: number | null,
	customViewThroughConversionsAttributionWindowDay?: number | null,
	customViewThroughConversionsAttributionWindowMonth?: number | null,
	customViewThroughConversionsAttributionWindowWeek?: number | null,
	impressions?: number | null,
	spend?: number | null,
	videoFullyViewableImpressions?: number | null,
	videoPlaysExpanded?: number | null,
	videoPlaysWithSound?: number | null,
	videoStarted?: number | null,
	videoViewableImpressions?: number | null,
	videoWatched100Percent?: number | null,
	videoWatched10Seconds?: number | null,
	videoWatched25Percent?: number | null,
	videoWatched3Seconds?: number | null,
	videoWatched50Percent?: number | null,
	videoWatched5Seconds?: number | null,
	videoWatched75Percent?: number | null,
	videoWatched95Percent?: number | null,
	viewableImpressions?: number | null,
	viewerComments?: number | null,
	cpc?: number | null,
	ctr?: number | null,
	ecpm?: number | null 
}

export type DashboardStatsQueryItemsItems = {
	__typename?: 'Campaign',
	id: string,
	name: string,
	lastStats?: Array<DashboardStatsQueryLastStats | null> | null,
	currStats?: Array<DashboardStatsQueryCurrStats | null> | null 
}

export type DashboardStatsQueryBestPerformers = {
	__typename?: 'CampaignCursored',
	items?: Array<DashboardStatsQueryItemsItems> | null 
}

export type DashboardStatsQueryWorstPerformers = {
	__typename?: 'CampaignCursored',
	items?: Array<DashboardStatsQueryItemsItems> | null 
}

export type DashboardStatsQuery = {
	__typename?: 'Query',
	sparklineStats?: DashboardStatsQuerySparklineStats | null,
	bestPerformers: DashboardStatsQueryBestPerformers, worstPerformers: DashboardStatsQueryWorstPerformers 
};

export type ClientAccessOptionsQueryVariables = Exact<{

  emailSearch: Scalars['String'];

  groupSearch: Scalars['String'];

  userSearch: Scalars['String'];

  userLevel: Array<UserAccountLevel> | UserAccountLevel;

  selectedGroupIds: Array<Scalars['ID']> | Scalars['ID'];

}>;

export type ClientAccessOptionsQueryUser = {
	__typename?: 'User',
	userEmail: any,
	id: string 
}

export type ClientAccessOptionsQueryUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: ClientAccessOptionsQueryUser 
}

export type ClientAccessOptionsQueryItems = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	id: string,
	profilePicture?: string | null,
	value: string,
	label: string,
	users?: Array<ClientAccessOptionsQueryUsers> | null 
}

export type ClientAccessOptionsQueryUserGroups = {
	__typename?: 'UserGroupCursored',
	items?: Array<ClientAccessOptionsQueryItems> | null 
}

export type ClientAccessOptionsQueryUsersUsers = {
	__typename?: 'SearchUser',
	userId: string,
	userFullName?: string | null,
	userEmail: any,
	id: string,
	profilePicture?: string | null,
	value: string,
	label?: string | null 
}

export type ClientAccessOptionsQuery = {
	__typename?: 'Query',
	userGroups: ClientAccessOptionsQueryUserGroups, users: Array<ClientAccessOptionsQueryUsersUsers> 
};

export type CancelUserToClientInvitationMutationVariables = Exact<{

  hash: Scalars['String'];

}>;

export type CancelUserToClientInvitationMutation = {
	__typename?: 'Mutation',
	resolvePendingInvite: boolean 
};

export type AdAccountIndustriesQueryVariables = Exact<{

  industryId: Array<Scalars['ID']> | Scalars['ID'];

}>;

export type AdAccountIndustriesQueryItems = {
	__typename?: 'Industry',
	industryId: string,
	industryName: string 
}

export type AdAccountIndustriesQueryIndustries = {
	__typename?: 'IndustryCursored',
	items?: Array<AdAccountIndustriesQueryItems> | null 
}

export type AdAccountIndustriesQuery = {
	__typename?: 'Query',
	industries: AdAccountIndustriesQueryIndustries 
};

export type LinkUserGroupsToClientMutationVariables = Exact<{

  clientId: Scalars['ID'];

  userGroupIds: Array<Scalars['ID']> | Scalars['ID'];

}>;

export type LinkUserGroupsToClientMutationProfiles = {
	__typename?: 'Profile',
	profileId: string,
	profileName: string,
	id: string,
	value: string,
	label: string 
}

export type LinkUserGroupsToClientMutationBusiness = {
	__typename?: 'Business',
	businessId: string,
	businessName: string,
	businessWebsiteUrl?: string | null,
	industryId?: string | null 
}

export type LinkUserGroupsToClientMutationFundingInstruments = {
	__typename?: 'FundingInstrument',
	fundingInstrumentId: string,
	fundingInstrumentName: string 
}

export type LinkUserGroupsToClientMutationAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string,
	adAccountName: string,
	profiles?: Array<LinkUserGroupsToClientMutationProfiles> | null,
	business: LinkUserGroupsToClientMutationBusiness, fundingInstruments?: Array<LinkUserGroupsToClientMutationFundingInstruments> | null 
}

export type LinkUserGroupsToClientMutationUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any 
}

export type LinkUserGroupsToClientMutationUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: LinkUserGroupsToClientMutationUser 
}

export type LinkUserGroupsToClientMutationUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<LinkUserGroupsToClientMutationUsers> | null 
}

export type LinkUserGroupsToClientMutationUserUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any,
	userName?: string | null,
	userSurname?: string | null,
	userProfilePictureUrl?: string | null 
}

export type LinkUserGroupsToClientMutationUsersUsers = {
	__typename?: 'AgencyUser',
	agencyPendingInviteHash?: string | null,
	agencyIsOwner: boolean,
	user: LinkUserGroupsToClientMutationUserUser 
}

export type LinkUserGroupsToClientMutationAgencyAccount = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	agencyAccountProfilePictureUrl?: string | null,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	userGroups?: Array<LinkUserGroupsToClientMutationUserGroups> | null,
	users?: Array<LinkUserGroupsToClientMutationUsersUsers> | null 
}

export type LinkUserGroupsToClientMutationFlatAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string 
}

export type LinkUserGroupsToClientMutationUsersUsersUsers = {
	__typename?: 'UserGroupUser',
	userGroupPendingInviteHash?: string | null,
	userGroupUserRole: UserGroupRole,
	user: LinkUserGroupsToClientMutationUser 
}

export type LinkUserGroupsToClientMutationUserGroupsUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<LinkUserGroupsToClientMutationUsersUsersUsers> | null 
}

export type LinkUserGroupsToClientMutationUserUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null 
}

export type LinkUserGroupsToClientMutationUsersUsersUsersUsers = {
	__typename?: 'ClientUser',
	clientPendingInviteHash?: string | null,
	user: LinkUserGroupsToClientMutationUserUserUser 
}

export type LinkUserGroupsToClientMutationLinkUserGroupsToClient = {
	__typename?: 'Client',
	clientPinned: boolean,
	clientKpi?: string | null,
	clientBreakdown?: string | null,
	clientStatus: ClientStatus,
	clientId: string,
	clientCreatedAt: any,
	id: string,
	name?: string | null,
	clientProfilePicture?: string | null,
	currency?: string | null,
	adAccount: LinkUserGroupsToClientMutationAdAccount, agencyAccount?: LinkUserGroupsToClientMutationAgencyAccount | null,
	flatAdAccount: LinkUserGroupsToClientMutationFlatAdAccount, userGroups?: Array<LinkUserGroupsToClientMutationUserGroupsUserGroups> | null,
	users?: Array<LinkUserGroupsToClientMutationUsersUsersUsersUsers> | null 
}

export type LinkUserGroupsToClientMutation = {
	__typename?: 'Mutation',
	linkUserGroupsToClient: LinkUserGroupsToClientMutationLinkUserGroupsToClient 
};

export type LinkUsersToClientMutationVariables = Exact<{

  clientId: Scalars['ID'];

  userIds: Array<Scalars['ID']> | Scalars['ID'];

}>;

export type LinkUsersToClientMutationProfiles = {
	__typename?: 'Profile',
	profileId: string,
	profileName: string,
	id: string,
	value: string,
	label: string 
}

export type LinkUsersToClientMutationBusiness = {
	__typename?: 'Business',
	businessId: string,
	businessName: string,
	businessWebsiteUrl?: string | null,
	industryId?: string | null 
}

export type LinkUsersToClientMutationFundingInstruments = {
	__typename?: 'FundingInstrument',
	fundingInstrumentId: string,
	fundingInstrumentName: string 
}

export type LinkUsersToClientMutationAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string,
	adAccountName: string,
	profiles?: Array<LinkUsersToClientMutationProfiles> | null,
	business: LinkUsersToClientMutationBusiness, fundingInstruments?: Array<LinkUsersToClientMutationFundingInstruments> | null 
}

export type LinkUsersToClientMutationUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any 
}

export type LinkUsersToClientMutationUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: LinkUsersToClientMutationUser 
}

export type LinkUsersToClientMutationUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<LinkUsersToClientMutationUsers> | null 
}

export type LinkUsersToClientMutationUserUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any,
	userName?: string | null,
	userSurname?: string | null,
	userProfilePictureUrl?: string | null 
}

export type LinkUsersToClientMutationUsersUsers = {
	__typename?: 'AgencyUser',
	agencyPendingInviteHash?: string | null,
	agencyIsOwner: boolean,
	user: LinkUsersToClientMutationUserUser 
}

export type LinkUsersToClientMutationAgencyAccount = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	agencyAccountProfilePictureUrl?: string | null,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	userGroups?: Array<LinkUsersToClientMutationUserGroups> | null,
	users?: Array<LinkUsersToClientMutationUsersUsers> | null 
}

export type LinkUsersToClientMutationFlatAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string 
}

export type LinkUsersToClientMutationUsersUsersUsers = {
	__typename?: 'UserGroupUser',
	userGroupPendingInviteHash?: string | null,
	userGroupUserRole: UserGroupRole,
	user: LinkUsersToClientMutationUser 
}

export type LinkUsersToClientMutationUserGroupsUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<LinkUsersToClientMutationUsersUsersUsers> | null 
}

export type LinkUsersToClientMutationUserUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null 
}

export type LinkUsersToClientMutationUsersUsersUsersUsers = {
	__typename?: 'ClientUser',
	clientPendingInviteHash?: string | null,
	user: LinkUsersToClientMutationUserUserUser 
}

export type LinkUsersToClientMutationLinkUsersToClient = {
	__typename?: 'Client',
	clientPinned: boolean,
	clientKpi?: string | null,
	clientBreakdown?: string | null,
	clientStatus: ClientStatus,
	clientId: string,
	clientCreatedAt: any,
	id: string,
	name?: string | null,
	clientProfilePicture?: string | null,
	currency?: string | null,
	adAccount: LinkUsersToClientMutationAdAccount, agencyAccount?: LinkUsersToClientMutationAgencyAccount | null,
	flatAdAccount: LinkUsersToClientMutationFlatAdAccount, userGroups?: Array<LinkUsersToClientMutationUserGroupsUserGroups> | null,
	users?: Array<LinkUsersToClientMutationUsersUsersUsersUsers> | null 
}

export type LinkUsersToClientMutation = {
	__typename?: 'Mutation',
	linkUsersToClient: LinkUsersToClientMutationLinkUsersToClient 
};

export type RevokeGroupAccessToClientMutationVariables = Exact<{

  userGroupIds: Array<Scalars['ID']> | Scalars['ID'];

  clientId: Scalars['ID'];

}>;

export type RevokeGroupAccessToClientMutationProfiles = {
	__typename?: 'Profile',
	profileId: string,
	profileName: string,
	id: string,
	value: string,
	label: string 
}

export type RevokeGroupAccessToClientMutationBusiness = {
	__typename?: 'Business',
	businessId: string,
	businessName: string,
	businessWebsiteUrl?: string | null,
	industryId?: string | null 
}

export type RevokeGroupAccessToClientMutationFundingInstruments = {
	__typename?: 'FundingInstrument',
	fundingInstrumentId: string,
	fundingInstrumentName: string 
}

export type RevokeGroupAccessToClientMutationAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string,
	adAccountName: string,
	profiles?: Array<RevokeGroupAccessToClientMutationProfiles> | null,
	business: RevokeGroupAccessToClientMutationBusiness, fundingInstruments?: Array<RevokeGroupAccessToClientMutationFundingInstruments> | null 
}

export type RevokeGroupAccessToClientMutationUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any 
}

export type RevokeGroupAccessToClientMutationUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: RevokeGroupAccessToClientMutationUser 
}

export type RevokeGroupAccessToClientMutationUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<RevokeGroupAccessToClientMutationUsers> | null 
}

export type RevokeGroupAccessToClientMutationUserUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any,
	userName?: string | null,
	userSurname?: string | null,
	userProfilePictureUrl?: string | null 
}

export type RevokeGroupAccessToClientMutationUsersUsers = {
	__typename?: 'AgencyUser',
	agencyPendingInviteHash?: string | null,
	agencyIsOwner: boolean,
	user: RevokeGroupAccessToClientMutationUserUser 
}

export type RevokeGroupAccessToClientMutationAgencyAccount = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	agencyAccountProfilePictureUrl?: string | null,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	userGroups?: Array<RevokeGroupAccessToClientMutationUserGroups> | null,
	users?: Array<RevokeGroupAccessToClientMutationUsersUsers> | null 
}

export type RevokeGroupAccessToClientMutationFlatAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string 
}

export type RevokeGroupAccessToClientMutationUsersUsersUsers = {
	__typename?: 'UserGroupUser',
	userGroupPendingInviteHash?: string | null,
	userGroupUserRole: UserGroupRole,
	user: RevokeGroupAccessToClientMutationUser 
}

export type RevokeGroupAccessToClientMutationUserGroupsUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<RevokeGroupAccessToClientMutationUsersUsersUsers> | null 
}

export type RevokeGroupAccessToClientMutationUserUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null 
}

export type RevokeGroupAccessToClientMutationUsersUsersUsersUsers = {
	__typename?: 'ClientUser',
	clientPendingInviteHash?: string | null,
	user: RevokeGroupAccessToClientMutationUserUserUser 
}

export type RevokeGroupAccessToClientMutationUnlinkUserGroupsFromClient = {
	__typename?: 'Client',
	clientPinned: boolean,
	clientKpi?: string | null,
	clientBreakdown?: string | null,
	clientStatus: ClientStatus,
	clientId: string,
	clientCreatedAt: any,
	id: string,
	name?: string | null,
	clientProfilePicture?: string | null,
	currency?: string | null,
	adAccount: RevokeGroupAccessToClientMutationAdAccount, agencyAccount?: RevokeGroupAccessToClientMutationAgencyAccount | null,
	flatAdAccount: RevokeGroupAccessToClientMutationFlatAdAccount, userGroups?: Array<RevokeGroupAccessToClientMutationUserGroupsUserGroups> | null,
	users?: Array<RevokeGroupAccessToClientMutationUsersUsersUsersUsers> | null 
}

export type RevokeGroupAccessToClientMutation = {
	__typename?: 'Mutation',
	unlinkUserGroupsFromClient: RevokeGroupAccessToClientMutationUnlinkUserGroupsFromClient 
};

export type RevokeUserAccessToClientMutationVariables = Exact<{

  userIds: Array<Scalars['ID']> | Scalars['ID'];

  clientId: Scalars['ID'];

}>;

export type RevokeUserAccessToClientMutationProfiles = {
	__typename?: 'Profile',
	profileId: string,
	profileName: string,
	id: string,
	value: string,
	label: string 
}

export type RevokeUserAccessToClientMutationBusiness = {
	__typename?: 'Business',
	businessId: string,
	businessName: string,
	businessWebsiteUrl?: string | null,
	industryId?: string | null 
}

export type RevokeUserAccessToClientMutationFundingInstruments = {
	__typename?: 'FundingInstrument',
	fundingInstrumentId: string,
	fundingInstrumentName: string 
}

export type RevokeUserAccessToClientMutationAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string,
	adAccountName: string,
	profiles?: Array<RevokeUserAccessToClientMutationProfiles> | null,
	business: RevokeUserAccessToClientMutationBusiness, fundingInstruments?: Array<RevokeUserAccessToClientMutationFundingInstruments> | null 
}

export type RevokeUserAccessToClientMutationUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any 
}

export type RevokeUserAccessToClientMutationUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: RevokeUserAccessToClientMutationUser 
}

export type RevokeUserAccessToClientMutationUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<RevokeUserAccessToClientMutationUsers> | null 
}

export type RevokeUserAccessToClientMutationUserUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any,
	userName?: string | null,
	userSurname?: string | null,
	userProfilePictureUrl?: string | null 
}

export type RevokeUserAccessToClientMutationUsersUsers = {
	__typename?: 'AgencyUser',
	agencyPendingInviteHash?: string | null,
	agencyIsOwner: boolean,
	user: RevokeUserAccessToClientMutationUserUser 
}

export type RevokeUserAccessToClientMutationAgencyAccount = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	agencyAccountProfilePictureUrl?: string | null,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	userGroups?: Array<RevokeUserAccessToClientMutationUserGroups> | null,
	users?: Array<RevokeUserAccessToClientMutationUsersUsers> | null 
}

export type RevokeUserAccessToClientMutationFlatAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string 
}

export type RevokeUserAccessToClientMutationUsersUsersUsers = {
	__typename?: 'UserGroupUser',
	userGroupPendingInviteHash?: string | null,
	userGroupUserRole: UserGroupRole,
	user: RevokeUserAccessToClientMutationUser 
}

export type RevokeUserAccessToClientMutationUserGroupsUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<RevokeUserAccessToClientMutationUsersUsersUsers> | null 
}

export type RevokeUserAccessToClientMutationUserUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null 
}

export type RevokeUserAccessToClientMutationUsersUsersUsersUsers = {
	__typename?: 'ClientUser',
	clientPendingInviteHash?: string | null,
	user: RevokeUserAccessToClientMutationUserUserUser 
}

export type RevokeUserAccessToClientMutationUnlinkUsersFromClient = {
	__typename?: 'Client',
	clientPinned: boolean,
	clientKpi?: string | null,
	clientBreakdown?: string | null,
	clientStatus: ClientStatus,
	clientId: string,
	clientCreatedAt: any,
	id: string,
	name?: string | null,
	clientProfilePicture?: string | null,
	currency?: string | null,
	adAccount: RevokeUserAccessToClientMutationAdAccount, agencyAccount?: RevokeUserAccessToClientMutationAgencyAccount | null,
	flatAdAccount: RevokeUserAccessToClientMutationFlatAdAccount, userGroups?: Array<RevokeUserAccessToClientMutationUserGroupsUserGroups> | null,
	users?: Array<RevokeUserAccessToClientMutationUsersUsersUsersUsers> | null 
}

export type RevokeUserAccessToClientMutation = {
	__typename?: 'Mutation',
	unlinkUsersFromClient: RevokeUserAccessToClientMutationUnlinkUsersFromClient 
};

export type UpdateRedditClientMutationVariables = Exact<{

  clientId: Scalars['ID'];

  profilePicture?: InputMaybe<Scalars['ImageFile']>;

}>;

export type UpdateRedditClientMutationProfiles = {
	__typename?: 'Profile',
	profileId: string,
	profileName: string,
	id: string,
	value: string,
	label: string 
}

export type UpdateRedditClientMutationBusiness = {
	__typename?: 'Business',
	businessId: string,
	businessName: string,
	businessWebsiteUrl?: string | null,
	industryId?: string | null 
}

export type UpdateRedditClientMutationFundingInstruments = {
	__typename?: 'FundingInstrument',
	fundingInstrumentId: string,
	fundingInstrumentName: string 
}

export type UpdateRedditClientMutationAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string,
	adAccountName: string,
	profiles?: Array<UpdateRedditClientMutationProfiles> | null,
	business: UpdateRedditClientMutationBusiness, fundingInstruments?: Array<UpdateRedditClientMutationFundingInstruments> | null 
}

export type UpdateRedditClientMutationUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any 
}

export type UpdateRedditClientMutationUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: UpdateRedditClientMutationUser 
}

export type UpdateRedditClientMutationUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<UpdateRedditClientMutationUsers> | null 
}

export type UpdateRedditClientMutationUserUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any,
	userName?: string | null,
	userSurname?: string | null,
	userProfilePictureUrl?: string | null 
}

export type UpdateRedditClientMutationUsersUsers = {
	__typename?: 'AgencyUser',
	agencyPendingInviteHash?: string | null,
	agencyIsOwner: boolean,
	user: UpdateRedditClientMutationUserUser 
}

export type UpdateRedditClientMutationAgencyAccount = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	agencyAccountProfilePictureUrl?: string | null,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	userGroups?: Array<UpdateRedditClientMutationUserGroups> | null,
	users?: Array<UpdateRedditClientMutationUsersUsers> | null 
}

export type UpdateRedditClientMutationFlatAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string 
}

export type UpdateRedditClientMutationUsersUsersUsers = {
	__typename?: 'UserGroupUser',
	userGroupPendingInviteHash?: string | null,
	userGroupUserRole: UserGroupRole,
	user: UpdateRedditClientMutationUser 
}

export type UpdateRedditClientMutationUserGroupsUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<UpdateRedditClientMutationUsersUsersUsers> | null 
}

export type UpdateRedditClientMutationUserUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null 
}

export type UpdateRedditClientMutationUsersUsersUsersUsers = {
	__typename?: 'ClientUser',
	clientPendingInviteHash?: string | null,
	user: UpdateRedditClientMutationUserUserUser 
}

export type UpdateRedditClientMutationUpdateClient = {
	__typename?: 'Client',
	clientPinned: boolean,
	clientKpi?: string | null,
	clientBreakdown?: string | null,
	clientStatus: ClientStatus,
	clientId: string,
	clientCreatedAt: any,
	id: string,
	name?: string | null,
	clientProfilePicture?: string | null,
	currency?: string | null,
	adAccount: UpdateRedditClientMutationAdAccount, agencyAccount?: UpdateRedditClientMutationAgencyAccount | null,
	flatAdAccount: UpdateRedditClientMutationFlatAdAccount, userGroups?: Array<UpdateRedditClientMutationUserGroupsUserGroups> | null,
	users?: Array<UpdateRedditClientMutationUsersUsersUsersUsers> | null 
}

export type UpdateRedditClientMutation = {
	__typename?: 'Mutation',
	updateClient: UpdateRedditClientMutationUpdateClient 
};

export type CampaignAddEntityQueryVariables = Exact<{

  filters?: InputMaybe<CampaignFilter>;

}>;

export type CampaignAddEntityQueryProfiles = {
	__typename?: 'Profile',
	profileId: string,
	profileName: string,
	id: string,
	value: string,
	label: string 
}

export type CampaignAddEntityQueryBusiness = {
	__typename?: 'Business',
	businessId: string,
	businessName: string,
	businessWebsiteUrl?: string | null,
	industryId?: string | null 
}

export type CampaignAddEntityQueryFundingInstruments = {
	__typename?: 'FundingInstrument',
	fundingInstrumentId: string,
	fundingInstrumentName: string 
}

export type CampaignAddEntityQueryAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string,
	adAccountName: string,
	profiles?: Array<CampaignAddEntityQueryProfiles> | null,
	business: CampaignAddEntityQueryBusiness, fundingInstruments?: Array<CampaignAddEntityQueryFundingInstruments> | null 
}

export type CampaignAddEntityQueryUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any 
}

export type CampaignAddEntityQueryUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: CampaignAddEntityQueryUser 
}

export type CampaignAddEntityQueryUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<CampaignAddEntityQueryUsers> | null 
}

export type CampaignAddEntityQueryUserUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any,
	userName?: string | null,
	userSurname?: string | null,
	userProfilePictureUrl?: string | null 
}

export type CampaignAddEntityQueryUsersUsers = {
	__typename?: 'AgencyUser',
	agencyPendingInviteHash?: string | null,
	agencyIsOwner: boolean,
	user: CampaignAddEntityQueryUserUser 
}

export type CampaignAddEntityQueryAgencyAccount = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	agencyAccountProfilePictureUrl?: string | null,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	userGroups?: Array<CampaignAddEntityQueryUserGroups> | null,
	users?: Array<CampaignAddEntityQueryUsersUsers> | null 
}

export type CampaignAddEntityQueryFlatAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string 
}

export type CampaignAddEntityQueryUsersUsersUsers = {
	__typename?: 'UserGroupUser',
	userGroupPendingInviteHash?: string | null,
	userGroupUserRole: UserGroupRole,
	user: CampaignAddEntityQueryUser 
}

export type CampaignAddEntityQueryUserGroupsUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<CampaignAddEntityQueryUsersUsersUsers> | null 
}

export type CampaignAddEntityQueryUserUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null 
}

export type CampaignAddEntityQueryUsersUsersUsersUsers = {
	__typename?: 'ClientUser',
	clientPendingInviteHash?: string | null,
	user: CampaignAddEntityQueryUserUserUser 
}

export type CampaignAddEntityQueryParent = {
	__typename?: 'Client',
	clientPinned: boolean,
	clientKpi?: string | null,
	clientBreakdown?: string | null,
	clientStatus: ClientStatus,
	clientId: string,
	clientCreatedAt: any,
	id: string,
	name?: string | null,
	clientProfilePicture?: string | null,
	currency?: string | null,
	adAccount: CampaignAddEntityQueryAdAccount, agencyAccount?: CampaignAddEntityQueryAgencyAccount | null,
	flatAdAccount: CampaignAddEntityQueryFlatAdAccount, userGroups?: Array<CampaignAddEntityQueryUserGroupsUserGroups> | null,
	users?: Array<CampaignAddEntityQueryUsersUsersUsersUsers> | null 
}

export type CampaignAddEntityQueryFundingInstrument = {
	__typename?: 'FundingInstrument',
	fundingInstrumentId: string,
	fundingInstrumentName: string 
}

export type CampaignAddEntityQueryItems = {
	__typename?: 'Campaign',
	campaignId: string,
	campaignName: string,
	campaignCreatedAt: any,
	campaignUpdatedAt: any,
	campaignSpecialAdCategories?: Array<CampaignSpecialAdCategory | null> | null,
	campaignObjective: CampaignObjective,
	campaignStatus?: CampaignStatus | null,
	campaignSpendCap?: any | null,
	id: string,
	name: string,
	externalId?: string | null,
	hasErrors: boolean,
	currency?: string | null,
	updatedAt: any,
	modificationTime: any,
	status?: CampaignStatus | null,
	statusPending?: CampaignStatus | null,
	parent: CampaignAddEntityQueryParent, fundingInstrument?: CampaignAddEntityQueryFundingInstrument | null 
}

export type CampaignAddEntityQueryEntities = {
	__typename?: 'CampaignCursored',
	items?: Array<CampaignAddEntityQueryItems> | null 
}

export type CampaignAddEntityQuery = {
	__typename?: 'Query',
	entities: CampaignAddEntityQueryEntities 
};

export type ClientAddEntityQueryVariables = Exact<{

  filters?: InputMaybe<ClientFilter>;

}>;

export type ClientAddEntityQueryProfiles = {
	__typename?: 'Profile',
	profileId: string,
	profileName: string,
	id: string,
	value: string,
	label: string 
}

export type ClientAddEntityQueryBusiness = {
	__typename?: 'Business',
	businessId: string,
	businessName: string,
	businessWebsiteUrl?: string | null,
	industryId?: string | null 
}

export type ClientAddEntityQueryFundingInstruments = {
	__typename?: 'FundingInstrument',
	fundingInstrumentId: string,
	fundingInstrumentName: string 
}

export type ClientAddEntityQueryAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string,
	adAccountName: string,
	profiles?: Array<ClientAddEntityQueryProfiles> | null,
	business: ClientAddEntityQueryBusiness, fundingInstruments?: Array<ClientAddEntityQueryFundingInstruments> | null 
}

export type ClientAddEntityQueryUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any 
}

export type ClientAddEntityQueryUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: ClientAddEntityQueryUser 
}

export type ClientAddEntityQueryUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<ClientAddEntityQueryUsers> | null 
}

export type ClientAddEntityQueryUserUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any,
	userName?: string | null,
	userSurname?: string | null,
	userProfilePictureUrl?: string | null 
}

export type ClientAddEntityQueryUsersUsers = {
	__typename?: 'AgencyUser',
	agencyPendingInviteHash?: string | null,
	agencyIsOwner: boolean,
	user: ClientAddEntityQueryUserUser 
}

export type ClientAddEntityQueryAgencyAccount = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	agencyAccountProfilePictureUrl?: string | null,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	userGroups?: Array<ClientAddEntityQueryUserGroups> | null,
	users?: Array<ClientAddEntityQueryUsersUsers> | null 
}

export type ClientAddEntityQueryFlatAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string 
}

export type ClientAddEntityQueryUsersUsersUsers = {
	__typename?: 'UserGroupUser',
	userGroupPendingInviteHash?: string | null,
	userGroupUserRole: UserGroupRole,
	user: ClientAddEntityQueryUser 
}

export type ClientAddEntityQueryUserGroupsUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<ClientAddEntityQueryUsersUsersUsers> | null 
}

export type ClientAddEntityQueryUserUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null 
}

export type ClientAddEntityQueryUsersUsersUsersUsers = {
	__typename?: 'ClientUser',
	clientPendingInviteHash?: string | null,
	user: ClientAddEntityQueryUserUserUser 
}

export type ClientAddEntityQueryItems = {
	__typename?: 'Client',
	clientPinned: boolean,
	clientKpi?: string | null,
	clientBreakdown?: string | null,
	clientStatus: ClientStatus,
	clientId: string,
	clientCreatedAt: any,
	id: string,
	name?: string | null,
	clientProfilePicture?: string | null,
	currency?: string | null,
	adAccount: ClientAddEntityQueryAdAccount, agencyAccount?: ClientAddEntityQueryAgencyAccount | null,
	flatAdAccount: ClientAddEntityQueryFlatAdAccount, userGroups?: Array<ClientAddEntityQueryUserGroupsUserGroups> | null,
	users?: Array<ClientAddEntityQueryUsersUsersUsersUsers> | null 
}

export type ClientAddEntityQueryEntities = {
	__typename?: 'ClientCursored',
	items?: Array<ClientAddEntityQueryItems> | null 
}

export type ClientAddEntityQuery = {
	__typename?: 'Query',
	entities: ClientAddEntityQueryEntities 
};

export type GroupAddEntityQueryVariables = Exact<{

  filters?: InputMaybe<GroupFilter>;

}>;

export type GroupAddEntityQueryProfiles = {
	__typename?: 'Profile',
	profileId: string,
	profileName: string,
	id: string,
	value: string,
	label: string 
}

export type GroupAddEntityQueryBusiness = {
	__typename?: 'Business',
	businessId: string,
	businessName: string,
	businessWebsiteUrl?: string | null,
	industryId?: string | null 
}

export type GroupAddEntityQueryFundingInstruments = {
	__typename?: 'FundingInstrument',
	fundingInstrumentId: string,
	fundingInstrumentName: string 
}

export type GroupAddEntityQueryAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string,
	adAccountName: string,
	profiles?: Array<GroupAddEntityQueryProfiles> | null,
	business: GroupAddEntityQueryBusiness, fundingInstruments?: Array<GroupAddEntityQueryFundingInstruments> | null 
}

export type GroupAddEntityQueryUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any 
}

export type GroupAddEntityQueryUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: GroupAddEntityQueryUser 
}

export type GroupAddEntityQueryUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<GroupAddEntityQueryUsers> | null 
}

export type GroupAddEntityQueryUserUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any,
	userName?: string | null,
	userSurname?: string | null,
	userProfilePictureUrl?: string | null 
}

export type GroupAddEntityQueryUsersUsers = {
	__typename?: 'AgencyUser',
	agencyPendingInviteHash?: string | null,
	agencyIsOwner: boolean,
	user: GroupAddEntityQueryUserUser 
}

export type GroupAddEntityQueryAgencyAccount = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	agencyAccountProfilePictureUrl?: string | null,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	userGroups?: Array<GroupAddEntityQueryUserGroups> | null,
	users?: Array<GroupAddEntityQueryUsersUsers> | null 
}

export type GroupAddEntityQueryFlatAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string 
}

export type GroupAddEntityQueryUsersUsersUsers = {
	__typename?: 'UserGroupUser',
	userGroupPendingInviteHash?: string | null,
	userGroupUserRole: UserGroupRole,
	user: GroupAddEntityQueryUser 
}

export type GroupAddEntityQueryUserGroupsUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<GroupAddEntityQueryUsersUsersUsers> | null 
}

export type GroupAddEntityQueryUserUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null 
}

export type GroupAddEntityQueryUsersUsersUsersUsers = {
	__typename?: 'ClientUser',
	clientPendingInviteHash?: string | null,
	user: GroupAddEntityQueryUserUserUser 
}

export type GroupAddEntityQueryParent = {
	__typename?: 'Client',
	clientPinned: boolean,
	clientKpi?: string | null,
	clientBreakdown?: string | null,
	clientStatus: ClientStatus,
	clientId: string,
	clientCreatedAt: any,
	id: string,
	name?: string | null,
	clientProfilePicture?: string | null,
	currency?: string | null,
	adAccount: GroupAddEntityQueryAdAccount, agencyAccount?: GroupAddEntityQueryAgencyAccount | null,
	flatAdAccount: GroupAddEntityQueryFlatAdAccount, userGroups?: Array<GroupAddEntityQueryUserGroupsUserGroups> | null,
	users?: Array<GroupAddEntityQueryUsersUsersUsersUsers> | null 
}

export type GroupAddEntityQueryFundingInstrument = {
	__typename?: 'FundingInstrument',
	fundingInstrumentId: string,
	fundingInstrumentName: string 
}

export type GroupAddEntityQueryParentParent = {
	__typename?: 'Campaign',
	campaignId: string,
	campaignName: string,
	campaignCreatedAt: any,
	campaignUpdatedAt: any,
	campaignSpecialAdCategories?: Array<CampaignSpecialAdCategory | null> | null,
	campaignObjective: CampaignObjective,
	campaignStatus?: CampaignStatus | null,
	campaignSpendCap?: any | null,
	id: string,
	name: string,
	externalId?: string | null,
	hasErrors: boolean,
	currency?: string | null,
	updatedAt: any,
	modificationTime: any,
	status?: CampaignStatus | null,
	statusPending?: CampaignStatus | null,
	parent: GroupAddEntityQueryParent, fundingInstrument?: GroupAddEntityQueryFundingInstrument | null 
}

export type GroupAddEntityQueryGroupTargetingDevices = {
	__typename?: 'GroupTargetingDevices',
	groupTargetingDevicesLabelMap?: any | null,
	groupTargetingDevicesOS?: GroupTargetingDevicesOs | null,
	groupTargetingDevicesOSMaxVersion?: string | null,
	groupTargetingDevicesOSMinVersion?: string | null,
	groupTargetingDevicesType?: GroupTargetingDeviceType | null 
}

export type GroupAddEntityQueryGroupTargeting = {
	__typename?: 'GroupTargeting',
	groupTargetingKeywords?: Array<string | null> | null,
	groupTargetingExcludedKeywords?: Array<string | null> | null,
	placements?: Array<GroupTargetingLocations | null> | null,
	gender?: GroupTargetingGender | null,
	deviceType?: Array<GroupTargetingPlatforms | null> | null,
	communities?: Array<string | null> | null,
	communitiesExcluded?: Array<string | null> | null,
	locations?: Array<string | null> | null,
	locationsExcluded?: Array<string | null> | null,
	interests?: Array<string | null> | null,
	keywords?: Array<string | null> | null,
	customAudiences?: Array<string | null> | null,
	customAudiencesExcluded?: Array<string | null> | null,
	carriers?: Array<string | null> | null,
	groupTargetingDevices?: Array<GroupAddEntityQueryGroupTargetingDevices | null> | null 
}

export type GroupAddEntityQueryItems = {
	__typename?: 'Group',
	groupId: string,
	groupName: string,
	externalGroupId?: string | null,
	groupStatus?: GroupStatus | null,
	groupBidType: GroupBidType,
	groupBidStrategy: GroupBidStrategy,
	groupBidAmount?: number | null,
	groupGoal?: GroupGoal | null,
	groupGoalAmount?: number | null,
	groupOptimizationGoal?: GroupOptimizationGoal | null,
	groupStartTime?: any | null,
	groupEndTime?: any | null,
	groupCreatedAt: any,
	groupModificationTime?: any | null,
	groupAppId?: string | null,
	id: string,
	name: string,
	externalId?: string | null,
	hasErrors: boolean,
	status?: GroupStatus | null,
	statusPending?: GroupStatus | null,
	updatedAt?: any | null,
	modificationTime?: any | null,
	currency?: string | null,
	parent: GroupAddEntityQueryParentParent, groupTargeting?: GroupAddEntityQueryGroupTargeting | null 
}

export type GroupAddEntityQueryEntities = {
	__typename?: 'GroupCursored',
	items?: Array<GroupAddEntityQueryItems> | null 
}

export type GroupAddEntityQuery = {
	__typename?: 'Query',
	entities: GroupAddEntityQueryEntities 
};

export type CreateRedditAdsMutationVariables = Exact<{

  ads: Array<CreateAdInput> | CreateAdInput;

}>;

export type CreateRedditAdsMutationCreateAds = {
	__typename?: 'Ad',
	adId: string,
	adHash?: string | null,
	id: string 
}

export type CreateRedditAdsMutation = {
	__typename?: 'Mutation',
	createAds: Array<CreateRedditAdsMutationCreateAds> 
};

export type CreateRedditCampaignMutationVariables = Exact<{

  campaigns: Array<CreateCampaignInput> | CreateCampaignInput;

}>;

export type CreateRedditCampaignMutationCreateCampaigns = {
	__typename?: 'Campaign',
	campaignId: string,
	campaignHash?: string | null,
	id: string 
}

export type CreateRedditCampaignMutation = {
	__typename?: 'Mutation',
	createCampaigns: Array<CreateRedditCampaignMutationCreateCampaigns> 
};

export type CreateRedditCreativesMutationVariables = Exact<{

  creatives: Array<CreateCreativeInput> | CreateCreativeInput;

}>;

export type CreateRedditCreativesMutationCreateCreatives = {
	__typename?: 'Creative',
	creativeId: string,
	creativeHash?: string | null,
	id: string 
}

export type CreateRedditCreativesMutation = {
	__typename?: 'Mutation',
	createCreatives?: Array<CreateRedditCreativesMutationCreateCreatives | null> | null 
};

export type CreateRedditGroupsMutationVariables = Exact<{

  groups: Array<CreateGroupInput> | CreateGroupInput;

}>;

export type CreateRedditGroupsMutationCreateGroups = {
	__typename?: 'Group',
	groupId: string,
	groupHash?: string | null,
	id: string 
}

export type CreateRedditGroupsMutation = {
	__typename?: 'Mutation',
	createGroups?: Array<CreateRedditGroupsMutationCreateGroups> | null 
};

export type OpenAiHeadlinesQueryVariables = Exact<{

  count: Scalars['Int'];

  prompt: Scalars['String'];

}>;

export type OpenAiHeadlinesQuery = {
	__typename?: 'Query',
	openAiHeadlines?: Array<string | null> | null 
};

export type RedditCarrierTargetingLabelsQueryVariables = Exact<{

  carrierIds: Array<Scalars['ID']> | Scalars['ID'];

}>;

export type RedditCarrierTargetingLabelsQueryItems = {
	__typename?: 'TargetingCarrier',
	value: string,
	label: string 
}

export type RedditCarrierTargetingLabelsQueryTargetingCarriers = {
	__typename?: 'TargetingCarrierCursored',
	items?: Array<RedditCarrierTargetingLabelsQueryItems> | null 
}

export type RedditCarrierTargetingLabelsQuery = {
	__typename?: 'Query',
	targetingCarriers: RedditCarrierTargetingLabelsQueryTargetingCarriers 
};

export type CarrierOptionsQueryVariables = Exact<{

  search: Scalars['String'];

}>;

export type CarrierOptionsQueryItems = {
	__typename?: 'TargetingCarrier',
	country: string,
	value: string,
	label: string 
}

export type CarrierOptionsQueryOptions = {
	__typename?: 'TargetingCarrierCursored',
	items?: Array<CarrierOptionsQueryItems> | null 
}

export type CarrierOptionsQuery = {
	__typename?: 'Query',
	options: CarrierOptionsQueryOptions 
};

export type CommunityOptionsQueryVariables = Exact<{

  search: Scalars['String'];

  cursor?: InputMaybe<Scalars['String']>;

  exclude: Array<Scalars['String']> | Scalars['String'];

}>;

export type CommunityOptionsQueryItems = {
	__typename?: 'TargetingCommunity',
	subs: number,
	value: string,
	label: string 
}

export type CommunityOptionsQueryOptions = {
	__typename?: 'TargetingCommunityCursored',
	cursor?: string | null,
	items?: Array<CommunityOptionsQueryItems> | null 
}

export type CommunityOptionsQuery = {
	__typename?: 'Query',
	options: CommunityOptionsQueryOptions 
};

export type RedditCommunityLabelsQueryVariables = Exact<{

  communityIds: Array<Scalars['String']> | Scalars['String'];

}>;

export type RedditCommunityLabelsQueryItems = {
	__typename?: 'TargetingCommunity',
	subs: number,
	value: string,
	label: string 
}

export type RedditCommunityLabelsQueryTargetingCommunities = {
	__typename?: 'TargetingCommunityCursored',
	items?: Array<RedditCommunityLabelsQueryItems> | null 
}

export type RedditCommunityLabelsQuery = {
	__typename?: 'Query',
	targetingCommunities: RedditCommunityLabelsQueryTargetingCommunities 
};

export type RedditCustomAudienceLabelsQueryVariables = Exact<{

  externalAudienceId: Array<Scalars['ID']> | Scalars['ID'];

}>;

export type RedditCustomAudienceLabelsQueryItems = {
	__typename?: 'Audience',
	type: AudienceType,
	value: string,
	label?: string | null 
}

export type RedditCustomAudienceLabelsQueryAudiences = {
	__typename?: 'AudienceCursored',
	items?: Array<RedditCustomAudienceLabelsQueryItems> | null 
}

export type RedditCustomAudienceLabelsQuery = {
	__typename?: 'Query',
	audiences: RedditCustomAudienceLabelsQueryAudiences 
};

export type RedditCustomAudienceOptionsQueryVariables = Exact<{

  adAccountId: Array<Scalars['ID']> | Scalars['ID'];

  search: Scalars['String'];

}>;

export type RedditCustomAudienceOptionsQueryItems = {
	__typename?: 'Audience',
	type: AudienceType,
	value: string,
	label?: string | null 
}

export type RedditCustomAudienceOptionsQueryOptions = {
	__typename?: 'AudienceCursored',
	items?: Array<RedditCustomAudienceOptionsQueryItems> | null 
}

export type RedditCustomAudienceOptionsQuery = {
	__typename?: 'Query',
	options: RedditCustomAudienceOptionsQueryOptions 
};

export type RedditDeviceLabelsQueryVariables = Exact<{

  deviceIds: Array<Scalars['String']> | Scalars['String'];

}>;

export type RedditDeviceLabelsQueryItems = {
	__typename?: 'TargetingDevice',
	make: string,
	value: string,
	label: string 
}

export type RedditDeviceLabelsQueryTargetingDevices = {
	__typename?: 'TargetingDeviceCursored',
	items?: Array<RedditDeviceLabelsQueryItems> | null 
}

export type RedditDeviceLabelsQuery = {
	__typename?: 'Query',
	targetingDevices: RedditDeviceLabelsQueryTargetingDevices 
};

export type DeviceOptionsQueryVariables = Exact<{

  search: Scalars['String'];

}>;

export type DeviceOptionsQueryItems = {
	__typename?: 'TargetingDevice',
	make: string,
	label: string,
	value: string 
}

export type DeviceOptionsQueryOptions = {
	__typename?: 'TargetingDeviceCursored',
	cursor?: string | null,
	items?: Array<DeviceOptionsQueryItems> | null 
}

export type DeviceOptionsQuery = {
	__typename?: 'Query',
	options: DeviceOptionsQueryOptions 
};

export type RedditInterestTargetingLabelsQueryVariables = Exact<{

  interestIds: Array<Scalars['ID']> | Scalars['ID'];

}>;

export type RedditInterestTargetingLabelsQueryItems = {
	__typename?: 'TargetingInterest',
	label: string,
	value: string 
}

export type RedditInterestTargetingLabelsQueryTargetingInterests = {
	__typename?: 'TargetingInterestCursored',
	items?: Array<RedditInterestTargetingLabelsQueryItems> | null 
}

export type RedditInterestTargetingLabelsQuery = {
	__typename?: 'Query',
	targetingInterests: RedditInterestTargetingLabelsQueryTargetingInterests 
};

export type InterestOptionsQueryVariables = Exact<{

  search: Scalars['String'];

}>;

export type InterestOptionsQueryItems = {
	__typename?: 'TargetingInterest',
	category: string,
	value: string,
	label: string 
}

export type InterestOptionsQueryOptions = {
	__typename?: 'TargetingInterestCursored',
	items?: Array<InterestOptionsQueryItems> | null 
}

export type InterestOptionsQuery = {
	__typename?: 'Query',
	options: InterestOptionsQueryOptions 
};

export type RedditLocationTargetingLabelsQueryVariables = Exact<{

  locationIds: Array<Scalars['ID']> | Scalars['ID'];

  locationNames: Array<Scalars['String']> | Scalars['String'];

}>;

export type RedditLocationTargetingLabelsQueryItems = {
	__typename?: 'TargetingGeolocation',
	country: string,
	region?: string | null,
	dma?: number | null,
	postalCode?: string | null,
	label: string,
	value: string 
}

export type RedditLocationTargetingLabelsQueryTargetingGeolocations = {
	__typename?: 'TargetingGeolocationCursored',
	items?: Array<RedditLocationTargetingLabelsQueryItems> | null 
}

export type RedditLocationTargetingLabelsQueryTargetingGeolocationsByLabel = {
	__typename?: 'TargetingGeolocationCursored',
	items?: Array<RedditLocationTargetingLabelsQueryItems> | null 
}

export type RedditLocationTargetingLabelsQuery = {
	__typename?: 'Query',
	targetingGeolocations: RedditLocationTargetingLabelsQueryTargetingGeolocations, targetingGeolocationsByLabel: RedditLocationTargetingLabelsQueryTargetingGeolocationsByLabel 
};

export type LocationOptionsQueryVariables = Exact<{

  search: Scalars['String'];

}>;

export type LocationOptionsQueryItems = {
	__typename?: 'TargetingGeolocation',
	country: string,
	region?: string | null,
	dma?: number | null,
	postalCode?: string | null,
	value: string,
	label: string 
}

export type LocationOptionsQueryOptions = {
	__typename?: 'TargetingGeolocationCursored',
	cursor?: string | null,
	items?: Array<LocationOptionsQueryItems> | null 
}

export type LocationOptionsQuery = {
	__typename?: 'Query',
	options: LocationOptionsQueryOptions 
};

export type RedditTargetingLabelsByIdQueryVariables = Exact<{

  locationIds: Array<Scalars['ID']> | Scalars['ID'];

  communityIds: Array<Scalars['String']> | Scalars['String'];

  interestIds: Array<Scalars['ID']> | Scalars['ID'];

  carrierIds: Array<Scalars['ID']> | Scalars['ID'];

  audienceIds: Array<Scalars['ID']> | Scalars['ID'];

}>;

export type RedditTargetingLabelsByIdQueryItems = {
	__typename?: 'TargetingGeolocation',
	value: string,
	label: string 
}

export type RedditTargetingLabelsByIdQueryTargetingGeolocations = {
	__typename?: 'TargetingGeolocationCursored',
	items?: Array<RedditTargetingLabelsByIdQueryItems> | null 
}

export type RedditTargetingLabelsByIdQueryItemsItems = {
	__typename?: 'TargetingCommunity',
	value: string,
	label: string,
	subs: number 
}

export type RedditTargetingLabelsByIdQueryTargetingCommunities = {
	__typename?: 'TargetingCommunityCursored',
	items?: Array<RedditTargetingLabelsByIdQueryItemsItems> | null 
}

export type RedditTargetingLabelsByIdQueryItemsItemsItems = {
	__typename?: 'TargetingInterest',
	value: string,
	label: string 
}

export type RedditTargetingLabelsByIdQueryTargetingInterests = {
	__typename?: 'TargetingInterestCursored',
	items?: Array<RedditTargetingLabelsByIdQueryItemsItemsItems> | null 
}

export type RedditTargetingLabelsByIdQueryItemsItemsItemsItems = {
	__typename?: 'TargetingCarrier',
	value: string,
	label: string 
}

export type RedditTargetingLabelsByIdQueryTargetingCarriers = {
	__typename?: 'TargetingCarrierCursored',
	items?: Array<RedditTargetingLabelsByIdQueryItemsItemsItemsItems> | null 
}

export type RedditTargetingLabelsByIdQueryItemsItemsItemsItemsItems = {
	__typename?: 'Audience',
	type: AudienceType,
	value: string,
	label?: string | null 
}

export type RedditTargetingLabelsByIdQueryAudiences = {
	__typename?: 'AudienceCursored',
	items?: Array<RedditTargetingLabelsByIdQueryItemsItemsItemsItemsItems> | null 
}

export type RedditTargetingLabelsByIdQuery = {
	__typename?: 'Query',
	targetingGeolocations: RedditTargetingLabelsByIdQueryTargetingGeolocations, targetingCommunities: RedditTargetingLabelsByIdQueryTargetingCommunities, targetingInterests: RedditTargetingLabelsByIdQueryTargetingInterests, targetingCarriers: RedditTargetingLabelsByIdQueryTargetingCarriers, audiences: RedditTargetingLabelsByIdQueryAudiences 
};

export type AgencyAccountsQueryVariables = Exact<{

  search: Scalars['String'];

}>;

export type AgencyAccountsQueryItems = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	agencyAccountProfilePictureUrl?: string | null,
	id: string 
}

export type AgencyAccountsQueryAgencyAccounts = {
	__typename?: 'AgencyAccountCursored',
	items?: Array<AgencyAccountsQueryItems> | null 
}

export type AgencyAccountsQuery = {
	__typename?: 'Query',
	agencyAccounts: AgencyAccountsQueryAgencyAccounts 
};

export type CreateOAuthAdAccountsMutationVariables = Exact<{

  businessId: Scalars['ID'];

  adAccountIds: Array<Scalars['ID']> | Scalars['ID'];

  memberId: Scalars['ID'];

  agencyAccountId: Scalars['ID'];

}>;

export type CreateOAuthAdAccountsMutationCreateAdAccounts = {
	__typename?: 'AdAccount',
	id: string 
}

export type CreateOAuthAdAccountsMutation = {
	__typename?: 'Mutation',
	createAdAccounts: Array<CreateOAuthAdAccountsMutationCreateAdAccounts> 
};

export type OauthAdAccountsByBusinessQueryVariables = Exact<{

  memberId: Scalars['ID'];

}>;

export type OauthAdAccountsByBusinessQueryAdAccounts = {
	__typename?: 'AdAccountLive',
	adAccountId: string,
	adAccountName: string,
	adAccountExists: boolean 
}

export type OauthAdAccountsByBusinessQueryAdAccountsByBusinessLive = {
	__typename?: 'AdAccountsByBusiness',
	businessId: string,
	businessName: string,
	adAccounts: Array<OauthAdAccountsByBusinessQueryAdAccounts | null> 
}

export type OauthAdAccountsByBusinessQuery = {
	__typename?: 'Query',
	adAccountsByBusinessLive?: Array<OauthAdAccountsByBusinessQueryAdAccountsByBusinessLive | null> | null 
};

export type ClientSearchOptionsQueryVariables = Exact<{

  search: Scalars['String'];

}>;

export type ClientSearchOptionsQueryItems = {
	__typename?: 'Client',
	clientId: string,
	adAccountName?: string | null,
	value: string,
	label?: string | null 
}

export type ClientSearchOptionsQueryOptions = {
	__typename?: 'ClientCursored',
	items?: Array<ClientSearchOptionsQueryItems> | null 
}

export type ClientSearchOptionsQuery = {
	__typename?: 'Query',
	options: ClientSearchOptionsQueryOptions 
};

export type RedditClientOptionsByIdQueryVariables = Exact<{

  clientIds: Array<Scalars['ID']> | Scalars['ID'];

}>;

export type RedditClientOptionsByIdQueryItems = {
	__typename?: 'Client',
	clientId: string,
	adAccountName?: string | null,
	value: string,
	label?: string | null 
}

export type RedditClientOptionsByIdQueryClients = {
	__typename?: 'ClientCursored',
	items?: Array<RedditClientOptionsByIdQueryItems> | null 
}

export type RedditClientOptionsByIdQuery = {
	__typename?: 'Query',
	clients: RedditClientOptionsByIdQueryClients 
};

export type CreateUserMutationVariables = Exact<{

  credentials?: InputMaybe<Array<InputMaybe<UserCredentialInput>> | InputMaybe<UserCredentialInput>>;

  userAccountLevel: CreateUserAccountLevel;

  userCompanyName: Scalars['String'];

  userEmail: Scalars['Email'];

  userIsActivated?: Scalars['Boolean'];

  userName: Scalars['String'];

  userSurname: Scalars['String'];

}>;

export type CreateUserMutationCreateUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any 
}

export type CreateUserMutation = {
	__typename?: 'Mutation',
	createUser: CreateUserMutationCreateUser 
};

export type EditRedditUserAccessMutationVariables = Exact<{

  userId: Scalars['ID'];

}>;

export type EditRedditUserAccessMutationUpdateUser = {
	__typename?: 'User',
	userId: string 
}

export type EditRedditUserAccessMutation = {
	__typename?: 'Mutation',
	updateUser: EditRedditUserAccessMutationUpdateUser 
};

export type RedditUsersWithAccessQueryVariables = Exact<{

  email: Scalars['String'];

}>;

export type RedditUsersWithAccessQueryUserAccess = {
	__typename?: 'UserAccess',
	userAccessEntityId: string,
	userAccessAccessType: UserAccessEntityType 
}

export type RedditUsersWithAccessQueryItems = {
	__typename?: 'User',
	value: string,
	label: any,
	userAccess?: Array<RedditUsersWithAccessQueryUserAccess> | null 
}

export type RedditUsersWithAccessQueryUsers = {
	__typename?: 'UserCursored',
	items?: Array<RedditUsersWithAccessQueryItems> | null 
}

export type RedditUsersWithAccessQuery = {
	__typename?: 'Query',
	users: RedditUsersWithAccessQueryUsers 
};

export type UpdateEntitiesMutationVariables = Exact<{

  campaignChanges: Array<UpdateCampaignInput> | UpdateCampaignInput;

  groupChanges: Array<UpdateGroupInput> | UpdateGroupInput;

  adChanges: Array<UpdateAdInput> | UpdateAdInput;

  creativeChanges: Array<UpdateCreativeInput> | UpdateCreativeInput;

}>;

export type UpdateEntitiesMutationFundingInstrument = {
	__typename?: 'FundingInstrument',
	fundingInstrumentId: string,
	fundingInstrumentName: string 
}

export type UpdateEntitiesMutationCampaignUpdates = {
	__typename?: 'Campaign',
	campaignId: string,
	campaignName: string,
	campaignCreatedAt: any,
	campaignUpdatedAt: any,
	campaignSpecialAdCategories?: Array<CampaignSpecialAdCategory | null> | null,
	campaignObjective: CampaignObjective,
	campaignStatus?: CampaignStatus | null,
	campaignSpendCap?: any | null,
	id: string,
	name: string,
	externalId?: string | null,
	hasErrors: boolean,
	currency?: string | null,
	updatedAt: any,
	modificationTime: any,
	status?: CampaignStatus | null,
	statusPending?: CampaignStatus | null,
	fundingInstrument?: UpdateEntitiesMutationFundingInstrument | null 
}

export type UpdateEntitiesMutationGroupTargetingDevices = {
	__typename?: 'GroupTargetingDevices',
	groupTargetingDevicesLabelMap?: any | null,
	groupTargetingDevicesOS?: GroupTargetingDevicesOs | null,
	groupTargetingDevicesOSMaxVersion?: string | null,
	groupTargetingDevicesOSMinVersion?: string | null,
	groupTargetingDevicesType?: GroupTargetingDeviceType | null 
}

export type UpdateEntitiesMutationGroupTargeting = {
	__typename?: 'GroupTargeting',
	groupTargetingKeywords?: Array<string | null> | null,
	groupTargetingExcludedKeywords?: Array<string | null> | null,
	placements?: Array<GroupTargetingLocations | null> | null,
	gender?: GroupTargetingGender | null,
	deviceType?: Array<GroupTargetingPlatforms | null> | null,
	communities?: Array<string | null> | null,
	communitiesExcluded?: Array<string | null> | null,
	locations?: Array<string | null> | null,
	locationsExcluded?: Array<string | null> | null,
	interests?: Array<string | null> | null,
	keywords?: Array<string | null> | null,
	customAudiences?: Array<string | null> | null,
	customAudiencesExcluded?: Array<string | null> | null,
	carriers?: Array<string | null> | null,
	groupTargetingDevices?: Array<UpdateEntitiesMutationGroupTargetingDevices | null> | null 
}

export type UpdateEntitiesMutationGroupUpdates = {
	__typename?: 'Group',
	groupId: string,
	groupName: string,
	externalGroupId?: string | null,
	groupStatus?: GroupStatus | null,
	groupBidType: GroupBidType,
	groupBidStrategy: GroupBidStrategy,
	groupBidAmount?: number | null,
	groupGoal?: GroupGoal | null,
	groupGoalAmount?: number | null,
	groupOptimizationGoal?: GroupOptimizationGoal | null,
	groupStartTime?: any | null,
	groupEndTime?: any | null,
	groupCreatedAt: any,
	groupModificationTime?: any | null,
	groupAppId?: string | null,
	id: string,
	name: string,
	externalId?: string | null,
	hasErrors: boolean,
	status?: GroupStatus | null,
	statusPending?: GroupStatus | null,
	updatedAt?: any | null,
	modificationTime?: any | null,
	currency?: string | null,
	groupTargeting?: UpdateEntitiesMutationGroupTargeting | null 
}

export type UpdateEntitiesMutationAdEventTrackers = {
	__typename?: 'EventTracker',
	url?: string | null,
	type?: EventTrackerType | null 
}

export type UpdateEntitiesMutationProfiles = {
	__typename?: 'Profile',
	profileId: string,
	profileName: string,
	id: string,
	value: string,
	label: string 
}

export type UpdateEntitiesMutationBusiness = {
	__typename?: 'Business',
	businessId: string,
	businessName: string,
	businessWebsiteUrl?: string | null,
	industryId?: string | null 
}

export type UpdateEntitiesMutationFundingInstruments = {
	__typename?: 'FundingInstrument',
	fundingInstrumentId: string,
	fundingInstrumentName: string 
}

export type UpdateEntitiesMutationAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string,
	adAccountName: string,
	profiles?: Array<UpdateEntitiesMutationProfiles> | null,
	business: UpdateEntitiesMutationBusiness, fundingInstruments?: Array<UpdateEntitiesMutationFundingInstruments> | null 
}

export type UpdateEntitiesMutationUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any 
}

export type UpdateEntitiesMutationUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: UpdateEntitiesMutationUser 
}

export type UpdateEntitiesMutationUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<UpdateEntitiesMutationUsers> | null 
}

export type UpdateEntitiesMutationUserUser = {
	__typename?: 'User',
	userId: string,
	userEmail: any,
	userName?: string | null,
	userSurname?: string | null,
	userProfilePictureUrl?: string | null 
}

export type UpdateEntitiesMutationUsersUsers = {
	__typename?: 'AgencyUser',
	agencyPendingInviteHash?: string | null,
	agencyIsOwner: boolean,
	user: UpdateEntitiesMutationUserUser 
}

export type UpdateEntitiesMutationAgencyAccount = {
	__typename?: 'AgencyAccount',
	agencyAccountId: string,
	agencyAccountName: string,
	agencyAccountProfilePictureUrl?: string | null,
	salesforceId?: string | null,
	agencyAccountActivatedAt?: any | null,
	userGroups?: Array<UpdateEntitiesMutationUserGroups> | null,
	users?: Array<UpdateEntitiesMutationUsersUsers> | null 
}

export type UpdateEntitiesMutationFlatAdAccount = {
	__typename?: 'AdAccount',
	adAccountId: string 
}

export type UpdateEntitiesMutationUsersUsersUsers = {
	__typename?: 'UserGroupUser',
	userGroupPendingInviteHash?: string | null,
	userGroupUserRole: UserGroupRole,
	user: UpdateEntitiesMutationUser 
}

export type UpdateEntitiesMutationUserGroupsUserGroups = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	users?: Array<UpdateEntitiesMutationUsersUsersUsers> | null 
}

export type UpdateEntitiesMutationUserUserUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userFullName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userProfilePictureUrl?: string | null 
}

export type UpdateEntitiesMutationUsersUsersUsersUsers = {
	__typename?: 'ClientUser',
	clientPendingInviteHash?: string | null,
	user: UpdateEntitiesMutationUserUserUser 
}

export type UpdateEntitiesMutationParent = {
	__typename?: 'Client',
	clientPinned: boolean,
	clientKpi?: string | null,
	clientBreakdown?: string | null,
	clientStatus: ClientStatus,
	clientId: string,
	clientCreatedAt: any,
	id: string,
	name?: string | null,
	clientProfilePicture?: string | null,
	currency?: string | null,
	adAccount: UpdateEntitiesMutationAdAccount, agencyAccount?: UpdateEntitiesMutationAgencyAccount | null,
	flatAdAccount: UpdateEntitiesMutationFlatAdAccount, userGroups?: Array<UpdateEntitiesMutationUserGroupsUserGroups> | null,
	users?: Array<UpdateEntitiesMutationUsersUsersUsersUsers> | null 
}

export type UpdateEntitiesMutationParentParent = {
	__typename?: 'Campaign',
	campaignId: string,
	campaignName: string,
	campaignCreatedAt: any,
	campaignUpdatedAt: any,
	campaignSpecialAdCategories?: Array<CampaignSpecialAdCategory | null> | null,
	campaignObjective: CampaignObjective,
	campaignStatus?: CampaignStatus | null,
	campaignSpendCap?: any | null,
	id: string,
	name: string,
	externalId?: string | null,
	hasErrors: boolean,
	currency?: string | null,
	updatedAt: any,
	modificationTime: any,
	status?: CampaignStatus | null,
	statusPending?: CampaignStatus | null,
	parent: UpdateEntitiesMutationParent, fundingInstrument?: UpdateEntitiesMutationFundingInstrument | null 
}

export type UpdateEntitiesMutationParentParentParent = {
	__typename?: 'Group',
	groupId: string,
	groupName: string,
	externalGroupId?: string | null,
	groupStatus?: GroupStatus | null,
	groupBidType: GroupBidType,
	groupBidStrategy: GroupBidStrategy,
	groupBidAmount?: number | null,
	groupGoal?: GroupGoal | null,
	groupGoalAmount?: number | null,
	groupOptimizationGoal?: GroupOptimizationGoal | null,
	groupStartTime?: any | null,
	groupEndTime?: any | null,
	groupCreatedAt: any,
	groupModificationTime?: any | null,
	groupAppId?: string | null,
	id: string,
	name: string,
	externalId?: string | null,
	hasErrors: boolean,
	status?: GroupStatus | null,
	statusPending?: GroupStatus | null,
	updatedAt?: any | null,
	modificationTime?: any | null,
	currency?: string | null,
	parent: UpdateEntitiesMutationParentParent, groupTargeting?: UpdateEntitiesMutationGroupTargeting | null 
}

export type UpdateEntitiesMutationProfile = {
	__typename?: 'Profile',
	profileName: string,
	id: string,
	value: string,
	label: string 
}

export type UpdateEntitiesMutationFlatText = {
	__typename?: 'Text',
	creativeText?: string | null 
}

export type UpdateEntitiesMutationFlatCreativeContent = {
	__typename?: 'CreativeContent',
	creativeContentId: string,
	creativeContentCallToAction?: CreativeContentCallToAction | null,
	creativeContentDestinationUrl?: string | null,
	creativeContentDisplayUrl?: string | null,
	creativeContentMediaUrl?: string | null,
	creativeContentCaption?: string | null 
}

export type UpdateEntitiesMutationFlatCreative = {
	__typename?: 'Creative',
	creativeId: string,
	creativePostUrl?: string | null,
	creativeHeadline: string,
	creativeThumbnailUrl?: string | null,
	creativeAllowComments: boolean,
	creativeType: CreativeType,
	externalCreativeId?: string | null,
	creativeHasErrors: boolean,
	profile: UpdateEntitiesMutationProfile, flatText?: UpdateEntitiesMutationFlatText | null,
	flatCreativeContent?: Array<UpdateEntitiesMutationFlatCreativeContent> | null 
}

export type UpdateEntitiesMutationFlatAdAccountFlatAdAccount = {
	__typename?: 'AdAccount',
	currency: string 
}

export type UpdateEntitiesMutationFlatClient = {
	__typename?: 'Client',
	flatAdAccount: UpdateEntitiesMutationFlatAdAccountFlatAdAccount 
}

export type UpdateEntitiesMutationAdUpdates = {
	__typename?: 'Ad',
	adId: string,
	adName?: string | null,
	adCreatedAt: any,
	adModificationTime?: any | null,
	id: string,
	name?: string | null,
	externalId?: string | null,
	hasErrors: boolean,
	modificationTime?: any | null,
	updatedAt?: any | null,
	status?: AdStatus | null,
	statusPending?: AdStatus | null,
	currency?: string | null,
	adEventTrackers?: Array<UpdateEntitiesMutationAdEventTrackers | null> | null,
	parent: UpdateEntitiesMutationParentParentParent, flatCreative?: UpdateEntitiesMutationFlatCreative | null,
	flatClient: UpdateEntitiesMutationFlatClient 
}

export type UpdateEntitiesMutationCreativeUpdates = {
	__typename?: 'Creative',
	creativeId: string,
	creativePostUrl?: string | null,
	creativeHeadline: string,
	creativeThumbnailUrl?: string | null,
	creativeAllowComments: boolean,
	creativeType: CreativeType,
	creativeHash?: string | null,
	externalCreativeId?: string | null,
	creativeHasErrors: boolean,
	profile: UpdateEntitiesMutationProfile, flatText?: UpdateEntitiesMutationFlatText | null,
	flatCreativeContent?: Array<UpdateEntitiesMutationFlatCreativeContent> | null 
}

export type UpdateEntitiesMutation = {
	__typename?: 'Mutation',
	campaignUpdates: Array<UpdateEntitiesMutationCampaignUpdates>,
	groupUpdates?: Array<UpdateEntitiesMutationGroupUpdates> | null,
	adUpdates: Array<UpdateEntitiesMutationAdUpdates>,
	creativeUpdates?: Array<UpdateEntitiesMutationCreativeUpdates | null> | null 
};

export type CancelUserInvitationMutationVariables = Exact<{

  pendingInviteHash: Scalars['String'];

}>;

export type CancelUserInvitationMutation = {
	__typename?: 'Mutation',
	resolvePendingInvite: boolean 
};

export type CreateUserGroupMutationVariables = Exact<{

  userGroupName: Scalars['String'];

  userGroupProfilePicture?: InputMaybe<Scalars['ImageFile']>;

  salesforceId?: InputMaybe<Scalars['String']>;

  userIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;

}>;

export type CreateUserGroupMutationUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userFullName?: string | null,
	userProfilePictureUrl?: string | null,
	userAccountLevel: UserAccountLevel,
	userTwoFactorAuthenticationEnabled: boolean,
	id: string,
	profilePictureUrl?: string | null 
}

export type CreateUserGroupMutationUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	userGroupPendingInviteHash?: string | null,
	user: CreateUserGroupMutationUser 
}

export type CreateUserGroupMutationClients = {
	__typename?: 'Client',
	id: string,
	name?: string | null,
	secondaryName?: string | null 
}

export type CreateUserGroupMutationAgencyAccounts = {
	__typename?: 'AgencyAccount',
	id: string,
	name: string,
	clients?: Array<CreateUserGroupMutationClients> | null 
}

export type CreateUserGroupMutationCreateUserGroup = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupType: UserGroupType,
	salesforceId?: string | null,
	id: string,
	userGroupProfilePicture?: string | null,
	users?: Array<CreateUserGroupMutationUsers> | null,
	clients?: Array<CreateUserGroupMutationClients> | null,
	agencyAccounts?: Array<CreateUserGroupMutationAgencyAccounts> | null 
}

export type CreateUserGroupMutation = {
	__typename?: 'Mutation',
	createUserGroup: CreateUserGroupMutationCreateUserGroup 
};

export type DeleteUserGroupMutationVariables = Exact<{

  userGroupId: Scalars['ID'];

}>;

export type DeleteUserGroupMutation = {
	__typename?: 'Mutation',
	deleteUserGroup: boolean 
};

export type RedditUserGroupFragmentFragment = { __typename?: 'UserGroup', userGroupId: string, userGroupName: string, userGroupType: UserGroupType, salesforceId?: string | null, id: string, userGroupProfilePicture?: string | null, users?: Array<{ __typename?: 'UserGroupUser', userGroupUserRole: UserGroupRole, userGroupPendingInviteHash?: string | null, user: { __typename?: 'User', userId: string, userName?: string | null, userSurname?: string | null, userEmail: any, userFullName?: string | null, userProfilePictureUrl?: string | null, userAccountLevel: UserAccountLevel, userTwoFactorAuthenticationEnabled: boolean, id: string, profilePictureUrl?: string | null } }> | null, clients?: Array<{ __typename?: 'Client', id: string, name?: string | null, secondaryName?: string | null }> | null, agencyAccounts?: Array<{ __typename?: 'AgencyAccount', id: string, name: string, clients?: Array<{ __typename?: 'Client', id: string, name?: string | null, secondaryName?: string | null }> | null }> | null };

export type RedditUserGroupsListQueryVariables = Exact<{

  search: Scalars['String'];

  cursor?: InputMaybe<Scalars['String']>;

}>;

export type RedditUserGroupsListQueryUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userFullName?: string | null,
	userProfilePictureUrl?: string | null,
	userAccountLevel: UserAccountLevel,
	userTwoFactorAuthenticationEnabled: boolean,
	id: string,
	profilePictureUrl?: string | null 
}

export type RedditUserGroupsListQueryUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	userGroupPendingInviteHash?: string | null,
	user: RedditUserGroupsListQueryUser 
}

export type RedditUserGroupsListQueryClients = {
	__typename?: 'Client',
	id: string,
	name?: string | null,
	secondaryName?: string | null 
}

export type RedditUserGroupsListQueryAgencyAccounts = {
	__typename?: 'AgencyAccount',
	id: string,
	name: string,
	clients?: Array<RedditUserGroupsListQueryClients> | null 
}

export type RedditUserGroupsListQueryItems = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupType: UserGroupType,
	salesforceId?: string | null,
	id: string,
	userGroupProfilePicture?: string | null,
	users?: Array<RedditUserGroupsListQueryUsers> | null,
	clients?: Array<RedditUserGroupsListQueryClients> | null,
	agencyAccounts?: Array<RedditUserGroupsListQueryAgencyAccounts> | null 
}

export type RedditUserGroupsListQueryUserGroups = {
	__typename?: 'UserGroupCursored',
	cursor?: string | null,
	items?: Array<RedditUserGroupsListQueryItems> | null 
}

export type RedditUserGroupsListQuery = {
	__typename?: 'Query',
	userGroups: RedditUserGroupsListQueryUserGroups 
};

export type InviteUserToGroupMutationVariables = Exact<{

  userId: Scalars['ID'];

  userGroupId: Scalars['ID'];

}>;

export type InviteUserToGroupMutationUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userFullName?: string | null,
	userProfilePictureUrl?: string | null,
	userAccountLevel: UserAccountLevel,
	userTwoFactorAuthenticationEnabled: boolean,
	id: string,
	profilePictureUrl?: string | null 
}

export type InviteUserToGroupMutationUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	userGroupPendingInviteHash?: string | null,
	user: InviteUserToGroupMutationUser 
}

export type InviteUserToGroupMutationClients = {
	__typename?: 'Client',
	id: string,
	name?: string | null,
	secondaryName?: string | null 
}

export type InviteUserToGroupMutationAgencyAccounts = {
	__typename?: 'AgencyAccount',
	id: string,
	name: string,
	clients?: Array<InviteUserToGroupMutationClients> | null 
}

export type InviteUserToGroupMutationLinkUsersToUserGroup = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupType: UserGroupType,
	salesforceId?: string | null,
	id: string,
	userGroupProfilePicture?: string | null,
	users?: Array<InviteUserToGroupMutationUsers> | null,
	clients?: Array<InviteUserToGroupMutationClients> | null,
	agencyAccounts?: Array<InviteUserToGroupMutationAgencyAccounts> | null 
}

export type InviteUserToGroupMutation = {
	__typename?: 'Mutation',
	linkUsersToUserGroup: InviteUserToGroupMutationLinkUsersToUserGroup 
};

export type RevokeUserFromGroupMutationVariables = Exact<{

  userId: Scalars['ID'];

  userGroupId: Scalars['ID'];

}>;

export type RevokeUserFromGroupMutationUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userFullName?: string | null,
	userProfilePictureUrl?: string | null,
	userAccountLevel: UserAccountLevel,
	userTwoFactorAuthenticationEnabled: boolean,
	id: string,
	profilePictureUrl?: string | null 
}

export type RevokeUserFromGroupMutationUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	userGroupPendingInviteHash?: string | null,
	user: RevokeUserFromGroupMutationUser 
}

export type RevokeUserFromGroupMutationClients = {
	__typename?: 'Client',
	id: string,
	name?: string | null,
	secondaryName?: string | null 
}

export type RevokeUserFromGroupMutationAgencyAccounts = {
	__typename?: 'AgencyAccount',
	id: string,
	name: string,
	clients?: Array<RevokeUserFromGroupMutationClients> | null 
}

export type RevokeUserFromGroupMutationUnlinkUsersFromUserGroup = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupType: UserGroupType,
	salesforceId?: string | null,
	id: string,
	userGroupProfilePicture?: string | null,
	users?: Array<RevokeUserFromGroupMutationUsers> | null,
	clients?: Array<RevokeUserFromGroupMutationClients> | null,
	agencyAccounts?: Array<RevokeUserFromGroupMutationAgencyAccounts> | null 
}

export type RevokeUserFromGroupMutation = {
	__typename?: 'Mutation',
	unlinkUsersFromUserGroup: RevokeUserFromGroupMutationUnlinkUsersFromUserGroup 
};

export type TransferTeamOwnershipMutationVariables = Exact<{

  userGroupId: Scalars['ID'];

  userId: Scalars['ID'];

}>;

export type TransferTeamOwnershipMutationUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userFullName?: string | null,
	userProfilePictureUrl?: string | null,
	userAccountLevel: UserAccountLevel,
	userTwoFactorAuthenticationEnabled: boolean,
	id: string,
	profilePictureUrl?: string | null 
}

export type TransferTeamOwnershipMutationUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	userGroupPendingInviteHash?: string | null,
	user: TransferTeamOwnershipMutationUser 
}

export type TransferTeamOwnershipMutationClients = {
	__typename?: 'Client',
	id: string,
	name?: string | null,
	secondaryName?: string | null 
}

export type TransferTeamOwnershipMutationAgencyAccounts = {
	__typename?: 'AgencyAccount',
	id: string,
	name: string,
	clients?: Array<TransferTeamOwnershipMutationClients> | null 
}

export type TransferTeamOwnershipMutationTransferUserGroupOwnership = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupType: UserGroupType,
	salesforceId?: string | null,
	id: string,
	userGroupProfilePicture?: string | null,
	users?: Array<TransferTeamOwnershipMutationUsers> | null,
	clients?: Array<TransferTeamOwnershipMutationClients> | null,
	agencyAccounts?: Array<TransferTeamOwnershipMutationAgencyAccounts> | null 
}

export type TransferTeamOwnershipMutation = {
	__typename?: 'Mutation',
	transferUserGroupOwnership: TransferTeamOwnershipMutationTransferUserGroupOwnership 
};

export type UpdateUserGroupMutationVariables = Exact<{

  userGroupId: Scalars['ID'];

  userGroupName: Scalars['String'];

  userGroupProfilePicture?: InputMaybe<Scalars['ImageFile']>;

  salesforceId?: InputMaybe<Scalars['String']>;

}>;

export type UpdateUserGroupMutationUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userFullName?: string | null,
	userProfilePictureUrl?: string | null,
	userAccountLevel: UserAccountLevel,
	userTwoFactorAuthenticationEnabled: boolean,
	id: string,
	profilePictureUrl?: string | null 
}

export type UpdateUserGroupMutationUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	userGroupPendingInviteHash?: string | null,
	user: UpdateUserGroupMutationUser 
}

export type UpdateUserGroupMutationClients = {
	__typename?: 'Client',
	id: string,
	name?: string | null,
	secondaryName?: string | null 
}

export type UpdateUserGroupMutationAgencyAccounts = {
	__typename?: 'AgencyAccount',
	id: string,
	name: string,
	clients?: Array<UpdateUserGroupMutationClients> | null 
}

export type UpdateUserGroupMutationUpdateUserGroup = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupType: UserGroupType,
	salesforceId?: string | null,
	id: string,
	userGroupProfilePicture?: string | null,
	users?: Array<UpdateUserGroupMutationUsers> | null,
	clients?: Array<UpdateUserGroupMutationClients> | null,
	agencyAccounts?: Array<UpdateUserGroupMutationAgencyAccounts> | null 
}

export type UpdateUserGroupMutation = {
	__typename?: 'Mutation',
	updateUserGroup: UpdateUserGroupMutationUpdateUserGroup 
};

export type UpdateUserGroupUserRoleMutationVariables = Exact<{

  userGroupId: Scalars['ID'];

  userId: Scalars['ID'];

  userRole: UserGroupRoleInput;

}>;

export type UpdateUserGroupUserRoleMutationUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userFullName?: string | null,
	userProfilePictureUrl?: string | null,
	userAccountLevel: UserAccountLevel,
	userTwoFactorAuthenticationEnabled: boolean,
	id: string,
	profilePictureUrl?: string | null 
}

export type UpdateUserGroupUserRoleMutationUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	userGroupPendingInviteHash?: string | null,
	user: UpdateUserGroupUserRoleMutationUser 
}

export type UpdateUserGroupUserRoleMutationClients = {
	__typename?: 'Client',
	id: string,
	name?: string | null,
	secondaryName?: string | null 
}

export type UpdateUserGroupUserRoleMutationAgencyAccounts = {
	__typename?: 'AgencyAccount',
	id: string,
	name: string,
	clients?: Array<UpdateUserGroupUserRoleMutationClients> | null 
}

export type UpdateUserGroupUserRoleMutationUpdateUserGroupUserRole = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupType: UserGroupType,
	salesforceId?: string | null,
	id: string,
	userGroupProfilePicture?: string | null,
	users?: Array<UpdateUserGroupUserRoleMutationUsers> | null,
	clients?: Array<UpdateUserGroupUserRoleMutationClients> | null,
	agencyAccounts?: Array<UpdateUserGroupUserRoleMutationAgencyAccounts> | null 
}

export type UpdateUserGroupUserRoleMutation = {
	__typename?: 'Mutation',
	updateUserGroupUserRole: UpdateUserGroupUserRoleMutationUpdateUserGroupUserRole 
};

export type RedditUserForGroupQueryVariables = Exact<{

  ownerEmail: Scalars['String'];

}>;

export type RedditUserForGroupQueryUsers = {
	__typename?: 'SearchUser',
	userId: string,
	userEmail: any,
	userFullName?: string | null,
	userProfilePictureUrl?: string | null,
	userAccountLevel: UserAccountLevel,
	id: string,
	profilePictureUrl?: string | null 
}

export type RedditUserForGroupQuery = {
	__typename?: 'Query',
	users: Array<RedditUserForGroupQueryUsers> 
};

export type RedditUserForGroupAutocompleteQueryVariables = Exact<{

  ownerEmail: Scalars['String'];

}>;

export type RedditUserForGroupAutocompleteQueryUsers = {
	__typename?: 'SearchUser',
	userId: string,
	userEmail: any,
	userFullName?: string | null,
	userProfilePictureUrl?: string | null,
	userAccountLevel: UserAccountLevel,
	id: string,
	profilePictureUrl?: string | null,
	value: string,
	label?: string | null 
}

export type RedditUserForGroupAutocompleteQuery = {
	__typename?: 'Query',
	users: Array<RedditUserForGroupAutocompleteQueryUsers> 
};

export type CreateRedditUserMutationVariables = Exact<{

  userName: Scalars['String'];

  userSurname: Scalars['String'];

  userEmail: Scalars['Email'];

  userAccountLevel: CreateUserAccountLevel;

  userProfilePicture?: InputMaybe<Scalars['ImageFile']>;

  credentials?: InputMaybe<Array<InputMaybe<UserCredentialInput>> | InputMaybe<UserCredentialInput>>;

}>;

export type CreateRedditUserMutationUserAccess = {
	__typename?: 'UserAccess',
	userAccessEntityId: string,
	userAccessAccessType: UserAccessEntityType,
	userAccessEntityName: string,
	type: UserAccessEntityType,
	name: string 
}

export type CreateRedditUserMutationUser = {
	__typename?: 'User',
	userId: string,
	id: string 
}

export type CreateRedditUserMutationUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: CreateRedditUserMutationUser 
}

export type CreateRedditUserMutationUserGroups = {
	__typename?: 'UserGroup',
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	id: string,
	value: string,
	label: string,
	profilePictureUrl?: string | null,
	users?: Array<CreateRedditUserMutationUsers> | null 
}

export type CreateRedditUserMutationPendingInvites = {
	__typename?: 'PendingInvite',
	pendingInviteHash: string,
	pendingInviteEntityId: string,
	pendingInviteEntityType: PendingInviteEntityType 
}

export type CreateRedditUserMutationCreateUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userAccountLevel: UserAccountLevel,
	userCompanyName?: string | null,
	id: string,
	userProfilePicture?: string | null,
	userAccess?: Array<CreateRedditUserMutationUserAccess> | null,
	userGroups?: Array<CreateRedditUserMutationUserGroups> | null,
	pendingInvites?: Array<CreateRedditUserMutationPendingInvites> | null 
}

export type CreateRedditUserMutation = {
	__typename?: 'Mutation',
	createUser: CreateRedditUserMutationCreateUser 
};

export type DeleteUserMutationVariables = Exact<{

  userId: Scalars['ID'];

}>;

export type DeleteUserMutation = {
	__typename?: 'Mutation',
	deleteUser: boolean 
};

export type RedditUserFragmentFragment = { __typename?: 'User', userId: string, userName?: string | null, userSurname?: string | null, userEmail: any, userAccountLevel: UserAccountLevel, userCompanyName?: string | null, id: string, userProfilePicture?: string | null, userAccess?: Array<{ __typename?: 'UserAccess', userAccessEntityId: string, userAccessAccessType: UserAccessEntityType, userAccessEntityName: string, type: UserAccessEntityType, name: string }> | null, userGroups?: Array<{ __typename?: 'UserGroup', userGroupName: string, userGroupProfilePictureUrl?: string | null, id: string, value: string, label: string, profilePictureUrl?: string | null, users?: Array<{ __typename?: 'UserGroupUser', userGroupUserRole: UserGroupRole, user: { __typename?: 'User', userId: string, id: string } }> | null }> | null, pendingInvites?: Array<{ __typename?: 'PendingInvite', pendingInviteHash: string, pendingInviteEntityId: string, pendingInviteEntityType: PendingInviteEntityType }> | null };

export type RedditGroupsForUsersQueryVariables = Exact<{

  search: Scalars['String'];

  selectedIds: Array<Scalars['ID']> | Scalars['ID'];

  emailSearch: Scalars['String'];

  userId?: InputMaybe<Array<IdFilter> | IdFilter>;

  userGroupUserRole?: InputMaybe<Array<UserGroupRoleFilter> | UserGroupRoleFilter>;

}>;

export type RedditGroupsForUsersQueryUser = {
	__typename?: 'User',
	userId: string,
	id: string 
}

export type RedditGroupsForUsersQueryUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: RedditGroupsForUsersQueryUser 
}

export type RedditGroupsForUsersQueryItems = {
	__typename?: 'UserGroup',
	userGroupProfilePictureUrl?: string | null,
	id: string,
	value: string,
	label: string,
	users?: Array<RedditGroupsForUsersQueryUsers> | null 
}

export type RedditGroupsForUsersQueryUserGroups = {
	__typename?: 'UserGroupCursored',
	items?: Array<RedditGroupsForUsersQueryItems> | null 
}

export type RedditGroupsForUsersQuery = {
	__typename?: 'Query',
	userGroups: RedditGroupsForUsersQueryUserGroups 
};

export type InviteUserToGroupsMutationVariables = Exact<{

  userId: Scalars['ID'];

  userGroupIds: Array<Scalars['ID']> | Scalars['ID'];

}>;

export type InviteUserToGroupsMutationUserAccess = {
	__typename?: 'UserAccess',
	userAccessEntityId: string,
	userAccessAccessType: UserAccessEntityType,
	userAccessEntityName: string,
	type: UserAccessEntityType,
	name: string 
}

export type InviteUserToGroupsMutationUser = {
	__typename?: 'User',
	userId: string,
	id: string 
}

export type InviteUserToGroupsMutationUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: InviteUserToGroupsMutationUser 
}

export type InviteUserToGroupsMutationUserGroups = {
	__typename?: 'UserGroup',
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	id: string,
	value: string,
	label: string,
	profilePictureUrl?: string | null,
	users?: Array<InviteUserToGroupsMutationUsers> | null 
}

export type InviteUserToGroupsMutationPendingInvites = {
	__typename?: 'PendingInvite',
	pendingInviteHash: string,
	pendingInviteEntityId: string,
	pendingInviteEntityType: PendingInviteEntityType 
}

export type InviteUserToGroupsMutationLinkUserGroupsToUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userAccountLevel: UserAccountLevel,
	userCompanyName?: string | null,
	id: string,
	userProfilePicture?: string | null,
	userAccess?: Array<InviteUserToGroupsMutationUserAccess> | null,
	userGroups?: Array<InviteUserToGroupsMutationUserGroups> | null,
	pendingInvites?: Array<InviteUserToGroupsMutationPendingInvites> | null 
}

export type InviteUserToGroupsMutation = {
	__typename?: 'Mutation',
	linkUserGroupsToUser: InviteUserToGroupsMutationLinkUserGroupsToUser 
};

export type UpdateRedditUserMutationVariables = Exact<{

  userId: Scalars['ID'];

  userName?: InputMaybe<Scalars['String']>;

  userSurname?: InputMaybe<Scalars['String']>;

  userPassword?: InputMaybe<Scalars['String']>;

  userPasswordConfirmation?: InputMaybe<Scalars['String']>;

  userAccountLevel?: InputMaybe<CreateUserAccountLevel>;

  userProfilePicture?: InputMaybe<Scalars['ImageFile']>;

  credentials?: InputMaybe<Array<InputMaybe<UserCredentialInput>> | InputMaybe<UserCredentialInput>>;

}>;

export type UpdateRedditUserMutationUserAccess = {
	__typename?: 'UserAccess',
	userAccessEntityId: string,
	userAccessAccessType: UserAccessEntityType,
	userAccessEntityName: string,
	type: UserAccessEntityType,
	name: string 
}

export type UpdateRedditUserMutationUser = {
	__typename?: 'User',
	userId: string,
	id: string 
}

export type UpdateRedditUserMutationUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: UpdateRedditUserMutationUser 
}

export type UpdateRedditUserMutationUserGroups = {
	__typename?: 'UserGroup',
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	id: string,
	value: string,
	label: string,
	profilePictureUrl?: string | null,
	users?: Array<UpdateRedditUserMutationUsers> | null 
}

export type UpdateRedditUserMutationPendingInvites = {
	__typename?: 'PendingInvite',
	pendingInviteHash: string,
	pendingInviteEntityId: string,
	pendingInviteEntityType: PendingInviteEntityType 
}

export type UpdateRedditUserMutationUpdateUser = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userAccountLevel: UserAccountLevel,
	userCompanyName?: string | null,
	id: string,
	userProfilePicture?: string | null,
	userAccess?: Array<UpdateRedditUserMutationUserAccess> | null,
	userGroups?: Array<UpdateRedditUserMutationUserGroups> | null,
	pendingInvites?: Array<UpdateRedditUserMutationPendingInvites> | null 
}

export type UpdateRedditUserMutation = {
	__typename?: 'Mutation',
	updateUser: UpdateRedditUserMutationUpdateUser 
};

export type RedditUsersListQueryVariables = Exact<{

  search: Scalars['String'];

  cursor?: InputMaybe<Scalars['String']>;

}>;

export type RedditUsersListQueryUserAccess = {
	__typename?: 'UserAccess',
	userAccessEntityId: string,
	userAccessAccessType: UserAccessEntityType,
	userAccessEntityName: string,
	type: UserAccessEntityType,
	name: string 
}

export type RedditUsersListQueryUser = {
	__typename?: 'User',
	userId: string,
	id: string 
}

export type RedditUsersListQueryUsers = {
	__typename?: 'UserGroupUser',
	userGroupUserRole: UserGroupRole,
	user: RedditUsersListQueryUser 
}

export type RedditUsersListQueryUserGroups = {
	__typename?: 'UserGroup',
	userGroupName: string,
	userGroupProfilePictureUrl?: string | null,
	id: string,
	value: string,
	label: string,
	profilePictureUrl?: string | null,
	users?: Array<RedditUsersListQueryUsers> | null 
}

export type RedditUsersListQueryPendingInvites = {
	__typename?: 'PendingInvite',
	pendingInviteHash: string,
	pendingInviteEntityId: string,
	pendingInviteEntityType: PendingInviteEntityType 
}

export type RedditUsersListQueryItems = {
	__typename?: 'User',
	userId: string,
	userName?: string | null,
	userSurname?: string | null,
	userEmail: any,
	userAccountLevel: UserAccountLevel,
	userCompanyName?: string | null,
	id: string,
	userProfilePicture?: string | null,
	userAccess?: Array<RedditUsersListQueryUserAccess> | null,
	userGroups?: Array<RedditUsersListQueryUserGroups> | null,
	pendingInvites?: Array<RedditUsersListQueryPendingInvites> | null 
}

export type RedditUsersListQueryUsersUsers = {
	__typename?: 'UserCursored',
	cursor?: string | null,
	items?: Array<RedditUsersListQueryItems> | null 
}

export type RedditUsersListQuery = {
	__typename?: 'Query',
	users: RedditUsersListQueryUsersUsers 
};
export const UserFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]} as unknown as DocumentNode<UserFieldsFragment, unknown>;
export const RedditAgencyFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedditAgencyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AgencyAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountProfilePicture"},"name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountDeletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}}]}}]}}]} as unknown as DocumentNode<RedditAgencyFragmentFragment, unknown>;
export const ReportFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Report"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"reportId"}},{"kind":"Field","name":{"kind":"Name","value":"reportId"}},{"kind":"Field","name":{"kind":"Name","value":"reportName"}},{"kind":"Field","name":{"kind":"Name","value":"reportReady"}},{"kind":"Field","name":{"kind":"Name","value":"reportApi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportApiToken"}},{"kind":"Field","name":{"kind":"Name","value":"reportApiMetrics"}},{"kind":"Field","name":{"kind":"Name","value":"reportApiDimensions"}},{"kind":"Field","name":{"kind":"Name","value":"reportApiFilters"}},{"kind":"Field","name":{"kind":"Name","value":"reportApiFiltersOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"filter"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"reportDateType"}},{"kind":"Field","name":{"kind":"Name","value":"reportActionOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionOptionType"}},{"kind":"Field","name":{"kind":"Name","value":"actionOptionValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportDateRangeOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateRangeType"}},{"kind":"Field","name":{"kind":"Name","value":"dateRangeValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]} as unknown as DocumentNode<ReportFragmentFragment, unknown>;
export const RedditSupergridGroupFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"groupId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"groupName"}},{"kind":"Field","alias":{"kind":"Name","value":"externalId"},"name":{"kind":"Name","value":"externalGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"groupHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"externalGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"groupStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"statusPending"},"name":{"kind":"Name","value":"groupStatusPending"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidType"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidStrategy"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidAmount"}},{"kind":"Field","name":{"kind":"Name","value":"groupGoal"}},{"kind":"Field","name":{"kind":"Name","value":"groupGoalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"groupOptimizationGoal"}},{"kind":"Field","name":{"kind":"Name","value":"groupStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"groupEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"groupCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"groupModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"updatedAt"},"name":{"kind":"Name","value":"groupUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"modificationTime"},"name":{"kind":"Name","value":"groupModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"groupHasErrors"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"groupAppId"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargeting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"placements"},"name":{"kind":"Name","value":"groupTargetingLocations"}},{"kind":"Field","alias":{"kind":"Name","value":"gender"},"name":{"kind":"Name","value":"groupTargetingGender"}},{"kind":"Field","alias":{"kind":"Name","value":"deviceType"},"name":{"kind":"Name","value":"groupTargetingPlatforms"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesLabelMap"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOS"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOSMaxVersion"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOSMinVersion"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesType"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"communities"},"name":{"kind":"Name","value":"groupTargetingCommunities"}},{"kind":"Field","alias":{"kind":"Name","value":"communitiesExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedCommunities"}},{"kind":"Field","alias":{"kind":"Name","value":"locations"},"name":{"kind":"Name","value":"groupTargetingGeolocations"}},{"kind":"Field","alias":{"kind":"Name","value":"locationsExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedGeolocations"}},{"kind":"Field","alias":{"kind":"Name","value":"interests"},"name":{"kind":"Name","value":"groupTargetingInterests"}},{"kind":"Field","alias":{"kind":"Name","value":"keywords"},"name":{"kind":"Name","value":"groupTargetingKeywords"}},{"kind":"Field","alias":{"kind":"Name","value":"customAudiences"},"name":{"kind":"Name","value":"groupTargetingCustomAudienceIds"}},{"kind":"Field","alias":{"kind":"Name","value":"customAudiencesExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedCustomAudienceIds"}},{"kind":"Field","alias":{"kind":"Name","value":"carriers"},"name":{"kind":"Name","value":"groupTargetingCarriers"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingExcludedKeywords"}}]}}]}}]} as unknown as DocumentNode<RedditSupergridGroupFragmentFragment, unknown>;
export const RedditSupergridCampaignFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridCampaignFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"campaignName"}},{"kind":"Field","alias":{"kind":"Name","value":"externalId"},"name":{"kind":"Name","value":"externalCampaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"campaignHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"campaignName"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"campaignCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"updatedAt"},"name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"modificationTime"},"name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"campaignSpecialAdCategories"}},{"kind":"Field","name":{"kind":"Name","value":"campaignObjective"}},{"kind":"Field","name":{"kind":"Name","value":"campaignStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"campaignStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"statusPending"},"name":{"kind":"Name","value":"campaignStatusPending"}},{"kind":"Field","name":{"kind":"Name","value":"campaignSpendCap"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}}]} as unknown as DocumentNode<RedditSupergridCampaignFragmentFragment, unknown>;
export const RedditSupergridClientFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridClientFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Client"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clientPinned"}},{"kind":"Field","name":{"kind":"Name","value":"clientKpi"}},{"kind":"Field","name":{"kind":"Name","value":"clientBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientCreatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"clientProfilePicture"},"name":{"kind":"Name","value":"clientProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"profileName"}},{"kind":"Field","name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"business"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessId"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"businessWebsiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"industryId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstruments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"flatAdAccount"},"name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]}}]} as unknown as DocumentNode<RedditSupergridClientFragmentFragment, unknown>;
export const RedditSupergridAdFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridAdFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Ad"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"adId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adName"}},{"kind":"Field","alias":{"kind":"Name","value":"externalId"},"name":{"kind":"Name","value":"externalAdId"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"adHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"adId"}},{"kind":"Field","name":{"kind":"Name","value":"adName"}},{"kind":"Field","name":{"kind":"Name","value":"adCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"adModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"modificationTime"},"name":{"kind":"Name","value":"adModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"updatedAt"},"name":{"kind":"Name","value":"adUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"adHasErrors"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"adStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"statusPending"},"name":{"kind":"Name","value":"adStatusPending"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"adEventTrackers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"parent"},"name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridGroupFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"parent"},"name":{"kind":"Name","value":"campaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridCampaignFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"parent"},"name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridClientFragment"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatCreative"},"name":{"kind":"Name","value":"creative"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creativeId"}},{"kind":"Field","name":{"kind":"Name","value":"creativePostUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeHeadline"}},{"kind":"Field","name":{"kind":"Name","value":"creativeThumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeAllowComments"}},{"kind":"Field","name":{"kind":"Name","value":"creativeType"}},{"kind":"Field","name":{"kind":"Name","value":"externalCreativeId"}},{"kind":"Field","name":{"kind":"Name","value":"creativeHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"profileName"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatText"},"name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"creativeText"},"name":{"kind":"Name","value":"textValue"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatCreativeContent"},"name":{"kind":"Name","value":"creativeContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creativeContentId"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentCallToAction"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentDestinationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentDisplayUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentMediaUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentCaption"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatClient"},"name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"flatAdAccount"},"name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"groupId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"groupName"}},{"kind":"Field","alias":{"kind":"Name","value":"externalId"},"name":{"kind":"Name","value":"externalGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"groupHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"externalGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"groupStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"statusPending"},"name":{"kind":"Name","value":"groupStatusPending"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidType"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidStrategy"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidAmount"}},{"kind":"Field","name":{"kind":"Name","value":"groupGoal"}},{"kind":"Field","name":{"kind":"Name","value":"groupGoalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"groupOptimizationGoal"}},{"kind":"Field","name":{"kind":"Name","value":"groupStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"groupEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"groupCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"groupModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"updatedAt"},"name":{"kind":"Name","value":"groupUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"modificationTime"},"name":{"kind":"Name","value":"groupModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"groupHasErrors"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"groupAppId"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargeting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"placements"},"name":{"kind":"Name","value":"groupTargetingLocations"}},{"kind":"Field","alias":{"kind":"Name","value":"gender"},"name":{"kind":"Name","value":"groupTargetingGender"}},{"kind":"Field","alias":{"kind":"Name","value":"deviceType"},"name":{"kind":"Name","value":"groupTargetingPlatforms"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesLabelMap"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOS"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOSMaxVersion"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOSMinVersion"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesType"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"communities"},"name":{"kind":"Name","value":"groupTargetingCommunities"}},{"kind":"Field","alias":{"kind":"Name","value":"communitiesExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedCommunities"}},{"kind":"Field","alias":{"kind":"Name","value":"locations"},"name":{"kind":"Name","value":"groupTargetingGeolocations"}},{"kind":"Field","alias":{"kind":"Name","value":"locationsExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedGeolocations"}},{"kind":"Field","alias":{"kind":"Name","value":"interests"},"name":{"kind":"Name","value":"groupTargetingInterests"}},{"kind":"Field","alias":{"kind":"Name","value":"keywords"},"name":{"kind":"Name","value":"groupTargetingKeywords"}},{"kind":"Field","alias":{"kind":"Name","value":"customAudiences"},"name":{"kind":"Name","value":"groupTargetingCustomAudienceIds"}},{"kind":"Field","alias":{"kind":"Name","value":"customAudiencesExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedCustomAudienceIds"}},{"kind":"Field","alias":{"kind":"Name","value":"carriers"},"name":{"kind":"Name","value":"groupTargetingCarriers"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingExcludedKeywords"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridCampaignFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"campaignName"}},{"kind":"Field","alias":{"kind":"Name","value":"externalId"},"name":{"kind":"Name","value":"externalCampaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"campaignHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"campaignName"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"campaignCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"updatedAt"},"name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"modificationTime"},"name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"campaignSpecialAdCategories"}},{"kind":"Field","name":{"kind":"Name","value":"campaignObjective"}},{"kind":"Field","name":{"kind":"Name","value":"campaignStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"campaignStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"statusPending"},"name":{"kind":"Name","value":"campaignStatusPending"}},{"kind":"Field","name":{"kind":"Name","value":"campaignSpendCap"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridClientFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Client"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clientPinned"}},{"kind":"Field","name":{"kind":"Name","value":"clientKpi"}},{"kind":"Field","name":{"kind":"Name","value":"clientBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientCreatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"clientProfilePicture"},"name":{"kind":"Name","value":"clientProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"profileName"}},{"kind":"Field","name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"business"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessId"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"businessWebsiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"industryId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstruments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"flatAdAccount"},"name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]}}]} as unknown as DocumentNode<RedditSupergridAdFragmentFragment, unknown>;
export const RedditSuperGridStatsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSuperGridStatsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Stats"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAddPaymentInfo"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAddToCart"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAppLaunch"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsCompletedTutorial"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsInstall"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsLevelAchieved"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSearch"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSignUp"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSpend"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSpendCredits"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsViewContent"}},{"kind":"Field","name":{"kind":"Name","value":"clicks"}},{"kind":"Field","name":{"kind":"Name","value":"commentDownvotes"}},{"kind":"Field","name":{"kind":"Name","value":"commentUpvotes"}},{"kind":"Field","name":{"kind":"Name","value":"commentsPageViews"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionLeadTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRoas"}},{"kind":"Field","name":{"kind":"Name","value":"conversionSignupTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowDay"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowMonth"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowWeek"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowDay"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowMonth"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowWeek"}},{"kind":"Field","name":{"kind":"Name","value":"impressions"}},{"kind":"Field","name":{"kind":"Name","value":"spend"}},{"kind":"Field","name":{"kind":"Name","value":"videoFullyViewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"videoPlaysExpanded"}},{"kind":"Field","name":{"kind":"Name","value":"videoPlaysWithSound"}},{"kind":"Field","name":{"kind":"Name","value":"videoStarted"}},{"kind":"Field","name":{"kind":"Name","value":"videoViewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched100Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched10Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched25Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched3Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched50Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched5Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched75Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched95Percent"}},{"kind":"Field","name":{"kind":"Name","value":"viewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"viewerComments"}},{"kind":"Field","name":{"kind":"Name","value":"cpc"}},{"kind":"Field","name":{"kind":"Name","value":"ctr"}},{"kind":"Field","name":{"kind":"Name","value":"ecpm"}}]}}]} as unknown as DocumentNode<RedditSuperGridStatsFragmentFragment, unknown>;
export const RedditUserGroupFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedditUserGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"userGroupProfilePicture"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupType"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userTwoFactorAuthenticationEnabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"clientName"}},{"kind":"Field","alias":{"kind":"Name","value":"secondaryName"},"name":{"kind":"Name","value":"adAccountName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"clientName"}},{"kind":"Field","alias":{"kind":"Name","value":"secondaryName"},"name":{"kind":"Name","value":"adAccountName"}}]}}]}}]}}]} as unknown as DocumentNode<RedditUserGroupFragmentFragment, unknown>;
export const RedditUserFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedditUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}},{"kind":"Field","name":{"kind":"Name","value":"userCompanyName"}},{"kind":"Field","name":{"kind":"Name","value":"userAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAccessEntityId"}},{"kind":"Field","name":{"kind":"Name","value":"userAccessAccessType"}},{"kind":"Field","name":{"kind":"Name","value":"userAccessEntityName"}},{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"userAccessAccessType"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"userAccessEntityName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pendingInvites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pendingInviteEntityType"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"EnumValue","value":"USER_GROUP"}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"pendingInviteEntityId"}},{"kind":"Field","name":{"kind":"Name","value":"pendingInviteEntityType"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"userProfilePicture"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]} as unknown as DocumentNode<RedditUserFragmentFragment, unknown>;
export const AcceptInviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"acceptInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hash"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resolvePendingInvite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pendingInviteAction"},"value":{"kind":"EnumValue","value":"ACCEPT"}},{"kind":"Argument","name":{"kind":"Name","value":"pendingInviteHash"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hash"}}}]}]}}]} as unknown as DocumentNode<AcceptInviteMutation, AcceptInviteMutationVariables>;
export const RequestResetPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"requestResetPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestResetPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userEmail"}}}]}]}}]} as unknown as DocumentNode<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>;
export const ResetPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"resetPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"Argument","name":{"kind":"Name","value":"userPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userPassword"}}},{"kind":"Argument","name":{"kind":"Name","value":"userPasswordConfirmation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userPassword"}}}]}]}}]} as unknown as DocumentNode<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const UpdateMeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateMe"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userProfilePicture"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFile"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userSurname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userPassword"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userPasswordConfirmation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMe"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userProfilePicture"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userProfilePicture"}}},{"kind":"Argument","name":{"kind":"Name","value":"userName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userName"}}},{"kind":"Argument","name":{"kind":"Name","value":"userSurname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userSurname"}}},{"kind":"Argument","name":{"kind":"Name","value":"userPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userPassword"}}},{"kind":"Argument","name":{"kind":"Name","value":"userPasswordConfirmation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userPasswordConfirmation"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]} as unknown as DocumentNode<UpdateMeMutation, UpdateMeMutationVariables>;
export const UserMetaDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}},{"kind":"Field","name":{"kind":"Name","value":"userTwoFactorAuthenticationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"userCredential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialId"}},{"kind":"Field","name":{"kind":"Name","value":"credentialName"}},{"kind":"Field","name":{"kind":"Name","value":"userCredentialRead"}},{"kind":"Field","name":{"kind":"Name","value":"userCredentialWrite"}},{"kind":"Field","name":{"kind":"Name","value":"userCredentialDelete"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userCompanyName"}}]}}]}}]} as unknown as DocumentNode<UserMetaDataQuery, UserMetaDataQueryVariables>;
export const RedditUsersAndGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"redditUsersAndGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"usersFilterName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"usersFilterEmail"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserGroupFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupSearchFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserGroupFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchUserFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchUserFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"sameOrganizationUsersEmail"},"name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usersFilterEmail"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFields"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"sameOrganizationUsersName"},"name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usersFilterName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFields"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"sharedTeamsName"},"name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usersFilterName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFields"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"sharedTeamsEmail"},"name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usersFilterEmail"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFields"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"sharedTeams"},"name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupSearchFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fullEmailUsers"},"name":{"kind":"Name","value":"searchUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchUserFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]} as unknown as DocumentNode<RedditUsersAndGroupsQuery, RedditUsersAndGroupsQueryVariables>;
export const MatchColumnNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"matchColumnNames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"columnNames"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stringFormats"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"columnNamesArray"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"temperature"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openAiCompletion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"columnNames"},"value":{"kind":"Variable","name":{"kind":"Name","value":"columnNames"}}},{"kind":"Argument","name":{"kind":"Name","value":"stringFormats"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stringFormats"}}},{"kind":"Argument","name":{"kind":"Name","value":"columnNamesArray"},"value":{"kind":"Variable","name":{"kind":"Name","value":"columnNamesArray"}}},{"kind":"Argument","name":{"kind":"Name","value":"temperature"},"value":{"kind":"Variable","name":{"kind":"Name","value":"temperature"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"toolCalls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"function"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"arguments"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"logprobs"}},{"kind":"Field","name":{"kind":"Name","value":"finishReason"}}]}}]}}]} as unknown as DocumentNode<MatchColumnNamesQuery, MatchColumnNamesQueryVariables>;
export const AgencyAccessOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"agencyAccessOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailSearch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupSearch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userSearch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userLevel"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserAccountLevel"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedGroupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedGroupIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"exclude"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupOwnerEmail"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"emailSearch"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"groupSearch"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"users"},"name":{"kind":"Name","value":"searchUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userEmail"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userSearch"}}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userAccountLevel"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userLevel"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<AgencyAccessOptionsQuery, AgencyAccessOptionsQueryVariables>;
export const ActivateAgencyAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"activateAgencyAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activateAgencyAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agencyAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RedditAgencyFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedditAgencyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AgencyAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountProfilePicture"},"name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountDeletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}}]}}]}}]} as unknown as DocumentNode<ActivateAgencyAccountMutation, ActivateAgencyAccountMutationVariables>;
export const AddTeamToAgencyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addTeamToAgency"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkUserGroupsToAgencyAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"agencyAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RedditAgencyFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedditAgencyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AgencyAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountProfilePicture"},"name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountDeletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}}]}}]}}]} as unknown as DocumentNode<AddTeamToAgencyMutation, AddTeamToAgencyMutationVariables>;
export const RedditAdvertiserListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"redditAdvertiserList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencyAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"agencyAccountName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"search"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"agencyAccountId"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RedditAgencyFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedditAgencyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AgencyAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountProfilePicture"},"name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountDeletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}}]}}]}}]} as unknown as DocumentNode<RedditAdvertiserListQuery, RedditAdvertiserListQueryVariables>;
export const CancelAgencyInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cancelAgencyInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hash"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resolvePendingInvite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pendingInviteHash"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hash"}}},{"kind":"Argument","name":{"kind":"Name","value":"pendingInviteAction"},"value":{"kind":"EnumValue","value":"DECLINE"}}]}]}}]} as unknown as DocumentNode<CancelAgencyInvitationMutation, CancelAgencyInvitationMutationVariables>;
export const CreateRedditAdvertiserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createRedditAdvertiser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountOwnerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountProfilePicture"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFile"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"salesforceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAgencyAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agencyAccountName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountName"}}},{"kind":"Argument","name":{"kind":"Name","value":"agencyAccountOwnerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountOwnerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"agencyAccountProfilePicture"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountProfilePicture"}}},{"kind":"Argument","name":{"kind":"Name","value":"salesforceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"salesforceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"userIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RedditAgencyFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedditAgencyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AgencyAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountProfilePicture"},"name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountDeletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}}]}}]}}]} as unknown as DocumentNode<CreateRedditAdvertiserMutation, CreateRedditAdvertiserMutationVariables>;
export const DeleteAgencyAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteAgencyAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAgencyAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agencyAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountId"}}}]}]}}]} as unknown as DocumentNode<DeleteAgencyAccountMutation, DeleteAgencyAccountMutationVariables>;
export const InviteUserToAgencyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"inviteUserToAgency"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkUsersToAgencyAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"agencyAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RedditAgencyFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedditAgencyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AgencyAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountProfilePicture"},"name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountDeletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}}]}}]}}]} as unknown as DocumentNode<InviteUserToAgencyMutation, InviteUserToAgencyMutationVariables>;
export const LinkGroupToAgencyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"linkGroupToAgency"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkUserGroupsToAgencyAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"agencyAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RedditAgencyFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedditAgencyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AgencyAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountProfilePicture"},"name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountDeletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}}]}}]}}]} as unknown as DocumentNode<LinkGroupToAgencyMutation, LinkGroupToAgencyMutationVariables>;
export const AdvertiserOwnerOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"advertiserOwnerOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"users"},"name":{"kind":"Name","value":"searchUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userEmail"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userAccountLevel"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"EnumValue","value":"ADVERTISER"}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]} as unknown as DocumentNode<AdvertiserOwnerOptionsQuery, AdvertiserOwnerOptionsQueryVariables>;
export const AdvertiserOwnerOptionsAutocompleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"advertiserOwnerOptionsAutocomplete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"users"},"name":{"kind":"Name","value":"searchUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userEmail"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userAccountLevel"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"EnumValue","value":"ADVERTISER"}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userFullName"}}]}}]}}]} as unknown as DocumentNode<AdvertiserOwnerOptionsAutocompleteQuery, AdvertiserOwnerOptionsAutocompleteQueryVariables>;
export const RevokeGroupAccessToAgencyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"revokeGroupAccessToAgency"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unlinkUserGroupsFromAgencyAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"agencyAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RedditAgencyFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedditAgencyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AgencyAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountProfilePicture"},"name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountDeletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}}]}}]}}]} as unknown as DocumentNode<RevokeGroupAccessToAgencyMutation, RevokeGroupAccessToAgencyMutationVariables>;
export const RevokeUserAccessToAgencyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"revokeUserAccessToAgency"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unlinkUsersFromAgencyAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"agencyAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RedditAgencyFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedditAgencyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AgencyAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountProfilePicture"},"name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountDeletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}}]}}]}}]} as unknown as DocumentNode<RevokeUserAccessToAgencyMutation, RevokeUserAccessToAgencyMutationVariables>;
export const RedditAdvertiserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"redditAdvertiser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"advertiserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencyAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"agencyAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"advertiserId"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RedditAgencyFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedditAgencyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AgencyAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountProfilePicture"},"name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountDeletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}}]}}]}}]} as unknown as DocumentNode<RedditAdvertiserQuery, RedditAdvertiserQueryVariables>;
export const TransferAdvertiserOwnershipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"transferAdvertiserOwnership"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transferAgencyAccountOwnership"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agencyAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RedditAgencyFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedditAgencyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AgencyAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountProfilePicture"},"name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountDeletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}}]}}]}}]} as unknown as DocumentNode<TransferAdvertiserOwnershipMutation, TransferAdvertiserOwnershipMutationVariables>;
export const UpdateRedditAdvertiserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateRedditAdvertiser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"salesforceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profilePicture"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFile"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAgencyAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agencyAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"agencyAccountName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountName"}}},{"kind":"Argument","name":{"kind":"Name","value":"salesforceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"salesforceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"agencyAccountProfilePicture"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profilePicture"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RedditAgencyFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedditAgencyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AgencyAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountProfilePicture"},"name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountDeletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}}]}}]}}]} as unknown as DocumentNode<UpdateRedditAdvertiserMutation, UpdateRedditAdvertiserMutationVariables>;
export const CreateReportGoogleAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createReportGoogleAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportApiToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createReportGoogleAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reportApiToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportApiToken"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}}]}}]}}]} as unknown as DocumentNode<CreateReportGoogleAccessMutation, CreateReportGoogleAccessMutationVariables>;
export const CreateRedditReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createRedditReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportActionFormat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateReportActionFormat"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportActionType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateReportActionType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportApiDimensions"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportApiMetrics"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportDateType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateReportDateType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportSchedule"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportDateRangeOptions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportDateRangeOptions"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportApiFiltersOptions"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportApiFiltersOptions"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportActionOptions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportActionOptions"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reportName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportName"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportActionFormat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportActionFormat"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportActionType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportActionType"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportApiDataset"},"value":{"kind":"StringValue","value":"endpoint_reddit_statistics","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"reportApiDimensions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportApiDimensions"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportApiMetrics"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportApiMetrics"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportDateType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportDateType"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportSchedule"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportSchedule"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportApiFiltersOptions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportApiFiltersOptions"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportApiConditions"},"value":{"kind":"ListValue","values":[]}},{"kind":"Argument","name":{"kind":"Name","value":"reportDateRangeOptions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportDateRangeOptions"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportActionOptions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportActionOptions"}}},{"kind":"Argument","name":{"kind":"Name","value":"userGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"userIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Report"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"reportId"}},{"kind":"Field","name":{"kind":"Name","value":"reportId"}},{"kind":"Field","name":{"kind":"Name","value":"reportName"}},{"kind":"Field","name":{"kind":"Name","value":"reportReady"}},{"kind":"Field","name":{"kind":"Name","value":"reportApi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportApiToken"}},{"kind":"Field","name":{"kind":"Name","value":"reportApiMetrics"}},{"kind":"Field","name":{"kind":"Name","value":"reportApiDimensions"}},{"kind":"Field","name":{"kind":"Name","value":"reportApiFilters"}},{"kind":"Field","name":{"kind":"Name","value":"reportApiFiltersOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"filter"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"reportDateType"}},{"kind":"Field","name":{"kind":"Name","value":"reportActionOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionOptionType"}},{"kind":"Field","name":{"kind":"Name","value":"actionOptionValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportDateRangeOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateRangeType"}},{"kind":"Field","name":{"kind":"Name","value":"dateRangeValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]} as unknown as DocumentNode<CreateRedditReportMutation, CreateRedditReportMutationVariables>;
export const RedditReportDataSourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"redditReportDataSources"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"datasourceClientSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencyAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"datasourceClientSearch"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clientProfilePictureUrl"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"datasourceClientSearch"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"clientName"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"clientProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"agencyAccountId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupName"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"userGroupName"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"clientProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"clientProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RedditReportDataSourcesQuery, RedditReportDataSourcesQueryVariables>;
export const DeleteRedditReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteRedditReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reportId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}}}]}]}}]} as unknown as DocumentNode<DeleteRedditReportMutation, DeleteRedditReportMutationVariables>;
export const ReportImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"reportImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clients"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"clientId"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientIds"}}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"adAccountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"agencyAccountId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ReportImageQuery, ReportImageQueryVariables>;
export const RedditReportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"redditReports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"reportCreatedAt"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"reportName"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"search"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Report"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"reportId"}},{"kind":"Field","name":{"kind":"Name","value":"reportId"}},{"kind":"Field","name":{"kind":"Name","value":"reportName"}},{"kind":"Field","name":{"kind":"Name","value":"reportReady"}},{"kind":"Field","name":{"kind":"Name","value":"reportApi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportApiToken"}},{"kind":"Field","name":{"kind":"Name","value":"reportApiMetrics"}},{"kind":"Field","name":{"kind":"Name","value":"reportApiDimensions"}},{"kind":"Field","name":{"kind":"Name","value":"reportApiFilters"}},{"kind":"Field","name":{"kind":"Name","value":"reportApiFiltersOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"filter"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"reportDateType"}},{"kind":"Field","name":{"kind":"Name","value":"reportActionOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionOptionType"}},{"kind":"Field","name":{"kind":"Name","value":"actionOptionValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportDateRangeOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateRangeType"}},{"kind":"Field","name":{"kind":"Name","value":"dateRangeValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]} as unknown as DocumentNode<RedditReportsQuery, RedditReportsQueryVariables>;
export const ToggleRedditReportStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"toggleRedditReportStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportActive"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reportId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportReady"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportActive"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Report"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"reportId"}},{"kind":"Field","name":{"kind":"Name","value":"reportId"}},{"kind":"Field","name":{"kind":"Name","value":"reportName"}},{"kind":"Field","name":{"kind":"Name","value":"reportReady"}},{"kind":"Field","name":{"kind":"Name","value":"reportApi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportApiToken"}},{"kind":"Field","name":{"kind":"Name","value":"reportApiMetrics"}},{"kind":"Field","name":{"kind":"Name","value":"reportApiDimensions"}},{"kind":"Field","name":{"kind":"Name","value":"reportApiFilters"}},{"kind":"Field","name":{"kind":"Name","value":"reportApiFiltersOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"filter"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"reportDateType"}},{"kind":"Field","name":{"kind":"Name","value":"reportActionOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionOptionType"}},{"kind":"Field","name":{"kind":"Name","value":"actionOptionValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportDateRangeOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateRangeType"}},{"kind":"Field","name":{"kind":"Name","value":"dateRangeValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]} as unknown as DocumentNode<ToggleRedditReportStatusMutation, ToggleRedditReportStatusMutationVariables>;
export const UpdateRedditReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateRedditReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportActionFormat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateReportActionFormat"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportActionType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateReportActionType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportApiDimensions"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportApiMetrics"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportDateType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateReportDateType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportSchedule"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportDateRangeOptions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportDateRangeOptions"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportApiFiltersOptions"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportApiFiltersOptions"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportActionOptions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportActionOptions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reportId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportName"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportActionFormat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportActionFormat"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportActionType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportActionType"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportApiDataset"},"value":{"kind":"StringValue","value":"endpoint_reddit_statistics","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"reportApiDimensions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportApiDimensions"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportApiMetrics"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportApiMetrics"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportDateType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportDateType"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportSchedule"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportSchedule"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportApiFiltersOptions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportApiFiltersOptions"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportApiConditions"},"value":{"kind":"ListValue","values":[]}},{"kind":"Argument","name":{"kind":"Name","value":"reportDateRangeOptions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportDateRangeOptions"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportActionOptions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportActionOptions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Report"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"reportId"}},{"kind":"Field","name":{"kind":"Name","value":"reportId"}},{"kind":"Field","name":{"kind":"Name","value":"reportName"}},{"kind":"Field","name":{"kind":"Name","value":"reportReady"}},{"kind":"Field","name":{"kind":"Name","value":"reportApi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportApiToken"}},{"kind":"Field","name":{"kind":"Name","value":"reportApiMetrics"}},{"kind":"Field","name":{"kind":"Name","value":"reportApiDimensions"}},{"kind":"Field","name":{"kind":"Name","value":"reportApiFilters"}},{"kind":"Field","name":{"kind":"Name","value":"reportApiFiltersOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"filter"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"reportDateType"}},{"kind":"Field","name":{"kind":"Name","value":"reportActionOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionOptionType"}},{"kind":"Field","name":{"kind":"Name","value":"actionOptionValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportDateRangeOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateRangeType"}},{"kind":"Field","name":{"kind":"Name","value":"dateRangeValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]} as unknown as DocumentNode<UpdateRedditReportMutation, UpdateRedditReportMutationVariables>;
export const UpdateRedditReportAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateRedditReportAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userEmails"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reportId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"userGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportActionOptions"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"actionOptionValue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userEmails"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"actionOptionType"},"value":{"kind":"EnumValue","value":"ACTION_EMAILS"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Report"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"reportId"}},{"kind":"Field","name":{"kind":"Name","value":"reportId"}},{"kind":"Field","name":{"kind":"Name","value":"reportName"}},{"kind":"Field","name":{"kind":"Name","value":"reportReady"}},{"kind":"Field","name":{"kind":"Name","value":"reportApi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportApiToken"}},{"kind":"Field","name":{"kind":"Name","value":"reportApiMetrics"}},{"kind":"Field","name":{"kind":"Name","value":"reportApiDimensions"}},{"kind":"Field","name":{"kind":"Name","value":"reportApiFilters"}},{"kind":"Field","name":{"kind":"Name","value":"reportApiFiltersOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"filter"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"reportDateType"}},{"kind":"Field","name":{"kind":"Name","value":"reportActionOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionOptionType"}},{"kind":"Field","name":{"kind":"Name","value":"actionOptionValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportDateRangeOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateRangeType"}},{"kind":"Field","name":{"kind":"Name","value":"dateRangeValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]} as unknown as DocumentNode<UpdateRedditReportAccessMutation, UpdateRedditReportAccessMutationVariables>;
export const DuplicateEntityTreeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"duplicateEntityTree"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignFilters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupFilters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GroupFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"adFilters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entities"},"name":{"kind":"Name","value":"campaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"campaigns"},"name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"parent"},"name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridClientFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridCampaignFragment"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridGroupFragment"}},{"kind":"Field","name":{"kind":"Name","value":"ads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"adFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridAdFragment"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"groupId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"groupName"}},{"kind":"Field","alias":{"kind":"Name","value":"externalId"},"name":{"kind":"Name","value":"externalGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"groupHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"externalGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"groupStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"statusPending"},"name":{"kind":"Name","value":"groupStatusPending"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidType"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidStrategy"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidAmount"}},{"kind":"Field","name":{"kind":"Name","value":"groupGoal"}},{"kind":"Field","name":{"kind":"Name","value":"groupGoalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"groupOptimizationGoal"}},{"kind":"Field","name":{"kind":"Name","value":"groupStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"groupEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"groupCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"groupModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"updatedAt"},"name":{"kind":"Name","value":"groupUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"modificationTime"},"name":{"kind":"Name","value":"groupModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"groupHasErrors"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"groupAppId"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargeting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"placements"},"name":{"kind":"Name","value":"groupTargetingLocations"}},{"kind":"Field","alias":{"kind":"Name","value":"gender"},"name":{"kind":"Name","value":"groupTargetingGender"}},{"kind":"Field","alias":{"kind":"Name","value":"deviceType"},"name":{"kind":"Name","value":"groupTargetingPlatforms"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesLabelMap"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOS"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOSMaxVersion"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOSMinVersion"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesType"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"communities"},"name":{"kind":"Name","value":"groupTargetingCommunities"}},{"kind":"Field","alias":{"kind":"Name","value":"communitiesExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedCommunities"}},{"kind":"Field","alias":{"kind":"Name","value":"locations"},"name":{"kind":"Name","value":"groupTargetingGeolocations"}},{"kind":"Field","alias":{"kind":"Name","value":"locationsExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedGeolocations"}},{"kind":"Field","alias":{"kind":"Name","value":"interests"},"name":{"kind":"Name","value":"groupTargetingInterests"}},{"kind":"Field","alias":{"kind":"Name","value":"keywords"},"name":{"kind":"Name","value":"groupTargetingKeywords"}},{"kind":"Field","alias":{"kind":"Name","value":"customAudiences"},"name":{"kind":"Name","value":"groupTargetingCustomAudienceIds"}},{"kind":"Field","alias":{"kind":"Name","value":"customAudiencesExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedCustomAudienceIds"}},{"kind":"Field","alias":{"kind":"Name","value":"carriers"},"name":{"kind":"Name","value":"groupTargetingCarriers"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingExcludedKeywords"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridCampaignFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"campaignName"}},{"kind":"Field","alias":{"kind":"Name","value":"externalId"},"name":{"kind":"Name","value":"externalCampaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"campaignHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"campaignName"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"campaignCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"updatedAt"},"name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"modificationTime"},"name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"campaignSpecialAdCategories"}},{"kind":"Field","name":{"kind":"Name","value":"campaignObjective"}},{"kind":"Field","name":{"kind":"Name","value":"campaignStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"campaignStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"statusPending"},"name":{"kind":"Name","value":"campaignStatusPending"}},{"kind":"Field","name":{"kind":"Name","value":"campaignSpendCap"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridClientFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Client"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clientPinned"}},{"kind":"Field","name":{"kind":"Name","value":"clientKpi"}},{"kind":"Field","name":{"kind":"Name","value":"clientBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientCreatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"clientProfilePicture"},"name":{"kind":"Name","value":"clientProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"profileName"}},{"kind":"Field","name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"business"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessId"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"businessWebsiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"industryId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstruments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"flatAdAccount"},"name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridAdFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Ad"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"adId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adName"}},{"kind":"Field","alias":{"kind":"Name","value":"externalId"},"name":{"kind":"Name","value":"externalAdId"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"adHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"adId"}},{"kind":"Field","name":{"kind":"Name","value":"adName"}},{"kind":"Field","name":{"kind":"Name","value":"adCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"adModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"modificationTime"},"name":{"kind":"Name","value":"adModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"updatedAt"},"name":{"kind":"Name","value":"adUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"adHasErrors"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"adStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"statusPending"},"name":{"kind":"Name","value":"adStatusPending"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"adEventTrackers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"parent"},"name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridGroupFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"parent"},"name":{"kind":"Name","value":"campaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridCampaignFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"parent"},"name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridClientFragment"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatCreative"},"name":{"kind":"Name","value":"creative"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creativeId"}},{"kind":"Field","name":{"kind":"Name","value":"creativePostUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeHeadline"}},{"kind":"Field","name":{"kind":"Name","value":"creativeThumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeAllowComments"}},{"kind":"Field","name":{"kind":"Name","value":"creativeType"}},{"kind":"Field","name":{"kind":"Name","value":"externalCreativeId"}},{"kind":"Field","name":{"kind":"Name","value":"creativeHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"profileName"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatText"},"name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"creativeText"},"name":{"kind":"Name","value":"textValue"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatCreativeContent"},"name":{"kind":"Name","value":"creativeContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creativeContentId"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentCallToAction"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentDestinationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentDisplayUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentMediaUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentCaption"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatClient"},"name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"flatAdAccount"},"name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}}]}}]}}]}}]} as unknown as DocumentNode<DuplicateEntityTreeQuery, DuplicateEntityTreeQueryVariables>;
export const CampaignBreadcrumbsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"campaignBreadcrumbs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"breadcrumbs"},"name":{"kind":"Name","value":"campaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"campaignName"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adAccountName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CampaignBreadcrumbsQuery, CampaignBreadcrumbsQueryVariables>;
export const ClientBreadcrumbsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"clientBreadcrumbs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"breadcrumbs"},"name":{"kind":"Name","value":"clients"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adAccountName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ClientBreadcrumbsQuery, ClientBreadcrumbsQueryVariables>;
export const GroupBreadcrumbsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"groupBreadcrumbs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GroupFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"breadcrumbs"},"name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"groupId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"campaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"campaignName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adAccountName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GroupBreadcrumbsQuery, GroupBreadcrumbsQueryVariables>;
export const ArchiveEntitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"archiveEntities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ads"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAdInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groups"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateGroupInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaigns"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCampaignInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ads"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ads"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridAdFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updateGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groups"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridGroupFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updateCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"campaigns"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaigns"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridCampaignFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"groupId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"groupName"}},{"kind":"Field","alias":{"kind":"Name","value":"externalId"},"name":{"kind":"Name","value":"externalGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"groupHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"externalGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"groupStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"statusPending"},"name":{"kind":"Name","value":"groupStatusPending"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidType"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidStrategy"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidAmount"}},{"kind":"Field","name":{"kind":"Name","value":"groupGoal"}},{"kind":"Field","name":{"kind":"Name","value":"groupGoalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"groupOptimizationGoal"}},{"kind":"Field","name":{"kind":"Name","value":"groupStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"groupEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"groupCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"groupModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"updatedAt"},"name":{"kind":"Name","value":"groupUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"modificationTime"},"name":{"kind":"Name","value":"groupModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"groupHasErrors"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"groupAppId"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargeting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"placements"},"name":{"kind":"Name","value":"groupTargetingLocations"}},{"kind":"Field","alias":{"kind":"Name","value":"gender"},"name":{"kind":"Name","value":"groupTargetingGender"}},{"kind":"Field","alias":{"kind":"Name","value":"deviceType"},"name":{"kind":"Name","value":"groupTargetingPlatforms"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesLabelMap"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOS"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOSMaxVersion"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOSMinVersion"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesType"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"communities"},"name":{"kind":"Name","value":"groupTargetingCommunities"}},{"kind":"Field","alias":{"kind":"Name","value":"communitiesExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedCommunities"}},{"kind":"Field","alias":{"kind":"Name","value":"locations"},"name":{"kind":"Name","value":"groupTargetingGeolocations"}},{"kind":"Field","alias":{"kind":"Name","value":"locationsExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedGeolocations"}},{"kind":"Field","alias":{"kind":"Name","value":"interests"},"name":{"kind":"Name","value":"groupTargetingInterests"}},{"kind":"Field","alias":{"kind":"Name","value":"keywords"},"name":{"kind":"Name","value":"groupTargetingKeywords"}},{"kind":"Field","alias":{"kind":"Name","value":"customAudiences"},"name":{"kind":"Name","value":"groupTargetingCustomAudienceIds"}},{"kind":"Field","alias":{"kind":"Name","value":"customAudiencesExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedCustomAudienceIds"}},{"kind":"Field","alias":{"kind":"Name","value":"carriers"},"name":{"kind":"Name","value":"groupTargetingCarriers"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingExcludedKeywords"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridCampaignFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"campaignName"}},{"kind":"Field","alias":{"kind":"Name","value":"externalId"},"name":{"kind":"Name","value":"externalCampaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"campaignHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"campaignName"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"campaignCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"updatedAt"},"name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"modificationTime"},"name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"campaignSpecialAdCategories"}},{"kind":"Field","name":{"kind":"Name","value":"campaignObjective"}},{"kind":"Field","name":{"kind":"Name","value":"campaignStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"campaignStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"statusPending"},"name":{"kind":"Name","value":"campaignStatusPending"}},{"kind":"Field","name":{"kind":"Name","value":"campaignSpendCap"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridClientFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Client"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clientPinned"}},{"kind":"Field","name":{"kind":"Name","value":"clientKpi"}},{"kind":"Field","name":{"kind":"Name","value":"clientBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientCreatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"clientProfilePicture"},"name":{"kind":"Name","value":"clientProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"profileName"}},{"kind":"Field","name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"business"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessId"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"businessWebsiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"industryId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstruments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"flatAdAccount"},"name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridAdFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Ad"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"adId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adName"}},{"kind":"Field","alias":{"kind":"Name","value":"externalId"},"name":{"kind":"Name","value":"externalAdId"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"adHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"adId"}},{"kind":"Field","name":{"kind":"Name","value":"adName"}},{"kind":"Field","name":{"kind":"Name","value":"adCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"adModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"modificationTime"},"name":{"kind":"Name","value":"adModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"updatedAt"},"name":{"kind":"Name","value":"adUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"adHasErrors"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"adStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"statusPending"},"name":{"kind":"Name","value":"adStatusPending"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"adEventTrackers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"parent"},"name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridGroupFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"parent"},"name":{"kind":"Name","value":"campaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridCampaignFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"parent"},"name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridClientFragment"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatCreative"},"name":{"kind":"Name","value":"creative"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creativeId"}},{"kind":"Field","name":{"kind":"Name","value":"creativePostUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeHeadline"}},{"kind":"Field","name":{"kind":"Name","value":"creativeThumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeAllowComments"}},{"kind":"Field","name":{"kind":"Name","value":"creativeType"}},{"kind":"Field","name":{"kind":"Name","value":"externalCreativeId"}},{"kind":"Field","name":{"kind":"Name","value":"creativeHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"profileName"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatText"},"name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"creativeText"},"name":{"kind":"Name","value":"textValue"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatCreativeContent"},"name":{"kind":"Name","value":"creativeContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creativeContentId"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentCallToAction"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentDestinationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentDisplayUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentMediaUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentCaption"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatClient"},"name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"flatAdAccount"},"name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}}]}}]}}]}}]} as unknown as DocumentNode<ArchiveEntitiesMutation, ArchiveEntitiesMutationVariables>;
export const ChangeStatusOfEntitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"changeStatusOfEntities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ads"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAdInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groups"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateGroupInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaigns"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCampaignInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ads"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ads"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridAdFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updateGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groups"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridGroupFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updateCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"campaigns"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaigns"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridCampaignFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"groupId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"groupName"}},{"kind":"Field","alias":{"kind":"Name","value":"externalId"},"name":{"kind":"Name","value":"externalGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"groupHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"externalGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"groupStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"statusPending"},"name":{"kind":"Name","value":"groupStatusPending"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidType"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidStrategy"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidAmount"}},{"kind":"Field","name":{"kind":"Name","value":"groupGoal"}},{"kind":"Field","name":{"kind":"Name","value":"groupGoalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"groupOptimizationGoal"}},{"kind":"Field","name":{"kind":"Name","value":"groupStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"groupEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"groupCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"groupModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"updatedAt"},"name":{"kind":"Name","value":"groupUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"modificationTime"},"name":{"kind":"Name","value":"groupModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"groupHasErrors"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"groupAppId"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargeting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"placements"},"name":{"kind":"Name","value":"groupTargetingLocations"}},{"kind":"Field","alias":{"kind":"Name","value":"gender"},"name":{"kind":"Name","value":"groupTargetingGender"}},{"kind":"Field","alias":{"kind":"Name","value":"deviceType"},"name":{"kind":"Name","value":"groupTargetingPlatforms"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesLabelMap"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOS"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOSMaxVersion"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOSMinVersion"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesType"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"communities"},"name":{"kind":"Name","value":"groupTargetingCommunities"}},{"kind":"Field","alias":{"kind":"Name","value":"communitiesExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedCommunities"}},{"kind":"Field","alias":{"kind":"Name","value":"locations"},"name":{"kind":"Name","value":"groupTargetingGeolocations"}},{"kind":"Field","alias":{"kind":"Name","value":"locationsExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedGeolocations"}},{"kind":"Field","alias":{"kind":"Name","value":"interests"},"name":{"kind":"Name","value":"groupTargetingInterests"}},{"kind":"Field","alias":{"kind":"Name","value":"keywords"},"name":{"kind":"Name","value":"groupTargetingKeywords"}},{"kind":"Field","alias":{"kind":"Name","value":"customAudiences"},"name":{"kind":"Name","value":"groupTargetingCustomAudienceIds"}},{"kind":"Field","alias":{"kind":"Name","value":"customAudiencesExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedCustomAudienceIds"}},{"kind":"Field","alias":{"kind":"Name","value":"carriers"},"name":{"kind":"Name","value":"groupTargetingCarriers"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingExcludedKeywords"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridCampaignFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"campaignName"}},{"kind":"Field","alias":{"kind":"Name","value":"externalId"},"name":{"kind":"Name","value":"externalCampaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"campaignHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"campaignName"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"campaignCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"updatedAt"},"name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"modificationTime"},"name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"campaignSpecialAdCategories"}},{"kind":"Field","name":{"kind":"Name","value":"campaignObjective"}},{"kind":"Field","name":{"kind":"Name","value":"campaignStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"campaignStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"statusPending"},"name":{"kind":"Name","value":"campaignStatusPending"}},{"kind":"Field","name":{"kind":"Name","value":"campaignSpendCap"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridClientFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Client"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clientPinned"}},{"kind":"Field","name":{"kind":"Name","value":"clientKpi"}},{"kind":"Field","name":{"kind":"Name","value":"clientBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientCreatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"clientProfilePicture"},"name":{"kind":"Name","value":"clientProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"profileName"}},{"kind":"Field","name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"business"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessId"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"businessWebsiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"industryId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstruments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"flatAdAccount"},"name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridAdFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Ad"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"adId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adName"}},{"kind":"Field","alias":{"kind":"Name","value":"externalId"},"name":{"kind":"Name","value":"externalAdId"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"adHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"adId"}},{"kind":"Field","name":{"kind":"Name","value":"adName"}},{"kind":"Field","name":{"kind":"Name","value":"adCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"adModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"modificationTime"},"name":{"kind":"Name","value":"adModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"updatedAt"},"name":{"kind":"Name","value":"adUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"adHasErrors"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"adStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"statusPending"},"name":{"kind":"Name","value":"adStatusPending"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"adEventTrackers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"parent"},"name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridGroupFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"parent"},"name":{"kind":"Name","value":"campaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridCampaignFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"parent"},"name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridClientFragment"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatCreative"},"name":{"kind":"Name","value":"creative"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creativeId"}},{"kind":"Field","name":{"kind":"Name","value":"creativePostUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeHeadline"}},{"kind":"Field","name":{"kind":"Name","value":"creativeThumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeAllowComments"}},{"kind":"Field","name":{"kind":"Name","value":"creativeType"}},{"kind":"Field","name":{"kind":"Name","value":"externalCreativeId"}},{"kind":"Field","name":{"kind":"Name","value":"creativeHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"profileName"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatText"},"name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"creativeText"},"name":{"kind":"Name","value":"textValue"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatCreativeContent"},"name":{"kind":"Name","value":"creativeContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creativeContentId"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentCallToAction"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentDestinationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentDisplayUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentMediaUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentCaption"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatClient"},"name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"flatAdAccount"},"name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}}]}}]}}]}}]} as unknown as DocumentNode<ChangeStatusOfEntitiesMutation, ChangeStatusOfEntitiesMutationVariables>;
export const DeleteEntitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteEntities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ads"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteAdInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groups"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteGroupInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaigns"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteCampaignInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ads"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ads"}}}]},{"kind":"Field","name":{"kind":"Name","value":"deleteGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groups"}}}]},{"kind":"Field","name":{"kind":"Name","value":"deleteCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"campaigns"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaigns"}}}]}]}}]} as unknown as DocumentNode<DeleteEntitiesMutation, DeleteEntitiesMutationVariables>;
export const AdOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"adOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AdFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"options"},"name":{"kind":"Name","value":"ads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"adId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"adName"}}]}}]}}]}}]} as unknown as DocumentNode<AdOptionsQuery, AdOptionsQueryVariables>;
export const AdvertisersOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"advertisersOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"options"},"name":{"kind":"Name","value":"agencyAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"agencyAccountName"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"search"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"agencyAccountName"}}]}}]}}]}}]} as unknown as DocumentNode<AdvertisersOptionsQuery, AdvertisersOptionsQueryVariables>;
export const CampaignOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"campaignOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"options"},"name":{"kind":"Name","value":"campaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"campaignName"}}]}}]}}]}}]} as unknown as DocumentNode<CampaignOptionsQuery, CampaignOptionsQueryVariables>;
export const ClientOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"clientOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"options"},"name":{"kind":"Name","value":"clients"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"adAccountName"}}]}}]}}]}}]} as unknown as DocumentNode<ClientOptionsQuery, ClientOptionsQueryVariables>;
export const GroupOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"groupOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GroupFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"options"},"name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"groupId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"groupName"}}]}}]}}]}}]} as unknown as DocumentNode<GroupOptionsQuery, GroupOptionsQueryVariables>;
export const UserGroupOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userGroupOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"options"},"name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupName"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"search"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userGroupName"}}]}}]}}]}}]} as unknown as DocumentNode<UserGroupOptionsQuery, UserGroupOptionsQueryVariables>;
export const UserOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"options"},"name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userFullName"}}]}}]}}]}}]} as unknown as DocumentNode<UserOptionsQuery, UserOptionsQueryVariables>;
export const MarkNotificationsAsReadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"markNotificationsAsRead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markAsRead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"notificationIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"notificationId"}},{"kind":"Field","name":{"kind":"Name","value":"notificationIsRead"}}]}}]}}]} as unknown as DocumentNode<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>;
export const RedditNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"redditNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"notificationCreatedAt"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"notificationPriority"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"notificationId"}},{"kind":"Field","name":{"kind":"Name","value":"notificationId"}},{"kind":"Field","name":{"kind":"Name","value":"notificationEntityType"}},{"kind":"Field","name":{"kind":"Name","value":"notificationEntityId"}},{"kind":"Field","name":{"kind":"Name","value":"notificationType"}},{"kind":"Field","name":{"kind":"Name","value":"notificationCategory"}},{"kind":"Field","name":{"kind":"Name","value":"notificationPriority"}},{"kind":"Field","name":{"kind":"Name","value":"notificationTitle"}},{"kind":"Field","name":{"kind":"Name","value":"notificationMessage"}},{"kind":"Field","name":{"kind":"Name","value":"notificationCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"notificationIsRead"}},{"kind":"Field","name":{"kind":"Name","value":"notificationIsGlobal"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"clientProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RedditNotificationsQuery, RedditNotificationsQueryVariables>;
export const AdSuperGridListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"adSuperGridList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statsFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StatsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AdFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entities"},"name":{"kind":"Name","value":"ads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridAdFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"flatStats"},"name":{"kind":"Name","value":"stats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSuperGridStatsFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"groupId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"groupName"}},{"kind":"Field","alias":{"kind":"Name","value":"externalId"},"name":{"kind":"Name","value":"externalGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"groupHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"externalGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"groupStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"statusPending"},"name":{"kind":"Name","value":"groupStatusPending"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidType"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidStrategy"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidAmount"}},{"kind":"Field","name":{"kind":"Name","value":"groupGoal"}},{"kind":"Field","name":{"kind":"Name","value":"groupGoalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"groupOptimizationGoal"}},{"kind":"Field","name":{"kind":"Name","value":"groupStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"groupEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"groupCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"groupModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"updatedAt"},"name":{"kind":"Name","value":"groupUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"modificationTime"},"name":{"kind":"Name","value":"groupModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"groupHasErrors"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"groupAppId"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargeting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"placements"},"name":{"kind":"Name","value":"groupTargetingLocations"}},{"kind":"Field","alias":{"kind":"Name","value":"gender"},"name":{"kind":"Name","value":"groupTargetingGender"}},{"kind":"Field","alias":{"kind":"Name","value":"deviceType"},"name":{"kind":"Name","value":"groupTargetingPlatforms"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesLabelMap"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOS"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOSMaxVersion"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOSMinVersion"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesType"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"communities"},"name":{"kind":"Name","value":"groupTargetingCommunities"}},{"kind":"Field","alias":{"kind":"Name","value":"communitiesExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedCommunities"}},{"kind":"Field","alias":{"kind":"Name","value":"locations"},"name":{"kind":"Name","value":"groupTargetingGeolocations"}},{"kind":"Field","alias":{"kind":"Name","value":"locationsExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedGeolocations"}},{"kind":"Field","alias":{"kind":"Name","value":"interests"},"name":{"kind":"Name","value":"groupTargetingInterests"}},{"kind":"Field","alias":{"kind":"Name","value":"keywords"},"name":{"kind":"Name","value":"groupTargetingKeywords"}},{"kind":"Field","alias":{"kind":"Name","value":"customAudiences"},"name":{"kind":"Name","value":"groupTargetingCustomAudienceIds"}},{"kind":"Field","alias":{"kind":"Name","value":"customAudiencesExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedCustomAudienceIds"}},{"kind":"Field","alias":{"kind":"Name","value":"carriers"},"name":{"kind":"Name","value":"groupTargetingCarriers"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingExcludedKeywords"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridCampaignFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"campaignName"}},{"kind":"Field","alias":{"kind":"Name","value":"externalId"},"name":{"kind":"Name","value":"externalCampaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"campaignHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"campaignName"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"campaignCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"updatedAt"},"name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"modificationTime"},"name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"campaignSpecialAdCategories"}},{"kind":"Field","name":{"kind":"Name","value":"campaignObjective"}},{"kind":"Field","name":{"kind":"Name","value":"campaignStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"campaignStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"statusPending"},"name":{"kind":"Name","value":"campaignStatusPending"}},{"kind":"Field","name":{"kind":"Name","value":"campaignSpendCap"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridClientFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Client"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clientPinned"}},{"kind":"Field","name":{"kind":"Name","value":"clientKpi"}},{"kind":"Field","name":{"kind":"Name","value":"clientBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientCreatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"clientProfilePicture"},"name":{"kind":"Name","value":"clientProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"profileName"}},{"kind":"Field","name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"business"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessId"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"businessWebsiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"industryId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstruments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"flatAdAccount"},"name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridAdFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Ad"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"adId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adName"}},{"kind":"Field","alias":{"kind":"Name","value":"externalId"},"name":{"kind":"Name","value":"externalAdId"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"adHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"adId"}},{"kind":"Field","name":{"kind":"Name","value":"adName"}},{"kind":"Field","name":{"kind":"Name","value":"adCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"adModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"modificationTime"},"name":{"kind":"Name","value":"adModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"updatedAt"},"name":{"kind":"Name","value":"adUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"adHasErrors"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"adStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"statusPending"},"name":{"kind":"Name","value":"adStatusPending"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"adEventTrackers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"parent"},"name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridGroupFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"parent"},"name":{"kind":"Name","value":"campaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridCampaignFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"parent"},"name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridClientFragment"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatCreative"},"name":{"kind":"Name","value":"creative"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creativeId"}},{"kind":"Field","name":{"kind":"Name","value":"creativePostUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeHeadline"}},{"kind":"Field","name":{"kind":"Name","value":"creativeThumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeAllowComments"}},{"kind":"Field","name":{"kind":"Name","value":"creativeType"}},{"kind":"Field","name":{"kind":"Name","value":"externalCreativeId"}},{"kind":"Field","name":{"kind":"Name","value":"creativeHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"profileName"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatText"},"name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"creativeText"},"name":{"kind":"Name","value":"textValue"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatCreativeContent"},"name":{"kind":"Name","value":"creativeContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creativeContentId"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentCallToAction"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentDestinationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentDisplayUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentMediaUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentCaption"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatClient"},"name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"flatAdAccount"},"name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSuperGridStatsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Stats"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAddPaymentInfo"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAddToCart"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAppLaunch"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsCompletedTutorial"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsInstall"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsLevelAchieved"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSearch"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSignUp"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSpend"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSpendCredits"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsViewContent"}},{"kind":"Field","name":{"kind":"Name","value":"clicks"}},{"kind":"Field","name":{"kind":"Name","value":"commentDownvotes"}},{"kind":"Field","name":{"kind":"Name","value":"commentUpvotes"}},{"kind":"Field","name":{"kind":"Name","value":"commentsPageViews"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionLeadTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRoas"}},{"kind":"Field","name":{"kind":"Name","value":"conversionSignupTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowDay"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowMonth"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowWeek"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowDay"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowMonth"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowWeek"}},{"kind":"Field","name":{"kind":"Name","value":"impressions"}},{"kind":"Field","name":{"kind":"Name","value":"spend"}},{"kind":"Field","name":{"kind":"Name","value":"videoFullyViewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"videoPlaysExpanded"}},{"kind":"Field","name":{"kind":"Name","value":"videoPlaysWithSound"}},{"kind":"Field","name":{"kind":"Name","value":"videoStarted"}},{"kind":"Field","name":{"kind":"Name","value":"videoViewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched100Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched10Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched25Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched3Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched50Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched5Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched75Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched95Percent"}},{"kind":"Field","name":{"kind":"Name","value":"viewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"viewerComments"}},{"kind":"Field","name":{"kind":"Name","value":"cpc"}},{"kind":"Field","name":{"kind":"Name","value":"ctr"}},{"kind":"Field","name":{"kind":"Name","value":"ecpm"}}]}}]} as unknown as DocumentNode<AdSuperGridListQuery, AdSuperGridListQueryVariables>;
export const CommunityBreakdownSuperGridListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"communityBreakdownSuperGridList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StatsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StatsOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entities"},"name":{"kind":"Name","value":"stats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"StringValue","value":"community IS NOT NULL","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"community"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"community"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSuperGridStatsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSuperGridStatsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Stats"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAddPaymentInfo"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAddToCart"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAppLaunch"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsCompletedTutorial"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsInstall"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsLevelAchieved"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSearch"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSignUp"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSpend"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSpendCredits"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsViewContent"}},{"kind":"Field","name":{"kind":"Name","value":"clicks"}},{"kind":"Field","name":{"kind":"Name","value":"commentDownvotes"}},{"kind":"Field","name":{"kind":"Name","value":"commentUpvotes"}},{"kind":"Field","name":{"kind":"Name","value":"commentsPageViews"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionLeadTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRoas"}},{"kind":"Field","name":{"kind":"Name","value":"conversionSignupTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowDay"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowMonth"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowWeek"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowDay"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowMonth"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowWeek"}},{"kind":"Field","name":{"kind":"Name","value":"impressions"}},{"kind":"Field","name":{"kind":"Name","value":"spend"}},{"kind":"Field","name":{"kind":"Name","value":"videoFullyViewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"videoPlaysExpanded"}},{"kind":"Field","name":{"kind":"Name","value":"videoPlaysWithSound"}},{"kind":"Field","name":{"kind":"Name","value":"videoStarted"}},{"kind":"Field","name":{"kind":"Name","value":"videoViewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched100Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched10Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched25Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched3Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched50Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched5Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched75Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched95Percent"}},{"kind":"Field","name":{"kind":"Name","value":"viewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"viewerComments"}},{"kind":"Field","name":{"kind":"Name","value":"cpc"}},{"kind":"Field","name":{"kind":"Name","value":"ctr"}},{"kind":"Field","name":{"kind":"Name","value":"ecpm"}}]}}]} as unknown as DocumentNode<CommunityBreakdownSuperGridListQuery, CommunityBreakdownSuperGridListQueryVariables>;
export const CountryBreakdownSuperGridListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"countryBreakdownSuperGridList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StatsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StatsOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entities"},"name":{"kind":"Name","value":"stats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"StringValue","value":"country IS NOT NULL","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"country"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"country"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSuperGridStatsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSuperGridStatsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Stats"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAddPaymentInfo"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAddToCart"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAppLaunch"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsCompletedTutorial"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsInstall"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsLevelAchieved"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSearch"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSignUp"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSpend"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSpendCredits"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsViewContent"}},{"kind":"Field","name":{"kind":"Name","value":"clicks"}},{"kind":"Field","name":{"kind":"Name","value":"commentDownvotes"}},{"kind":"Field","name":{"kind":"Name","value":"commentUpvotes"}},{"kind":"Field","name":{"kind":"Name","value":"commentsPageViews"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionLeadTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRoas"}},{"kind":"Field","name":{"kind":"Name","value":"conversionSignupTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowDay"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowMonth"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowWeek"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowDay"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowMonth"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowWeek"}},{"kind":"Field","name":{"kind":"Name","value":"impressions"}},{"kind":"Field","name":{"kind":"Name","value":"spend"}},{"kind":"Field","name":{"kind":"Name","value":"videoFullyViewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"videoPlaysExpanded"}},{"kind":"Field","name":{"kind":"Name","value":"videoPlaysWithSound"}},{"kind":"Field","name":{"kind":"Name","value":"videoStarted"}},{"kind":"Field","name":{"kind":"Name","value":"videoViewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched100Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched10Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched25Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched3Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched50Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched5Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched75Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched95Percent"}},{"kind":"Field","name":{"kind":"Name","value":"viewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"viewerComments"}},{"kind":"Field","name":{"kind":"Name","value":"cpc"}},{"kind":"Field","name":{"kind":"Name","value":"ctr"}},{"kind":"Field","name":{"kind":"Name","value":"ecpm"}}]}}]} as unknown as DocumentNode<CountryBreakdownSuperGridListQuery, CountryBreakdownSuperGridListQueryVariables>;
export const DateBreakdownSuperGridListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dateBreakdownSuperGridList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StatsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entities"},"name":{"kind":"Name","value":"stats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"StringValue","value":"date IS NOT NULL","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"date"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSuperGridStatsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSuperGridStatsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Stats"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAddPaymentInfo"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAddToCart"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAppLaunch"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsCompletedTutorial"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsInstall"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsLevelAchieved"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSearch"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSignUp"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSpend"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSpendCredits"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsViewContent"}},{"kind":"Field","name":{"kind":"Name","value":"clicks"}},{"kind":"Field","name":{"kind":"Name","value":"commentDownvotes"}},{"kind":"Field","name":{"kind":"Name","value":"commentUpvotes"}},{"kind":"Field","name":{"kind":"Name","value":"commentsPageViews"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionLeadTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRoas"}},{"kind":"Field","name":{"kind":"Name","value":"conversionSignupTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowDay"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowMonth"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowWeek"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowDay"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowMonth"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowWeek"}},{"kind":"Field","name":{"kind":"Name","value":"impressions"}},{"kind":"Field","name":{"kind":"Name","value":"spend"}},{"kind":"Field","name":{"kind":"Name","value":"videoFullyViewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"videoPlaysExpanded"}},{"kind":"Field","name":{"kind":"Name","value":"videoPlaysWithSound"}},{"kind":"Field","name":{"kind":"Name","value":"videoStarted"}},{"kind":"Field","name":{"kind":"Name","value":"videoViewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched100Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched10Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched25Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched3Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched50Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched5Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched75Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched95Percent"}},{"kind":"Field","name":{"kind":"Name","value":"viewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"viewerComments"}},{"kind":"Field","name":{"kind":"Name","value":"cpc"}},{"kind":"Field","name":{"kind":"Name","value":"ctr"}},{"kind":"Field","name":{"kind":"Name","value":"ecpm"}}]}}]} as unknown as DocumentNode<DateBreakdownSuperGridListQuery, DateBreakdownSuperGridListQueryVariables>;
export const InterestBreakdownSuperGridListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"interestBreakdownSuperGridList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StatsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StatsOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entities"},"name":{"kind":"Name","value":"stats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"StringValue","value":"interest IS NOT NULL","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"interest"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"interest"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSuperGridStatsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSuperGridStatsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Stats"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAddPaymentInfo"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAddToCart"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAppLaunch"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsCompletedTutorial"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsInstall"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsLevelAchieved"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSearch"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSignUp"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSpend"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSpendCredits"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsViewContent"}},{"kind":"Field","name":{"kind":"Name","value":"clicks"}},{"kind":"Field","name":{"kind":"Name","value":"commentDownvotes"}},{"kind":"Field","name":{"kind":"Name","value":"commentUpvotes"}},{"kind":"Field","name":{"kind":"Name","value":"commentsPageViews"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionLeadTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRoas"}},{"kind":"Field","name":{"kind":"Name","value":"conversionSignupTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowDay"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowMonth"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowWeek"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowDay"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowMonth"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowWeek"}},{"kind":"Field","name":{"kind":"Name","value":"impressions"}},{"kind":"Field","name":{"kind":"Name","value":"spend"}},{"kind":"Field","name":{"kind":"Name","value":"videoFullyViewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"videoPlaysExpanded"}},{"kind":"Field","name":{"kind":"Name","value":"videoPlaysWithSound"}},{"kind":"Field","name":{"kind":"Name","value":"videoStarted"}},{"kind":"Field","name":{"kind":"Name","value":"videoViewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched100Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched10Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched25Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched3Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched50Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched5Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched75Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched95Percent"}},{"kind":"Field","name":{"kind":"Name","value":"viewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"viewerComments"}},{"kind":"Field","name":{"kind":"Name","value":"cpc"}},{"kind":"Field","name":{"kind":"Name","value":"ctr"}},{"kind":"Field","name":{"kind":"Name","value":"ecpm"}}]}}]} as unknown as DocumentNode<InterestBreakdownSuperGridListQuery, InterestBreakdownSuperGridListQueryVariables>;
export const RegionBreakdownSuperGridListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"regionBreakdownSuperGridList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StatsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StatsOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entities"},"name":{"kind":"Name","value":"stats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"StringValue","value":"region IS NOT NULL","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"region"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"region"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSuperGridStatsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSuperGridStatsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Stats"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAddPaymentInfo"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAddToCart"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAppLaunch"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsCompletedTutorial"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsInstall"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsLevelAchieved"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSearch"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSignUp"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSpend"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSpendCredits"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsViewContent"}},{"kind":"Field","name":{"kind":"Name","value":"clicks"}},{"kind":"Field","name":{"kind":"Name","value":"commentDownvotes"}},{"kind":"Field","name":{"kind":"Name","value":"commentUpvotes"}},{"kind":"Field","name":{"kind":"Name","value":"commentsPageViews"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionLeadTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRoas"}},{"kind":"Field","name":{"kind":"Name","value":"conversionSignupTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowDay"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowMonth"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowWeek"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowDay"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowMonth"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowWeek"}},{"kind":"Field","name":{"kind":"Name","value":"impressions"}},{"kind":"Field","name":{"kind":"Name","value":"spend"}},{"kind":"Field","name":{"kind":"Name","value":"videoFullyViewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"videoPlaysExpanded"}},{"kind":"Field","name":{"kind":"Name","value":"videoPlaysWithSound"}},{"kind":"Field","name":{"kind":"Name","value":"videoStarted"}},{"kind":"Field","name":{"kind":"Name","value":"videoViewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched100Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched10Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched25Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched3Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched50Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched5Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched75Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched95Percent"}},{"kind":"Field","name":{"kind":"Name","value":"viewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"viewerComments"}},{"kind":"Field","name":{"kind":"Name","value":"cpc"}},{"kind":"Field","name":{"kind":"Name","value":"ctr"}},{"kind":"Field","name":{"kind":"Name","value":"ecpm"}}]}}]} as unknown as DocumentNode<RegionBreakdownSuperGridListQuery, RegionBreakdownSuperGridListQueryVariables>;
export const CampaignSuperGridListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"campaignSuperGridList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statsFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StatsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entities"},"name":{"kind":"Name","value":"campaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridCampaignFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"parent"},"name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridClientFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatStats"},"name":{"kind":"Name","value":"stats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSuperGridStatsFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridCampaignFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"campaignName"}},{"kind":"Field","alias":{"kind":"Name","value":"externalId"},"name":{"kind":"Name","value":"externalCampaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"campaignHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"campaignName"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"campaignCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"updatedAt"},"name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"modificationTime"},"name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"campaignSpecialAdCategories"}},{"kind":"Field","name":{"kind":"Name","value":"campaignObjective"}},{"kind":"Field","name":{"kind":"Name","value":"campaignStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"campaignStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"statusPending"},"name":{"kind":"Name","value":"campaignStatusPending"}},{"kind":"Field","name":{"kind":"Name","value":"campaignSpendCap"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridClientFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Client"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clientPinned"}},{"kind":"Field","name":{"kind":"Name","value":"clientKpi"}},{"kind":"Field","name":{"kind":"Name","value":"clientBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientCreatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"clientProfilePicture"},"name":{"kind":"Name","value":"clientProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"profileName"}},{"kind":"Field","name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"business"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessId"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"businessWebsiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"industryId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstruments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"flatAdAccount"},"name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSuperGridStatsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Stats"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAddPaymentInfo"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAddToCart"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAppLaunch"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsCompletedTutorial"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsInstall"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsLevelAchieved"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSearch"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSignUp"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSpend"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSpendCredits"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsViewContent"}},{"kind":"Field","name":{"kind":"Name","value":"clicks"}},{"kind":"Field","name":{"kind":"Name","value":"commentDownvotes"}},{"kind":"Field","name":{"kind":"Name","value":"commentUpvotes"}},{"kind":"Field","name":{"kind":"Name","value":"commentsPageViews"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionLeadTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRoas"}},{"kind":"Field","name":{"kind":"Name","value":"conversionSignupTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowDay"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowMonth"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowWeek"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowDay"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowMonth"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowWeek"}},{"kind":"Field","name":{"kind":"Name","value":"impressions"}},{"kind":"Field","name":{"kind":"Name","value":"spend"}},{"kind":"Field","name":{"kind":"Name","value":"videoFullyViewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"videoPlaysExpanded"}},{"kind":"Field","name":{"kind":"Name","value":"videoPlaysWithSound"}},{"kind":"Field","name":{"kind":"Name","value":"videoStarted"}},{"kind":"Field","name":{"kind":"Name","value":"videoViewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched100Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched10Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched25Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched3Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched50Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched5Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched75Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched95Percent"}},{"kind":"Field","name":{"kind":"Name","value":"viewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"viewerComments"}},{"kind":"Field","name":{"kind":"Name","value":"cpc"}},{"kind":"Field","name":{"kind":"Name","value":"ctr"}},{"kind":"Field","name":{"kind":"Name","value":"ecpm"}}]}}]} as unknown as DocumentNode<CampaignSuperGridListQuery, CampaignSuperGridListQueryVariables>;
export const ClientSuperGridListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"clientSuperGridList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statsFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StatsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entities"},"name":{"kind":"Name","value":"clients"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridClientFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"flatStats"},"name":{"kind":"Name","value":"stats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSuperGridStatsFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridClientFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Client"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clientPinned"}},{"kind":"Field","name":{"kind":"Name","value":"clientKpi"}},{"kind":"Field","name":{"kind":"Name","value":"clientBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientCreatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"clientProfilePicture"},"name":{"kind":"Name","value":"clientProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"profileName"}},{"kind":"Field","name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"business"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessId"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"businessWebsiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"industryId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstruments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"flatAdAccount"},"name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSuperGridStatsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Stats"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAddPaymentInfo"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAddToCart"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAppLaunch"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsCompletedTutorial"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsInstall"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsLevelAchieved"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSearch"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSignUp"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSpend"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSpendCredits"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsViewContent"}},{"kind":"Field","name":{"kind":"Name","value":"clicks"}},{"kind":"Field","name":{"kind":"Name","value":"commentDownvotes"}},{"kind":"Field","name":{"kind":"Name","value":"commentUpvotes"}},{"kind":"Field","name":{"kind":"Name","value":"commentsPageViews"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionLeadTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRoas"}},{"kind":"Field","name":{"kind":"Name","value":"conversionSignupTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowDay"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowMonth"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowWeek"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowDay"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowMonth"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowWeek"}},{"kind":"Field","name":{"kind":"Name","value":"impressions"}},{"kind":"Field","name":{"kind":"Name","value":"spend"}},{"kind":"Field","name":{"kind":"Name","value":"videoFullyViewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"videoPlaysExpanded"}},{"kind":"Field","name":{"kind":"Name","value":"videoPlaysWithSound"}},{"kind":"Field","name":{"kind":"Name","value":"videoStarted"}},{"kind":"Field","name":{"kind":"Name","value":"videoViewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched100Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched10Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched25Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched3Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched50Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched5Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched75Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched95Percent"}},{"kind":"Field","name":{"kind":"Name","value":"viewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"viewerComments"}},{"kind":"Field","name":{"kind":"Name","value":"cpc"}},{"kind":"Field","name":{"kind":"Name","value":"ctr"}},{"kind":"Field","name":{"kind":"Name","value":"ecpm"}}]}}]} as unknown as DocumentNode<ClientSuperGridListQuery, ClientSuperGridListQueryVariables>;
export const GroupSuperGridListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"groupSuperGridList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statsFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StatsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GroupFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GroupOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entities"},"name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridGroupFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"parent"},"name":{"kind":"Name","value":"campaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridCampaignFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"parent"},"name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridClientFragment"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatStats"},"name":{"kind":"Name","value":"stats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSuperGridStatsFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"groupId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"groupName"}},{"kind":"Field","alias":{"kind":"Name","value":"externalId"},"name":{"kind":"Name","value":"externalGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"groupHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"externalGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"groupStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"statusPending"},"name":{"kind":"Name","value":"groupStatusPending"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidType"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidStrategy"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidAmount"}},{"kind":"Field","name":{"kind":"Name","value":"groupGoal"}},{"kind":"Field","name":{"kind":"Name","value":"groupGoalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"groupOptimizationGoal"}},{"kind":"Field","name":{"kind":"Name","value":"groupStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"groupEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"groupCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"groupModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"updatedAt"},"name":{"kind":"Name","value":"groupUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"modificationTime"},"name":{"kind":"Name","value":"groupModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"groupHasErrors"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"groupAppId"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargeting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"placements"},"name":{"kind":"Name","value":"groupTargetingLocations"}},{"kind":"Field","alias":{"kind":"Name","value":"gender"},"name":{"kind":"Name","value":"groupTargetingGender"}},{"kind":"Field","alias":{"kind":"Name","value":"deviceType"},"name":{"kind":"Name","value":"groupTargetingPlatforms"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesLabelMap"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOS"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOSMaxVersion"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOSMinVersion"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesType"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"communities"},"name":{"kind":"Name","value":"groupTargetingCommunities"}},{"kind":"Field","alias":{"kind":"Name","value":"communitiesExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedCommunities"}},{"kind":"Field","alias":{"kind":"Name","value":"locations"},"name":{"kind":"Name","value":"groupTargetingGeolocations"}},{"kind":"Field","alias":{"kind":"Name","value":"locationsExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedGeolocations"}},{"kind":"Field","alias":{"kind":"Name","value":"interests"},"name":{"kind":"Name","value":"groupTargetingInterests"}},{"kind":"Field","alias":{"kind":"Name","value":"keywords"},"name":{"kind":"Name","value":"groupTargetingKeywords"}},{"kind":"Field","alias":{"kind":"Name","value":"customAudiences"},"name":{"kind":"Name","value":"groupTargetingCustomAudienceIds"}},{"kind":"Field","alias":{"kind":"Name","value":"customAudiencesExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedCustomAudienceIds"}},{"kind":"Field","alias":{"kind":"Name","value":"carriers"},"name":{"kind":"Name","value":"groupTargetingCarriers"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingExcludedKeywords"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridCampaignFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"campaignName"}},{"kind":"Field","alias":{"kind":"Name","value":"externalId"},"name":{"kind":"Name","value":"externalCampaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"campaignHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"campaignName"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"campaignCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"updatedAt"},"name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"modificationTime"},"name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"campaignSpecialAdCategories"}},{"kind":"Field","name":{"kind":"Name","value":"campaignObjective"}},{"kind":"Field","name":{"kind":"Name","value":"campaignStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"campaignStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"statusPending"},"name":{"kind":"Name","value":"campaignStatusPending"}},{"kind":"Field","name":{"kind":"Name","value":"campaignSpendCap"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridClientFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Client"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clientPinned"}},{"kind":"Field","name":{"kind":"Name","value":"clientKpi"}},{"kind":"Field","name":{"kind":"Name","value":"clientBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientCreatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"clientProfilePicture"},"name":{"kind":"Name","value":"clientProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"profileName"}},{"kind":"Field","name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"business"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessId"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"businessWebsiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"industryId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstruments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"flatAdAccount"},"name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSuperGridStatsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Stats"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAddPaymentInfo"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAddToCart"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAppLaunch"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsCompletedTutorial"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsInstall"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsLevelAchieved"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSearch"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSignUp"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSpend"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSpendCredits"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsViewContent"}},{"kind":"Field","name":{"kind":"Name","value":"clicks"}},{"kind":"Field","name":{"kind":"Name","value":"commentDownvotes"}},{"kind":"Field","name":{"kind":"Name","value":"commentUpvotes"}},{"kind":"Field","name":{"kind":"Name","value":"commentsPageViews"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionLeadTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRoas"}},{"kind":"Field","name":{"kind":"Name","value":"conversionSignupTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowDay"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowMonth"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowWeek"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowDay"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowMonth"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowWeek"}},{"kind":"Field","name":{"kind":"Name","value":"impressions"}},{"kind":"Field","name":{"kind":"Name","value":"spend"}},{"kind":"Field","name":{"kind":"Name","value":"videoFullyViewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"videoPlaysExpanded"}},{"kind":"Field","name":{"kind":"Name","value":"videoPlaysWithSound"}},{"kind":"Field","name":{"kind":"Name","value":"videoStarted"}},{"kind":"Field","name":{"kind":"Name","value":"videoViewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched100Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched10Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched25Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched3Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched50Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched5Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched75Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched95Percent"}},{"kind":"Field","name":{"kind":"Name","value":"viewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"viewerComments"}},{"kind":"Field","name":{"kind":"Name","value":"cpc"}},{"kind":"Field","name":{"kind":"Name","value":"ctr"}},{"kind":"Field","name":{"kind":"Name","value":"ecpm"}}]}}]} as unknown as DocumentNode<GroupSuperGridListQuery, GroupSuperGridListQueryVariables>;
export const PixelEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"pixelEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"adAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pixelLastFiredAt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pixelId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"adAccountId"}}}]}}]}}]}]}}]} as unknown as DocumentNode<PixelEventsQuery, PixelEventsQueryVariables>;
export const UpdateClientPinnedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateClientPinned"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientPinned"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateClient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientPinned"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientPinned"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientPinned"}}]}}]}}]} as unknown as DocumentNode<UpdateClientPinnedMutation, UpdateClientPinnedMutationVariables>;
export const UploadRedditMediaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uploadRedditMedia"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"media"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MediaInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadMedia"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"media"},"value":{"kind":"Variable","name":{"kind":"Name","value":"media"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"mediaUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mediaThumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}}]}}]}}]} as unknown as DocumentNode<UploadRedditMediaMutation, UploadRedditMediaMutationVariables>;
export const UpdateClientDashboardSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateClientDashboardSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientKpi"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientBreakdown"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateClient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientKpi"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientKpi"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientBreakdown"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientBreakdown"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientKpi"}},{"kind":"Field","name":{"kind":"Name","value":"clientBreakdown"}}]}}]}}]} as unknown as DocumentNode<UpdateClientDashboardSettingsMutation, UpdateClientDashboardSettingsMutationVariables>;
export const RedditMediaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"redditMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaId"}},{"kind":"Field","name":{"kind":"Name","value":"mediaThumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"mediaUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}}]}}]}}]}}]} as unknown as DocumentNode<RedditMediaQuery, RedditMediaQueryVariables>;
export const DashboardStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dashboardStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StatsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"performerFilters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currDateFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRangeFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastDateFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRangeFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"performersSortColumn"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignOrderByColumn"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"sparklineStats"},"name":{"kind":"Name","value":"stats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"300"}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSuperGridStatsFragment"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"bestPerformers"},"name":{"kind":"Name","value":"campaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"performerFilters"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"3"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"Variable","name":{"kind":"Name","value":"performersSortColumn"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"StringValue","value":"impressions > 0","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"campaignName"}},{"kind":"Field","alias":{"kind":"Name","value":"lastStats"},"name":{"kind":"Name","value":"stats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastDateFilter"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"StringValue","value":"impressions IS NOT NULL","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSuperGridStatsFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currStats"},"name":{"kind":"Name","value":"stats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currDateFilter"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"StringValue","value":"impressions IS NOT NULL","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSuperGridStatsFragment"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"worstPerformers"},"name":{"kind":"Name","value":"campaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"performerFilters"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"3"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"Variable","name":{"kind":"Name","value":"performersSortColumn"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"StringValue","value":"impressions > 0","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"campaignName"}},{"kind":"Field","alias":{"kind":"Name","value":"lastStats"},"name":{"kind":"Name","value":"stats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastDateFilter"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSuperGridStatsFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currStats"},"name":{"kind":"Name","value":"stats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currDateFilter"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSuperGridStatsFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSuperGridStatsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Stats"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAddPaymentInfo"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAddToCart"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsAppLaunch"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsCompletedTutorial"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsInstall"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsLevelAchieved"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsPurchase"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSearch"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSignUp"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSpend"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsSpendCredits"}},{"kind":"Field","name":{"kind":"Name","value":"appInstallMetricsViewContent"}},{"kind":"Field","name":{"kind":"Name","value":"clicks"}},{"kind":"Field","name":{"kind":"Name","value":"commentDownvotes"}},{"kind":"Field","name":{"kind":"Name","value":"commentUpvotes"}},{"kind":"Field","name":{"kind":"Name","value":"commentsPageViews"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToCartTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionAddToWishlistTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionLeadTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseAvgValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseTotalItems"}},{"kind":"Field","name":{"kind":"Name","value":"conversionPurchaseTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRoas"}},{"kind":"Field","name":{"kind":"Name","value":"conversionSignupTotalValue"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowDay"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowMonth"}},{"kind":"Field","name":{"kind":"Name","value":"customClickThroughConversionsAttributionWindowWeek"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowDay"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowMonth"}},{"kind":"Field","name":{"kind":"Name","value":"customViewThroughConversionsAttributionWindowWeek"}},{"kind":"Field","name":{"kind":"Name","value":"impressions"}},{"kind":"Field","name":{"kind":"Name","value":"spend"}},{"kind":"Field","name":{"kind":"Name","value":"videoFullyViewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"videoPlaysExpanded"}},{"kind":"Field","name":{"kind":"Name","value":"videoPlaysWithSound"}},{"kind":"Field","name":{"kind":"Name","value":"videoStarted"}},{"kind":"Field","name":{"kind":"Name","value":"videoViewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched100Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched10Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched25Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched3Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched50Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched5Seconds"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched75Percent"}},{"kind":"Field","name":{"kind":"Name","value":"videoWatched95Percent"}},{"kind":"Field","name":{"kind":"Name","value":"viewableImpressions"}},{"kind":"Field","name":{"kind":"Name","value":"viewerComments"}},{"kind":"Field","name":{"kind":"Name","value":"cpc"}},{"kind":"Field","name":{"kind":"Name","value":"ctr"}},{"kind":"Field","name":{"kind":"Name","value":"ecpm"}}]}}]} as unknown as DocumentNode<DashboardStatsQuery, DashboardStatsQueryVariables>;
export const ClientAccessOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"clientAccessOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailSearch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupSearch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userSearch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userLevel"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserAccountLevel"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedGroupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedGroupIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"exclude"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupOwnerEmail"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"emailSearch"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"groupSearch"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userGroupName"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"users"},"name":{"kind":"Name","value":"searchUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userEmail"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userSearch"}}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userAccountLevel"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userLevel"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePicture"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userFullName"}}]}}]}}]} as unknown as DocumentNode<ClientAccessOptionsQuery, ClientAccessOptionsQueryVariables>;
export const CancelUserToClientInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cancelUserToClientInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hash"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resolvePendingInvite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pendingInviteAction"},"value":{"kind":"EnumValue","value":"DECLINE"}},{"kind":"Argument","name":{"kind":"Name","value":"pendingInviteHash"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hash"}}}]}]}}]} as unknown as DocumentNode<CancelUserToClientInvitationMutation, CancelUserToClientInvitationMutationVariables>;
export const AdAccountIndustriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"adAccountIndustries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"industryId"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"industries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"industryId"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"industryId"}}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"industryId"}},{"kind":"Field","name":{"kind":"Name","value":"industryName"}}]}}]}}]}}]} as unknown as DocumentNode<AdAccountIndustriesQuery, AdAccountIndustriesQueryVariables>;
export const LinkUserGroupsToClientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"linkUserGroupsToClient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkUserGroupsToClient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridClientFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridClientFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Client"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clientPinned"}},{"kind":"Field","name":{"kind":"Name","value":"clientKpi"}},{"kind":"Field","name":{"kind":"Name","value":"clientBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientCreatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"clientProfilePicture"},"name":{"kind":"Name","value":"clientProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"profileName"}},{"kind":"Field","name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"business"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessId"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"businessWebsiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"industryId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstruments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"flatAdAccount"},"name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]}}]} as unknown as DocumentNode<LinkUserGroupsToClientMutation, LinkUserGroupsToClientMutationVariables>;
export const LinkUsersToClientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"linkUsersToClient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkUsersToClient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridClientFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridClientFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Client"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clientPinned"}},{"kind":"Field","name":{"kind":"Name","value":"clientKpi"}},{"kind":"Field","name":{"kind":"Name","value":"clientBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientCreatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"clientProfilePicture"},"name":{"kind":"Name","value":"clientProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"profileName"}},{"kind":"Field","name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"business"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessId"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"businessWebsiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"industryId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstruments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"flatAdAccount"},"name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]}}]} as unknown as DocumentNode<LinkUsersToClientMutation, LinkUsersToClientMutationVariables>;
export const RevokeGroupAccessToClientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"revokeGroupAccessToClient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unlinkUserGroupsFromClient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridClientFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridClientFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Client"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clientPinned"}},{"kind":"Field","name":{"kind":"Name","value":"clientKpi"}},{"kind":"Field","name":{"kind":"Name","value":"clientBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientCreatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"clientProfilePicture"},"name":{"kind":"Name","value":"clientProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"profileName"}},{"kind":"Field","name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"business"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessId"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"businessWebsiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"industryId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstruments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"flatAdAccount"},"name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]}}]} as unknown as DocumentNode<RevokeGroupAccessToClientMutation, RevokeGroupAccessToClientMutationVariables>;
export const RevokeUserAccessToClientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"revokeUserAccessToClient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unlinkUsersFromClient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridClientFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridClientFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Client"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clientPinned"}},{"kind":"Field","name":{"kind":"Name","value":"clientKpi"}},{"kind":"Field","name":{"kind":"Name","value":"clientBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientCreatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"clientProfilePicture"},"name":{"kind":"Name","value":"clientProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"profileName"}},{"kind":"Field","name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"business"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessId"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"businessWebsiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"industryId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstruments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"flatAdAccount"},"name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]}}]} as unknown as DocumentNode<RevokeUserAccessToClientMutation, RevokeUserAccessToClientMutationVariables>;
export const UpdateRedditClientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateRedditClient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profilePicture"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFile"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateClient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientProfilePicture"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profilePicture"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridClientFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridClientFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Client"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clientPinned"}},{"kind":"Field","name":{"kind":"Name","value":"clientKpi"}},{"kind":"Field","name":{"kind":"Name","value":"clientBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientCreatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"clientProfilePicture"},"name":{"kind":"Name","value":"clientProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"profileName"}},{"kind":"Field","name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"business"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessId"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"businessWebsiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"industryId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstruments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"flatAdAccount"},"name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateRedditClientMutation, UpdateRedditClientMutationVariables>;
export const CampaignAddEntityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"campaignAddEntity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entities"},"name":{"kind":"Name","value":"campaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridCampaignFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"parent"},"name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridClientFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridCampaignFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"campaignName"}},{"kind":"Field","alias":{"kind":"Name","value":"externalId"},"name":{"kind":"Name","value":"externalCampaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"campaignHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"campaignName"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"campaignCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"updatedAt"},"name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"modificationTime"},"name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"campaignSpecialAdCategories"}},{"kind":"Field","name":{"kind":"Name","value":"campaignObjective"}},{"kind":"Field","name":{"kind":"Name","value":"campaignStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"campaignStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"statusPending"},"name":{"kind":"Name","value":"campaignStatusPending"}},{"kind":"Field","name":{"kind":"Name","value":"campaignSpendCap"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridClientFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Client"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clientPinned"}},{"kind":"Field","name":{"kind":"Name","value":"clientKpi"}},{"kind":"Field","name":{"kind":"Name","value":"clientBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientCreatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"clientProfilePicture"},"name":{"kind":"Name","value":"clientProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"profileName"}},{"kind":"Field","name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"business"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessId"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"businessWebsiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"industryId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstruments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"flatAdAccount"},"name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]}}]} as unknown as DocumentNode<CampaignAddEntityQuery, CampaignAddEntityQueryVariables>;
export const ClientAddEntityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"clientAddEntity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entities"},"name":{"kind":"Name","value":"clients"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridClientFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridClientFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Client"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clientPinned"}},{"kind":"Field","name":{"kind":"Name","value":"clientKpi"}},{"kind":"Field","name":{"kind":"Name","value":"clientBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientCreatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"clientProfilePicture"},"name":{"kind":"Name","value":"clientProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"profileName"}},{"kind":"Field","name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"business"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessId"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"businessWebsiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"industryId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstruments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"flatAdAccount"},"name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]}}]} as unknown as DocumentNode<ClientAddEntityQuery, ClientAddEntityQueryVariables>;
export const GroupAddEntityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"groupAddEntity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GroupFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entities"},"name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridGroupFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"parent"},"name":{"kind":"Name","value":"campaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridCampaignFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"parent"},"name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridClientFragment"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"groupId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"groupName"}},{"kind":"Field","alias":{"kind":"Name","value":"externalId"},"name":{"kind":"Name","value":"externalGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"groupHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"externalGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"groupStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"statusPending"},"name":{"kind":"Name","value":"groupStatusPending"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidType"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidStrategy"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidAmount"}},{"kind":"Field","name":{"kind":"Name","value":"groupGoal"}},{"kind":"Field","name":{"kind":"Name","value":"groupGoalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"groupOptimizationGoal"}},{"kind":"Field","name":{"kind":"Name","value":"groupStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"groupEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"groupCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"groupModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"updatedAt"},"name":{"kind":"Name","value":"groupUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"modificationTime"},"name":{"kind":"Name","value":"groupModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"groupHasErrors"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"groupAppId"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargeting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"placements"},"name":{"kind":"Name","value":"groupTargetingLocations"}},{"kind":"Field","alias":{"kind":"Name","value":"gender"},"name":{"kind":"Name","value":"groupTargetingGender"}},{"kind":"Field","alias":{"kind":"Name","value":"deviceType"},"name":{"kind":"Name","value":"groupTargetingPlatforms"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesLabelMap"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOS"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOSMaxVersion"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOSMinVersion"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesType"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"communities"},"name":{"kind":"Name","value":"groupTargetingCommunities"}},{"kind":"Field","alias":{"kind":"Name","value":"communitiesExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedCommunities"}},{"kind":"Field","alias":{"kind":"Name","value":"locations"},"name":{"kind":"Name","value":"groupTargetingGeolocations"}},{"kind":"Field","alias":{"kind":"Name","value":"locationsExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedGeolocations"}},{"kind":"Field","alias":{"kind":"Name","value":"interests"},"name":{"kind":"Name","value":"groupTargetingInterests"}},{"kind":"Field","alias":{"kind":"Name","value":"keywords"},"name":{"kind":"Name","value":"groupTargetingKeywords"}},{"kind":"Field","alias":{"kind":"Name","value":"customAudiences"},"name":{"kind":"Name","value":"groupTargetingCustomAudienceIds"}},{"kind":"Field","alias":{"kind":"Name","value":"customAudiencesExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedCustomAudienceIds"}},{"kind":"Field","alias":{"kind":"Name","value":"carriers"},"name":{"kind":"Name","value":"groupTargetingCarriers"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingExcludedKeywords"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridCampaignFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"campaignName"}},{"kind":"Field","alias":{"kind":"Name","value":"externalId"},"name":{"kind":"Name","value":"externalCampaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"campaignHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"campaignName"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"campaignCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"updatedAt"},"name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"modificationTime"},"name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"campaignSpecialAdCategories"}},{"kind":"Field","name":{"kind":"Name","value":"campaignObjective"}},{"kind":"Field","name":{"kind":"Name","value":"campaignStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"campaignStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"statusPending"},"name":{"kind":"Name","value":"campaignStatusPending"}},{"kind":"Field","name":{"kind":"Name","value":"campaignSpendCap"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridClientFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Client"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clientPinned"}},{"kind":"Field","name":{"kind":"Name","value":"clientKpi"}},{"kind":"Field","name":{"kind":"Name","value":"clientBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientCreatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"clientProfilePicture"},"name":{"kind":"Name","value":"clientProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"profileName"}},{"kind":"Field","name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"business"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessId"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"businessWebsiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"industryId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstruments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"flatAdAccount"},"name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]}}]} as unknown as DocumentNode<GroupAddEntityQuery, GroupAddEntityQueryVariables>;
export const CreateRedditAdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createRedditAds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ads"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAdInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ads"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ads"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"adId"}},{"kind":"Field","name":{"kind":"Name","value":"adId"}},{"kind":"Field","name":{"kind":"Name","value":"adHash"}}]}}]}}]} as unknown as DocumentNode<CreateRedditAdsMutation, CreateRedditAdsMutationVariables>;
export const CreateRedditCampaignDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createRedditCampaign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaigns"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCampaignInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"campaigns"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaigns"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"campaignHash"}}]}}]}}]} as unknown as DocumentNode<CreateRedditCampaignMutation, CreateRedditCampaignMutationVariables>;
export const CreateRedditCreativesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createRedditCreatives"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"creatives"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCreativeInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCreatives"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"creatives"},"value":{"kind":"Variable","name":{"kind":"Name","value":"creatives"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"creativeId"}},{"kind":"Field","name":{"kind":"Name","value":"creativeId"}},{"kind":"Field","name":{"kind":"Name","value":"creativeHash"}}]}}]}}]} as unknown as DocumentNode<CreateRedditCreativesMutation, CreateRedditCreativesMutationVariables>;
export const CreateRedditGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createRedditGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groups"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateGroupInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groups"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupHash"}}]}}]}}]} as unknown as DocumentNode<CreateRedditGroupsMutation, CreateRedditGroupsMutationVariables>;
export const OpenAiHeadlinesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"openAiHeadlines"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"count"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"prompt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openAiHeadlines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"count"},"value":{"kind":"Variable","name":{"kind":"Name","value":"count"}}},{"kind":"Argument","name":{"kind":"Name","value":"prompt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"prompt"}}}]}]}}]} as unknown as DocumentNode<OpenAiHeadlinesQuery, OpenAiHeadlinesQueryVariables>;
export const RedditCarrierTargetingLabelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"redditCarrierTargetingLabels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"carrierIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetingCarriers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetingCarrierId"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"carrierIds"}}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"targetingCarrierId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"targetingCarrierName"}}]}}]}}]}}]} as unknown as DocumentNode<RedditCarrierTargetingLabelsQuery, RedditCarrierTargetingLabelsQueryVariables>;
export const CarrierOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"carrierOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"options"},"name":{"kind":"Name","value":"targetingCarriers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetingCarrierName"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"search"}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"country"},"name":{"kind":"Name","value":"targetingCarrierCountryCode"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"targetingCarrierId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"targetingCarrierName"}}]}}]}}]}}]} as unknown as DocumentNode<CarrierOptionsQuery, CarrierOptionsQueryVariables>;
export const CommunityOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"communityOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"exclude"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"options"},"name":{"kind":"Name","value":"targetingCommunities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetingCommunityName"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"search"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exclude"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"exclude"}}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"targetingCommunitySubscriberCount"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"subs"},"name":{"kind":"Name","value":"targetingCommunitySubscriberCount"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"targetingCommunityName"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"targetingCommunityName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]} as unknown as DocumentNode<CommunityOptionsQuery, CommunityOptionsQueryVariables>;
export const RedditCommunityLabelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"redditCommunityLabels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"communityIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetingCommunities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetingCommunityName"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"communityIds"}}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"subs"},"name":{"kind":"Name","value":"targetingCommunitySubscriberCount"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"targetingCommunityName"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"targetingCommunityName"}}]}}]}}]}}]} as unknown as DocumentNode<RedditCommunityLabelsQuery, RedditCommunityLabelsQueryVariables>;
export const RedditCustomAudienceLabelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"redditCustomAudienceLabels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalAudienceId"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audiences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"externalAudienceId"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalAudienceId"}}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"audienceType"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"externalAudienceId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"audienceName"}}]}}]}}]}}]} as unknown as DocumentNode<RedditCustomAudienceLabelsQuery, RedditCustomAudienceLabelsQueryVariables>;
export const RedditCustomAudienceOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"redditCustomAudienceOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"adAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"options"},"name":{"kind":"Name","value":"audiences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"adAccountId"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"adAccountId"}}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"audienceName"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"search"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"audienceType"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"externalAudienceId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"audienceName"}}]}}]}}]}}]} as unknown as DocumentNode<RedditCustomAudienceOptionsQuery, RedditCustomAudienceOptionsQueryVariables>;
export const RedditDeviceLabelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"redditDeviceLabels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetingDevices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetingDeviceModel"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceIds"}}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"make"},"name":{"kind":"Name","value":"targetingDeviceMake"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"targetingDeviceModel"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"targetingDeviceModel"}}]}}]}}]}}]} as unknown as DocumentNode<RedditDeviceLabelsQuery, RedditDeviceLabelsQueryVariables>;
export const DeviceOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"deviceOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"options"},"name":{"kind":"Name","value":"targetingDevices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetingDeviceModel"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"search"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"make"},"name":{"kind":"Name","value":"targetingDeviceMake"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"targetingDeviceModel"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"targetingDeviceModel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]} as unknown as DocumentNode<DeviceOptionsQuery, DeviceOptionsQueryVariables>;
export const RedditInterestTargetingLabelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"redditInterestTargetingLabels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interestIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetingInterests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetingInterestId"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interestIds"}}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"targetingInterestName"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"targetingInterestId"}}]}}]}}]}}]} as unknown as DocumentNode<RedditInterestTargetingLabelsQuery, RedditInterestTargetingLabelsQueryVariables>;
export const InterestOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"interestOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"options"},"name":{"kind":"Name","value":"targetingInterests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetingInterestName"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"search"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"200"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"category"},"name":{"kind":"Name","value":"targetingInterestCategory"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"targetingInterestId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"targetingInterestName"}}]}}]}}]}}]} as unknown as DocumentNode<InterestOptionsQuery, InterestOptionsQueryVariables>;
export const RedditLocationTargetingLabelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"redditLocationTargetingLabels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationNames"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetingGeolocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetingGeolocationId"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationIds"}}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"country"},"name":{"kind":"Name","value":"targetingGeolocationCountry"}},{"kind":"Field","alias":{"kind":"Name","value":"region"},"name":{"kind":"Name","value":"targetingGeolocationRegion"}},{"kind":"Field","alias":{"kind":"Name","value":"dma"},"name":{"kind":"Name","value":"targetingGeolocationDma"}},{"kind":"Field","alias":{"kind":"Name","value":"postalCode"},"name":{"kind":"Name","value":"targetingGeolocationPostalCode"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"targetingGeolocationName"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"targetingGeolocationId"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"targetingGeolocationsByLabel"},"name":{"kind":"Name","value":"targetingGeolocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetingGeolocationName"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationNames"}}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"country"},"name":{"kind":"Name","value":"targetingGeolocationCountry"}},{"kind":"Field","alias":{"kind":"Name","value":"region"},"name":{"kind":"Name","value":"targetingGeolocationRegion"}},{"kind":"Field","alias":{"kind":"Name","value":"dma"},"name":{"kind":"Name","value":"targetingGeolocationDma"}},{"kind":"Field","alias":{"kind":"Name","value":"postalCode"},"name":{"kind":"Name","value":"targetingGeolocationPostalCode"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"targetingGeolocationName"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"targetingGeolocationId"}}]}}]}}]}}]} as unknown as DocumentNode<RedditLocationTargetingLabelsQuery, RedditLocationTargetingLabelsQueryVariables>;
export const LocationOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"locationOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"options"},"name":{"kind":"Name","value":"targetingGeolocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetingGeolocationName"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"search"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"country"},"name":{"kind":"Name","value":"targetingGeolocationCountry"}},{"kind":"Field","alias":{"kind":"Name","value":"region"},"name":{"kind":"Name","value":"targetingGeolocationRegion"}},{"kind":"Field","alias":{"kind":"Name","value":"dma"},"name":{"kind":"Name","value":"targetingGeolocationDma"}},{"kind":"Field","alias":{"kind":"Name","value":"postalCode"},"name":{"kind":"Name","value":"targetingGeolocationPostalCode"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"targetingGeolocationId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"targetingGeolocationName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]} as unknown as DocumentNode<LocationOptionsQuery, LocationOptionsQueryVariables>;
export const RedditTargetingLabelsByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"redditTargetingLabelsById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"communityIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interestIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"carrierIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"audienceIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetingGeolocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetingGeolocationId"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationIds"}}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"targetingGeolocationId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"targetingGeolocationName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetingCommunities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetingCommunityName"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"communityIds"}}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"targetingCommunityName"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"targetingCommunityName"}},{"kind":"Field","alias":{"kind":"Name","value":"subs"},"name":{"kind":"Name","value":"targetingCommunitySubscriberCount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetingInterests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetingInterestId"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interestIds"}}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"targetingInterestId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"targetingInterestName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetingCarriers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetingCarrierId"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"carrierIds"}}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"targetingCarrierId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"targetingCarrierName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"audiences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"externalAudienceId"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"audienceIds"}}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"audienceType"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"externalAudienceId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"audienceName"}}]}}]}}]}}]} as unknown as DocumentNode<RedditTargetingLabelsByIdQuery, RedditTargetingLabelsByIdQueryVariables>;
export const AgencyAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"agencyAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencyAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"agencyAccountName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"search"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}}]}}]}}]}}]} as unknown as DocumentNode<AgencyAccountsQuery, AgencyAccountsQueryVariables>;
export const CreateOAuthAdAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createOAuthAdAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"businessId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"adAccountIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAdAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"businessId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"businessId"}}},{"kind":"Argument","name":{"kind":"Name","value":"adAccountIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"adAccountIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"agencyAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agencyAccountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"adAccountId"}}]}}]}}]} as unknown as DocumentNode<CreateOAuthAdAccountsMutation, CreateOAuthAdAccountsMutationVariables>;
export const OauthAdAccountsByBusinessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"oauthAdAccountsByBusiness"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountsByBusinessLive"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"memberId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessId"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"adAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountExists"}}]}}]}}]}}]} as unknown as DocumentNode<OauthAdAccountsByBusinessQuery, OauthAdAccountsByBusinessQueryVariables>;
export const ClientSearchOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"clientSearchOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"options"},"name":{"kind":"Name","value":"clients"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"adAccountName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"search"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}}]}}]}}]}}]} as unknown as DocumentNode<ClientSearchOptionsQuery, ClientSearchOptionsQueryVariables>;
export const RedditClientOptionsByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"redditClientOptionsById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clients"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"clientId"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientIds"}}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"adAccountName"}}]}}]}}]}}]} as unknown as DocumentNode<RedditClientOptionsByIdQuery, RedditClientOptionsByIdQueryVariables>;
export const CreateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"credentials"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCredentialInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAccountLevel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUserAccountLevel"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userCompanyName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Email"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIsActivated"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userSurname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"credentials"},"value":{"kind":"Variable","name":{"kind":"Name","value":"credentials"}}},{"kind":"Argument","name":{"kind":"Name","value":"userAccountLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAccountLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"userCompanyName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userCompanyName"}}},{"kind":"Argument","name":{"kind":"Name","value":"userEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userEmail"}}},{"kind":"Argument","name":{"kind":"Name","value":"userIsActivated"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIsActivated"}}},{"kind":"Argument","name":{"kind":"Name","value":"userName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userName"}}},{"kind":"Argument","name":{"kind":"Name","value":"userSurname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userSurname"}}},{"kind":"Argument","name":{"kind":"Name","value":"userHasAgreedToTerms"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}}]}}]} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const EditRedditUserAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editRedditUserAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<EditRedditUserAccessMutation, EditRedditUserAccessMutationVariables>;
export const RedditUsersWithAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"redditUsersWithAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userEmail"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"email"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAccessEntityId"}},{"kind":"Field","name":{"kind":"Name","value":"userAccessAccessType"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RedditUsersWithAccessQuery, RedditUsersWithAccessQueryVariables>;
export const UpdateEntitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateEntities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignChanges"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCampaignInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupChanges"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateGroupInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"adChanges"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAdInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"creativeChanges"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCreativeInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"campaignUpdates"},"name":{"kind":"Name","value":"updateCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"campaigns"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignChanges"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridCampaignFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"groupUpdates"},"name":{"kind":"Name","value":"updateGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupChanges"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridGroupFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"adUpdates"},"name":{"kind":"Name","value":"updateAds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ads"},"value":{"kind":"Variable","name":{"kind":"Name","value":"adChanges"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridAdFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"creativeUpdates"},"name":{"kind":"Name","value":"updateCreatives"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"creatives"},"value":{"kind":"Variable","name":{"kind":"Name","value":"creativeChanges"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creativeId"}},{"kind":"Field","name":{"kind":"Name","value":"creativePostUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeHeadline"}},{"kind":"Field","name":{"kind":"Name","value":"creativeThumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeAllowComments"}},{"kind":"Field","name":{"kind":"Name","value":"creativeType"}},{"kind":"Field","name":{"kind":"Name","value":"creativeHash"}},{"kind":"Field","name":{"kind":"Name","value":"externalCreativeId"}},{"kind":"Field","name":{"kind":"Name","value":"creativeHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"profileName"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatText"},"name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"creativeText"},"name":{"kind":"Name","value":"textValue"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatCreativeContent"},"name":{"kind":"Name","value":"creativeContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creativeContentId"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentCallToAction"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentDestinationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentDisplayUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentMediaUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentCaption"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"groupId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"groupName"}},{"kind":"Field","alias":{"kind":"Name","value":"externalId"},"name":{"kind":"Name","value":"externalGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"groupHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"externalGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"groupStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"statusPending"},"name":{"kind":"Name","value":"groupStatusPending"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidType"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidStrategy"}},{"kind":"Field","name":{"kind":"Name","value":"groupBidAmount"}},{"kind":"Field","name":{"kind":"Name","value":"groupGoal"}},{"kind":"Field","name":{"kind":"Name","value":"groupGoalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"groupOptimizationGoal"}},{"kind":"Field","name":{"kind":"Name","value":"groupStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"groupEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"groupCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"groupModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"updatedAt"},"name":{"kind":"Name","value":"groupUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"modificationTime"},"name":{"kind":"Name","value":"groupModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"groupHasErrors"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"groupAppId"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargeting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"placements"},"name":{"kind":"Name","value":"groupTargetingLocations"}},{"kind":"Field","alias":{"kind":"Name","value":"gender"},"name":{"kind":"Name","value":"groupTargetingGender"}},{"kind":"Field","alias":{"kind":"Name","value":"deviceType"},"name":{"kind":"Name","value":"groupTargetingPlatforms"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesLabelMap"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOS"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOSMaxVersion"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesOSMinVersion"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingDevicesType"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"communities"},"name":{"kind":"Name","value":"groupTargetingCommunities"}},{"kind":"Field","alias":{"kind":"Name","value":"communitiesExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedCommunities"}},{"kind":"Field","alias":{"kind":"Name","value":"locations"},"name":{"kind":"Name","value":"groupTargetingGeolocations"}},{"kind":"Field","alias":{"kind":"Name","value":"locationsExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedGeolocations"}},{"kind":"Field","alias":{"kind":"Name","value":"interests"},"name":{"kind":"Name","value":"groupTargetingInterests"}},{"kind":"Field","alias":{"kind":"Name","value":"keywords"},"name":{"kind":"Name","value":"groupTargetingKeywords"}},{"kind":"Field","alias":{"kind":"Name","value":"customAudiences"},"name":{"kind":"Name","value":"groupTargetingCustomAudienceIds"}},{"kind":"Field","alias":{"kind":"Name","value":"customAudiencesExcluded"},"name":{"kind":"Name","value":"groupTargetingExcludedCustomAudienceIds"}},{"kind":"Field","alias":{"kind":"Name","value":"carriers"},"name":{"kind":"Name","value":"groupTargetingCarriers"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"groupTargetingExcludedKeywords"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridCampaignFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"campaignName"}},{"kind":"Field","alias":{"kind":"Name","value":"externalId"},"name":{"kind":"Name","value":"externalCampaignId"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"campaignHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"campaignName"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"campaignCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"updatedAt"},"name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"modificationTime"},"name":{"kind":"Name","value":"campaignUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"campaignSpecialAdCategories"}},{"kind":"Field","name":{"kind":"Name","value":"campaignObjective"}},{"kind":"Field","name":{"kind":"Name","value":"campaignStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"campaignStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"statusPending"},"name":{"kind":"Name","value":"campaignStatusPending"}},{"kind":"Field","name":{"kind":"Name","value":"campaignSpendCap"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridClientFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Client"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clientPinned"}},{"kind":"Field","name":{"kind":"Name","value":"clientKpi"}},{"kind":"Field","name":{"kind":"Name","value":"clientBreakdown"}},{"kind":"Field","name":{"kind":"Name","value":"clientStatus"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientCreatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"clientProfilePicture"},"name":{"kind":"Name","value":"clientProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"profileName"}},{"kind":"Field","name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"business"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessId"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"businessWebsiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"industryId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstruments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"fundingInstrumentName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccountActivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"agencyIsOwner"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","alias":{"kind":"Name","value":"flatAdAccount"},"name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adAccountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientPendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"redditSupergridAdFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Ad"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"adId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"adName"}},{"kind":"Field","alias":{"kind":"Name","value":"externalId"},"name":{"kind":"Name","value":"externalAdId"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"adHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"adId"}},{"kind":"Field","name":{"kind":"Name","value":"adName"}},{"kind":"Field","name":{"kind":"Name","value":"adCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"adModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"modificationTime"},"name":{"kind":"Name","value":"adModificationTime"}},{"kind":"Field","alias":{"kind":"Name","value":"updatedAt"},"name":{"kind":"Name","value":"adUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"hasErrors"},"name":{"kind":"Name","value":"adHasErrors"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"adStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"statusPending"},"name":{"kind":"Name","value":"adStatusPending"}},{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"adEventTrackers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"parent"},"name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridGroupFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"parent"},"name":{"kind":"Name","value":"campaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridCampaignFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"parent"},"name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"redditSupergridClientFragment"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatCreative"},"name":{"kind":"Name","value":"creative"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creativeId"}},{"kind":"Field","name":{"kind":"Name","value":"creativePostUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeHeadline"}},{"kind":"Field","name":{"kind":"Name","value":"creativeThumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeAllowComments"}},{"kind":"Field","name":{"kind":"Name","value":"creativeType"}},{"kind":"Field","name":{"kind":"Name","value":"externalCreativeId"}},{"kind":"Field","name":{"kind":"Name","value":"creativeHasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"profileId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"profileName"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatText"},"name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"creativeText"},"name":{"kind":"Name","value":"textValue"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatCreativeContent"},"name":{"kind":"Name","value":"creativeContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creativeContentId"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentCallToAction"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentDestinationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentDisplayUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentMediaUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creativeContentCaption"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flatClient"},"name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"flatAdAccount"},"name":{"kind":"Name","value":"adAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"currency"},"name":{"kind":"Name","value":"adAccountCurrency"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateEntitiesMutation, UpdateEntitiesMutationVariables>;
export const CancelUserInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cancelUserInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pendingInviteHash"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resolvePendingInvite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pendingInviteAction"},"value":{"kind":"EnumValue","value":"DECLINE"}},{"kind":"Argument","name":{"kind":"Name","value":"pendingInviteHash"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pendingInviteHash"}}}]}]}}]} as unknown as DocumentNode<CancelUserInvitationMutation, CancelUserInvitationMutationVariables>;
export const CreateUserGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createUserGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupProfilePicture"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFile"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"salesforceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userGroupName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupName"}}},{"kind":"Argument","name":{"kind":"Name","value":"userGroupProfilePicture"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupProfilePicture"}}},{"kind":"Argument","name":{"kind":"Name","value":"salesforceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"salesforceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RedditUserGroupFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedditUserGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"userGroupProfilePicture"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupType"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userTwoFactorAuthenticationEnabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"clientName"}},{"kind":"Field","alias":{"kind":"Name","value":"secondaryName"},"name":{"kind":"Name","value":"adAccountName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"clientName"}},{"kind":"Field","alias":{"kind":"Name","value":"secondaryName"},"name":{"kind":"Name","value":"adAccountName"}}]}}]}}]}}]} as unknown as DocumentNode<CreateUserGroupMutation, CreateUserGroupMutationVariables>;
export const DeleteUserGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteUserGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUserGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}}}]}]}}]} as unknown as DocumentNode<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>;
export const RedditUserGroupsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"redditUserGroupsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupName"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"search"}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"userGroupId"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RedditUserGroupFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedditUserGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"userGroupProfilePicture"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupType"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userTwoFactorAuthenticationEnabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"clientName"}},{"kind":"Field","alias":{"kind":"Name","value":"secondaryName"},"name":{"kind":"Name","value":"adAccountName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"clientName"}},{"kind":"Field","alias":{"kind":"Name","value":"secondaryName"},"name":{"kind":"Name","value":"adAccountName"}}]}}]}}]}}]} as unknown as DocumentNode<RedditUserGroupsListQuery, RedditUserGroupsListQueryVariables>;
export const InviteUserToGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"inviteUserToGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkUsersToUserGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"userGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RedditUserGroupFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedditUserGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"userGroupProfilePicture"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupType"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userTwoFactorAuthenticationEnabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"clientName"}},{"kind":"Field","alias":{"kind":"Name","value":"secondaryName"},"name":{"kind":"Name","value":"adAccountName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"clientName"}},{"kind":"Field","alias":{"kind":"Name","value":"secondaryName"},"name":{"kind":"Name","value":"adAccountName"}}]}}]}}]}}]} as unknown as DocumentNode<InviteUserToGroupMutation, InviteUserToGroupMutationVariables>;
export const RevokeUserFromGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"revokeUserFromGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unlinkUsersFromUserGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"userGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RedditUserGroupFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedditUserGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"userGroupProfilePicture"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupType"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userTwoFactorAuthenticationEnabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"clientName"}},{"kind":"Field","alias":{"kind":"Name","value":"secondaryName"},"name":{"kind":"Name","value":"adAccountName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"clientName"}},{"kind":"Field","alias":{"kind":"Name","value":"secondaryName"},"name":{"kind":"Name","value":"adAccountName"}}]}}]}}]}}]} as unknown as DocumentNode<RevokeUserFromGroupMutation, RevokeUserFromGroupMutationVariables>;
export const TransferTeamOwnershipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"transferTeamOwnership"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transferUserGroupOwnership"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RedditUserGroupFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedditUserGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"userGroupProfilePicture"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupType"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userTwoFactorAuthenticationEnabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"clientName"}},{"kind":"Field","alias":{"kind":"Name","value":"secondaryName"},"name":{"kind":"Name","value":"adAccountName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"clientName"}},{"kind":"Field","alias":{"kind":"Name","value":"secondaryName"},"name":{"kind":"Name","value":"adAccountName"}}]}}]}}]}}]} as unknown as DocumentNode<TransferTeamOwnershipMutation, TransferTeamOwnershipMutationVariables>;
export const UpdateUserGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUserGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupProfilePicture"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFile"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"salesforceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userGroupName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupName"}}},{"kind":"Argument","name":{"kind":"Name","value":"userGroupProfilePicture"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupProfilePicture"}}},{"kind":"Argument","name":{"kind":"Name","value":"salesforceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"salesforceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RedditUserGroupFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedditUserGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"userGroupProfilePicture"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupType"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userTwoFactorAuthenticationEnabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"clientName"}},{"kind":"Field","alias":{"kind":"Name","value":"secondaryName"},"name":{"kind":"Name","value":"adAccountName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"clientName"}},{"kind":"Field","alias":{"kind":"Name","value":"secondaryName"},"name":{"kind":"Name","value":"adAccountName"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserGroupMutation, UpdateUserGroupMutationVariables>;
export const UpdateUserGroupUserRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUserGroupUserRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userRole"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserGroupRoleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserGroupUserRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userRole"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userRole"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RedditUserGroupFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedditUserGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"userGroupProfilePicture"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupType"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userTwoFactorAuthenticationEnabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupPendingInviteHash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"clientName"}},{"kind":"Field","alias":{"kind":"Name","value":"secondaryName"},"name":{"kind":"Name","value":"adAccountName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agencyAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"agencyAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"agencyAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"clientId"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"clientName"}},{"kind":"Field","alias":{"kind":"Name","value":"secondaryName"},"name":{"kind":"Name","value":"adAccountName"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserGroupUserRoleMutation, UpdateUserGroupUserRoleMutationVariables>;
export const RedditUserForGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"redditUserForGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ownerEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"users"},"name":{"kind":"Name","value":"searchUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userEmail"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ownerEmail"}}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]}}]} as unknown as DocumentNode<RedditUserForGroupQuery, RedditUserForGroupQueryVariables>;
export const RedditUserForGroupAutocompleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"redditUserForGroupAutocomplete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ownerEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"users"},"name":{"kind":"Name","value":"searchUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userEmail"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ownerEmail"}}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userFullName"}}]}}]}}]} as unknown as DocumentNode<RedditUserForGroupAutocompleteQuery, RedditUserForGroupAutocompleteQueryVariables>;
export const CreateRedditUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createRedditUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userSurname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Email"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAccountLevel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUserAccountLevel"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userProfilePicture"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFile"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"credentials"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCredentialInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userName"}}},{"kind":"Argument","name":{"kind":"Name","value":"userSurname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userSurname"}}},{"kind":"Argument","name":{"kind":"Name","value":"userEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userEmail"}}},{"kind":"Argument","name":{"kind":"Name","value":"userAccountLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAccountLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"userProfilePicture"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userProfilePicture"}}},{"kind":"Argument","name":{"kind":"Name","value":"credentials"},"value":{"kind":"Variable","name":{"kind":"Name","value":"credentials"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RedditUserFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedditUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}},{"kind":"Field","name":{"kind":"Name","value":"userCompanyName"}},{"kind":"Field","name":{"kind":"Name","value":"userAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAccessEntityId"}},{"kind":"Field","name":{"kind":"Name","value":"userAccessAccessType"}},{"kind":"Field","name":{"kind":"Name","value":"userAccessEntityName"}},{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"userAccessAccessType"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"userAccessEntityName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pendingInvites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pendingInviteEntityType"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"EnumValue","value":"USER_GROUP"}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"pendingInviteEntityId"}},{"kind":"Field","name":{"kind":"Name","value":"pendingInviteEntityType"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"userProfilePicture"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]} as unknown as DocumentNode<CreateRedditUserMutation, CreateRedditUserMutationVariables>;
export const DeleteUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}]}}]} as unknown as DocumentNode<DeleteUserMutation, DeleteUserMutationVariables>;
export const RedditGroupsForUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"redditGroupsForUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailSearch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IdFilter"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupUserRole"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserGroupRoleFilter"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupName"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"search"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupId"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"exclude"},"value":{"kind":"BooleanValue","value":true}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupOwnerEmail"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"emailSearch"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupUserRole"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupUserRole"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RedditGroupsForUsersQuery, RedditGroupsForUsersQueryVariables>;
export const InviteUserToGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"inviteUserToGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkUserGroupsToUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RedditUserFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedditUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}},{"kind":"Field","name":{"kind":"Name","value":"userCompanyName"}},{"kind":"Field","name":{"kind":"Name","value":"userAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAccessEntityId"}},{"kind":"Field","name":{"kind":"Name","value":"userAccessAccessType"}},{"kind":"Field","name":{"kind":"Name","value":"userAccessEntityName"}},{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"userAccessAccessType"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"userAccessEntityName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pendingInvites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pendingInviteEntityType"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"EnumValue","value":"USER_GROUP"}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"pendingInviteEntityId"}},{"kind":"Field","name":{"kind":"Name","value":"pendingInviteEntityType"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"userProfilePicture"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]} as unknown as DocumentNode<InviteUserToGroupsMutation, InviteUserToGroupsMutationVariables>;
export const UpdateRedditUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateRedditUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userSurname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userPassword"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userPasswordConfirmation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAccountLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUserAccountLevel"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userProfilePicture"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ImageFile"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"credentials"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCredentialInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userName"}}},{"kind":"Argument","name":{"kind":"Name","value":"userSurname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userSurname"}}},{"kind":"Argument","name":{"kind":"Name","value":"userPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userPassword"}}},{"kind":"Argument","name":{"kind":"Name","value":"userPasswordConfirmation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userPasswordConfirmation"}}},{"kind":"Argument","name":{"kind":"Name","value":"userAccountLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAccountLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"userProfilePicture"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userProfilePicture"}}},{"kind":"Argument","name":{"kind":"Name","value":"credentials"},"value":{"kind":"Variable","name":{"kind":"Name","value":"credentials"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RedditUserFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedditUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}},{"kind":"Field","name":{"kind":"Name","value":"userCompanyName"}},{"kind":"Field","name":{"kind":"Name","value":"userAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAccessEntityId"}},{"kind":"Field","name":{"kind":"Name","value":"userAccessAccessType"}},{"kind":"Field","name":{"kind":"Name","value":"userAccessEntityName"}},{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"userAccessAccessType"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"userAccessEntityName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pendingInvites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pendingInviteEntityType"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"EnumValue","value":"USER_GROUP"}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"pendingInviteEntityId"}},{"kind":"Field","name":{"kind":"Name","value":"pendingInviteEntityType"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"userProfilePicture"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]} as unknown as DocumentNode<UpdateRedditUserMutation, UpdateRedditUserMutationVariables>;
export const RedditUsersListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"redditUsersList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userFullName"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"search"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"userId"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RedditUserFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedditUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}},{"kind":"Field","name":{"kind":"Name","value":"userCompanyName"}},{"kind":"Field","name":{"kind":"Name","value":"userAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAccessEntityId"}},{"kind":"Field","name":{"kind":"Name","value":"userAccessAccessType"}},{"kind":"Field","name":{"kind":"Name","value":"userAccessEntityName"}},{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"userAccessAccessType"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"userAccessEntityName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"profilePictureUrl"},"name":{"kind":"Name","value":"userGroupProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUserRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pendingInvites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pendingInviteEntityType"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"EnumValue","value":"USER_GROUP"}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pendingInviteHash"}},{"kind":"Field","name":{"kind":"Name","value":"pendingInviteEntityId"}},{"kind":"Field","name":{"kind":"Name","value":"pendingInviteEntityType"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"userProfilePicture"},"name":{"kind":"Name","value":"userProfilePictureUrl"}}]}}]} as unknown as DocumentNode<RedditUsersListQuery, RedditUsersListQueryVariables>;